/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type Company = {
  __typename: "Company",
  id: string,
  name: string,
  lowerName?: string | null,
  lowerNameKey: string,
  displayCompanyName?: string | null,
  slug: string,
  type: CompanyType,
  logo?: Picture | null,
  domainWhitelist?: Array< string > | null,
  onboardingSections?: CompanyOnboardingSections | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  completedOnboardingQuestionsBy?: string | null,
  isPartnerCompany?: boolean | null,
  isParent?: boolean | null,
  children?: ModelCompanyConnection | null,
  parent?: Company | null,
  parentID?: string | null,
  archived?: ArchivedState | null,
  companyNumber: number,
  nationalCount?: number | null,
  foreignNationals?: ModelForeignNationalConnection | null,
  assignedAttorneys?: ModelAttorneyAssignmentConnection | null,
  assignedParalegals?: ModelParalegalAssignmentConnection | null,
  accountManagerID?: string | null,
  accountManager?: TeamMember | null,
  assignedEmployers?: ModelEmployerAssignmentConnection | null,
  assignedEmployerAdmins?: ModelEmployerAdminAssignmentConnection | null,
  invoicingContacts?: ModelInvoicingContactConnection | null,
  primaryContacts?: ModelPrimaryContactConnection | null,
  seniorContacts?: ModelSeniorContactConnection | null,
  signatoryContacts?: ModelSignatoryContactConnection | null,
  data?: CompanyData | null,
  processRequests?: ModelProcessRequestConnection | null,
  jobDescriptions?: ModelJobDescriptionConnection | null,
  files?: ModelFileDataConnection | null,
  fileRequirements?:  Array<FileRequirement > | null,
  cases?: ModelCaseConnection | null,
  openCaseCount?: number | null,
  closedCaseCount?: number | null,
  completedCaseCount?: number | null,
  legalTeamIDs?: Array< string > | null,
  notes?: string | null,
  petitionerParagraph?: string | null,
  reportEntries?: ModelReportEntriesConnection | null,
  createdAt: string,
  updatedAt: string,
  companyDataId?: string | null,
};

export enum CompanyType {
  Company = "Company",
}


export type Picture = {
  __typename: "Picture",
  original: S3Object,
  square?: S3Object | null,
  squareThumbnails?:  Array<Thumbnail > | null,
  thumbnails?:  Array<Thumbnail > | null,
  version: number,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
  level?: S3Level | null,
  identityId?: string | null,
};

export enum S3Level {
  PRIVATE = "PRIVATE",
  PROTECTED = "PROTECTED",
  PUBLIC = "PUBLIC",
}


export type Thumbnail = {
  __typename: "Thumbnail",
  image: S3Object,
  size: number,
};

export type CompanyOnboardingSections = {
  __typename: "CompanyOnboardingSections",
  companyInfo?: boolean | null,
  contactInfo?: boolean | null,
  companyPreferences?: boolean | null,
  immigrationPreferences?: boolean | null,
  paymentPreferences?: boolean | null,
  questions?: boolean | null,
  employeeInformation?: boolean | null,
};

export type ModelCompanyConnection = {
  __typename: "ModelCompanyConnection",
  items:  Array<Company | null >,
  nextToken?: string | null,
};

export enum ArchivedState {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}


export type ModelForeignNationalConnection = {
  __typename: "ModelForeignNationalConnection",
  items:  Array<ForeignNational | null >,
  nextToken?: string | null,
};

export type ForeignNational = {
  __typename: "ForeignNational",
  type: PersonType,
  id: string,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  onboardingSections?: NationalOnboardingSections | null,
  completedOnboardingQuestionsBy?: string | null,
  email?: string | null,
  emailPersonal?: string | null,
  emailWork?: string | null,
  usMailingAddress?: StreetAddress | null,
  usResidentialAddress?: StreetAddress | null,
  lastAddressOutsideUS?: StreetAddress | null,
  username?: string | null,
  avatar?: Picture | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  nickname?: string | null,
  employeeId?: string | null,
  additionalFirstnames?: Array< string > | null,
  additionalMiddlenames?: Array< string > | null,
  additionalLastnames?: Array< string > | null,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  maritalStatus?: MaritalStatus | null,
  spouse?: boolean | null,
  dependents?: number | null,
  phone?: string | null,
  phoneWork?: string | null,
  companyID?: string | null,
  company?: Company | null,
  companyNationalNumber?: number | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  workLocation?: StreetAddress | null,
  relativesAsSource?: ModelFamilyRelationshipConnection | null,
  relativesAsTarget?: ModelFamilyRelationshipConnection | null,
  relatives?: Array< string > | null,
  relativeAdmins?: Array< string > | null,
  immigrationStatus?: ImmigrationStatus | null,
  immigrationVisaStatus?: string | null,
  visaExpiration?: string | null,
  nonImmigrantVisaNumber?: string | null,
  visaIssueDate?: string | null,
  visaConsulate?: string | null,
  immigrantVisaApplicant?: boolean | null,
  immigrantPetitionEverFiled?: boolean | null,
  j1j2?: J1J2 | null,
  hasHadI485Filed?: BooleanTwoPart | null,
  hasPendingETA9089?: boolean | null,
  hasApprovedI140?: I140 | null,
  aosFilingEligible?: AOSFilingEligibility | null,
  hasValidOrExpiredEAD?: boolean | null,
  hasPendingUSCISApplication?: boolean | null,
  hasHadVisaPetitionRevokedOrDenied?: boolean | null,
  hasBeenArrestedSinceLastUSEntry?: boolean | null,
  criminalHistory?: CriminalHistory | null,
  hasTransportedWeapons?: boolean | null,
  hasParticipatedInArmedGroup?: boolean | null,
  hasDetailedPerson?: boolean | null,
  hasUsedWeapons?: boolean | null,
  hasWeaponsTraining?: boolean | null,
  hasCriminalOffence?: boolean | null,
  hasViolatedVisaTerms?: boolean | null,
  isInRemovalProceedings?: BooleanExplain | null,
  hasBeenEmployedSinceLastAdmitted?: BooleanExplain | null,
  citizenshipCountry?: Array< CountryCode > | null,
  birthCountry?: CountryCode | null,
  birthState?: string | null,
  birthDate?: string | null,
  birthCity?: string | null,
  jobDescriptionID?: string | null,
  jobDescription?: JobDescription | null,
  nivMaxout?: string | null,
  offeredSalary?: Money | null,
  isRemote?: boolean | null,
  loginStatus?: LoginStatus | null,
  hasNonUSPassport?: boolean | null,
  passportGender?: PassportGender | null,
  passportIssueDate?: string | null,
  passportExpirationDate?: string | null,
  passportExpirationReminderSentForDate?: string | null,
  passportNumber?: string | null,
  passportCountry?: CountryCode | null,
  usSSN?: string | null,
  hasSSN?: boolean | null,
  aNumber?: string | null,
  lastEntryUS?: string | null,
  i94ArrivalDepartureRecordNumber?: string | null,
  sevisNumber?: string | null,
  eadNumber?: string | null,
  cases?: ModelCaseConnection | null,
  sponsoredCases?: ModelCaseConnection | null,
  processRequests?: ModelProcessRequestConnection | null,
  tasks?: ModelTaskConnection | null,
  files?: ModelFileDataConnection | null,
  fileRequirements?:  Array<FileRequirement > | null,
  fileRequirementsManipulated?: string | null,
  test?: string | null,
  notes?: string | null,
  companyName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  eadExpDate?: string | null,
  I797ExpDate?: string | null,
  visaExpDate?: string | null,
  reportEntries?: ModelReportEntriesConnection | null,
  chargeabilityCountry?: CountryCode | null,
  birthCountryCode?: string | null,
  socCode?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  citizenshipEligibilityDate?: string | null,
  startDate?: string | null,
  legalTeamIDs?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
};

export type Person = {
  __typename: "Person",
  id: string,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  email?: string | null,
  username?: string | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  phone?: string | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  avatar?: Picture | null,
  loginStatus?: LoginStatus | null,
  type: PersonType,
  createdBy?: string | null,
};

export type Employer = {
  __typename: "Employer",
  id: string,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type: PersonType,
  email?: string | null,
  personalEmail?: string | null,
  newsletterModalViewCount?: number | null,
  username?: string | null,
  avatar?: Picture | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  address?: string | null,
  phone?: string | null,
  personalPhone?: string | null,
  title?: string | null,
  companyIDs?: Array< string > | null,
  companies?: ModelEmployerAssignmentConnection | null,
  adminCompanies?: ModelEmployerAdminAssignmentConnection | null,
  invoicingContactCompanies?: ModelInvoicingContactConnection | null,
  primaryContactCompanies?: ModelPrimaryContactConnection | null,
  seniorContactCompanies?: ModelSeniorContactConnection | null,
  signatoryContactCompanies?: ModelSignatoryContactConnection | null,
  sponsoredCases?: ModelCaseConnection | null,
  contributorCases?: ModelCaseContributorConnection | null,
  processRequestAssignments?: ModelProcessRequestConnection | null,
  tasks?: ModelTaskConnection | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  recentlyViewedCases?: Array< string > | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  loginStatus?: LoginStatus | null,
  customTemplates?: ModelCustomTemplateConnection | null,
  invoicingContactCompanyIDs?: Array< string > | null,
  isInvoicingContact?: boolean | null,
  primaryContactCompanyIDs?: Array< string > | null,
  isPrimaryContact?: boolean | null,
  seniorContactCompanyIDs?: Array< string > | null,
  isSeniorContact?: boolean | null,
  signatoryContactCompanyIDs?: Array< string > | null,
  isSignatoryContact?: boolean | null,
  assignedCaseIDs?: Array< string > | null,
  nationalsWithOpenCases?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
};

export enum PersonType {
  Employer = "Employer",
  ForeignNational = "ForeignNational",
  System = "System",
  TeamMember = "TeamMember",
}


export type ModelEmployerAssignmentConnection = {
  __typename: "ModelEmployerAssignmentConnection",
  items:  Array<EmployerAssignment | null >,
  nextToken?: string | null,
};

export type EmployerAssignment = {
  __typename: "EmployerAssignment",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelEmployerAdminAssignmentConnection = {
  __typename: "ModelEmployerAdminAssignmentConnection",
  items:  Array<EmployerAdminAssignment | null >,
  nextToken?: string | null,
};

export type EmployerAdminAssignment = {
  __typename: "EmployerAdminAssignment",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelInvoicingContactConnection = {
  __typename: "ModelInvoicingContactConnection",
  items:  Array<InvoicingContact | null >,
  nextToken?: string | null,
};

export type InvoicingContact = {
  __typename: "InvoicingContact",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPrimaryContactConnection = {
  __typename: "ModelPrimaryContactConnection",
  items:  Array<PrimaryContact | null >,
  nextToken?: string | null,
};

export type PrimaryContact = {
  __typename: "PrimaryContact",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelSeniorContactConnection = {
  __typename: "ModelSeniorContactConnection",
  items:  Array<SeniorContact | null >,
  nextToken?: string | null,
};

export type SeniorContact = {
  __typename: "SeniorContact",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelSignatoryContactConnection = {
  __typename: "ModelSignatoryContactConnection",
  items:  Array<SignatoryContact | null >,
  nextToken?: string | null,
};

export type SignatoryContact = {
  __typename: "SignatoryContact",
  id: string,
  companyID: string,
  employerID: string,
  company?: Company | null,
  employer?: Employer | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelCaseConnection = {
  __typename: "ModelCaseConnection",
  items:  Array<Case | null >,
  nextToken?: string | null,
};

export type Case = {
  __typename: "Case",
  id: string,
  caseNumber?: string | null,
  slug: string,
  attorneyID?: string | null,
  attorney?: TeamMember | null,
  caseManagerID?: string | null,
  caseManager?: TeamMember | null,
  complianceListID?: string | null,
  complianceList?: CaseComplianceList | null,
  PERMFilingDataID?: string | null,
  PERMFilingData?: PERMFilingData | null,
  caseNotes?: ModelCaseNoteConnection | null,
  pinnedCaseNoteID?: string | null,
  contributorIds?: Array< string | null > | null,
  contributors?: ModelCaseContributorConnection | null,
  sponsoringEmployerID?: string | null,
  sponsoringEmployer?: Employer | null,
  sponsoringNationalID?: string | null,
  sponsoringNational?: ForeignNational | null,
  foreignNationalID: string,
  foreignNational?: ForeignNational | null,
  welcomeLetterAcknowledged?: boolean | null,
  welcomeLetterAcknowledgementDate?: string | null,
  welcomeLetterAcknowledgedBy?: string | null,
  welcomeLetterText?: string | null,
  nationalVisaExpiration?: string | null,
  relativeAdmins?: Array< string > | null,
  startDate: string,
  closeDate?: string | null,
  closeReason?: string | null,
  completeDate?: string | null,
  sourceID: string,
  source?: ProcessRequest | null,
  state: CaseState,
  tasks?: ModelTaskConnection | null,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
  fileRequirements:  Array<FileRequirement >,
  currentPhase?: CasePhase | null,
  phaseRequirements:  Array<CasePhaseRequirement >,
  completedMilestones:  Array<CompletedCaseMilestone >,
  files?: ModelCaseFileConnection | null,
  preparedForms?: ModelPreparedFormConnection | null,
  prevailingWageCaseNumber?: string | null,
  USCISReceiptNumber?: string | null,
  USCISReceiptDetails?: ModelUSCISReceiptDetailsConnection | null,
  AOSReceiptNotice?: string | null,
  I485JReceiptNotice?: string | null,
  SelectionNoticeNo?: string | null,
  ETACaseNumber?: string | null,
  shipmentTracking?:  Array<CaseShipmentTracking > | null,
  isShipmentTrackingElectronically?: boolean | null,
  companyID?: string | null,
  company?: Company | null,
  individualSponsored?: boolean | null,
  jobDescriptionID?: string | null,
  jobDescription?: JobDescription | null,
  employeeData?: ProcessRequestEmployeeData | null,
  employmentData?: ProcessRequestEmploymentData | null,
  resumeID?: string | null,
  resume?: FileData | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  additionalFieldID?: string | null,
  additionalFields?: AdditionalFields | null,
  createdAt: string,
  updatedAt: string,
};

export type TeamMember = {
  __typename: "TeamMember",
  id: string,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type: PersonType,
  email?: string | null,
  username?: string | null,
  avatar?: Picture | null,
  firstname: string,
  middlename?: string | null,
  lastname: string,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  phone?: string | null,
  position?: Position | null,
  title?: string | null,
  licensingAuthority?: string | null,
  stateBarNumber?: string | null,
  isAdmin?: boolean | null,
  manager?: TeamMember | null,
  managerID?: string | null,
  attorneyAssignments?: ModelAttorneyAssignmentConnection | null,
  paralegalAssignments?: ModelParalegalAssignmentConnection | null,
  accountManagerAssignments?: ModelCompanyConnection | null,
  attorneyCases?: ModelCaseConnection | null,
  caseManagerCases?: ModelCaseConnection | null,
  contributorCases?: ModelCaseContributorConnection | null,
  processRequestAssignments?: ModelProcessRequestConnection | null,
  tasks?: ModelTaskConnection | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  loginStatus?: LoginStatus | null,
  recentlyViewedCases?: Array< string > | null,
  customTemplates?: ModelCustomTemplateConnection | null,
  nationalsWithOpenCases?: Array< string > | null,
  companiesAssignedTo?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
};

export enum Position {
  ATTORNEY = "ATTORNEY",
  PARALEGAL = "PARALEGAL",
  LEGAL_ASSISTANT = "LEGAL_ASSISTANT",
  CONTRIBUTOR = "CONTRIBUTOR",
}


export type ModelAttorneyAssignmentConnection = {
  __typename: "ModelAttorneyAssignmentConnection",
  items:  Array<AttorneyAssignment | null >,
  nextToken?: string | null,
};

export type AttorneyAssignment = {
  __typename: "AttorneyAssignment",
  id: string,
  companyID: string,
  attorneyID: string,
  company: Company,
  attorney: TeamMember,
  createdAt: string,
  updatedAt: string,
};

export type ModelParalegalAssignmentConnection = {
  __typename: "ModelParalegalAssignmentConnection",
  items:  Array<ParalegalAssignment | null >,
  nextToken?: string | null,
};

export type ParalegalAssignment = {
  __typename: "ParalegalAssignment",
  id: string,
  companyID: string,
  paralegalID: string,
  company: Company,
  paralegal: TeamMember,
  createdAt: string,
  updatedAt: string,
};

export type ModelCaseContributorConnection = {
  __typename: "ModelCaseContributorConnection",
  items:  Array<CaseContributor | null >,
  nextToken?: string | null,
};

export type CaseContributor = {
  __typename: "CaseContributor",
  id: string,
  caseID: string,
  case: Case,
  contributorID: string,
  contributorEmployer?: Employer | null,
  contributorForeignNational?: ForeignNational | null,
  contributorTeamMember?: TeamMember | null,
  foreignNationalID: string,
  foreignNational?: ForeignNational | null,
  state: CaseState,
  type: PersonType,
  createdAt: string,
  updatedAt: string,
};

export enum CaseState {
  NA = "NA",
  PENDING = "PENDING",
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  COMPLETED = "COMPLETED",
}


export type ModelProcessRequestConnection = {
  __typename: "ModelProcessRequestConnection",
  items:  Array<ProcessRequest | null >,
  nextToken?: string | null,
};

export type ProcessRequest = {
  __typename: "ProcessRequest",
  id: string,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToTeamMemberID?: string | null,
  assignedToEmployer?: Employer | null,
  assignedToTeamMember?: TeamMember | null,
  caseNotes?: ModelCaseNoteConnection | null,
  companyID?: string | null,
  company?: Company | null,
  files?: ModelFileDataConnection | null,
  individualSponsored?: boolean | null,
  initiatorID?: string | null,
  initiator?: TeamMember | null,
  jobDescriptionID?: string | null,
  jobDescription?: JobDescription | null,
  requesterID?: string | null,
  requester?: Employer | null,
  requestDate: string,
  approvalDate?: string | null,
  archivedDate?: string | null,
  cancelDate?: string | null,
  foreignNationalID?: string | null,
  foreignNational?: ForeignNational | null,
  employeeData?: ProcessRequestEmployeeData | null,
  employmentData?: ProcessRequestEmploymentData | null,
  needsEmployerRevision?: boolean | null,
  resume?: FileData | null,
  resumeID?: string | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  vendor?: Vendor | null,
  slug: string,
  state: ProcessRequestState,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelCaseNoteConnection = {
  __typename: "ModelCaseNoteConnection",
  items:  Array<CaseNote | null >,
  nextToken?: string | null,
};

export type CaseNote = {
  __typename: "CaseNote",
  id: string,
  createdAt?: string | null,
  postDate?: string | null,
  authorID?: string | null,
  authorEmployerID?: string | null,
  authorTeamMemberID?: string | null,
  authorEmployer?: Employer | null,
  authorTeamMember?: TeamMember | null,
  isPinned?: boolean | null,
  note?: string | null,
  caseID?: string | null,
  processRequestID?: string | null,
  companyID?: string | null,
  userGroup: UserGroup,
  updatedAt: string,
  owner?: string | null,
};

export enum UserGroup {
  Admins = "Admins",
  Employers = "Employers",
  GlobalPartners = "GlobalPartners",
  Nationals = "Nationals",
  Team = "Team",
}


export type ModelFileDataConnection = {
  __typename: "ModelFileDataConnection",
  items:  Array<FileData | null >,
  nextToken?: string | null,
};

export type FileData = {
  __typename: "FileData",
  id: string,
  expirationDate?: string | null,
  durationOfStatus?: boolean | null,
  fileName: string,
  original: S3Object,
  fileType?: FileType | null,
  fileRequirement?: string | null,
  fileCategory?: string | null,
  contentType?: string | null,
  issueDate?: string | null,
  dueDate?: string | null,
  isFlattened?: boolean | null,
  processRequestID?: string | null,
  companyID?: string | null,
  ownerNationalID?: string | null,
  sourceID?: string | null,
  uploadDate: string,
  uploaderID?: string | null,
  uploaderEmployerID?: string | null,
  uploaderForeignNationalID?: string | null,
  uploaderTeamMemberID?: string | null,
  uploaderForeignNational?: ForeignNational | null,
  uploaderTeamMember?: TeamMember | null,
  uploaderEmployer?: ForeignNational | null,
  cases?: ModelCaseFileConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum FileType {
  I_140_APPLICATION = "I_140_APPLICATION",
  DS_160_COPY = "DS_160_COPY",
  DOL_AUDIT_RESPONSE = "DOL_AUDIT_RESPONSE",
  E_3_APPLICATION = "E_3_APPLICATION",
  E_3D_APPLICATION = "E_3D_APPLICATION",
  E_3D_CONSULAR_PACKET = "E_3D_CONSULAR_PACKET",
  H_1B1_APPLICATION = "H_1B1_APPLICATION",
  H_4_CONSULAR_PACKET = "H_4_CONSULAR_PACKET",
  REQUEST_EVIDENCE_RESPONSE = "REQUEST_EVIDENCE_RESPONSE",
  TD_APPLICATION = "TD_APPLICATION",
  TD_BORDER_PACKET = "TD_BORDER_PACKET",
  TD_CONSULAR_PACKET = "TD_CONSULAR_PACKET",
  TN_APPLICATION = "TN_APPLICATION",
  APPLICATION_COPY_EMPLOYEE = "APPLICATION_COPY_EMPLOYEE",
  COMPLETED_FORMS = "COMPLETED_FORMS",
  PREMIUM_PROCESSING_UPGRADE_FORMS = "PREMIUM_PROCESSING_UPGRADE_FORMS",
  I_140_RECEIPT_NOTICE = "I_140_RECEIPT_NOTICE",
  APPROVAL_NOTICE = "APPROVAL_NOTICE",
  CERTIFIED_PERM = "CERTIFIED_PERM",
  DOL_AUDIT_NOTICE = "DOL_AUDIT_NOTICE",
  OTHER_NOTICES = "OTHER_NOTICES",
  RECEIPT_NOTICE = "RECEIPT_NOTICE",
  REQUEST_FOR_EVIDENCE = "REQUEST_FOR_EVIDENCE",
  ACTUAL_PREVAILING_WAGE_MEMO = "ACTUAL_PREVAILING_WAGE_MEMO",
  OES_WAGES = "OES_WAGES",
  PAF_TEMPLATES = "PAF_TEMPLATES",
  SIGNED_CERTIFIED_LCA = "SIGNED_CERTIFIED_LCA",
  SIGNED_NOTICE_FILING_CONFIRMATION = "SIGNED_NOTICE_FILING_CONFIRMATION",
  SUMMARY_OF_BENEFITS = "SUMMARY_OF_BENEFITS",
  DEPENDENT_VISA_USCIS_SIGNATURE_PAGES = "DEPENDENT_VISA_USCIS_SIGNATURE_PAGES",
  EMPLOYMENT_VISA_CONSULAR_SIGNATURE_PAGES = "EMPLOYMENT_VISA_CONSULAR_SIGNATURE_PAGES",
  EMPLOYMENT_VISA_USCIS_SIGNATURE_PAGES = "EMPLOYMENT_VISA_USCIS_SIGNATURE_PAGES",
  EVIDENCE_OF_PRIMARY_E3 = "EVIDENCE_OF_PRIMARY_E3",
  EVIDENCE_OF_PRIMARY_H1B = "EVIDENCE_OF_PRIMARY_H1B",
  EVIDENCE_OF_PRIMARY_TN = "EVIDENCE_OF_PRIMARY_TN",
  BIRTH_CERTIFICATE = "BIRTH_CERTIFICATE",
  COMPANY_FINANCIAL_STATEMENT = "COMPANY_FINANCIAL_STATEMENT",
  DIPLOMA = "DIPLOMA",
  EAD_CARD = "EAD_CARD",
  EDUCATION_EVALUATION = "EDUCATION_EVALUATION",
  EXPERIENCE_LETTER = "EXPERIENCE_LETTER",
  H_1B_APPLICATION = "H_1B_APPLICATION",
  H_4_APPLICATION = "H_4_APPLICATION",
  I_140_APPROVAL_NOTICE = "I_140_APPROVAL_NOTICE",
  I_20_COPY = "I_20_COPY",
  I_797_APPROVAL_NOTICE = "I_797_APPROVAL_NOTICE",
  I_94 = "I_94",
  JOB_DESCRIPTION = "JOB_DESCRIPTION",
  MARKETING_MATERIAL = "MARKETING_MATERIAL",
  MARRIAGE_CERTIFICATE = "MARRIAGE_CERTIFICATE",
  MASTER_AGREEMENT = "MASTER_AGREEMENT",
  OTHER = "OTHER",
  PASSPORT = "PASSPORT",
  PASSPORT_PHOTO = "PASSPORT_PHOTO",
  PAY_STUBS = "PAY_STUBS",
  PERM_APPLICATION = "PERM_APPLICATION",
  PERM_SIGNATURE_PAGES = "PERM_SIGNATURE_PAGES",
  PREVIOUS_I_140_APPROVAL_NOTICES = "PREVIOUS_I_140_APPROVAL_NOTICES",
  PREVIOUS_I_797_APPROVAL_NOTICES = "PREVIOUS_I_797_APPROVAL_NOTICES",
  PRIOR_EAD = "PRIOR_EAD",
  RESUME = "RESUME",
  SCHOOL_MARK_TRANSCRIPT = "SCHOOL_MARK_TRANSCRIPT",
  SIGNED_EMPLOYMENT_CONTRACT = "SIGNED_EMPLOYMENT_CONTRACT",
  USCIS_PRIMARY_APPLICATION = "USCIS_PRIMARY_APPLICATION",
  USCIS_DEPENDENT_APPLICATION = "USCIS_DEPENDENT_APPLICATION",
  EVIDENCE_OF_PRIMARY_USCIS = "EVIDENCE_OF_PRIMARY_USCIS",
  SUPPORT_LETTER = "SUPPORT_LETTER",
  VENDOR_CLIENT_LETTERS = "VENDOR_CLIENT_LETTERS",
  VISA_STAMPS = "VISA_STAMPS",
  W2 = "W2",
  CERTIFIED_LABOR_CONDITION_APPLICATION = "CERTIFIED_LABOR_CONDITION_APPLICATION",
  LABOR_CONDITION_APPLICATION_NOTICE_FILLING = "LABOR_CONDITION_APPLICATION_NOTICE_FILLING",
  H_1B_RECEIPT_NOTICE = "H_1B_RECEIPT_NOTICE",
  H_1B_SIGNATURE_PAGES = "H_1B_SIGNATURE_PAGES",
  H_4_RECEIPT_NOTICE = "H_4_RECEIPT_NOTICE",
  H_4_SIGNATURE_PAGES = "H_4_SIGNATURE_PAGES",
  PRIOR_I_20 = "PRIOR_I_20",
  BIRTH_CERTIFICATE_OR_MARRIAGE_CERTIFICATE = "BIRTH_CERTIFICATE_OR_MARRIAGE_CERTIFICATE",
  H_1B1_SIGNATURE_PAGES = "H_1B1_SIGNATURE_PAGES",
  H_1B1_APPROVAL_NOTICE = "H_1B1_APPROVAL_NOTICE",
  H_1B1_RECEIPT_NOTICE = "H_1B1_RECEIPT_NOTICE",
  EAD_COPIES = "EAD_COPIES",
  STATEMENT_OF_WORK = "STATEMENT_OF_WORK",
  OTHER_PUBLIC_ACCESS_FILE = "OTHER_PUBLIC_ACCESS_FILE",
  EAD_SIGNATURE_PAGES = "EAD_SIGNATURE_PAGES",
  I94_FROM_MOST_RECENT_US_ENTRY = "I94_FROM_MOST_RECENT_US_ENTRY",
  EAD_APPLICATION = "EAD_APPLICATION",
  H1B_LOTTERY_SELECTION_NOTICE = "H1B_LOTTERY_SELECTION_NOTICE",
  CANDIDATE_RESUMES_AND_ASSESSMENTS = "CANDIDATE_RESUMES_AND_ASSESSMENTS",
  SIGNED_COPY_OF_NOTICE_OF_FILLING_NOF = "SIGNED_COPY_OF_NOTICE_OF_FILLING_NOF",
  EMPLOYEE_REFERRAL_PROGRAM = "EMPLOYEE_REFERRAL_PROGRAM",
  SUNDAY_NEWSPAPER_AD_1 = "SUNDAY_NEWSPAPER_AD_1",
  SUNDAY_NEWSPAPER_AD_2 = "SUNDAY_NEWSPAPER_AD_2",
  STATE_WORKFORCE_AGENCY_POSTING = "STATE_WORKFORCE_AGENCY_POSTING",
  WEEKDAY_ETHNIC_NEWSPAPER_AD = "WEEKDAY_ETHNIC_NEWSPAPER_AD",
  RADIO_AD = "RADIO_AD",
  CAMPUS_PLACEMENT = "CAMPUS_PLACEMENT",
  JOB_FAIR = "JOB_FAIR",
  COMPANY_WEBSITE = "COMPANY_WEBSITE",
  JOB_SEARCH_ENGINE = "JOB_SEARCH_ENGINE",
  GREEN_CARD = "GREEN_CARD",
  PREVAILING_WAGE_DETERMINATION = "PREVAILING_WAGE_DETERMINATION",
  ATTORNEY_CLIENT_AGREEMENT = "ATTORNEY_CLIENT_AGREEMENT",
  ADVANCED_PAROLE = "ADVANCED_PAROLE",
  RE_ENTRY_PERMIT = "RE_ENTRY_PERMIT",
  DS_2019 = "DS_2019",
  FLATTENED_FORMS = "FLATTENED_FORMS",
  RFGP_FINAL_SUBMISSION = "RFGP_FINAL_SUBMISSION",
  CUSTOM = "CUSTOM",
}


export type ModelCaseFileConnection = {
  __typename: "ModelCaseFileConnection",
  items:  Array<CaseFile | null >,
  nextToken?: string | null,
};

export type CaseFile = {
  __typename: "CaseFile",
  id: string,
  fileID: string,
  caseID: string,
  file: FileData,
  case: Case,
  createdAt: string,
  updatedAt: string,
};

export type JobDescription = {
  __typename: "JobDescription",
  companyID?: string | null,
  id: string,
  archived: ArchivedState,
  type: JobDescriptionType,
  foreignNationalID?: string | null,
  title: string,
  officialTitle?: string | null,
  degrees?: Array< Degree > | null,
  requiresBachelors?: boolean | null,
  requiresMasters?: boolean | null,
  requiresPhd?: boolean | null,
  dotNumber?: string | null,
  caseSocCode?: string | null,
  duties?: string | null,
  jobURL?: string | null,
  majors?: string | null,
  specialRequirements?: string | null,
  yearsGeneralExperience?: number | null,
  objectiveSkillSetsRequired?: string | null,
  offeredSalary?: string | null,
  certificationLicenses?: string | null,
  travelIsRequired?: boolean | null,
  travelPercentage?: number | null,
  travelDomestic?: boolean | null,
  travelInternational?: boolean | null,
  supervisesOthers?: boolean | null,
  supervisesOthersCount?: number | null,
  supervisesTitles?: Array< string > | null,
  supervisorTitle?: string | null,
  canWorkFromHome?: boolean | null,
  uploadedDescriptionID?: string | null,
  uploadedDescription?: FileData | null,
  createdAt: string,
  updatedAt: string,
};

export enum JobDescriptionType {
  STANDARD = "STANDARD",
  ONEOFF = "ONEOFF",
}


export enum Degree {
  NONE = "NONE",
  BACHELORS = "BACHELORS",
  MASTERS = "MASTERS",
  PHD = "PHD",
}


export type ProcessRequestEmployeeData = {
  __typename: "ProcessRequestEmployeeData",
  firstname: string,
  lastname: string,
  middlename?: string | null,
  email?: string | null,
  employeeId?: string | null,
  tempID: string,
  spouse?: boolean | null,
  dependents?: number | null,
};

export type ProcessRequestEmploymentData = {
  __typename: "ProcessRequestEmploymentData",
  location?: ProcessRequestLocation | null,
  premiumProcessing?: boolean | null,
  salary?: Money | null,
  startDate?: string | null,
  notes?: string | null,
};

export type ProcessRequestLocation = {
  __typename: "ProcessRequestLocation",
  type?: ProcessRequestLocationType | null,
  remoteAddress?: StreetAddress | null,
};

export enum ProcessRequestLocationType {
  HEADQUARTERS = "HEADQUARTERS",
  SECONDARY = "SECONDARY",
  REMOTE = "REMOTE",
}


export type StreetAddress = {
  __typename: "StreetAddress",
  careOf?: string | null,
  address?: string | null,
  companyAddressType?: CompanyAddressType | null,
  unitNumber?: string | null,
  unitType?: UnitType | null,
  adminArea?: string | null,
  state?: StateCode | null,
  city?: string | null,
  country?: CountryCode | null,
  postalCode?: string | null,
  title?: string | null,
};

export enum CompanyAddressType {
  HEADQUARTERS = "HEADQUARTERS",
  SECONDARY = "SECONDARY",
}


export enum UnitType {
  APARTMENT = "APARTMENT",
  SUITE = "SUITE",
  FLOOR = "FLOOR",
  NONE = "NONE",
}


export enum StateCode {
  AL = "AL",
  AK = "AK",
  AZ = "AZ",
  AR = "AR",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DE = "DE",
  DC = "DC",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  IA = "IA",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  ME = "ME",
  MD = "MD",
  MA = "MA",
  MI = "MI",
  MN = "MN",
  MS = "MS",
  MO = "MO",
  MT = "MT",
  NE = "NE",
  NV = "NV",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NY = "NY",
  NC = "NC",
  ND = "ND",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VT = "VT",
  VA = "VA",
  WA = "WA",
  WV = "WV",
  WI = "WI",
  WY = "WY",
  XK = "XK",
}


export enum CountryCode {
  AD = "AD",
  AE = "AE",
  AF = "AF",
  AG = "AG",
  AI = "AI",
  AL = "AL",
  AM = "AM",
  AN = "AN",
  AO = "AO",
  AQ = "AQ",
  AR = "AR",
  AS = "AS",
  AT = "AT",
  AU = "AU",
  AW = "AW",
  AX = "AX",
  AZ = "AZ",
  BA = "BA",
  BB = "BB",
  BD = "BD",
  BE = "BE",
  BF = "BF",
  BG = "BG",
  BH = "BH",
  BI = "BI",
  BJ = "BJ",
  BL = "BL",
  BM = "BM",
  BN = "BN",
  BO = "BO",
  BQ = "BQ",
  BR = "BR",
  BS = "BS",
  BT = "BT",
  BV = "BV",
  BW = "BW",
  BY = "BY",
  BZ = "BZ",
  CA = "CA",
  CC = "CC",
  CD = "CD",
  CF = "CF",
  CG = "CG",
  CH = "CH",
  CI = "CI",
  CK = "CK",
  CL = "CL",
  CM = "CM",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  CU = "CU",
  CV = "CV",
  CW = "CW",
  CX = "CX",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DJ = "DJ",
  DK = "DK",
  DM = "DM",
  DO = "DO",
  DZ = "DZ",
  EC = "EC",
  EE = "EE",
  EG = "EG",
  EH = "EH",
  ER = "ER",
  ES = "ES",
  ET = "ET",
  EU = "EU",
  FI = "FI",
  FJ = "FJ",
  FK = "FK",
  FM = "FM",
  FO = "FO",
  FR = "FR",
  GA = "GA",
  GB = "GB",
  GD = "GD",
  GE = "GE",
  GF = "GF",
  GG = "GG",
  GH = "GH",
  GI = "GI",
  GL = "GL",
  GM = "GM",
  GN = "GN",
  GP = "GP",
  GQ = "GQ",
  GR = "GR",
  GS = "GS",
  GT = "GT",
  GU = "GU",
  GW = "GW",
  GY = "GY",
  HK = "HK",
  HM = "HM",
  HN = "HN",
  HR = "HR",
  HT = "HT",
  HU = "HU",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IM = "IM",
  IN = "IN",
  IO = "IO",
  IQ = "IQ",
  IR = "IR",
  IS = "IS",
  IT = "IT",
  JE = "JE",
  JM = "JM",
  JO = "JO",
  JP = "JP",
  KE = "KE",
  KG = "KG",
  KH = "KH",
  KI = "KI",
  KM = "KM",
  KN = "KN",
  KP = "KP",
  KR = "KR",
  KW = "KW",
  KY = "KY",
  KZ = "KZ",
  LA = "LA",
  LB = "LB",
  LC = "LC",
  LI = "LI",
  LK = "LK",
  LR = "LR",
  LS = "LS",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  LY = "LY",
  MA = "MA",
  MC = "MC",
  MD = "MD",
  ME = "ME",
  MF = "MF",
  MG = "MG",
  MH = "MH",
  MK = "MK",
  ML = "ML",
  MM = "MM",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MQ = "MQ",
  MR = "MR",
  MS = "MS",
  MT = "MT",
  MU = "MU",
  MV = "MV",
  MW = "MW",
  MX = "MX",
  MY = "MY",
  MZ = "MZ",
  NA = "NA",
  NC = "NC",
  NE = "NE",
  NF = "NF",
  NG = "NG",
  NI = "NI",
  NL = "NL",
  NO = "NO",
  NP = "NP",
  NR = "NR",
  NU = "NU",
  NZ = "NZ",
  OM = "OM",
  PA = "PA",
  PE = "PE",
  PF = "PF",
  PG = "PG",
  PH = "PH",
  PK = "PK",
  PL = "PL",
  PM = "PM",
  PN = "PN",
  PR = "PR",
  PS = "PS",
  PT = "PT",
  PW = "PW",
  PY = "PY",
  QA = "QA",
  RE = "RE",
  RO = "RO",
  RS = "RS",
  RU = "RU",
  RW = "RW",
  SA = "SA",
  SB = "SB",
  SC = "SC",
  SD = "SD",
  SE = "SE",
  SG = "SG",
  SH = "SH",
  SI = "SI",
  SJ = "SJ",
  SK = "SK",
  SL = "SL",
  SM = "SM",
  SN = "SN",
  SO = "SO",
  SR = "SR",
  SS = "SS",
  ST = "ST",
  SV = "SV",
  SX = "SX",
  SY = "SY",
  SZ = "SZ",
  TC = "TC",
  TD = "TD",
  TF = "TF",
  TG = "TG",
  TH = "TH",
  TJ = "TJ",
  TK = "TK",
  TL = "TL",
  TM = "TM",
  TN = "TN",
  TO = "TO",
  TR = "TR",
  TT = "TT",
  TV = "TV",
  TW = "TW",
  TZ = "TZ",
  UA = "UA",
  UG = "UG",
  UM = "UM",
  US = "US",
  UY = "UY",
  UZ = "UZ",
  VA = "VA",
  VI = "VI",
  VC = "VC",
  VE = "VE",
  VG = "VG",
  VN = "VN",
  VU = "VU",
  WF = "WF",
  WS = "WS",
  XK = "XK",
  YE = "YE",
  YT = "YT",
  ZA = "ZA",
  ZM = "ZM",
  ZW = "ZW",
}


export type Money = {
  __typename: "Money",
  currency: Currency,
  amount: number,
  period?: CurrencyPeriod | null,
};

export enum Currency {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}


export enum CurrencyPeriod {
  ANNUAL = "ANNUAL",
  QUARTERLY = "QUARTERLY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
  HOURLY = "HOURLY",
}


export enum VisaStatus {
  A_1 = "A_1",
  A_2 = "A_2",
  A_3 = "A_3",
  ASYLEE = "ASYLEE",
  B_1 = "B_1",
  B_2 = "B_2",
  C_1 = "C_1",
  CW_1 = "CW_1",
  CW_2 = "CW_2",
  D = "D",
  DACA = "DACA",
  E_1 = "E_1",
  E_1D = "E_1D",
  E_2D = "E_2D",
  E_2 = "E_2",
  E_3 = "E_3",
  E_3D = "E_3D",
  E_3D_CONSULATE = "E_3D_CONSULATE",
  E_3D_STATUS = "E_3D_STATUS",
  E_3_CONSULATE = "E_3_CONSULATE",
  E_3_STATUS = "E_3_STATUS",
  EAD_PRIMARY = "EAD_PRIMARY",
  EAD_DEPENDENT = "EAD_DEPENDENT",
  ESTA = "ESTA",
  F_1 = "F_1",
  F_2 = "F_2",
  G_1 = "G_1",
  G_2 = "G_2",
  G_3 = "G_3",
  G_4 = "G_4",
  G_5 = "G_5",
  GLOBAL_PROCESS = "GLOBAL_PROCESS",
  H4_CONSULATE = "H4_CONSULATE",
  H_1B = "H_1B",
  H_1B1 = "H_1B1",
  H_1B1_CONSULATE = "H_1B1_CONSULATE",
  H_1B1_STATUS = "H_1B1_STATUS",
  H_2A = "H_2A",
  H_2B = "H_2B",
  H_3 = "H_3",
  H_4 = "H_4",
  H_4_STATUS = "H_4_STATUS",
  I = "I",
  J_1 = "J_1",
  L_1 = "L_1",
  L_1A = "L_1A",
  L_1B = "L_1B",
  L_BLANKET = "L_BLANKET",
  L_2 = "L_2",
  LPR = "LPR",
  M_1 = "M_1",
  M_2 = "M_2",
  NATO_1 = "NATO_1",
  NATO_2 = "NATO_2",
  NATO_3 = "NATO_3",
  NATO_4 = "NATO_4",
  NATO_5 = "NATO_5",
  NATO_6 = "NATO_6",
  NATO_7 = "NATO_7",
  O_1 = "O_1",
  O_2 = "O_2",
  O_3 = "O_3",
  OTHER = "OTHER",
  PERM_GREEN_CARD = "PERM_GREEN_CARD",
  P_1 = "P_1",
  P_2 = "P_2",
  P_3 = "P_3",
  P_4 = "P_4",
  Q_1 = "Q_1",
  PAROLEE = "PAROLEE",
  PENDING_ASYLEE = "PENDING_ASYLEE",
  R_1 = "R_1",
  R_2 = "R_2",
  TD = "TD",
  TD_CANADA = "TD_CANADA",
  TD_MEXICO = "TD_MEXICO",
  TD_STATUS = "TD_STATUS",
  TN = "TN",
  TN_CANADA = "TN_CANADA",
  TN_MEXICO = "TN_MEXICO",
  TN_STATUS = "TN_STATUS",
  U_1 = "U_1",
  U_2 = "U_2",
  U_3 = "U_3",
  U_4 = "U_4",
  U_5 = "U_5",
  T_1 = "T_1",
  T_2 = "T_2",
  T_3 = "T_3",
  T_4 = "T_4",
  TPS = "TPS",
  US_CITIZEN = "US_CITIZEN",
  NOT_IN_US = "NOT_IN_US",
  AOS_APPLICANT = "AOS_APPLICANT",
  NOT_SURE = "NOT_SURE",
  USCIS_PRIMARY = "USCIS_PRIMARY",
  USCIS_PRIMARY_2 = "USCIS_PRIMARY_2",
  USCIS_DEPENDENT = "USCIS_DEPENDENT",
  AOS = "AOS",
  H_1B_LOTTERY = "H_1B_LOTTERY",
  H_1B_24_LOTTERY = "H_1B_24_LOTTERY",
  H_1B_25_LOTTERY = "H_1B_25_LOTTERY",
  H_1B_26_LOTTERY = "H_1B_26_LOTTERY",
  EAD = "EAD",
  J_2 = "J_2",
  K_1 = "K_1",
  K_3 = "K_3",
}


export enum VisaSubCategory {
  H_1B_CHANGE_STATUS = "H_1B_CHANGE_STATUS",
  H_1B_EXTENSION = "H_1B_EXTENSION",
  H_1B_EXTENSION_SUBSEQUENT = "H_1B_EXTENSION_SUBSEQUENT",
  H_1B_AMENDMENT = "H_1B_AMENDMENT",
  H_1B_TRANSFER = "H_1B_TRANSFER",
  H_1B_CAP_LOTTERY = "H_1B_CAP_LOTTERY",
  H_4_CHANGE_STATUS = "H_4_CHANGE_STATUS",
  H_4_EXTENSION = "H_4_EXTENSION",
  USCIS_PRIMARY_ADVANCE_PAROLE = "USCIS_PRIMARY_ADVANCE_PAROLE",
  USCIS_PRIMARY_B_1 = "USCIS_PRIMARY_B_1",
  USCIS_PRIMARY_EB_1A = "USCIS_PRIMARY_EB_1A",
  USCIS_PRIMARY_EB_1B = "USCIS_PRIMARY_EB_1B",
  USCIS_PRIMARY_EB_1C = "USCIS_PRIMARY_EB_1C",
  USCIS_PRIMARY_E_1 = "USCIS_PRIMARY_E_1",
  USCIS_PRIMARY_E_2 = "USCIS_PRIMARY_E_2",
  USCIS_PRIMARY_H_3 = "USCIS_PRIMARY_H_3",
  USCIS_PRIMARY_I = "USCIS_PRIMARY_I",
  USCIS_PRIMARY_INTERNATIONAL_ENTREPRENEUR_PAROLE = "USCIS_PRIMARY_INTERNATIONAL_ENTREPRENEUR_PAROLE",
  USCIS_PRIMARY_I_485J = "USCIS_PRIMARY_I_485J",
  USCIS_PRIMARY_I_140 = "USCIS_PRIMARY_I_140",
  USCIS_PRIMARY_J_1 = "USCIS_PRIMARY_J_1",
  USCIS_PRIMARY_L_BLANKET = "USCIS_PRIMARY_L_BLANKET",
  USCIS_PRIMARY_L_1A = "USCIS_PRIMARY_L_1A",
  USCIS_PRIMARY_L_1B = "USCIS_PRIMARY_L_1B",
  USCIS_PRIMARY_NATIONAL_INTEREST_WAIVER = "USCIS_PRIMARY_NATIONAL_INTEREST_WAIVER",
  USCIS_PRIMARY_N_400 = "USCIS_PRIMARY_N_400",
  USCIS_PRIMARY_O_1 = "USCIS_PRIMARY_O_1",
  USCIS_PRIMARY_O_2 = "USCIS_PRIMARY_O_2",
  USCIS_PRIMARY_P_1 = "USCIS_PRIMARY_P_1",
  USCIS_PRIMARY_P_3 = "USCIS_PRIMARY_P_3",
  USCIS_PRIMARY_Q_1 = "USCIS_PRIMARY_Q_1",
  USCIS_PRIMARY_R_1 = "USCIS_PRIMARY_R_1",
  USCIS_PRIMARY_RE_ENTRY_PERMIT = "USCIS_PRIMARY_RE_ENTRY_PERMIT",
  USCIS_PRIMARY_SCHEDULE_A_GREEN_CARD = "USCIS_PRIMARY_SCHEDULE_A_GREEN_CARD",
  USCIS_DEPENDENT_ADVANCE_PAROLE = "USCIS_DEPENDENT_ADVANCE_PAROLE",
  USCIS_DEPENDENT_B_1 = "USCIS_DEPENDENT_B_1",
  USCIS_DEPENDENT_B_2 = "USCIS_DEPENDENT_B_2",
  USCIS_DEPENDENT_DACA = "USCIS_DEPENDENT_DACA",
  USCIS_DEPENDENT_E_1_DEPENDENT = "USCIS_DEPENDENT_E_1_DEPENDENT",
  USCIS_DEPENDENT_E_2_DEPENDENT = "USCIS_DEPENDENT_E_2_DEPENDENT",
  USCIS_DEPENDENT_EB_5_INVESTOR_I_526 = "USCIS_DEPENDENT_EB_5_INVESTOR_I_526",
  USCIS_DEPENDENT_EB_5_INVESTOR_I_829 = "USCIS_DEPENDENT_EB_5_INVESTOR_I_829",
  USCIS_DEPENDENT_F_1 = "USCIS_DEPENDENT_F_1",
  USCIS_DEPENDENT_F_2 = "USCIS_DEPENDENT_F_2",
  USCIS_DEPENDENT_I_130 = "USCIS_DEPENDENT_I_130",
  USCIS_DEPENDENT_I_140 = "USCIS_DEPENDENT_I_140",
  USCIS_DEPENDENT_I_751 = "USCIS_DEPENDENT_I_751",
  USCIS_DEPENDENT_INTENATIONAL_ENTREPRENEUR_PAROLE_DEPENDENT = "USCIS_DEPENDENT_INTENATIONAL_ENTREPRENEUR_PAROLE_DEPENDENT",
  USCIS_DEPENDENT_J_2 = "USCIS_DEPENDENT_J_2",
  USCIS_DEPENDENT_K_1 = "USCIS_DEPENDENT_K_1",
  USCIS_DEPENDENT_L_2 = "USCIS_DEPENDENT_L_2",
  USCIS_DEPENDENT_N_400_CITIZENSHIP = "USCIS_DEPENDENT_N_400_CITIZENSHIP",
  USCIS_DEPENDENT_O_3 = "USCIS_DEPENDENT_O_3",
  USCIS_DEPENDENT_P_4 = "USCIS_DEPENDENT_P_4",
  USCIS_DEPENDENT_Q_2 = "USCIS_DEPENDENT_Q_2",
  USCIS_DEPENDENT_REENTRY_PERMIT = "USCIS_DEPENDENT_REENTRY_PERMIT",
  USCIS_DEPENDENT_R_2 = "USCIS_DEPENDENT_R_2",
  USCIS_DEPENDENT_TEMPORARY_PROTECTED_STATUS = "USCIS_DEPENDENT_TEMPORARY_PROTECTED_STATUS",
  H_1B_LOTTERY_CHANGE_OF_STATUS = "H_1B_LOTTERY_CHANGE_OF_STATUS",
  H_1B_LOTTERY_CONSULAR_NOTIFICATION = "H_1B_LOTTERY_CONSULAR_NOTIFICATION",
  H_1B_LOTTERY_24_CHANGE_OF_STATUS = "H_1B_LOTTERY_24_CHANGE_OF_STATUS",
  H_1B_LOTTERY_24_CONSULAR_NOTIFICATION = "H_1B_LOTTERY_24_CONSULAR_NOTIFICATION",
  H_1B_LOTTERY_25_CHANGE_OF_STATUS = "H_1B_LOTTERY_25_CHANGE_OF_STATUS",
  H_1B_LOTTERY_25_CONSULAR_NOTIFICATION = "H_1B_LOTTERY_25_CONSULAR_NOTIFICATION",
  H_1B_LOTTERY_26_CHANGE_OF_STATUS = "H_1B_LOTTERY_26_CHANGE_OF_STATUS",
  H_1B_LOTTERY_26_CONSULAR_NOTIFICATION = "H_1B_LOTTERY_26_CONSULAR_NOTIFICATION",
  EAD_PRIMARY = "EAD_PRIMARY",
  USCIS_PRIMARY_2_ADVANCE_PAROLE = "USCIS_PRIMARY_2_ADVANCE_PAROLE",
  USCIS_PRIMARY_2_B_1 = "USCIS_PRIMARY_2_B_1",
  USCIS_PRIMARY_2_B_2 = "USCIS_PRIMARY_2_B_2",
  USCIS_PRIMARY_2_CONSULAR_PROCESSING = "USCIS_PRIMARY_2_CONSULAR_PROCESSING",
  USCIS_PRIMARY_2_EB_1A = "USCIS_PRIMARY_2_EB_1A",
  USCIS_PRIMARY_2_F_1 = "USCIS_PRIMARY_2_F_1",
  USCIS_PRIMARY_2_I_130 = "USCIS_PRIMARY_2_I_130",
  USCIS_PRIMARY_2_K_1 = "USCIS_PRIMARY_2_K_1",
  USCIS_PRIMARY_2_I_485J = "USCIS_PRIMARY_2_I_485J",
  USCIS_PRIMARY_2_NATIONAL_INTEREST_WAIVER = "USCIS_PRIMARY_2_NATIONAL_INTEREST_WAIVER",
  USCIS_PRIMARY_2_N_400 = "USCIS_PRIMARY_2_N_400",
  USCIS_PRIMARY_2_O_1 = "USCIS_PRIMARY_2_O_1",
  USCIS_PRIMARY_2_RE_ENTRY_PERMIT = "USCIS_PRIMARY_2_RE_ENTRY_PERMIT",
  USCIS_PRIMARY_2_U = "USCIS_PRIMARY_2_U",
  H_1B_LOTTERY_MASTERS = "H_1B_LOTTERY_MASTERS",
  GLOBAL_PROCESS = "GLOBAL_PROCESS",
}


export enum VisaAdditionalProcessing {
  EAD = "EAD",
  AP = "AP",
}


export enum GlobalProcessDuration {
  SHORT_TERM_BUSINESS_VISA = "SHORT_TERM_BUSINESS_VISA",
  LONG_TERM_EMPLOYMENT = "LONG_TERM_EMPLOYMENT",
}


export enum GlobalVisaType {
  BUSINESS = "BUSINESS",
  TOURIST = "TOURIST",
  CONFERENCE = "CONFERENCE",
}


export type Vendor = {
  __typename: "Vendor",
  id: string,
  name: string,
  type: VendorType,
  location?: string | null,
  email?: string | null,
  lowerName?: string | null,
  processRequests?: ModelProcessRequestConnection | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export enum VendorType {
  COMPANY = "COMPANY",
  CO_COUNSEL = "CO_COUNSEL",
}


export enum ProcessRequestState {
  REQUESTED = "REQUESTED",
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
}


export type ModelTaskConnection = {
  __typename: "ModelTaskConnection",
  items:  Array<Task | null >,
  nextToken?: string | null,
};

export type Task = {
  __typename: "Task",
  id: string,
  action: string,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  paymentStatusAlternateAction?: string | null,
  assignedToID?: string | null,
  isAssignedToLegalAssistants?: boolean | null,
  assignedToEmployerID?: string | null,
  assignedToForeignNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  assignedToEmployer?: Employer | null,
  assignedToForeignNational?: ForeignNational | null,
  assignedToTeamMember?: TeamMember | null,
  caseID: string,
  case: Case,
  caseState?: CaseState | null,
  category: TaskCategory,
  companyID?: string | null,
  company?: Company | null,
  comments?: ModelCommentConnection | null,
  completeDate?: string | null,
  deadline: string,
  deadlineIsManuallySet?: boolean | null,
  deleteDate?: string | null,
  deleteReason?: string | null,
  dependencies?: ModelTaskConnection | null,
  description?: string | null,
  duration?: number | null,
  foreignNationalID: string,
  foreignNational?: ForeignNational | null,
  groupsCanRead?: Array< string > | null,
  isCustom?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  prerequisite?: Task | null,
  prerequisiteID?: string | null,
  startDate: string,
  state: TaskState,
  templateID?: string | null,
  assigneeLowerName?: string | null,
  attorneyLowerFirstName?: string | null,
  attorneyLowerName?: string | null,
  paralegalLowerName?: string | null,
  paralegalLowerFirstName?: string | null,
  companyLowerName?: string | null,
  nationalLowerName?: string | null,
  orderIndex?: number | null,
  defaultAssignee?: string | null,
  createdAt: string,
  updatedAt: string,
  foreignNationalTasksId?: string | null,
  employerTasksId?: string | null,
};

export enum TaskCategory {
  OPENING_CASE = "OPENING_CASE",
  LCA_FILING = "LCA_FILING",
  PUBLIC_ACCESS_FILE = "PUBLIC_ACCESS_FILE",
  PREPARING_MATERIALS = "PREPARING_MATERIALS",
  APPLICATION_REVIEW = "APPLICATION_REVIEW",
  SUBMITTING_APPLICATION = "SUBMITTING_APPLICATION",
  RECEIPT_BY_GOVERNMENT = "RECEIPT_BY_GOVERNMENT",
  PREMIUM_PROCESSING_UPGRADE = "PREMIUM_PROCESSING_UPGRADE",
  REQUEST_FOR_EVIDENCE = "REQUEST_FOR_EVIDENCE",
  FINAL_DECISION = "FINAL_DECISION",
  OPENING_PERM_CASE = "OPENING_PERM_CASE",
  FINALIZE_JOB_DESCRIPTION = "FINALIZE_JOB_DESCRIPTION",
  EXPERIENCE_LETTERS = "EXPERIENCE_LETTERS",
  PREVAILING_WAGE_REQUEST = "PREVAILING_WAGE_REQUEST",
  RECRUITMENT = "RECRUITMENT",
  PERM_SUBMISSION = "PERM_SUBMISSION",
  DOL_AUDIT = "DOL_AUDIT",
  PERM_CERTIFICATION = "PERM_CERTIFICATION",
  REQUEST_FOR_RECONSIDERATION = "REQUEST_FOR_RECONSIDERATION",
  OPENING_I40_CASE = "OPENING_I40_CASE",
  CONSULAR_PROCESS = "CONSULAR_PROCESS",
  CBP_APPLICATION_PROCESS = "CBP_APPLICATION_PROCESS",
  MEDICAL_EXAM = "MEDICAL_EXAM",
  I_485J_PROCESS = "I_485J_PROCESS",
  BIOMETRICS = "BIOMETRICS",
  USCIS_INTERVIEW = "USCIS_INTERVIEW",
  LOTTERY_PROCESS = "LOTTERY_PROCESS",
  NEW_USCIS_ACCOUNT = "NEW_USCIS_ACCOUNT",
  PUBLIC_ACCESS_FILE_HIDDEN = "PUBLIC_ACCESS_FILE_HIDDEN",
  LCA_FILING_HIDDEN = "LCA_FILING_HIDDEN",
  PREPARING_MATERIALS_HIDDEN = "PREPARING_MATERIALS_HIDDEN",
  APPLICATION_REVIEW_HIDDEN = "APPLICATION_REVIEW_HIDDEN",
  SUBMITTING_APPLICATION_HIDDEN = "SUBMITTING_APPLICATION_HIDDEN",
  RECEIPT_BY_GOVERNMENT_HIDDEN = "RECEIPT_BY_GOVERNMENT_HIDDEN",
  FINAL_DECISION_HIDDEN = "FINAL_DECISION_HIDDEN",
}


export type ModelCommentConnection = {
  __typename: "ModelCommentConnection",
  items:  Array<Comment | null >,
  nextToken?: string | null,
};

export type Comment = {
  __typename: "Comment",
  createdAt?: string | null,
  authorID: string,
  authorEmployerID?: string | null,
  authorForeignNationalID?: string | null,
  authorTeamMemberID?: string | null,
  authorEmployer?: Employer | null,
  authorForeignNational?: ForeignNational | null,
  authorTeamMember?: TeamMember | null,
  note?: string | null,
  sourceID: string,
  id: string,
  updatedAt: string,
  owner?: string | null,
};

export enum TaskState {
  HIDDEN = "HIDDEN",
  LOCKED = "LOCKED",
  TODO = "TODO",
  COMPLETED = "COMPLETED",
  DELETED = "DELETED",
}


export type LoginStatus = {
  __typename: "LoginStatus",
  isEnabled?: boolean | null,
  status?: UserStatus | null,
};

export enum UserStatus {
  UNCONFIRMED = "UNCONFIRMED",
  CONFIRMED = "CONFIRMED",
  ARCHIVED = "ARCHIVED",
  COMPROMISED = "COMPROMISED",
  UNKNOWN = "UNKNOWN",
  RESET_REQUIRED = "RESET_REQUIRED",
  FORCE_CHANGE_PASSWORD = "FORCE_CHANGE_PASSWORD",
}


export type ModelCustomTemplateConnection = {
  __typename: "ModelCustomTemplateConnection",
  items:  Array<CustomTemplate | null >,
  nextToken?: string | null,
};

export type CustomTemplate = {
  __typename: "CustomTemplate",
  id: string,
  teamMemberId?: string | null,
  teamMember?: TeamMember | null,
  employerID?: string | null,
  employer?: Employer | null,
  reports?: ModelReportConnection | null,
  templateReports?: ModelReportConnection | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  name: string,
  selectedFields?: string | null,
  includeFN?: boolean | null,
  individualFNCase?: boolean | null,
  includeCases?: boolean | null,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  type?: TemplateType | null,
  category?: TemplateCategory | null,
  isDeleted?: boolean | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  accessibleCompanyIds?: Array< string | null > | null,
  companyIds?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReportConnection = {
  __typename: "ModelReportConnection",
  items:  Array<Report | null >,
  nextToken?: string | null,
};

export type Report = {
  __typename: "Report",
  id: string,
  templateID: string,
  template?: CustomTemplate | null,
  customTemplate: CustomTemplate,
  reportEntries?: ModelReportEntriesConnection | null,
  companyIds?: Array< string | null > | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  type?: TemplateType | null,
  name: string,
  status: ReportStatus,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  fromTemplate?: boolean | null,
  totalCountCycle?: number | null,
  completedCountCycle?: number | null,
  isCurrent?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReportEntriesConnection = {
  __typename: "ModelReportEntriesConnection",
  items:  Array<ReportEntries | null >,
  nextToken?: string | null,
};

export type ReportEntries = {
  __typename: "ReportEntries",
  id: string,
  reportID: string,
  report?: Report | null,
  companyID?: string | null,
  company?: Company | null,
  foreignNationalID?: string | null,
  foreignNational?: ForeignNational | null,
  fullname?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  middlename?: string | null,
  archived?: string | null,
  email?: string | null,
  personalEmail?: string | null,
  birthDate?: string | null,
  numberOfDependents?: number | null,
  numberOfFamilyContacts?: number | null,
  displayCompanyName?: string | null,
  companyLegalName?: string | null,
  companyFullName?: string | null,
  sponsoringCompanyFullName?: string | null,
  companyDbaName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  birthCountryCode?: string | null,
  citizenshipCountry?: Array< string | null > | null,
  chargeabilityCountry?: string | null,
  passportExpirationDate?: string | null,
  nivMaxout?: string | null,
  visaExpDate?: string | null,
  hasApprovedI140?: boolean | null,
  petitionerI140?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  fnJobTitle?: string | null,
  socCode?: string | null,
  caseSocCode?: string | null,
  fnSalary?: string | null,
  startDate?: string | null,
  fnWorkLocation?: string | null,
  addressPrimary?: string | null,
  addressSecondary?: string | null,
  usResidentialAddress?: string | null,
  lastProcessType?: string | null,
  currentProcessType?: string | null,
  lowerProcessType?: string | null,
  lastPhaseCompleted?: string | null,
  currentPhase?: string | null,
  capType?: string | null,
  eadExpDate?: string | null,
  I797ApprovalExpDate?: string | null,
  I94ExpDate?: string | null,
  I94DS?: string | null,
  greenCardExpDate?: string | null,
  prevailingWageExpDate?: string | null,
  citizenshipEligibilityDate?: string | null,
  rfeDueDate?: string | null,
  dolAuditDueDate?: string | null,
  pwdExpDate?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  agreementExpDate?: string | null,
  agreementEffectiveDate?: string | null,
  mswsowExpDate?: string | null,
  permDueDate?: string | null,
  lotterySelectionDueDate?: string | null,
  advancedParoleExpDate?: string | null,
  reEntryPermitExpDate?: string | null,
  certifiedLcaExpDate?: string | null,
  title?: string | null,
  notes?: string | null,
  DS2019ExpDate?: string | null,
  isRelative?: boolean | null,
  relativeIds?: Array< string | null > | null,
  nextPhase?: string | null,
  requestedProcessSubCategory?: string | null,
  fnNameSlug?: string | null,
  caseSlug?: string | null,
  companyNameSlug?: string | null,
  employerNameSlug?: string | null,
  inviteStatus?: string | null,
  passportNumber?: string | null,
  phoneNumber?: string | null,
  personalPhone?: string | null,
  faxNumber?: string | null,
  passportGender?: string | null,
  preferredMailingAddress?: string | null,
  onboardingSections?: boolean | null,
  lastEntryUS?: string | null,
  employeeId?: string | null,
  caseNumber?: string | null,
  requestedProcess?: string | null,
  attorneyID?: string | null,
  caseAttorney?: string | null,
  sponsoringEmployerID?: string | null,
  sponsoringNationalID?: string | null,
  caseSponsor?: string | null,
  caseSponsorId?: string | null,
  caseManagerID?: string | null,
  caseManager?: string | null,
  contributorIds?: Array< string | null > | null,
  caseContributors?: Array< string | null > | null,
  caseStartDate?: string | null,
  caseOpenDate?: string | null,
  caseSalary?: string | null,
  state?: string | null,
  workLocation?: string | null,
  keyFilingDates?: string | null,
  lcaFiled?: string | null,
  capGap?: string | null,
  visaAdditionalProcessing?: Array< string | null > | null,
  stemExtEligible?: string | null,
  educationEvaluationNeeded?: string | null,
  wageIssues?: string | null,
  selection?: string | null,
  caseNature?: string | null,
  registrationCompleted?: string | null,
  receiptNumber?: string | null,
  currentCaseStatusText?: string | null,
  modifiedDate?: string | null,
  incompleteUscisReceiptNumber?: boolean | null,
  caseStatusHistory?: string | null,
  companyAttorneys?: Array< string | null > | null,
  companyAttorneyIds?: Array< string | null > | null,
  companyParalegals?: Array< string | null > | null,
  companyParalegalIds?: Array< string | null > | null,
  companyTotalCases?: string | null,
  companyTotalOpenCases?: string | null,
  companyTotalClosedCases?: string | null,
  companyTotalCompletedCases?: string | null,
  companyNationalCount?: string | null,
  fullTimeEmployeesInUS?: string | null,
  partTimeEmployeesInUS?: string | null,
  companyActiveNationalCount?: string | null,
  grossRevenueForMostRecentFiscalYear?: string | null,
  netRevenueForMostRecentFiscalYear?: string | null,
  naicsCodeOfCompany?: string | null,
  typeOfBusiness?: string | null,
  fein?: string | null,
  yearCompanyWasFoundedInUS?: string | null,
  aosFilingEligible?: string | null,
  requiresMeetingReminder?: boolean | null,
  isParent?: boolean | null,
  isPartnerCompany?: boolean | null,
  companyWhitelistedDomains?: Array< string | null > | null,
  companyContactLabel?: Array< string | null > | null,
  annualMeetingDate?: string | null,
  emCompanyNames?: Array< string | null > | null,
  emCompanyNameSlugs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum AccessPermission {
  ONLY_ME = "ONLY_ME",
  TEAM_AND_SELECTED_COMPANIES = "TEAM_AND_SELECTED_COMPANIES",
  TEAM_AND_ALL_COMPANIES = "TEAM_AND_ALL_COMPANIES",
  UNSET = "UNSET",
}


export enum EditPermission {
  ONLY_MH_ADMINS = "ONLY_MH_ADMINS",
  ONLY_MH_TEAM = "ONLY_MH_TEAM",
  TEAM_AND_ALL_SELECTED_COMPANIES = "TEAM_AND_ALL_SELECTED_COMPANIES",
  ONLY_ME = "ONLY_ME",
  UNSET = "UNSET",
}


export enum TemplateType {
  CUSTOM = "CUSTOM",
  STANDARD = "STANDARD",
}


export enum ReportStatus {
  IN_PROGRESS = "IN_PROGRESS",
  FAIL = "FAIL",
  COMPLETE = "COMPLETE",
  IN_COMPLETE = "IN_COMPLETE",
}


export enum TemplateCategory {
  ForeignNational = "ForeignNational",
  Case = "Case",
  Company = "Company",
  Employer = "Employer",
}


export type CaseComplianceList = {
  __typename: "CaseComplianceList",
  id: string,
  caseID?: string | null,
  case?: Case | null,
  educationEvaluationNeeded?: ComplianceCheckList | null,
  stemExtEligible?: ComplianceCheckList | null,
  capGap?: ComplianceCheckList | null,
  wageIssues?: ComplianceCheckList | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum ComplianceCheckList {
  YES = "YES",
  NO = "NO",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}


export type PERMFilingData = {
  __typename: "PERMFilingData",
  id: string,
  caseID?: string | null,
  case?: Case | null,
  PERMFirstPossibleFilingDate?: string | null,
  PERMLastPossibleFilingDate?: string | null,
  applicantsReceived?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type FileRequirement = {
  __typename: "FileRequirement",
  type: FileType,
  fileType?: string | null,
  fileCategory?: string | null,
  fileInstruction?: string | null,
  defaultStorage?: string | null,
  visibility?: Array< Role | null > | null,
  assignedToID?: string | null,
  isAssignedToLegalAssistants?: boolean | null,
  expirationDateRequired?: boolean | null,
  issueDateRequired?: boolean | null,
  dueDateRequired?: boolean | null,
  isApproved?: boolean | null,
  isRequested?: boolean | null,
  hidden?: boolean | null,
  durationOfStatus?: boolean | null,
};

export enum Role {
  TEAMMEMBER = "TEAMMEMBER",
  ADMIN = "ADMIN",
  FOREIGNNATIONAL = "FOREIGNNATIONAL",
  EMPLOYER = "EMPLOYER",
}


export enum CasePhase {
  APPLICATION_SUBMISSION = "APPLICATION_SUBMISSION",
  CASE_OPENING = "CASE_OPENING",
  CASE_PREPARATION = "CASE_PREPARATION",
  DATA_COLLECTION = "DATA_COLLECTION",
  FILE_I140 = "FILE_I140",
  FILE_PREVAILING_WAGE_REQUEST = "FILE_PREVAILING_WAGE_REQUEST",
  FINAL_DECISION = "FINAL_DECISION",
  FORMS_PREPARATION = "FORMS_PREPARATION",
  I140_PREPARATION = "I140_PREPARATION",
  LCA_FILING = "LCA_FILING",
  NEXT_STEPS = "NEXT_STEPS",
  PERM_SUBMISSION = "PERM_SUBMISSION",
  RECRUITMENT = "RECRUITMENT",
  DS_160_SUBMISSION = "DS_160_SUBMISSION",
  CONSULAR_PREPARATION = "CONSULAR_PREPARATION",
  AWAITING_RECEIPT = "AWAITING_RECEIPT",
  CBP_PREPARATION = "CBP_PREPARATION",
  LOTTERY_SUBMISSION = "LOTTERY_SUBMISSION",
  LOTTERY_DECISION = "LOTTERY_DECISION",
}


export type CasePhaseRequirement = {
  __typename: "CasePhaseRequirement",
  phase: CasePhase,
  milestones: Array< CaseMilestone >,
};

export enum CaseMilestone {
  APPLICATION_DECISION = "APPLICATION_DECISION",
  APPLICATION_SHIPPED = "APPLICATION_SHIPPED",
  APPROVAL_NOTICE_SHIPPED = "APPROVAL_NOTICE_SHIPPED",
  CASE_OPENED = "CASE_OPENED",
  DOCUMENTS_UPLOADED = "DOCUMENTS_UPLOADED",
  EXPERIENCE_LETTERS_UPLOADED = "EXPERIENCE_LETTERS_UPLOADED",
  FINAL_DECISION = "FINAL_DECISION",
  FORMS_COMPLETED = "FORMS_COMPLETED",
  FORMS_PREPARED = "FORMS_PREPARED",
  I140_APPLICATION_SHIPPED = "I140_APPLICATION_SHIPPED",
  I140_CASE_OPENING = "I140_CASE_OPENING",
  I140_FORMS_PREPARED = "I140_FORMS_PREPARED",
  I140_RECEIPT_NOTICE_RECEIVED = "I140_RECEIPT_NOTICE_RECEIVED",
  JOB_DESCRIPTION_FINALIZED = "JOB_DESCRIPTION_FINALIZED",
  LCA_FILED = "LCA_FILED",
  LCA_RECEIVED = "LCA_RECEIVED",
  NEXT_STEPS = "NEXT_STEPS",
  PERM_CERTIFIED = "PERM_CERTIFIED",
  PERM_PREPARED = "PERM_PREPARED",
  PERM_REVIEWED = "PERM_REVIEWED",
  PERM_SUBMITED = "PERM_SUBMITED",
  PREVAILING_WAGE_DETERMINATION_RECEIVED = "PREVAILING_WAGE_DETERMINATION_RECEIVED",
  PREVAILING_WAGE_REQUEST_FILED = "PREVAILING_WAGE_REQUEST_FILED",
  QUESTIONNAIRE_COMPLETED = "QUESTIONNAIRE_COMPLETED",
  RECEIPT_NOTICE_RECEIVED = "RECEIPT_NOTICE_RECEIVED",
  RECRUITMENT_BEGUN = "RECRUITMENT_BEGUN",
  RECRUITMENT_COMPLETE = "RECRUITMENT_COMPLETE",
  PREPARE_DS_160 = "PREPARE_DS_160",
  COMPLETE_DS_160 = "COMPLETE_DS_160",
  MH_PREP_PHONE_CALL = "MH_PREP_PHONE_CALL",
  INVOICE_PAID = "INVOICE_PAID",
  SHIP_EAD_AND_ADVANCE_PAROLE_DOCUMENTS = "SHIP_EAD_AND_ADVANCE_PAROLE_DOCUMENTS",
  SHIP_GREEN_CARD_AND_DECISION = "SHIP_GREEN_CARD_AND_DECISION",
  USCIS_DECISION = "USCIS_DECISION",
  FORMS_SHIPPED = "FORMS_SHIPPED",
  SHIP_DECISION_NOTICE = "SHIP_DECISION_NOTICE",
  LOTTERY_PREPARATION = "LOTTERY_PREPARATION",
  LOTTERY_SUBMISSION = "LOTTERY_SUBMISSION",
  LOTTERY_DECISION = "LOTTERY_DECISION",
  LOTTERY_NOTIFICATION = "LOTTERY_NOTIFICATION",
  SHIPMENT_APPROVAL_NOTICE = "SHIPMENT_APPROVAL_NOTICE",
}


export type CompletedCaseMilestone = {
  __typename: "CompletedCaseMilestone",
  completionDate?: string | null,
  completedByID: string,
  milestone: CaseMilestone,
  receiptNumber?: string | null,
};

export type ModelPreparedFormConnection = {
  __typename: "ModelPreparedFormConnection",
  items:  Array<PreparedForm | null >,
  nextToken?: string | null,
};

export type PreparedForm = {
  __typename: "PreparedForm",
  id: string,
  caseID?: string | null,
  case?: Case | null,
  companyID?: string | null,
  foreignNationalID: string,
  foreignNational?: ForeignNational | null,
  relativeAdmins?: Array< string > | null,
  state: PreparedFormState,
  preparerID?: string | null,
  preparer?: TeamMember | null,
  templateID?: string | null,
  template?: PreparedFormTemplate | null,
  completedFormID?: string | null,
  completedForm?: FileData | null,
  completedFormHistory?: ModelFileDataConnection | null,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  assignedToEmployer?: Employer | null,
  assignedToNational?: ForeignNational | null,
  assignedToTeamMember?: TeamMember | null,
  rejectedDate?: string | null,
  rejectedByID?: string | null,
  rejectedByEmployerID?: string | null,
  rejectedByNationalID?: string | null,
  rejectedByTeamMemberID?: string | null,
  rejectedByEmployer?: Employer | null,
  rejectedByNational?: ForeignNational | null,
  rejectedByTeamMember?: TeamMember | null,
  requiresAttorneyApproval?: boolean | null,
  attorneyApproverID?: string | null,
  attorneyApprover?: TeamMember | null,
  attorneyApprovalDate?: string | null,
  requiresSponsorApproval?: boolean | null,
  sponsorApproverID?: string | null,
  sponsorApproverEmployerID?: string | null,
  sponsorApproverNationalID?: string | null,
  sponsorApproverEmployer?: Employer | null,
  sponsorApproverNational?: ForeignNational | null,
  sponsorApprovalDate?: string | null,
  requiresNationalApproval?: boolean | null,
  nationalApproverID?: string | null,
  nationalApprover?: ForeignNational | null,
  nationalApprovalDate?: string | null,
  finalCaseManagerApproverID?: string | null,
  finalCaseManagerApprover?: TeamMember | null,
  finalCaseManagerApprovalDate?: string | null,
  employersCanView?: boolean | null,
  nationalsCanView?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  comments?: ModelCommentConnection | null,
  activities?: ModelActivityConnection | null,
};

export enum PreparedFormState {
  TODO = "TODO",
  PREPARED = "PREPARED",
  AWAITING_ATTORNEY_APPROVAL = "AWAITING_ATTORNEY_APPROVAL",
  AWAITING_NATIONAL_APPROVAL = "AWAITING_NATIONAL_APPROVAL",
  AWAITING_SPONSOR_APPROVAL = "AWAITING_SPONSOR_APPROVAL",
  AWAITING_FINAL_APPROVAL = "AWAITING_FINAL_APPROVAL",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
}


export type PreparedFormTemplate = {
  __typename: "PreparedFormTemplate",
  id: string,
  file: S3Object,
  name: string,
  processes?: Array< VisaStatus > | null,
  archived?: boolean | null,
  updatedAt: string,
  requiresAttorneyApproval?: boolean | null,
  requiresSponsorApproval?: boolean | null,
  requiresNationalApproval?: boolean | null,
  employersCanView?: boolean | null,
  nationalsCanView?: boolean | null,
};

export type ModelActivityConnection = {
  __typename: "ModelActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
};

export type Activity = {
  __typename: "Activity",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  activityType: ActivityType,
  ipAddress?: string | null,
  fieldName?: string | null,
  updatedValue?: string | null,
  actorID: string,
  actorEmployerID?: string | null,
  actorForeignNationalID?: string | null,
  actorTeamMemberID?: string | null,
  actorType?: PersonType | null,
  actorEmployer?: Employer | null,
  actorForeignNational?: ForeignNational | null,
  actorTeamMember?: TeamMember | null,
  directTargetID?: string | null,
  directTargetCaseID?: string | null,
  directTargetCompanyID?: string | null,
  directTargetEmployerID?: string | null,
  directTargetFileDataID?: string | null,
  directTargetForeignNationalID?: string | null,
  directTargetProcessRequestID?: string | null,
  directTargetTaskID?: string | null,
  directTargetTeamMemberID?: string | null,
  directTargetReportID?: string | null,
  targetString?: string | null,
  targetCase?: Case | null,
  targetCompany?: Company | null,
  targetEmployer?: Employer | null,
  targetFileData?: FileData | null,
  targetForeignNational?: ForeignNational | null,
  targetProcessRequest?: ProcessRequest | null,
  targetTask?: Task | null,
  targetTeamMember?: TeamMember | null,
  targetReport?: Report | null,
  indirectTargetID?: string | null,
  indirectTargetCaseID?: string | null,
  indirectTargetCompanyID?: string | null,
  indirectTargetEmployerID?: string | null,
  indirectTargetForeignNationalID?: string | null,
  indirectTargetProcessRequestID?: string | null,
  indirectTargetTeamMemberID?: string | null,
  indirectTargetReportID?: string | null,
  indirectTargetString?: string | null,
  indirectTargetCase?: Case | null,
  indirectTargetCompany?: Company | null,
  indirectTargetEmployer?: Employer | null,
  indirectTargetForeignNational?: ForeignNational | null,
  indirectTargetProcessRequest?: ProcessRequest | null,
  indirectTargetTeamMember?: TeamMember | null,
  indirectTargetReport?: Report | null,
  ownerID?: string | null,
  ownerCaseID?: string | null,
  ownerCompanyID?: string | null,
  ownerEmployerID?: string | null,
  ownerFileDataID?: string | null,
  ownerForeignNationalID?: string | null,
  ownerProcessRequestID?: string | null,
  ownerTeamMemberID?: string | null,
  ownerReportID?: string | null,
  ownerCase?: Case | null,
  ownerCompany?: Company | null,
  ownerEmployer?: Employer | null,
  ownerFileData?: FileData | null,
  ownerForeignNational?: ForeignNational | null,
  ownerProcessRequest?: ProcessRequest | null,
  ownerTeamMember?: TeamMember | null,
  ownerReport?: Report | null,
};

export enum ActivityType {
  DOCUMENT_EXPIRATION_INCOMING = "DOCUMENT_EXPIRATION_INCOMING",
  DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED",
  DOCUMENT_UPLOAD_REQUESTED = "DOCUMENT_UPLOAD_REQUESTED",
  DOCUMENT_TYPE_COMPLETED = "DOCUMENT_TYPE_COMPLETED",
  PROCESS_REQUEST_SUBMITTED = "PROCESS_REQUEST_SUBMITTED",
  PROCESS_REQUEST_REASSIGNED = "PROCESS_REQUEST_REASSIGNED",
  PROCESS_REQUEST_ARCHIVED = "PROCESS_REQUEST_ARCHIVED",
  PROCESS_REQUEST_APPROVED = "PROCESS_REQUEST_APPROVED",
  PROCESS_REQUEST_RESUBMITTED = "PROCESS_REQUEST_RESUBMITTED",
  CASE_COMMENT_ADDED = "CASE_COMMENT_ADDED",
  CASE_MILESTONE_COMPLETED = "CASE_MILESTONE_COMPLETED",
  CASE_MILESTONE_UNCOMPLETED = "CASE_MILESTONE_UNCOMPLETED",
  CASE_MILESTONE_RECEIPT_NUMBER_CHANGED = "CASE_MILESTONE_RECEIPT_NUMBER_CHANGED",
  CASE_FORM_PREPARED = "CASE_FORM_PREPARED",
  CASE_FORM_REJECTED = "CASE_FORM_REJECTED",
  CASE_FORM_RESET = "CASE_FORM_RESET",
  CASE_FORM_REVIEW_REQUESTED = "CASE_FORM_REVIEW_REQUESTED",
  CASE_FORM_APPROVED = "CASE_FORM_APPROVED",
  CASE_FORM_COMPLETED = "CASE_FORM_COMPLETED",
  CASE_TEAM_ATTORNEY_ADDED = "CASE_TEAM_ATTORNEY_ADDED",
  CASE_TEAM_MANAGER_ADDED = "CASE_TEAM_MANAGER_ADDED",
  CASE_TEAM_SPONSOR_ADDED = "CASE_TEAM_SPONSOR_ADDED",
  CASE_TEAM_CONTRIBUTOR_ADDED = "CASE_TEAM_CONTRIBUTOR_ADDED",
  CASE_COMPLETED = "CASE_COMPLETED",
  CASE_CLOSED = "CASE_CLOSED",
  CASE_REOPENED = "CASE_REOPENED",
  LEGAL_TEAM_ATTORNEY_ADDED = "LEGAL_TEAM_ATTORNEY_ADDED",
  LEGAL_TEAM_PARALEGAL_ADDED = "LEGAL_TEAM_PARALEGAL_ADDED",
  LEGAL_TEAM_ACCOUNT_MANAGER_ADDED = "LEGAL_TEAM_ACCOUNT_MANAGER_ADDED",
  PROFILE_QUESTIONNAIRE_COMPLETED = "PROFILE_QUESTIONNAIRE_COMPLETED",
  PROFILE_CREATED = "PROFILE_CREATED",
  TASK_ASSIGNEE_CHANGED = "TASK_ASSIGNEE_CHANGED",
  TASK_COMPLETED = "TASK_COMPLETED",
  TASK_DEADLINE_CHANGED = "TASK_DEADLINE_CHANGED",
  TASK_DELETED = "TASK_DELETED",
  TASK_LOCKED = "TASK_LOCKED",
  TASK_UNLOCKED = "TASK_UNLOCKED",
  TASK_UNCOMPLETED = "TASK_UNCOMPLETED",
  COMPANY_QUESTIONNAIRE_COMPLETED = "COMPANY_QUESTIONNAIRE_COMPLETED",
  RELATIVE_ADMIN_QUESTIONNAIRE_COMPLETED = "RELATIVE_ADMIN_QUESTIONNAIRE_COMPLETED",
  COMPANY_PROFILE_UPDATED = "COMPANY_PROFILE_UPDATED",
  PERSON_PROFILE_UPDATED = "PERSON_PROFILE_UPDATED",
  CASE_DETAIL_UPDATED = "CASE_DETAIL_UPDATED",
  FN_PROFILE_UPDATE_OPEN_CASE = "FN_PROFILE_UPDATE_OPEN_CASE",
  FN_PROFILE_UPDATE_NO_OPEN_CASE = "FN_PROFILE_UPDATE_NO_OPEN_CASE",
  COMPLETE_REPORT_MANUALLY = "COMPLETE_REPORT_MANUALLY",
  REPORT_SENT_MANUALLY = "REPORT_SENT_MANUALLY",
  AUTOMATED_REPORT_SENT = "AUTOMATED_REPORT_SENT",
  MONTHLY_MEETING_REMINDER_FOR_ANNUAL_REVIEW_MEETING = "MONTHLY_MEETING_REMINDER_FOR_ANNUAL_REVIEW_MEETING",
  USCIS_CASE_STATUS_UPDATED = "USCIS_CASE_STATUS_UPDATED",
  PASSPORT_EXPIRATION_REMINDER = "PASSPORT_EXPIRATION_REMINDER",
  DOCUMENT_FLATTENED = "DOCUMENT_FLATTENED",
  RFGP_GENERATED = "RFGP_GENERATED",
}


export type ModelUSCISReceiptDetailsConnection = {
  __typename: "ModelUSCISReceiptDetailsConnection",
  items:  Array<USCISReceiptDetails | null >,
  nextToken?: string | null,
};

export type USCISReceiptDetails = {
  __typename: "USCISReceiptDetails",
  id: string,
  caseID: string,
  receiptType: ReceiptType,
  case?: Case | null,
  receiptNumber?: string | null,
  formType?: string | null,
  submittedDate?: string | null,
  modifiedDate?: string | null,
  currentCaseStatusText?: string | null,
  currentCaseStatusDesc?: string | null,
  histCaseStatus?:  Array<HitCaseStatus > | null,
  message?: string | null,
  isActive?: boolean | null,
  isLatest?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum ReceiptType {
  AOS = "AOS",
  USCIS = "USCIS",
  I485J = "I485J",
}


export type HitCaseStatus = {
  __typename: "HitCaseStatus",
  date?: string | null,
  completedText?: string | null,
};

export type CaseShipmentTracking = {
  __typename: "CaseShipmentTracking",
  id: string,
  item?: string | null,
  date?: string | null,
  trackingNumber?: string | null,
  provider?: CaseShippingProvider | null,
};

export enum CaseShippingProvider {
  FEDEX = "FEDEX",
  UPS = "UPS",
}


export type AdditionalFields = {
  __typename: "AdditionalFields",
  id: string,
  caseID: string,
  case?: Case | null,
  fields?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type NationalOnboardingSections = {
  __typename: "NationalOnboardingSections",
  background?: boolean | null,
  contact?: boolean | null,
  employment?: boolean | null,
  family?: boolean | null,
  immigration?: boolean | null,
  personal?: boolean | null,
};

export enum MaritalStatus {
  UNMARRIED = "UNMARRIED",
  MARRIED = "MARRIED",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED",
}


export type ModelFamilyRelationshipConnection = {
  __typename: "ModelFamilyRelationshipConnection",
  items:  Array<FamilyRelationship | null >,
  nextToken?: string | null,
};

export type FamilyRelationship = {
  __typename: "FamilyRelationship",
  id: string,
  sourceID: string,
  source?: ForeignNational | null,
  targetID: string,
  target: ForeignNational,
  type?: FamilyRelationshipType | null,
  createdAt: string,
  updatedAt: string,
};

export enum FamilyRelationshipType {
  AUNT_UNCLE = "AUNT_UNCLE",
  CHILD = "CHILD",
  CHILD_IN_LAW = "CHILD_IN_LAW",
  CHILD_OF_GUARDIAN = "CHILD_OF_GUARDIAN",
  COMMON_LAW_PARTNER = "COMMON_LAW_PARTNER",
  COUSIN = "COUSIN",
  FIANCE = "FIANCE",
  GRANDCHILD = "GRANDCHILD",
  GRANDPARENT = "GRANDPARENT",
  GUARDIAN = "GUARDIAN",
  LTDP = "LTDP",
  NIECE_NEPHEW = "NIECE_NEPHEW",
  PARENT = "PARENT",
  PARENT_IN_LAW = "PARENT_IN_LAW",
  PRIOR_LTDP = "PRIOR_LTDP",
  SIBLING = "SIBLING",
  SPOUSE = "SPOUSE",
  SPOUSE_DECEASED = "SPOUSE_DECEASED",
  SPOUSE_DIVORCED = "SPOUSE_DIVORCED",
  PRIOR_SPOUSE_OF_DECEASED = "PRIOR_SPOUSE_OF_DECEASED",
  STEP_CHILD = "STEP_CHILD",
  STEP_PARENT = "STEP_PARENT",
}


export type ImmigrationStatus = {
  __typename: "ImmigrationStatus",
  status?: VisaStatus | null,
  doesNotExpire?: boolean | null,
  expiration?: string | null,
};

export type J1J2 = {
  __typename: "J1J2",
  hasHad?: boolean | null,
  start?: string | null,
  end?: string | null,
};

export type BooleanTwoPart = {
  __typename: "BooleanTwoPart",
  value?: boolean | null,
  followPrompt?: string | null,
  followValue?: boolean | null,
};

export type I140 = {
  __typename: "I140",
  hasApproved?: boolean | null,
  classification?: string | null,
  employmentBasedCategory?: EmploymentBasedCategory | null,
  priorityDate?: string | null,
  petitionerI140?: string | null,
};

export enum EmploymentBasedCategory {
  EB_1 = "EB_1",
  EB_2 = "EB_2",
  EB_3 = "EB_3",
  EB_4 = "EB_4",
  EB_5_NON_REGIONAL_CENTER = "EB_5_NON_REGIONAL_CENTER",
  EB_5_REGIONAL_CENTER = "EB_5_REGIONAL_CENTER",
  EB_5_SET_ASIDE = "EB_5_SET_ASIDE",
  EB_OTHER_WORKERS = "EB_OTHER_WORKERS",
  EB_CERTAIN_RELIGIOUS_WORKERS = "EB_CERTAIN_RELIGIOUS_WORKERS",
  SPOUSE_OF_US_CITIZEN = "SPOUSE_OF_US_CITIZEN",
  PARENT_OF_US_CITIZEN = "PARENT_OF_US_CITIZEN",
  F_1 = "F_1",
  F_2A = "F_2A",
  F_2B = "F_2B",
  F_3 = "F_3",
  F_4 = "F_4",
  REFUGEE_OR_ASYLEE = "REFUGEE_OR_ASYLEE",
  DIVERSITY = "DIVERSITY",
  SPECIAL_IMMIGRANT = "SPECIAL_IMMIGRANT",
  HUMAN_TRAFFICKING_AND_CRIME_VICTIM = "HUMAN_TRAFFICKING_AND_CRIME_VICTIM",
  VICTIM_OF_ABUSE = "VICTIM_OF_ABUSE",
}


export enum AOSFilingEligibility {
  YES = "YES",
  NO = "NO",
  UNDETERMINED = "UNDETERMINED",
}


export type CriminalHistory = {
  __typename: "CriminalHistory",
  tortureGenocide?: boolean | null,
  killing?: boolean | null,
  severeInjuring?: boolean | null,
  nonconsensualSex?: boolean | null,
  religiousBelief?: boolean | null,
};

export type BooleanExplain = {
  __typename: "BooleanExplain",
  value?: boolean | null,
  reason?: string | null,
};

export enum PassportGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}


export type CompanyData = {
  __typename: "CompanyData",
  id: string,
  companyID?: string | null,
  addressPrimary?: StreetAddress | null,
  addressSecondary?: StreetAddress | null,
  allowsEmployeesToTelecommute?: BooleanThreePart | null,
  preferredMailingAddress?: CompanyAddressType | null,
  companyNameShowToFN?: CompanyNameShowToFN | null,
  companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
  doingBusinessAs?: string | null,
  educationEvaluation?: EducationEvaluation | null,
  employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
  fein?: string | null,
  fullTimeEmployeesInUS?: number | null,
  grossRevenueForMostRecentFiscalYear?: Money | null,
  isH1BDependentEmloyer?: boolean | null,
  hasBeenWillfulViolator?: boolean | null,
  employs50OrMore?: BooleanTwoPart | null,
  isHigherEd_20_USC_1001_a?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
  isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
  maintainsAWrittenImmigrationPolicy?: boolean | null,
  naicsCodeOfCompany?: string | null,
  netRevenueForMostRecentFiscalYear?: Money | null,
  partTimeEmployeesInUS?: number | null,
  paymentPreference?: PaymentPreference | null,
  permissionPowerAttorney?: CompanyEmployee | null,
  permissionReleaseApprovalNotices?: boolean | null,
  permissionReleasePetitionsRFE?: boolean | null,
  permissionReleaseLCA?: boolean | null,
  permissionRelease9089?: boolean | null,
  phone?: string | null,
  placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
  preferenceForEmployeesToPayPartOfGreenCard?: BooleanExplain | null,
  preferenceForEmployeesToPayPartOfH1B?: BooleanExplain | null,
  fax?: string | null,
  preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
  shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
  shippingPreference?: ShippingPreference | null,
  staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
  typeOfBusiness?: string | null,
  usesWageSurvey?: boolean | null,
  usesApplicantTrackingSystem?: BooleanExplain | null,
  usesHRSSystem?: BooleanExplain | null,
  usesEVerify?: boolean | null,
  utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
  technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
  yearCompanyWasFoundedInUS?: string | null,
  I9_audit_has_been_completed_in_past_18_months?: boolean | null,
  current_number_of_H1B_employees?: string | null,
  current_number_of_employees_on_L_visas?: string | null,
  other_visa_statuses_sponsored?: string | null,
  email_address_invoices_should_be_addressed_to?: string | null,
  name_invoices_should_be_addressed_to?: string | null,
  companyCoversExpenseOfDependentPetitions?: boolean | null,
  placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
  annualMeetingDate?: string | null,
  requiresMeetingReminder?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type BooleanThreePart = {
  __typename: "BooleanThreePart",
  value?: boolean | null,
  followPrompt?: string | null,
  followValue?: boolean | null,
  followPromptSecond?: string | null,
  followValueSecond?: boolean | null,
};

export enum CompanyNameShowToFN {
  LEGAL_NAME_OF_US_COMPANY = "LEGAL_NAME_OF_US_COMPANY",
  DOING_BUSINESS_AS = "DOING_BUSINESS_AS",
}


export enum EducationEvaluation {
  MH_SHOULD_GET = "MH_SHOULD_GET",
  MH_SHOULD_REACH_OUT = "MH_SHOULD_REACH_OUT",
  COMPANY_WILL_PROVIDE = "COMPANY_WILL_PROVIDE",
}


export enum EmployeesEmailContactDirectly {
  A_COMPANY_REPRESENTATIVE_SHOULD_BE_COPIED_ON_ALL_COMMUNICATION = "A_COMPANY_REPRESENTATIVE_SHOULD_BE_COPIED_ON_ALL_COMMUNICATION",
  A_COMPANY_REPRESENTATIVE_WILL_ONLY_BE_COPIED_ON_INFORMATION_IMPACTING_THE_COMPANY_BUT_WILL_BE_LEFT_OFF_ON_COMMUNICATION_THAT_DOES_NOT_IMPACT_THE_COMPANY = "A_COMPANY_REPRESENTATIVE_WILL_ONLY_BE_COPIED_ON_INFORMATION_IMPACTING_THE_COMPANY_BUT_WILL_BE_LEFT_OFF_ON_COMMUNICATION_THAT_DOES_NOT_IMPACT_THE_COMPANY",
  TRUE = "TRUE",
  COMPANY_REPRESENTATIVE_COPIED = "COMPANY_REPRESENTATIVE_COPIED",
  FALSE = "FALSE",
}


export enum PaymentPreference {
  CHECK = "CHECK",
  ACH = "ACH",
  CREDIT_CARD = "CREDIT_CARD",
}


export enum CompanyEmployee {
  COMPANY = "COMPANY",
  EMPLOYEE = "EMPLOYEE",
}


export enum PreferredShippingSpeedForDocuments {
  OVERNIGHT = "OVERNIGHT",
  TWO_DAYS = "TWO_DAYS",
  SAVER = "SAVER",
}


export enum ShipOriginalApprovalNotices {
  COMPANY = "COMPANY",
  EMPLOYEE = "EMPLOYEE",
  HOLD = "HOLD",
}


export type ShippingPreference = {
  __typename: "ShippingPreference",
  preference?: ShippingPaymentPreference | null,
  fedexAccount?: string | null,
  upsAccount?: string | null,
};

export enum ShippingPaymentPreference {
  FEDEX = "FEDEX",
  MH = "MH",
}


export enum UtilizePremiumProcessingService {
  ALWAYS_PAID = "ALWAYS_PAID",
  CASE_BY_CASE = "CASE_BY_CASE",
  PAID_BY_EMPLOYEE = "PAID_BY_EMPLOYEE",
}


export enum TechnologyReleaseLicenseRequirement {
  REQUIRED = "REQUIRED",
  NON_REQUIRED = "NON_REQUIRED",
}


export type ModelJobDescriptionConnection = {
  __typename: "ModelJobDescriptionConnection",
  items:  Array<JobDescription | null >,
  nextToken?: string | null,
};

export type UpdateCompanyInput = {
  id: string,
  name?: string | null,
  lowerName?: string | null,
  lowerNameKey?: string | null,
  displayCompanyName?: string | null,
  slug?: string | null,
  type?: CompanyType | null,
  logo?: PictureInput | null,
  domainWhitelist?: Array< string > | null,
  onboardingSections?: CompanyOnboardingSectionsInput | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  completedOnboardingQuestionsBy?: string | null,
  isPartnerCompany?: boolean | null,
  isParent?: boolean | null,
  parentID?: string | null,
  archived?: ArchivedState | null,
  companyNumber?: number | null,
  nationalCount?: number | null,
  accountManagerID?: string | null,
  fileRequirements?: Array< FileRequirementInput > | null,
  openCaseCount?: number | null,
  closedCaseCount?: number | null,
  completedCaseCount?: number | null,
  legalTeamIDs?: Array< string > | null,
  notes?: string | null,
  petitionerParagraph?: string | null,
  companyDataId?: string | null,
};

export type PictureInput = {
  original: S3ObjectInput,
  square?: S3ObjectInput | null,
  squareThumbnails?: Array< ThumbnailInput > | null,
  thumbnails?: Array< ThumbnailInput > | null,
  version: number,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
  level?: S3Level | null,
  identityId?: string | null,
};

export type ThumbnailInput = {
  image: S3ObjectInput,
  size: number,
};

export type CompanyOnboardingSectionsInput = {
  companyInfo?: boolean | null,
  contactInfo?: boolean | null,
  companyPreferences?: boolean | null,
  immigrationPreferences?: boolean | null,
  paymentPreferences?: boolean | null,
  questions?: boolean | null,
  employeeInformation?: boolean | null,
};

export type FileRequirementInput = {
  type: FileType,
  fileType?: string | null,
  fileCategory?: string | null,
  fileInstruction?: string | null,
  defaultStorage?: string | null,
  visibility?: Array< Role | null > | null,
  assignedToID?: string | null,
  isAssignedToLegalAssistants?: boolean | null,
  expirationDateRequired?: boolean | null,
  issueDateRequired?: boolean | null,
  dueDateRequired?: boolean | null,
  isApproved?: boolean | null,
  isRequested?: boolean | null,
  hidden?: boolean | null,
  durationOfStatus?: boolean | null,
};

export type ModelCompanyConditionInput = {
  name?: ModelStringInput | null,
  lowerName?: ModelStringInput | null,
  lowerNameKey?: ModelStringInput | null,
  displayCompanyName?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  type?: ModelCompanyTypeInput | null,
  domainWhitelist?: ModelStringInput | null,
  hasCompletedOnboardingQuestions?: ModelBooleanInput | null,
  completedOnboardingQuestionsBy?: ModelStringInput | null,
  isPartnerCompany?: ModelBooleanInput | null,
  isParent?: ModelBooleanInput | null,
  parentID?: ModelIDInput | null,
  archived?: ModelArchivedStateInput | null,
  companyNumber?: ModelIntInput | null,
  nationalCount?: ModelIntInput | null,
  accountManagerID?: ModelIDInput | null,
  openCaseCount?: ModelIntInput | null,
  closedCaseCount?: ModelIntInput | null,
  completedCaseCount?: ModelIntInput | null,
  legalTeamIDs?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  petitionerParagraph?: ModelStringInput | null,
  and?: Array< ModelCompanyConditionInput | null > | null,
  or?: Array< ModelCompanyConditionInput | null > | null,
  not?: ModelCompanyConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  companyDataId?: ModelIDInput | null,
  id?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelCompanyTypeInput = {
  eq?: CompanyType | null,
  ne?: CompanyType | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelArchivedStateInput = {
  eq?: ArchivedState | null,
  ne?: ArchivedState | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Firm = {
  __typename: "Firm",
  id: string,
  name: string,
  slug: string,
  logo?: Picture | null,
  domainWhitelist?: Array< string > | null,
  address?: StreetAddress | null,
  mailingAddress?: StreetAddress | null,
  doingBusinessAs?: string | null,
  phone?: string | null,
  fax?: string | null,
  knowledgeCenterLinks?:  Array<KnowledgeCenterLink > | null,
  shortcuts?:  Array<Shortcut > | null,
  holidays?: Array< string > | null,
  companyCount: number,
  nationalCount: number,
  preparedFormTemplates?:  Array<PreparedFormTemplate > | null,
  createdAt: string,
  updatedAt: string,
};

export type KnowledgeCenterLink = {
  __typename: "KnowledgeCenterLink",
  id: string,
  text: string,
  file: S3Object,
  roles?: Array< Role | null > | null,
};

export type Shortcut = {
  __typename: "Shortcut",
  id: string,
  text: string,
  link: string,
  roles: Array< Role >,
};

export type UpdateFirmInput = {
  id: string,
  name?: string | null,
  slug?: string | null,
  logo?: PictureInput | null,
  domainWhitelist?: Array< string > | null,
  address?: StreetAddressInput | null,
  mailingAddress?: StreetAddressInput | null,
  doingBusinessAs?: string | null,
  phone?: string | null,
  fax?: string | null,
  knowledgeCenterLinks?: Array< KnowledgeCenterLinkInput > | null,
  shortcuts?: Array< ShortcutInput > | null,
  holidays?: Array< string > | null,
  companyCount?: number | null,
  nationalCount?: number | null,
  preparedFormTemplates?: Array< PreparedFormTemplateInput > | null,
};

export type StreetAddressInput = {
  careOf?: string | null,
  address?: string | null,
  companyAddressType?: CompanyAddressType | null,
  unitNumber?: string | null,
  unitType?: UnitType | null,
  adminArea?: string | null,
  state?: StateCode | null,
  city?: string | null,
  country?: CountryCode | null,
  postalCode?: string | null,
  title?: string | null,
};

export type KnowledgeCenterLinkInput = {
  id: string,
  text: string,
  file: S3ObjectInput,
  roles?: Array< Role | null > | null,
};

export type ShortcutInput = {
  id: string,
  text: string,
  link: string,
  roles: Array< Role >,
};

export type PreparedFormTemplateInput = {
  id: string,
  file: S3ObjectInput,
  name: string,
  processes?: Array< VisaStatus > | null,
  archived?: boolean | null,
  updatedAt: string,
  requiresAttorneyApproval?: boolean | null,
  requiresSponsorApproval?: boolean | null,
  requiresNationalApproval?: boolean | null,
  employersCanView?: boolean | null,
  nationalsCanView?: boolean | null,
};

export type ModelFirmConditionInput = {
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  domainWhitelist?: ModelStringInput | null,
  doingBusinessAs?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  fax?: ModelStringInput | null,
  holidays?: ModelStringInput | null,
  companyCount?: ModelIntInput | null,
  nationalCount?: ModelIntInput | null,
  and?: Array< ModelFirmConditionInput | null > | null,
  or?: Array< ModelFirmConditionInput | null > | null,
  not?: ModelFirmConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SearchableForeignNationalFilterInput = {
  archived?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  hasLoggedIn?: SearchableBooleanFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  emailPersonal?: SearchableStringFilterInput | null,
  emailWork?: SearchableStringFilterInput | null,
  username?: SearchableIDFilterInput | null,
  firstname?: SearchableStringFilterInput | null,
  middlename?: SearchableStringFilterInput | null,
  lastname?: SearchableStringFilterInput | null,
  nickname?: SearchableStringFilterInput | null,
  additionalFirstnames?: SearchableStringFilterInput | null,
  additionalMiddlenames?: SearchableStringFilterInput | null,
  additionalLastnames?: SearchableStringFilterInput | null,
  lowerFirst?: SearchableStringFilterInput | null,
  lowerLast?: SearchableStringFilterInput | null,
  lowerFull?: SearchableStringFilterInput | null,
  spouse?: SearchableBooleanFilterInput | null,
  dependents?: SearchableIntFilterInput | null,
  phone?: SearchableStringFilterInput | null,
  phoneWork?: SearchableStringFilterInput | null,
  companyID?: SearchableIDFilterInput | null,
  mostRecentlyInvited?: SearchableStringFilterInput | null,
  relatives?: SearchableStringFilterInput | null,
  relativeAdmins?: SearchableStringFilterInput | null,
  nonImmigrantVisaNumber?: SearchableStringFilterInput | null,
  visaIssueDate?: SearchableStringFilterInput | null,
  visaExpiration?: SearchableStringFilterInput | null,
  visaConsulate?: SearchableStringFilterInput | null,
  immigrantVisaApplicant?: SearchableBooleanFilterInput | null,
  immigrantPetitionEverFiled?: SearchableBooleanFilterInput | null,
  hasPendingETA9089?: SearchableBooleanFilterInput | null,
  hasValidOrExpiredEAD?: SearchableBooleanFilterInput | null,
  hasPendingUSCISApplication?: SearchableBooleanFilterInput | null,
  hasHadVisaPetitionRevokedOrDenied?: SearchableBooleanFilterInput | null,
  hasBeenArrestedSinceLastUSEntry?: SearchableBooleanFilterInput | null,
  hasTransportedWeapons?: SearchableBooleanFilterInput | null,
  hasParticipatedInArmedGroup?: SearchableBooleanFilterInput | null,
  hasDetailedPerson?: SearchableBooleanFilterInput | null,
  hasUsedWeapons?: SearchableBooleanFilterInput | null,
  hasWeaponsTraining?: SearchableBooleanFilterInput | null,
  hasCriminalOffence?: SearchableBooleanFilterInput | null,
  hasViolatedVisaTerms?: SearchableBooleanFilterInput | null,
  birthState?: SearchableStringFilterInput | null,
  birthDate?: SearchableStringFilterInput | null,
  jobDescriptionID?: SearchableIDFilterInput | null,
  isRemote?: SearchableBooleanFilterInput | null,
  hasNonUSPassport?: SearchableBooleanFilterInput | null,
  aosFilingEligible?: SearchableStringFilterInput | null,
  passportIssueDate?: SearchableStringFilterInput | null,
  passportExpirationDate?: SearchableStringFilterInput | null,
  passportNumber?: SearchableStringFilterInput | null,
  usSSN?: SearchableStringFilterInput | null,
  aNumber?: SearchableStringFilterInput | null,
  lastEntryUS?: SearchableStringFilterInput | null,
  i94ArrivalDepartureRecordNumber?: SearchableStringFilterInput | null,
  sevisNumber?: SearchableStringFilterInput | null,
  eadNumber?: SearchableStringFilterInput | null,
  immigrationVisaStatus?: SearchableStringFilterInput | null,
  companyName?: SearchableStringFilterInput | null,
  immigrationCurrentStatus?: SearchableStringFilterInput | null,
  immigrationStatusExpiration?: SearchableStringFilterInput | null,
  employmentBasedCategory?: SearchableStringFilterInput | null,
  priorityDate?: SearchableStringFilterInput | null,
  birthCountryCode?: SearchableStringFilterInput | null,
  eadExpDate?: SearchableStringFilterInput | null,
  I797ExpDate?: SearchableStringFilterInput | null,
  nivMaxout?: SearchableStringFilterInput | null,
  visaExpDate?: SearchableStringFilterInput | null,
  and?: Array< SearchableForeignNationalFilterInput | null > | null,
  or?: Array< SearchableForeignNationalFilterInput | null > | null,
  not?: SearchableForeignNationalFilterInput | null,
  legalTeamIDs?: SearchableStringFilterInput | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableForeignNationalSortInput = {
  field?: SearchableForeignNationalSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableForeignNationalSortableFields {
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  completedOnboardingQuestionsBy = "completedOnboardingQuestionsBy",
  email = "email",
  emailPersonal = "emailPersonal",
  emailWork = "emailWork",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  nickname = "nickname",
  employeeId = "employeeId",
  additionalFirstnames = "additionalFirstnames",
  additionalMiddlenames = "additionalMiddlenames",
  additionalLastnames = "additionalLastnames",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  spouse = "spouse",
  dependents = "dependents",
  phone = "phone",
  phoneWork = "phoneWork",
  companyID = "companyID",
  companyNationalNumber = "companyNationalNumber",
  mostRecentlyInvited = "mostRecentlyInvited",
  relatives = "relatives",
  relativeAdmins = "relativeAdmins",
  immigrationVisaStatus = "immigrationVisaStatus",
  visaExpiration = "visaExpiration",
  nonImmigrantVisaNumber = "nonImmigrantVisaNumber",
  visaIssueDate = "visaIssueDate",
  visaConsulate = "visaConsulate",
  immigrantVisaApplicant = "immigrantVisaApplicant",
  immigrantPetitionEverFiled = "immigrantPetitionEverFiled",
  hasPendingETA9089 = "hasPendingETA9089",
  hasValidOrExpiredEAD = "hasValidOrExpiredEAD",
  hasPendingUSCISApplication = "hasPendingUSCISApplication",
  hasHadVisaPetitionRevokedOrDenied = "hasHadVisaPetitionRevokedOrDenied",
  hasBeenArrestedSinceLastUSEntry = "hasBeenArrestedSinceLastUSEntry",
  hasTransportedWeapons = "hasTransportedWeapons",
  hasParticipatedInArmedGroup = "hasParticipatedInArmedGroup",
  hasDetailedPerson = "hasDetailedPerson",
  hasUsedWeapons = "hasUsedWeapons",
  hasWeaponsTraining = "hasWeaponsTraining",
  hasCriminalOffence = "hasCriminalOffence",
  hasViolatedVisaTerms = "hasViolatedVisaTerms",
  birthState = "birthState",
  birthDate = "birthDate",
  birthCity = "birthCity",
  jobDescriptionID = "jobDescriptionID",
  nivMaxout = "nivMaxout",
  isRemote = "isRemote",
  hasNonUSPassport = "hasNonUSPassport",
  passportIssueDate = "passportIssueDate",
  passportExpirationDate = "passportExpirationDate",
  passportExpirationReminderSentForDate = "passportExpirationReminderSentForDate",
  passportNumber = "passportNumber",
  usSSN = "usSSN",
  hasSSN = "hasSSN",
  aNumber = "aNumber",
  lastEntryUS = "lastEntryUS",
  i94ArrivalDepartureRecordNumber = "i94ArrivalDepartureRecordNumber",
  sevisNumber = "sevisNumber",
  eadNumber = "eadNumber",
  fileRequirementsManipulated = "fileRequirementsManipulated",
  test = "test",
  notes = "notes",
  companyName = "companyName",
  immigrationCurrentStatus = "immigrationCurrentStatus",
  immigrationStatusExpiration = "immigrationStatusExpiration",
  employmentBasedCategory = "employmentBasedCategory",
  priorityDate = "priorityDate",
  eadExpDate = "eadExpDate",
  I797ExpDate = "I797ExpDate",
  visaExpDate = "visaExpDate",
  birthCountryCode = "birthCountryCode",
  socCode = "socCode",
  firstEntryUS = "firstEntryUS",
  taxTrackingF1J1 = "taxTrackingF1J1",
  citizenshipEligibilityDate = "citizenshipEligibilityDate",
  startDate = "startDate",
  legalTeamIDs = "legalTeamIDs",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableForeignNationalConnection = {
  __typename: "SearchableForeignNationalConnection",
  items:  Array<ForeignNational | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type SearchableActivityFilterInput = {
  id?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  ipAddress?: SearchableStringFilterInput | null,
  fieldName?: SearchableStringFilterInput | null,
  updatedValue?: SearchableStringFilterInput | null,
  actorID?: SearchableIDFilterInput | null,
  actorEmployerID?: SearchableIDFilterInput | null,
  actorForeignNationalID?: SearchableIDFilterInput | null,
  actorTeamMemberID?: SearchableIDFilterInput | null,
  directTargetID?: SearchableIDFilterInput | null,
  directTargetCaseID?: SearchableIDFilterInput | null,
  directTargetCompanyID?: SearchableIDFilterInput | null,
  directTargetEmployerID?: SearchableIDFilterInput | null,
  directTargetFileDataID?: SearchableIDFilterInput | null,
  directTargetForeignNationalID?: SearchableIDFilterInput | null,
  directTargetProcessRequestID?: SearchableIDFilterInput | null,
  directTargetTaskID?: SearchableIDFilterInput | null,
  directTargetTeamMemberID?: SearchableIDFilterInput | null,
  directTargetReportID?: SearchableIDFilterInput | null,
  targetString?: SearchableStringFilterInput | null,
  indirectTargetID?: SearchableIDFilterInput | null,
  indirectTargetCaseID?: SearchableIDFilterInput | null,
  indirectTargetCompanyID?: SearchableIDFilterInput | null,
  indirectTargetEmployerID?: SearchableIDFilterInput | null,
  indirectTargetForeignNationalID?: SearchableIDFilterInput | null,
  indirectTargetProcessRequestID?: SearchableIDFilterInput | null,
  indirectTargetTeamMemberID?: SearchableIDFilterInput | null,
  indirectTargetReportID?: SearchableIDFilterInput | null,
  indirectTargetString?: SearchableStringFilterInput | null,
  ownerID?: SearchableIDFilterInput | null,
  ownerCaseID?: SearchableIDFilterInput | null,
  ownerCompanyID?: SearchableIDFilterInput | null,
  ownerEmployerID?: SearchableIDFilterInput | null,
  ownerFileDataID?: SearchableIDFilterInput | null,
  ownerForeignNationalID?: SearchableIDFilterInput | null,
  ownerProcessRequestID?: SearchableIDFilterInput | null,
  ownerTeamMemberID?: SearchableIDFilterInput | null,
  ownerReportID?: SearchableIDFilterInput | null,
  activityType?: SearchableStringFilterInput | null,
  actorType?: SearchableStringFilterInput | null,
  and?: Array< SearchableActivityFilterInput | null > | null,
  or?: Array< SearchableActivityFilterInput | null > | null,
  not?: SearchableActivityFilterInput | null,
};

export type SearchableActivitySortInput = {
  field?: SearchableActivitySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableActivitySortableFields {
  id = "id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  ipAddress = "ipAddress",
  fieldName = "fieldName",
  updatedValue = "updatedValue",
  actorID = "actorID",
  actorEmployerID = "actorEmployerID",
  actorForeignNationalID = "actorForeignNationalID",
  actorTeamMemberID = "actorTeamMemberID",
  directTargetID = "directTargetID",
  directTargetCaseID = "directTargetCaseID",
  directTargetCompanyID = "directTargetCompanyID",
  directTargetEmployerID = "directTargetEmployerID",
  directTargetFileDataID = "directTargetFileDataID",
  directTargetForeignNationalID = "directTargetForeignNationalID",
  directTargetProcessRequestID = "directTargetProcessRequestID",
  directTargetTaskID = "directTargetTaskID",
  directTargetTeamMemberID = "directTargetTeamMemberID",
  directTargetReportID = "directTargetReportID",
  targetString = "targetString",
  indirectTargetID = "indirectTargetID",
  indirectTargetCaseID = "indirectTargetCaseID",
  indirectTargetCompanyID = "indirectTargetCompanyID",
  indirectTargetEmployerID = "indirectTargetEmployerID",
  indirectTargetForeignNationalID = "indirectTargetForeignNationalID",
  indirectTargetProcessRequestID = "indirectTargetProcessRequestID",
  indirectTargetTeamMemberID = "indirectTargetTeamMemberID",
  indirectTargetReportID = "indirectTargetReportID",
  indirectTargetString = "indirectTargetString",
  ownerID = "ownerID",
  ownerCaseID = "ownerCaseID",
  ownerCompanyID = "ownerCompanyID",
  ownerEmployerID = "ownerEmployerID",
  ownerFileDataID = "ownerFileDataID",
  ownerForeignNationalID = "ownerForeignNationalID",
  ownerProcessRequestID = "ownerProcessRequestID",
  ownerTeamMemberID = "ownerTeamMemberID",
  ownerReportID = "ownerReportID",
}


export type SearchableActivityConnection = {
  __typename: "SearchableActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  personID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  read?: ModelReadStateInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
};

export type ModelReadStateInput = {
  eq?: ReadState | null,
  ne?: ReadState | null,
};

export enum ReadState {
  READ = "READ",
  UNREAD = "UNREAD",
}


export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<Notification | null >,
  nextToken?: string | null,
};

export type Notification = {
  __typename: "Notification",
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  personID: string,
  activityID: string,
  activity?: Activity | null,
  read: ReadState,
  personNational?: ForeignNational | null,
  personEmployer?: Employer | null,
  personTeamMember?: TeamMember | null,
};

export type UpdateAdditionalFieldsInput = {
  id: string,
  caseID?: string | null,
  fields?: string | null,
};

export type ModelAdditionalFieldsConditionInput = {
  caseID?: ModelIDInput | null,
  fields?: ModelStringInput | null,
  and?: Array< ModelAdditionalFieldsConditionInput | null > | null,
  or?: Array< ModelAdditionalFieldsConditionInput | null > | null,
  not?: ModelAdditionalFieldsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type CreateCaseNoteInput = {
  id?: string | null,
  createdAt?: string | null,
  postDate?: string | null,
  authorID?: string | null,
  authorEmployerID?: string | null,
  authorTeamMemberID?: string | null,
  isPinned?: boolean | null,
  note?: string | null,
  caseID?: string | null,
  processRequestID?: string | null,
  companyID?: string | null,
  userGroup: UserGroup,
};

export type ModelCaseNoteConditionInput = {
  createdAt?: ModelStringInput | null,
  postDate?: ModelStringInput | null,
  authorID?: ModelIDInput | null,
  authorEmployerID?: ModelIDInput | null,
  authorTeamMemberID?: ModelIDInput | null,
  isPinned?: ModelBooleanInput | null,
  note?: ModelStringInput | null,
  caseID?: ModelIDInput | null,
  processRequestID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  userGroup?: ModelUserGroupInput | null,
  and?: Array< ModelCaseNoteConditionInput | null > | null,
  or?: Array< ModelCaseNoteConditionInput | null > | null,
  not?: ModelCaseNoteConditionInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelUserGroupInput = {
  eq?: UserGroup | null,
  ne?: UserGroup | null,
};

export type UpdateCaseNoteInput = {
  id: string,
  createdAt?: string | null,
  postDate?: string | null,
  authorID?: string | null,
  authorEmployerID?: string | null,
  authorTeamMemberID?: string | null,
  isPinned?: boolean | null,
  note?: string | null,
  caseID?: string | null,
  processRequestID?: string | null,
  companyID?: string | null,
  userGroup?: UserGroup | null,
};

export type DeleteCaseNoteInput = {
  id: string,
};

export type UpdateCaseInput = {
  id: string,
  caseNumber?: string | null,
  slug?: string | null,
  attorneyID?: string | null,
  caseManagerID?: string | null,
  complianceListID?: string | null,
  PERMFilingDataID?: string | null,
  pinnedCaseNoteID?: string | null,
  contributorIds?: Array< string | null > | null,
  sponsoringEmployerID?: string | null,
  sponsoringNationalID?: string | null,
  foreignNationalID?: string | null,
  welcomeLetterAcknowledged?: boolean | null,
  welcomeLetterAcknowledgementDate?: string | null,
  welcomeLetterAcknowledgedBy?: string | null,
  welcomeLetterText?: string | null,
  nationalVisaExpiration?: string | null,
  relativeAdmins?: Array< string > | null,
  startDate?: string | null,
  closeDate?: string | null,
  closeReason?: string | null,
  completeDate?: string | null,
  sourceID?: string | null,
  state?: CaseState | null,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
  fileRequirements?: Array< FileRequirementInput > | null,
  currentPhase?: CasePhase | null,
  phaseRequirements?: Array< CasePhaseRequirementInput > | null,
  completedMilestones?: Array< CompletedCaseMilestoneInput > | null,
  prevailingWageCaseNumber?: string | null,
  USCISReceiptNumber?: string | null,
  AOSReceiptNotice?: string | null,
  I485JReceiptNotice?: string | null,
  SelectionNoticeNo?: string | null,
  ETACaseNumber?: string | null,
  shipmentTracking?: Array< CaseShipmentTrackingInput > | null,
  isShipmentTrackingElectronically?: boolean | null,
  companyID?: string | null,
  individualSponsored?: boolean | null,
  jobDescriptionID?: string | null,
  employeeData?: ProcessRequestEmployeeDataInput | null,
  employmentData?: ProcessRequestEmploymentDataInput | null,
  resumeID?: string | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  additionalFieldID?: string | null,
};

export type CasePhaseRequirementInput = {
  phase: CasePhase,
  milestones: Array< CaseMilestone >,
};

export type CompletedCaseMilestoneInput = {
  completionDate?: string | null,
  completedByID: string,
  milestone: CaseMilestone,
  receiptNumber?: string | null,
};

export type CaseShipmentTrackingInput = {
  id: string,
  item?: string | null,
  date?: string | null,
  trackingNumber?: string | null,
  provider?: CaseShippingProvider | null,
};

export type ProcessRequestEmployeeDataInput = {
  firstname: string,
  lastname: string,
  middlename?: string | null,
  email?: string | null,
  employeeId?: string | null,
  tempID: string,
  spouse?: boolean | null,
  dependents?: number | null,
};

export type ProcessRequestEmploymentDataInput = {
  location?: ProcessRequestLocationInput | null,
  premiumProcessing?: boolean | null,
  salary?: MoneyInput | null,
  startDate?: string | null,
  notes?: string | null,
};

export type ProcessRequestLocationInput = {
  type?: ProcessRequestLocationType | null,
  remoteAddress?: StreetAddressInput | null,
};

export type MoneyInput = {
  currency: Currency,
  amount: number,
  period?: CurrencyPeriod | null,
};

export type SearchableCaseFilterInput = {
  id?: SearchableIDFilterInput | null,
  caseNumber?: SearchableStringFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  attorneyID?: SearchableIDFilterInput | null,
  caseManagerID?: SearchableIDFilterInput | null,
  pinnedCaseNoteID?: SearchableIDFilterInput | null,
  sponsoringEmployerID?: SearchableIDFilterInput | null,
  sponsoringNationalID?: SearchableIDFilterInput | null,
  foreignNationalID?: SearchableIDFilterInput | null,
  nationalVisaExpiration?: SearchableStringFilterInput | null,
  relativeAdmins?: SearchableStringFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  closeDate?: SearchableStringFilterInput | null,
  closeReason?: SearchableStringFilterInput | null,
  completeDate?: SearchableStringFilterInput | null,
  sourceID?: SearchableIDFilterInput | null,
  lowerNationalName?: SearchableStringFilterInput | null,
  lowerCompanyName?: SearchableStringFilterInput | null,
  lowerProcessType?: SearchableStringFilterInput | null,
  companyID?: SearchableIDFilterInput | null,
  individualSponsored?: SearchableBooleanFilterInput | null,
  jobDescriptionID?: SearchableIDFilterInput | null,
  resumeID?: SearchableIDFilterInput | null,
  contributorIds?: SearchableStringFilterInput | null,
  and?: Array< SearchableCaseFilterInput | null > | null,
  or?: Array< SearchableCaseFilterInput | null > | null,
  not?: SearchableCaseFilterInput | null,
  state?: SearchableStringFilterInput | null,
};

export type SearchableCaseSortInput = {
  field?: SearchableCaseSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCaseSortableFields {
  id = "id",
  caseNumber = "caseNumber",
  slug = "slug",
  attorneyID = "attorneyID",
  caseManagerID = "caseManagerID",
  complianceListID = "complianceListID",
  PERMFilingDataID = "PERMFilingDataID",
  pinnedCaseNoteID = "pinnedCaseNoteID",
  contributorIds = "contributorIds",
  sponsoringEmployerID = "sponsoringEmployerID",
  sponsoringNationalID = "sponsoringNationalID",
  foreignNationalID = "foreignNationalID",
  welcomeLetterAcknowledged = "welcomeLetterAcknowledged",
  welcomeLetterAcknowledgementDate = "welcomeLetterAcknowledgementDate",
  welcomeLetterAcknowledgedBy = "welcomeLetterAcknowledgedBy",
  welcomeLetterText = "welcomeLetterText",
  nationalVisaExpiration = "nationalVisaExpiration",
  relativeAdmins = "relativeAdmins",
  startDate = "startDate",
  closeDate = "closeDate",
  closeReason = "closeReason",
  completeDate = "completeDate",
  sourceID = "sourceID",
  lowerNationalName = "lowerNationalName",
  lowerCompanyName = "lowerCompanyName",
  lowerProcessType = "lowerProcessType",
  prevailingWageCaseNumber = "prevailingWageCaseNumber",
  USCISReceiptNumber = "USCISReceiptNumber",
  AOSReceiptNotice = "AOSReceiptNotice",
  I485JReceiptNotice = "I485JReceiptNotice",
  SelectionNoticeNo = "SelectionNoticeNo",
  ETACaseNumber = "ETACaseNumber",
  isShipmentTrackingElectronically = "isShipmentTrackingElectronically",
  companyID = "companyID",
  individualSponsored = "individualSponsored",
  jobDescriptionID = "jobDescriptionID",
  resumeID = "resumeID",
  globalRequestedProcessSubCategory = "globalRequestedProcessSubCategory",
  vendorID = "vendorID",
  additionalFieldID = "additionalFieldID",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCaseConnection = {
  __typename: "SearchableCaseConnection",
  items:  Array<Case | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelCaseFilterInput = {
  id?: ModelIDInput | null,
  caseNumber?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  attorneyID?: ModelIDInput | null,
  caseManagerID?: ModelIDInput | null,
  complianceListID?: ModelIDInput | null,
  PERMFilingDataID?: ModelIDInput | null,
  pinnedCaseNoteID?: ModelIDInput | null,
  contributorIds?: ModelStringInput | null,
  sponsoringEmployerID?: ModelIDInput | null,
  sponsoringNationalID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  welcomeLetterAcknowledged?: ModelBooleanInput | null,
  welcomeLetterAcknowledgementDate?: ModelStringInput | null,
  welcomeLetterAcknowledgedBy?: ModelIDInput | null,
  welcomeLetterText?: ModelStringInput | null,
  nationalVisaExpiration?: ModelStringInput | null,
  relativeAdmins?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  closeDate?: ModelStringInput | null,
  closeReason?: ModelStringInput | null,
  completeDate?: ModelStringInput | null,
  sourceID?: ModelIDInput | null,
  state?: ModelCaseStateInput | null,
  lowerNationalName?: ModelStringInput | null,
  lowerCompanyName?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  currentPhase?: ModelCasePhaseInput | null,
  prevailingWageCaseNumber?: ModelStringInput | null,
  USCISReceiptNumber?: ModelStringInput | null,
  AOSReceiptNotice?: ModelStringInput | null,
  I485JReceiptNotice?: ModelStringInput | null,
  SelectionNoticeNo?: ModelStringInput | null,
  ETACaseNumber?: ModelStringInput | null,
  isShipmentTrackingElectronically?: ModelBooleanInput | null,
  companyID?: ModelIDInput | null,
  individualSponsored?: ModelBooleanInput | null,
  jobDescriptionID?: ModelIDInput | null,
  resumeID?: ModelIDInput | null,
  requestedProcess?: ModelVisaStatusInput | null,
  requestedProcessSubCategory?: ModelVisaSubCategoryInput | null,
  requestedProcessAdditionalProcessing?: ModelVisaAdditionalProcessingListInput | null,
  globalRequestedProcessSubCategory?: ModelStringInput | null,
  globalProcessCountryCode?: ModelCountryCodeInput | null,
  globalProcessDuration?: ModelGlobalProcessDurationInput | null,
  globalVisaType?: ModelGlobalVisaTypeInput | null,
  vendorID?: ModelIDInput | null,
  additionalFieldID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseFilterInput | null > | null,
  or?: Array< ModelCaseFilterInput | null > | null,
  not?: ModelCaseFilterInput | null,
};

export type ModelCaseStateInput = {
  eq?: CaseState | null,
  ne?: CaseState | null,
};

export type ModelCasePhaseInput = {
  eq?: CasePhase | null,
  ne?: CasePhase | null,
};

export type ModelVisaStatusInput = {
  eq?: VisaStatus | null,
  ne?: VisaStatus | null,
};

export type ModelVisaSubCategoryInput = {
  eq?: VisaSubCategory | null,
  ne?: VisaSubCategory | null,
};

export type ModelVisaAdditionalProcessingListInput = {
  eq?: Array< VisaAdditionalProcessing | null > | null,
  ne?: Array< VisaAdditionalProcessing | null > | null,
  contains?: VisaAdditionalProcessing | null,
  notContains?: VisaAdditionalProcessing | null,
};

export type ModelCountryCodeInput = {
  eq?: CountryCode | null,
  ne?: CountryCode | null,
};

export type ModelGlobalProcessDurationInput = {
  eq?: GlobalProcessDuration | null,
  ne?: GlobalProcessDuration | null,
};

export type ModelGlobalVisaTypeInput = {
  eq?: GlobalVisaType | null,
  ne?: GlobalVisaType | null,
};

export type CreateFileDataInput = {
  id?: string | null,
  expirationDate?: string | null,
  durationOfStatus?: boolean | null,
  fileName: string,
  original: S3ObjectInput,
  fileType?: FileType | null,
  fileRequirement?: string | null,
  fileCategory?: string | null,
  contentType?: string | null,
  issueDate?: string | null,
  dueDate?: string | null,
  isFlattened?: boolean | null,
  processRequestID?: string | null,
  companyID?: string | null,
  ownerNationalID?: string | null,
  sourceID?: string | null,
  uploadDate: string,
  uploaderID?: string | null,
  uploaderEmployerID?: string | null,
  uploaderForeignNationalID?: string | null,
  uploaderTeamMemberID?: string | null,
};

export type ModelFileDataConditionInput = {
  expirationDate?: ModelStringInput | null,
  durationOfStatus?: ModelBooleanInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelFileTypeInput | null,
  fileRequirement?: ModelStringInput | null,
  fileCategory?: ModelStringInput | null,
  contentType?: ModelStringInput | null,
  issueDate?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  isFlattened?: ModelBooleanInput | null,
  processRequestID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  ownerNationalID?: ModelIDInput | null,
  sourceID?: ModelIDInput | null,
  uploadDate?: ModelStringInput | null,
  uploaderID?: ModelIDInput | null,
  uploaderEmployerID?: ModelIDInput | null,
  uploaderForeignNationalID?: ModelIDInput | null,
  uploaderTeamMemberID?: ModelIDInput | null,
  and?: Array< ModelFileDataConditionInput | null > | null,
  or?: Array< ModelFileDataConditionInput | null > | null,
  not?: ModelFileDataConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFileTypeInput = {
  eq?: FileType | null,
  ne?: FileType | null,
};

export type UpdateFileDataInput = {
  id: string,
  expirationDate?: string | null,
  durationOfStatus?: boolean | null,
  fileName?: string | null,
  original?: S3ObjectInput | null,
  fileType?: FileType | null,
  fileRequirement?: string | null,
  fileCategory?: string | null,
  contentType?: string | null,
  issueDate?: string | null,
  dueDate?: string | null,
  isFlattened?: boolean | null,
  processRequestID?: string | null,
  companyID?: string | null,
  ownerNationalID?: string | null,
  sourceID?: string | null,
  uploadDate?: string | null,
  uploaderID?: string | null,
  uploaderEmployerID?: string | null,
  uploaderForeignNationalID?: string | null,
  uploaderTeamMemberID?: string | null,
};

export type UpdateEmployerInput = {
  id: string,
  createdBy?: string | null,
  slug?: string | null,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type?: PersonType | null,
  email?: string | null,
  personalEmail?: string | null,
  newsletterModalViewCount?: number | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  lowerFirst?: string | null,
  lowerLast?: string | null,
  lowerFull?: string | null,
  address?: string | null,
  phone?: string | null,
  personalPhone?: string | null,
  title?: string | null,
  companyIDs?: Array< string > | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  recentlyViewedCases?: Array< string > | null,
  mostRecentlyInvited?: string | null,
  archived?: ArchivedState | null,
  loginStatus?: LoginStatusInput | null,
  invoicingContactCompanyIDs?: Array< string > | null,
  isInvoicingContact?: boolean | null,
  primaryContactCompanyIDs?: Array< string > | null,
  isPrimaryContact?: boolean | null,
  seniorContactCompanyIDs?: Array< string > | null,
  isSeniorContact?: boolean | null,
  signatoryContactCompanyIDs?: Array< string > | null,
  isSignatoryContact?: boolean | null,
  assignedCaseIDs?: Array< string > | null,
  nationalsWithOpenCases?: Array< string > | null,
};

export type LoginStatusInput = {
  isEnabled?: boolean | null,
  status?: UserStatus | null,
};

export type ModelEmployerConditionInput = {
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  type?: ModelPersonTypeInput | null,
  email?: ModelStringInput | null,
  personalEmail?: ModelStringInput | null,
  newsletterModalViewCount?: ModelIntInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  address?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  personalPhone?: ModelStringInput | null,
  title?: ModelStringInput | null,
  companyIDs?: ModelStringInput | null,
  hasCompletedOnboardingQuestions?: ModelBooleanInput | null,
  recentlyViewedCases?: ModelIDInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  invoicingContactCompanyIDs?: ModelIDInput | null,
  isInvoicingContact?: ModelBooleanInput | null,
  primaryContactCompanyIDs?: ModelIDInput | null,
  isPrimaryContact?: ModelBooleanInput | null,
  seniorContactCompanyIDs?: ModelIDInput | null,
  isSeniorContact?: ModelBooleanInput | null,
  signatoryContactCompanyIDs?: ModelIDInput | null,
  isSignatoryContact?: ModelBooleanInput | null,
  assignedCaseIDs?: ModelIDInput | null,
  nationalsWithOpenCases?: ModelIDInput | null,
  and?: Array< ModelEmployerConditionInput | null > | null,
  or?: Array< ModelEmployerConditionInput | null > | null,
  not?: ModelEmployerConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  id?: ModelStringInput | null,
};

export type ModelPersonTypeInput = {
  eq?: PersonType | null,
  ne?: PersonType | null,
};

export type UpdateForeignNationalInput = {
  type?: PersonType | null,
  id: string,
  createdBy?: string | null,
  slug?: string | null,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  onboardingSections?: NationalOnboardingSectionsInput | null,
  completedOnboardingQuestionsBy?: string | null,
  email?: string | null,
  emailPersonal?: string | null,
  emailWork?: string | null,
  usMailingAddress?: StreetAddressInput | null,
  usResidentialAddress?: StreetAddressInput | null,
  lastAddressOutsideUS?: StreetAddressInput | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  nickname?: string | null,
  employeeId?: string | null,
  additionalFirstnames?: Array< string > | null,
  additionalMiddlenames?: Array< string > | null,
  additionalLastnames?: Array< string > | null,
  lowerFirst?: string | null,
  lowerLast?: string | null,
  lowerFull?: string | null,
  maritalStatus?: MaritalStatus | null,
  spouse?: boolean | null,
  dependents?: number | null,
  phone?: string | null,
  phoneWork?: string | null,
  companyID?: string | null,
  companyNationalNumber?: number | null,
  mostRecentlyInvited?: string | null,
  archived?: ArchivedState | null,
  workLocation?: StreetAddressInput | null,
  relatives?: Array< string > | null,
  relativeAdmins?: Array< string > | null,
  immigrationStatus?: ImmigrationStatusInput | null,
  immigrationVisaStatus?: string | null,
  visaExpiration?: string | null,
  nonImmigrantVisaNumber?: string | null,
  visaIssueDate?: string | null,
  visaConsulate?: string | null,
  immigrantVisaApplicant?: boolean | null,
  immigrantPetitionEverFiled?: boolean | null,
  j1j2?: J1J2Input | null,
  hasHadI485Filed?: BooleanTwoPartInput | null,
  hasPendingETA9089?: boolean | null,
  hasApprovedI140?: I140Input | null,
  aosFilingEligible?: AOSFilingEligibility | null,
  hasValidOrExpiredEAD?: boolean | null,
  hasPendingUSCISApplication?: boolean | null,
  hasHadVisaPetitionRevokedOrDenied?: boolean | null,
  hasBeenArrestedSinceLastUSEntry?: boolean | null,
  criminalHistory?: CriminalHistoryInput | null,
  hasTransportedWeapons?: boolean | null,
  hasParticipatedInArmedGroup?: boolean | null,
  hasDetailedPerson?: boolean | null,
  hasUsedWeapons?: boolean | null,
  hasWeaponsTraining?: boolean | null,
  hasCriminalOffence?: boolean | null,
  hasViolatedVisaTerms?: boolean | null,
  isInRemovalProceedings?: BooleanExplainInput | null,
  hasBeenEmployedSinceLastAdmitted?: BooleanExplainInput | null,
  citizenshipCountry?: Array< CountryCode > | null,
  birthCountry?: CountryCode | null,
  birthState?: string | null,
  birthDate?: string | null,
  birthCity?: string | null,
  jobDescriptionID?: string | null,
  nivMaxout?: string | null,
  offeredSalary?: MoneyInput | null,
  isRemote?: boolean | null,
  loginStatus?: LoginStatusInput | null,
  hasNonUSPassport?: boolean | null,
  passportGender?: PassportGender | null,
  passportIssueDate?: string | null,
  passportExpirationDate?: string | null,
  passportExpirationReminderSentForDate?: string | null,
  passportNumber?: string | null,
  passportCountry?: CountryCode | null,
  usSSN?: string | null,
  hasSSN?: boolean | null,
  aNumber?: string | null,
  lastEntryUS?: string | null,
  i94ArrivalDepartureRecordNumber?: string | null,
  sevisNumber?: string | null,
  eadNumber?: string | null,
  fileRequirements?: Array< FileRequirementInput > | null,
  fileRequirementsManipulated?: string | null,
  test?: string | null,
  notes?: string | null,
  companyName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  eadExpDate?: string | null,
  I797ExpDate?: string | null,
  visaExpDate?: string | null,
  chargeabilityCountry?: CountryCode | null,
  birthCountryCode?: string | null,
  socCode?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  citizenshipEligibilityDate?: string | null,
  startDate?: string | null,
  legalTeamIDs?: Array< string > | null,
};

export type NationalOnboardingSectionsInput = {
  background?: boolean | null,
  contact?: boolean | null,
  employment?: boolean | null,
  family?: boolean | null,
  immigration?: boolean | null,
  personal?: boolean | null,
};

export type ImmigrationStatusInput = {
  status?: VisaStatus | null,
  doesNotExpire?: boolean | null,
  expiration?: string | null,
};

export type J1J2Input = {
  hasHad?: boolean | null,
  start?: string | null,
  end?: string | null,
};

export type BooleanTwoPartInput = {
  value?: boolean | null,
  followPrompt?: string | null,
  followValue?: boolean | null,
};

export type I140Input = {
  hasApproved?: boolean | null,
  classification?: string | null,
  employmentBasedCategory?: EmploymentBasedCategory | null,
  priorityDate?: string | null,
  petitionerI140?: string | null,
};

export type CriminalHistoryInput = {
  tortureGenocide?: boolean | null,
  killing?: boolean | null,
  severeInjuring?: boolean | null,
  nonconsensualSex?: boolean | null,
  religiousBelief?: boolean | null,
};

export type BooleanExplainInput = {
  value?: boolean | null,
  reason?: string | null,
};

export type ModelForeignNationalConditionInput = {
  type?: ModelPersonTypeInput | null,
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  completedOnboardingQuestionsBy?: ModelStringInput | null,
  email?: ModelStringInput | null,
  emailPersonal?: ModelStringInput | null,
  emailWork?: ModelStringInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  nickname?: ModelStringInput | null,
  employeeId?: ModelStringInput | null,
  additionalFirstnames?: ModelStringInput | null,
  additionalMiddlenames?: ModelStringInput | null,
  additionalLastnames?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  maritalStatus?: ModelMaritalStatusInput | null,
  spouse?: ModelBooleanInput | null,
  dependents?: ModelIntInput | null,
  phone?: ModelStringInput | null,
  phoneWork?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  companyNationalNumber?: ModelIntInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  relatives?: ModelStringInput | null,
  relativeAdmins?: ModelStringInput | null,
  immigrationVisaStatus?: ModelStringInput | null,
  visaExpiration?: ModelStringInput | null,
  nonImmigrantVisaNumber?: ModelStringInput | null,
  visaIssueDate?: ModelStringInput | null,
  visaConsulate?: ModelStringInput | null,
  immigrantVisaApplicant?: ModelBooleanInput | null,
  immigrantPetitionEverFiled?: ModelBooleanInput | null,
  hasPendingETA9089?: ModelBooleanInput | null,
  aosFilingEligible?: ModelAOSFilingEligibilityInput | null,
  hasValidOrExpiredEAD?: ModelBooleanInput | null,
  hasPendingUSCISApplication?: ModelBooleanInput | null,
  hasHadVisaPetitionRevokedOrDenied?: ModelBooleanInput | null,
  hasBeenArrestedSinceLastUSEntry?: ModelBooleanInput | null,
  hasTransportedWeapons?: ModelBooleanInput | null,
  hasParticipatedInArmedGroup?: ModelBooleanInput | null,
  hasDetailedPerson?: ModelBooleanInput | null,
  hasUsedWeapons?: ModelBooleanInput | null,
  hasWeaponsTraining?: ModelBooleanInput | null,
  hasCriminalOffence?: ModelBooleanInput | null,
  hasViolatedVisaTerms?: ModelBooleanInput | null,
  citizenshipCountry?: ModelCountryCodeListInput | null,
  birthCountry?: ModelCountryCodeInput | null,
  birthState?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  birthCity?: ModelStringInput | null,
  jobDescriptionID?: ModelIDInput | null,
  nivMaxout?: ModelStringInput | null,
  isRemote?: ModelBooleanInput | null,
  hasNonUSPassport?: ModelBooleanInput | null,
  passportGender?: ModelPassportGenderInput | null,
  passportIssueDate?: ModelStringInput | null,
  passportExpirationDate?: ModelStringInput | null,
  passportExpirationReminderSentForDate?: ModelStringInput | null,
  passportNumber?: ModelStringInput | null,
  passportCountry?: ModelCountryCodeInput | null,
  usSSN?: ModelStringInput | null,
  hasSSN?: ModelBooleanInput | null,
  aNumber?: ModelStringInput | null,
  lastEntryUS?: ModelStringInput | null,
  i94ArrivalDepartureRecordNumber?: ModelStringInput | null,
  sevisNumber?: ModelStringInput | null,
  eadNumber?: ModelStringInput | null,
  fileRequirementsManipulated?: ModelStringInput | null,
  test?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  immigrationCurrentStatus?: ModelStringInput | null,
  immigrationStatusExpiration?: ModelStringInput | null,
  employmentBasedCategory?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  eadExpDate?: ModelStringInput | null,
  I797ExpDate?: ModelStringInput | null,
  visaExpDate?: ModelStringInput | null,
  chargeabilityCountry?: ModelCountryCodeInput | null,
  birthCountryCode?: ModelStringInput | null,
  socCode?: ModelStringInput | null,
  firstEntryUS?: ModelStringInput | null,
  taxTrackingF1J1?: ModelStringInput | null,
  citizenshipEligibilityDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  legalTeamIDs?: ModelIDInput | null,
  and?: Array< ModelForeignNationalConditionInput | null > | null,
  or?: Array< ModelForeignNationalConditionInput | null > | null,
  not?: ModelForeignNationalConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  id?: ModelStringInput | null,
};

export type ModelMaritalStatusInput = {
  eq?: MaritalStatus | null,
  ne?: MaritalStatus | null,
};

export type ModelAOSFilingEligibilityInput = {
  eq?: AOSFilingEligibility | null,
  ne?: AOSFilingEligibility | null,
};

export type ModelCountryCodeListInput = {
  eq?: Array< CountryCode | null > | null,
  ne?: Array< CountryCode | null > | null,
  contains?: CountryCode | null,
  notContains?: CountryCode | null,
};

export type ModelPassportGenderInput = {
  eq?: PassportGender | null,
  ne?: PassportGender | null,
};

export type UpdateTeamMemberInput = {
  id: string,
  createdBy?: string | null,
  slug?: string | null,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type?: PersonType | null,
  email?: string | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  lowerFirst?: string | null,
  lowerLast?: string | null,
  lowerFull?: string | null,
  phone?: string | null,
  position?: Position | null,
  title?: string | null,
  licensingAuthority?: string | null,
  stateBarNumber?: string | null,
  isAdmin?: boolean | null,
  managerID?: string | null,
  mostRecentlyInvited?: string | null,
  archived?: ArchivedState | null,
  loginStatus?: LoginStatusInput | null,
  recentlyViewedCases?: Array< string > | null,
  nationalsWithOpenCases?: Array< string > | null,
  companiesAssignedTo?: Array< string > | null,
};

export type ModelTeamMemberConditionInput = {
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  type?: ModelPersonTypeInput | null,
  email?: ModelStringInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  position?: ModelPositionInput | null,
  title?: ModelStringInput | null,
  licensingAuthority?: ModelStringInput | null,
  stateBarNumber?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  managerID?: ModelIDInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  recentlyViewedCases?: ModelIDInput | null,
  nationalsWithOpenCases?: ModelIDInput | null,
  companiesAssignedTo?: ModelIDInput | null,
  and?: Array< ModelTeamMemberConditionInput | null > | null,
  or?: Array< ModelTeamMemberConditionInput | null > | null,
  not?: ModelTeamMemberConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelPositionInput = {
  eq?: Position | null,
  ne?: Position | null,
};

export type SearchableProcessRequestFilterInput = {
  state?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  assignedToID?: SearchableIDFilterInput | null,
  companyID?: SearchableIDFilterInput | null,
  individualSponsored?: SearchableBooleanFilterInput | null,
  initiatorID?: SearchableIDFilterInput | null,
  jobDescriptionID?: SearchableIDFilterInput | null,
  requesterID?: SearchableIDFilterInput | null,
  requestDate?: SearchableStringFilterInput | null,
  foreignNationalID?: SearchableIDFilterInput | null,
  needsEmployerRevision?: SearchableBooleanFilterInput | null,
  resumeID?: SearchableIDFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  lowerNationalName?: SearchableStringFilterInput | null,
  and?: Array< SearchableProcessRequestFilterInput | null > | null,
  or?: Array< SearchableProcessRequestFilterInput | null > | null,
  not?: SearchableProcessRequestFilterInput | null,
};

export type SearchableProcessRequestSortInput = {
  field?: SearchableProcessRequestSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProcessRequestSortableFields {
  id = "id",
  assignedToID = "assignedToID",
  assignedToEmployerID = "assignedToEmployerID",
  assignedToTeamMemberID = "assignedToTeamMemberID",
  companyID = "companyID",
  individualSponsored = "individualSponsored",
  initiatorID = "initiatorID",
  jobDescriptionID = "jobDescriptionID",
  requesterID = "requesterID",
  requestDate = "requestDate",
  approvalDate = "approvalDate",
  archivedDate = "archivedDate",
  cancelDate = "cancelDate",
  foreignNationalID = "foreignNationalID",
  needsEmployerRevision = "needsEmployerRevision",
  resumeID = "resumeID",
  globalRequestedProcessSubCategory = "globalRequestedProcessSubCategory",
  vendorID = "vendorID",
  slug = "slug",
  lowerNationalName = "lowerNationalName",
  lowerCompanyName = "lowerCompanyName",
  lowerProcessType = "lowerProcessType",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableProcessRequestConnection = {
  __typename: "SearchableProcessRequestConnection",
  items:  Array<ProcessRequest | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type UpdateProcessRequestInput = {
  id: string,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToTeamMemberID?: string | null,
  companyID?: string | null,
  individualSponsored?: boolean | null,
  initiatorID?: string | null,
  jobDescriptionID?: string | null,
  requesterID?: string | null,
  requestDate?: string | null,
  approvalDate?: string | null,
  archivedDate?: string | null,
  cancelDate?: string | null,
  foreignNationalID?: string | null,
  employeeData?: ProcessRequestEmployeeDataInput | null,
  employmentData?: ProcessRequestEmploymentDataInput | null,
  needsEmployerRevision?: boolean | null,
  resumeID?: string | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  slug?: string | null,
  state?: ProcessRequestState | null,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
};

export type ModelProcessRequestConditionInput = {
  assignedToID?: ModelIDInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  individualSponsored?: ModelBooleanInput | null,
  initiatorID?: ModelIDInput | null,
  jobDescriptionID?: ModelIDInput | null,
  requesterID?: ModelIDInput | null,
  requestDate?: ModelStringInput | null,
  approvalDate?: ModelStringInput | null,
  archivedDate?: ModelStringInput | null,
  cancelDate?: ModelStringInput | null,
  foreignNationalID?: ModelIDInput | null,
  needsEmployerRevision?: ModelBooleanInput | null,
  resumeID?: ModelIDInput | null,
  requestedProcess?: ModelVisaStatusInput | null,
  requestedProcessSubCategory?: ModelVisaSubCategoryInput | null,
  requestedProcessAdditionalProcessing?: ModelVisaAdditionalProcessingListInput | null,
  globalRequestedProcessSubCategory?: ModelStringInput | null,
  globalProcessCountryCode?: ModelCountryCodeInput | null,
  globalProcessDuration?: ModelGlobalProcessDurationInput | null,
  globalVisaType?: ModelGlobalVisaTypeInput | null,
  vendorID?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  state?: ModelProcessRequestStateInput | null,
  lowerNationalName?: ModelStringInput | null,
  lowerCompanyName?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  and?: Array< ModelProcessRequestConditionInput | null > | null,
  or?: Array< ModelProcessRequestConditionInput | null > | null,
  not?: ModelProcessRequestConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelProcessRequestStateInput = {
  eq?: ProcessRequestState | null,
  ne?: ProcessRequestState | null,
};

export type ModelForeignNationalFilterInput = {
  type?: ModelPersonTypeInput | null,
  id?: ModelIDInput | null,
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  completedOnboardingQuestionsBy?: ModelStringInput | null,
  email?: ModelStringInput | null,
  emailPersonal?: ModelStringInput | null,
  emailWork?: ModelStringInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  nickname?: ModelStringInput | null,
  employeeId?: ModelStringInput | null,
  additionalFirstnames?: ModelStringInput | null,
  additionalMiddlenames?: ModelStringInput | null,
  additionalLastnames?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  maritalStatus?: ModelMaritalStatusInput | null,
  spouse?: ModelBooleanInput | null,
  dependents?: ModelIntInput | null,
  phone?: ModelStringInput | null,
  phoneWork?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  companyNationalNumber?: ModelIntInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  relatives?: ModelStringInput | null,
  relativeAdmins?: ModelStringInput | null,
  immigrationVisaStatus?: ModelStringInput | null,
  visaExpiration?: ModelStringInput | null,
  nonImmigrantVisaNumber?: ModelStringInput | null,
  visaIssueDate?: ModelStringInput | null,
  visaConsulate?: ModelStringInput | null,
  immigrantVisaApplicant?: ModelBooleanInput | null,
  immigrantPetitionEverFiled?: ModelBooleanInput | null,
  hasPendingETA9089?: ModelBooleanInput | null,
  aosFilingEligible?: ModelAOSFilingEligibilityInput | null,
  hasValidOrExpiredEAD?: ModelBooleanInput | null,
  hasPendingUSCISApplication?: ModelBooleanInput | null,
  hasHadVisaPetitionRevokedOrDenied?: ModelBooleanInput | null,
  hasBeenArrestedSinceLastUSEntry?: ModelBooleanInput | null,
  hasTransportedWeapons?: ModelBooleanInput | null,
  hasParticipatedInArmedGroup?: ModelBooleanInput | null,
  hasDetailedPerson?: ModelBooleanInput | null,
  hasUsedWeapons?: ModelBooleanInput | null,
  hasWeaponsTraining?: ModelBooleanInput | null,
  hasCriminalOffence?: ModelBooleanInput | null,
  hasViolatedVisaTerms?: ModelBooleanInput | null,
  citizenshipCountry?: ModelCountryCodeListInput | null,
  birthCountry?: ModelCountryCodeInput | null,
  birthState?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  birthCity?: ModelStringInput | null,
  jobDescriptionID?: ModelIDInput | null,
  nivMaxout?: ModelStringInput | null,
  isRemote?: ModelBooleanInput | null,
  hasNonUSPassport?: ModelBooleanInput | null,
  passportGender?: ModelPassportGenderInput | null,
  passportIssueDate?: ModelStringInput | null,
  passportExpirationDate?: ModelStringInput | null,
  passportExpirationReminderSentForDate?: ModelStringInput | null,
  passportNumber?: ModelStringInput | null,
  passportCountry?: ModelCountryCodeInput | null,
  usSSN?: ModelStringInput | null,
  hasSSN?: ModelBooleanInput | null,
  aNumber?: ModelStringInput | null,
  lastEntryUS?: ModelStringInput | null,
  i94ArrivalDepartureRecordNumber?: ModelStringInput | null,
  sevisNumber?: ModelStringInput | null,
  eadNumber?: ModelStringInput | null,
  fileRequirementsManipulated?: ModelStringInput | null,
  test?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  immigrationCurrentStatus?: ModelStringInput | null,
  immigrationStatusExpiration?: ModelStringInput | null,
  employmentBasedCategory?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  eadExpDate?: ModelStringInput | null,
  I797ExpDate?: ModelStringInput | null,
  visaExpDate?: ModelStringInput | null,
  chargeabilityCountry?: ModelCountryCodeInput | null,
  birthCountryCode?: ModelStringInput | null,
  socCode?: ModelStringInput | null,
  firstEntryUS?: ModelStringInput | null,
  taxTrackingF1J1?: ModelStringInput | null,
  citizenshipEligibilityDate?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  legalTeamIDs?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelForeignNationalFilterInput | null > | null,
  or?: Array< ModelForeignNationalFilterInput | null > | null,
  not?: ModelForeignNationalFilterInput | null,
};

export type ModelTeamMemberConnection = {
  __typename: "ModelTeamMemberConnection",
  items:  Array<TeamMember | null >,
  nextToken?: string | null,
};

export type ModelEmployerConnection = {
  __typename: "ModelEmployerConnection",
  items:  Array<Employer | null >,
  nextToken?: string | null,
};

export type SearchableCompanyFilterInput = {
  archived?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  lowerName?: SearchableStringFilterInput | null,
  lowerNameKey?: SearchableStringFilterInput | null,
  displayCompanyName?: SearchableStringFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  domainWhitelist?: SearchableStringFilterInput | null,
  isPartnerCompany?: SearchableBooleanFilterInput | null,
  isParent?: SearchableBooleanFilterInput | null,
  legalTeamIDs?: SearchableStringFilterInput | null,
  parentID?: SearchableIDFilterInput | null,
  accountManagerID?: SearchableIDFilterInput | null,
  and?: Array< SearchableCompanyFilterInput | null > | null,
  or?: Array< SearchableCompanyFilterInput | null > | null,
  not?: SearchableCompanyFilterInput | null,
};

export type SearchableCompanyConnection = {
  __typename: "SearchableCompanyConnection",
  items:  Array<Company | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableEmployerFilterInput = {
  archived?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  hasLoggedIn?: SearchableBooleanFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  username?: SearchableIDFilterInput | null,
  firstname?: SearchableStringFilterInput | null,
  middlename?: SearchableStringFilterInput | null,
  lastname?: SearchableStringFilterInput | null,
  lowerFirst?: SearchableStringFilterInput | null,
  lowerLast?: SearchableStringFilterInput | null,
  lowerFull?: SearchableStringFilterInput | null,
  address?: SearchableStringFilterInput | null,
  phone?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  companyIDs?: SearchableStringFilterInput | null,
  mostRecentlyInvited?: SearchableStringFilterInput | null,
  and?: Array< SearchableEmployerFilterInput | null > | null,
  or?: Array< SearchableEmployerFilterInput | null > | null,
  not?: SearchableEmployerFilterInput | null,
  invoicingContactCompanyIDs?: SearchableStringFilterInput | null,
  primaryContactCompanyIDs?: SearchableStringFilterInput | null,
  seniorContactCompanyIDs?: SearchableStringFilterInput | null,
  signatoryContactCompanyIDs?: SearchableStringFilterInput | null,
  assignedCaseIDs?: SearchableStringFilterInput | null,
  nationalsWithOpenCases?: SearchableStringFilterInput | null,
  isInvoicingContact?: SearchableBooleanFilterInput | null,
  isPrimaryContact?: SearchableBooleanFilterInput | null,
  isSeniorContact?: SearchableBooleanFilterInput | null,
  isSignatoryContact?: SearchableBooleanFilterInput | null,
};

export type SearchableEmployerConnection = {
  __typename: "SearchableEmployerConnection",
  items:  Array<Employer | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableTeamMemberFilterInput = {
  archived?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  hasLoggedIn?: SearchableBooleanFilterInput | null,
  slug?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  username?: SearchableIDFilterInput | null,
  firstname?: SearchableStringFilterInput | null,
  middlename?: SearchableStringFilterInput | null,
  lastname?: SearchableStringFilterInput | null,
  lowerFirst?: SearchableStringFilterInput | null,
  lowerLast?: SearchableStringFilterInput | null,
  lowerFull?: SearchableStringFilterInput | null,
  phone?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  licensingAuthority?: SearchableStringFilterInput | null,
  stateBarNumber?: SearchableStringFilterInput | null,
  isAdmin?: SearchableBooleanFilterInput | null,
  managerID?: SearchableIDFilterInput | null,
  mostRecentlyInvited?: SearchableStringFilterInput | null,
  and?: Array< SearchableTeamMemberFilterInput | null > | null,
  or?: Array< SearchableTeamMemberFilterInput | null > | null,
  not?: SearchableTeamMemberFilterInput | null,
  nationalsWithOpenCases?: SearchableStringFilterInput | null,
  companiesAssignedTo?: SearchableStringFilterInput | null,
};

export type SearchableTeamMemberConnection = {
  __typename: "SearchableTeamMemberConnection",
  items:  Array<TeamMember | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type CreateCommentInput = {
  createdAt?: string | null,
  authorID: string,
  authorEmployerID?: string | null,
  authorForeignNationalID?: string | null,
  authorTeamMemberID?: string | null,
  note?: string | null,
  sourceID: string,
  id?: string | null,
};

export type ModelCommentConditionInput = {
  createdAt?: ModelStringInput | null,
  authorID?: ModelIDInput | null,
  authorEmployerID?: ModelIDInput | null,
  authorForeignNationalID?: ModelIDInput | null,
  authorTeamMemberID?: ModelIDInput | null,
  note?: ModelStringInput | null,
  sourceID?: ModelIDInput | null,
  and?: Array< ModelCommentConditionInput | null > | null,
  or?: Array< ModelCommentConditionInput | null > | null,
  not?: ModelCommentConditionInput | null,
  updatedAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
};

export type ModelTaskFilterInput = {
  id?: ModelIDInput | null,
  action?: ModelStringInput | null,
  isKeyDate?: ModelBooleanInput | null,
  keyDateAlternateAction?: ModelStringInput | null,
  isPaymentStatus?: ModelBooleanInput | null,
  paymentStatusAlternateAction?: ModelStringInput | null,
  assignedToID?: ModelIDInput | null,
  isAssignedToLegalAssistants?: ModelBooleanInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToForeignNationalID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  caseState?: ModelCaseStateInput | null,
  category?: ModelTaskCategoryInput | null,
  companyID?: ModelIDInput | null,
  completeDate?: ModelStringInput | null,
  deadline?: ModelStringInput | null,
  deadlineIsManuallySet?: ModelBooleanInput | null,
  deleteDate?: ModelStringInput | null,
  deleteReason?: ModelStringInput | null,
  description?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  foreignNationalID?: ModelIDInput | null,
  groupsCanRead?: ModelStringInput | null,
  isCustom?: ModelBooleanInput | null,
  isManuallyUnlocked?: ModelBooleanInput | null,
  prerequisiteID?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  state?: ModelTaskStateInput | null,
  templateID?: ModelIDInput | null,
  assigneeLowerName?: ModelStringInput | null,
  attorneyLowerFirstName?: ModelStringInput | null,
  attorneyLowerName?: ModelStringInput | null,
  paralegalLowerName?: ModelStringInput | null,
  paralegalLowerFirstName?: ModelStringInput | null,
  companyLowerName?: ModelStringInput | null,
  nationalLowerName?: ModelStringInput | null,
  orderIndex?: ModelIntInput | null,
  defaultAssignee?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTaskFilterInput | null > | null,
  or?: Array< ModelTaskFilterInput | null > | null,
  not?: ModelTaskFilterInput | null,
  foreignNationalTasksId?: ModelIDInput | null,
  employerTasksId?: ModelIDInput | null,
};

export type ModelTaskCategoryInput = {
  eq?: TaskCategory | null,
  ne?: TaskCategory | null,
};

export type ModelTaskStateInput = {
  eq?: TaskState | null,
  ne?: TaskState | null,
};

export type UpdateJobDescriptionInput = {
  companyID?: string | null,
  id: string,
  archived?: ArchivedState | null,
  type?: JobDescriptionType | null,
  foreignNationalID?: string | null,
  title?: string | null,
  officialTitle?: string | null,
  degrees?: Array< Degree > | null,
  requiresBachelors?: boolean | null,
  requiresMasters?: boolean | null,
  requiresPhd?: boolean | null,
  dotNumber?: string | null,
  caseSocCode?: string | null,
  duties?: string | null,
  jobURL?: string | null,
  majors?: string | null,
  specialRequirements?: string | null,
  yearsGeneralExperience?: number | null,
  objectiveSkillSetsRequired?: string | null,
  offeredSalary?: string | null,
  certificationLicenses?: string | null,
  travelIsRequired?: boolean | null,
  travelPercentage?: number | null,
  travelDomestic?: boolean | null,
  travelInternational?: boolean | null,
  supervisesOthers?: boolean | null,
  supervisesOthersCount?: number | null,
  supervisesTitles?: Array< string > | null,
  supervisorTitle?: string | null,
  canWorkFromHome?: boolean | null,
  uploadedDescriptionID?: string | null,
};

export type ModelJobDescriptionConditionInput = {
  companyID?: ModelIDInput | null,
  archived?: ModelArchivedStateInput | null,
  type?: ModelJobDescriptionTypeInput | null,
  foreignNationalID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  officialTitle?: ModelStringInput | null,
  degrees?: ModelDegreeListInput | null,
  requiresBachelors?: ModelBooleanInput | null,
  requiresMasters?: ModelBooleanInput | null,
  requiresPhd?: ModelBooleanInput | null,
  dotNumber?: ModelStringInput | null,
  caseSocCode?: ModelStringInput | null,
  duties?: ModelStringInput | null,
  jobURL?: ModelStringInput | null,
  majors?: ModelStringInput | null,
  specialRequirements?: ModelStringInput | null,
  yearsGeneralExperience?: ModelIntInput | null,
  objectiveSkillSetsRequired?: ModelStringInput | null,
  offeredSalary?: ModelStringInput | null,
  certificationLicenses?: ModelStringInput | null,
  travelIsRequired?: ModelBooleanInput | null,
  travelPercentage?: ModelIntInput | null,
  travelDomestic?: ModelBooleanInput | null,
  travelInternational?: ModelBooleanInput | null,
  supervisesOthers?: ModelBooleanInput | null,
  supervisesOthersCount?: ModelIntInput | null,
  supervisesTitles?: ModelStringInput | null,
  supervisorTitle?: ModelStringInput | null,
  canWorkFromHome?: ModelBooleanInput | null,
  uploadedDescriptionID?: ModelIDInput | null,
  and?: Array< ModelJobDescriptionConditionInput | null > | null,
  or?: Array< ModelJobDescriptionConditionInput | null > | null,
  not?: ModelJobDescriptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelJobDescriptionTypeInput = {
  eq?: JobDescriptionType | null,
  ne?: JobDescriptionType | null,
};

export type ModelDegreeListInput = {
  eq?: Array< Degree | null > | null,
  ne?: Array< Degree | null > | null,
  contains?: Degree | null,
  notContains?: Degree | null,
};

export type SearchableReportEntriesFilterInput = {
  id?: SearchableIDFilterInput | null,
  reportID?: SearchableIDFilterInput | null,
  companyID?: SearchableIDFilterInput | null,
  foreignNationalID?: SearchableIDFilterInput | null,
  fullname?: SearchableStringFilterInput | null,
  firstname?: SearchableStringFilterInput | null,
  lastname?: SearchableStringFilterInput | null,
  middlename?: SearchableStringFilterInput | null,
  archived?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  personalEmail?: SearchableStringFilterInput | null,
  birthDate?: SearchableStringFilterInput | null,
  numberOfDependents?: SearchableIntFilterInput | null,
  numberOfFamilyContacts?: SearchableIntFilterInput | null,
  displayCompanyName?: SearchableStringFilterInput | null,
  companyLegalName?: SearchableStringFilterInput | null,
  companyFullName?: SearchableStringFilterInput | null,
  sponsoringCompanyFullName?: SearchableStringFilterInput | null,
  companyDbaName?: SearchableStringFilterInput | null,
  immigrationCurrentStatus?: SearchableStringFilterInput | null,
  immigrationStatusExpiration?: SearchableStringFilterInput | null,
  birthCountryCode?: SearchableStringFilterInput | null,
  citizenshipCountry?: SearchableStringFilterInput | null,
  chargeabilityCountry?: SearchableStringFilterInput | null,
  passportExpirationDate?: SearchableStringFilterInput | null,
  nivMaxout?: SearchableStringFilterInput | null,
  visaExpDate?: SearchableStringFilterInput | null,
  hasApprovedI140?: SearchableBooleanFilterInput | null,
  petitionerI140?: SearchableStringFilterInput | null,
  employmentBasedCategory?: SearchableStringFilterInput | null,
  priorityDate?: SearchableStringFilterInput | null,
  fnJobTitle?: SearchableStringFilterInput | null,
  socCode?: SearchableStringFilterInput | null,
  caseSocCode?: SearchableStringFilterInput | null,
  fnSalary?: SearchableStringFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  fnWorkLocation?: SearchableStringFilterInput | null,
  addressPrimary?: SearchableStringFilterInput | null,
  addressSecondary?: SearchableStringFilterInput | null,
  usResidentialAddress?: SearchableStringFilterInput | null,
  lastProcessType?: SearchableStringFilterInput | null,
  currentProcessType?: SearchableStringFilterInput | null,
  lowerProcessType?: SearchableStringFilterInput | null,
  lastPhaseCompleted?: SearchableStringFilterInput | null,
  currentPhase?: SearchableStringFilterInput | null,
  capType?: SearchableStringFilterInput | null,
  eadExpDate?: SearchableStringFilterInput | null,
  I797ApprovalExpDate?: SearchableStringFilterInput | null,
  I94ExpDate?: SearchableStringFilterInput | null,
  I94DS?: SearchableStringFilterInput | null,
  greenCardExpDate?: SearchableStringFilterInput | null,
  prevailingWageExpDate?: SearchableStringFilterInput | null,
  citizenshipEligibilityDate?: SearchableStringFilterInput | null,
  rfeDueDate?: SearchableStringFilterInput | null,
  dolAuditDueDate?: SearchableStringFilterInput | null,
  pwdExpDate?: SearchableStringFilterInput | null,
  firstEntryUS?: SearchableStringFilterInput | null,
  taxTrackingF1J1?: SearchableStringFilterInput | null,
  agreementExpDate?: SearchableStringFilterInput | null,
  agreementEffectiveDate?: SearchableStringFilterInput | null,
  mswsowExpDate?: SearchableStringFilterInput | null,
  permDueDate?: SearchableStringFilterInput | null,
  lotterySelectionDueDate?: SearchableStringFilterInput | null,
  advancedParoleExpDate?: SearchableStringFilterInput | null,
  reEntryPermitExpDate?: SearchableStringFilterInput | null,
  certifiedLcaExpDate?: SearchableStringFilterInput | null,
  title?: SearchableStringFilterInput | null,
  notes?: SearchableStringFilterInput | null,
  DS2019ExpDate?: SearchableStringFilterInput | null,
  isRelative?: SearchableBooleanFilterInput | null,
  relativeIds?: SearchableStringFilterInput | null,
  nextPhase?: SearchableStringFilterInput | null,
  requestedProcessSubCategory?: SearchableStringFilterInput | null,
  fnNameSlug?: SearchableStringFilterInput | null,
  caseSlug?: SearchableStringFilterInput | null,
  companyNameSlug?: SearchableStringFilterInput | null,
  employerNameSlug?: SearchableStringFilterInput | null,
  inviteStatus?: SearchableStringFilterInput | null,
  passportNumber?: SearchableStringFilterInput | null,
  phoneNumber?: SearchableStringFilterInput | null,
  personalPhone?: SearchableStringFilterInput | null,
  faxNumber?: SearchableStringFilterInput | null,
  passportGender?: SearchableStringFilterInput | null,
  preferredMailingAddress?: SearchableStringFilterInput | null,
  onboardingSections?: SearchableBooleanFilterInput | null,
  lastEntryUS?: SearchableStringFilterInput | null,
  employeeId?: SearchableStringFilterInput | null,
  caseNumber?: SearchableStringFilterInput | null,
  requestedProcess?: SearchableStringFilterInput | null,
  attorneyID?: SearchableStringFilterInput | null,
  caseAttorney?: SearchableStringFilterInput | null,
  sponsoringEmployerID?: SearchableStringFilterInput | null,
  sponsoringNationalID?: SearchableStringFilterInput | null,
  caseSponsor?: SearchableStringFilterInput | null,
  caseSponsorId?: SearchableStringFilterInput | null,
  caseManagerID?: SearchableStringFilterInput | null,
  caseManager?: SearchableStringFilterInput | null,
  contributorIds?: SearchableStringFilterInput | null,
  caseContributors?: SearchableStringFilterInput | null,
  caseStartDate?: SearchableStringFilterInput | null,
  caseOpenDate?: SearchableStringFilterInput | null,
  caseSalary?: SearchableStringFilterInput | null,
  state?: SearchableStringFilterInput | null,
  workLocation?: SearchableStringFilterInput | null,
  keyFilingDates?: SearchableStringFilterInput | null,
  lcaFiled?: SearchableStringFilterInput | null,
  capGap?: SearchableStringFilterInput | null,
  visaAdditionalProcessing?: SearchableStringFilterInput | null,
  stemExtEligible?: SearchableStringFilterInput | null,
  educationEvaluationNeeded?: SearchableStringFilterInput | null,
  wageIssues?: SearchableStringFilterInput | null,
  selection?: SearchableStringFilterInput | null,
  caseNature?: SearchableStringFilterInput | null,
  registrationCompleted?: SearchableStringFilterInput | null,
  receiptNumber?: SearchableStringFilterInput | null,
  currentCaseStatusText?: SearchableStringFilterInput | null,
  modifiedDate?: SearchableStringFilterInput | null,
  incompleteUscisReceiptNumber?: SearchableBooleanFilterInput | null,
  caseStatusHistory?: SearchableStringFilterInput | null,
  companyAttorneys?: SearchableStringFilterInput | null,
  companyAttorneyIds?: SearchableStringFilterInput | null,
  companyParalegals?: SearchableStringFilterInput | null,
  companyParalegalIds?: SearchableStringFilterInput | null,
  companyTotalCases?: SearchableStringFilterInput | null,
  companyTotalOpenCases?: SearchableStringFilterInput | null,
  companyTotalClosedCases?: SearchableStringFilterInput | null,
  companyTotalCompletedCases?: SearchableStringFilterInput | null,
  companyNationalCount?: SearchableStringFilterInput | null,
  fullTimeEmployeesInUS?: SearchableStringFilterInput | null,
  partTimeEmployeesInUS?: SearchableStringFilterInput | null,
  companyActiveNationalCount?: SearchableStringFilterInput | null,
  grossRevenueForMostRecentFiscalYear?: SearchableStringFilterInput | null,
  netRevenueForMostRecentFiscalYear?: SearchableStringFilterInput | null,
  naicsCodeOfCompany?: SearchableStringFilterInput | null,
  typeOfBusiness?: SearchableStringFilterInput | null,
  fein?: SearchableStringFilterInput | null,
  yearCompanyWasFoundedInUS?: SearchableStringFilterInput | null,
  aosFilingEligible?: SearchableStringFilterInput | null,
  requiresMeetingReminder?: SearchableBooleanFilterInput | null,
  isParent?: SearchableBooleanFilterInput | null,
  isPartnerCompany?: SearchableBooleanFilterInput | null,
  companyWhitelistedDomains?: SearchableStringFilterInput | null,
  companyContactLabel?: SearchableStringFilterInput | null,
  annualMeetingDate?: SearchableStringFilterInput | null,
  emCompanyNames?: SearchableStringFilterInput | null,
  emCompanyNameSlugs?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableReportEntriesFilterInput | null > | null,
  or?: Array< SearchableReportEntriesFilterInput | null > | null,
  not?: SearchableReportEntriesFilterInput | null,
};

export type SearchableReportEntriesSortInput = {
  field?: SearchableReportEntriesSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReportEntriesSortableFields {
  id = "id",
  reportID = "reportID",
  companyID = "companyID",
  foreignNationalID = "foreignNationalID",
  fullname = "fullname",
  firstname = "firstname",
  lastname = "lastname",
  middlename = "middlename",
  archived = "archived",
  email = "email",
  personalEmail = "personalEmail",
  birthDate = "birthDate",
  numberOfDependents = "numberOfDependents",
  numberOfFamilyContacts = "numberOfFamilyContacts",
  displayCompanyName = "displayCompanyName",
  companyLegalName = "companyLegalName",
  companyFullName = "companyFullName",
  sponsoringCompanyFullName = "sponsoringCompanyFullName",
  companyDbaName = "companyDbaName",
  immigrationCurrentStatus = "immigrationCurrentStatus",
  immigrationStatusExpiration = "immigrationStatusExpiration",
  birthCountryCode = "birthCountryCode",
  citizenshipCountry = "citizenshipCountry",
  chargeabilityCountry = "chargeabilityCountry",
  passportExpirationDate = "passportExpirationDate",
  nivMaxout = "nivMaxout",
  visaExpDate = "visaExpDate",
  hasApprovedI140 = "hasApprovedI140",
  petitionerI140 = "petitionerI140",
  employmentBasedCategory = "employmentBasedCategory",
  priorityDate = "priorityDate",
  fnJobTitle = "fnJobTitle",
  socCode = "socCode",
  caseSocCode = "caseSocCode",
  fnSalary = "fnSalary",
  startDate = "startDate",
  fnWorkLocation = "fnWorkLocation",
  addressPrimary = "addressPrimary",
  addressSecondary = "addressSecondary",
  usResidentialAddress = "usResidentialAddress",
  lastProcessType = "lastProcessType",
  currentProcessType = "currentProcessType",
  lowerProcessType = "lowerProcessType",
  lastPhaseCompleted = "lastPhaseCompleted",
  currentPhase = "currentPhase",
  capType = "capType",
  eadExpDate = "eadExpDate",
  I797ApprovalExpDate = "I797ApprovalExpDate",
  I94ExpDate = "I94ExpDate",
  I94DS = "I94DS",
  greenCardExpDate = "greenCardExpDate",
  prevailingWageExpDate = "prevailingWageExpDate",
  citizenshipEligibilityDate = "citizenshipEligibilityDate",
  rfeDueDate = "rfeDueDate",
  dolAuditDueDate = "dolAuditDueDate",
  pwdExpDate = "pwdExpDate",
  firstEntryUS = "firstEntryUS",
  taxTrackingF1J1 = "taxTrackingF1J1",
  agreementExpDate = "agreementExpDate",
  agreementEffectiveDate = "agreementEffectiveDate",
  mswsowExpDate = "mswsowExpDate",
  permDueDate = "permDueDate",
  lotterySelectionDueDate = "lotterySelectionDueDate",
  advancedParoleExpDate = "advancedParoleExpDate",
  reEntryPermitExpDate = "reEntryPermitExpDate",
  certifiedLcaExpDate = "certifiedLcaExpDate",
  title = "title",
  notes = "notes",
  DS2019ExpDate = "DS2019ExpDate",
  isRelative = "isRelative",
  relativeIds = "relativeIds",
  nextPhase = "nextPhase",
  requestedProcessSubCategory = "requestedProcessSubCategory",
  fnNameSlug = "fnNameSlug",
  caseSlug = "caseSlug",
  companyNameSlug = "companyNameSlug",
  employerNameSlug = "employerNameSlug",
  inviteStatus = "inviteStatus",
  passportNumber = "passportNumber",
  phoneNumber = "phoneNumber",
  personalPhone = "personalPhone",
  faxNumber = "faxNumber",
  passportGender = "passportGender",
  preferredMailingAddress = "preferredMailingAddress",
  onboardingSections = "onboardingSections",
  lastEntryUS = "lastEntryUS",
  employeeId = "employeeId",
  caseNumber = "caseNumber",
  requestedProcess = "requestedProcess",
  attorneyID = "attorneyID",
  caseAttorney = "caseAttorney",
  sponsoringEmployerID = "sponsoringEmployerID",
  sponsoringNationalID = "sponsoringNationalID",
  caseSponsor = "caseSponsor",
  caseSponsorId = "caseSponsorId",
  caseManagerID = "caseManagerID",
  caseManager = "caseManager",
  contributorIds = "contributorIds",
  caseContributors = "caseContributors",
  caseStartDate = "caseStartDate",
  caseOpenDate = "caseOpenDate",
  caseSalary = "caseSalary",
  state = "state",
  workLocation = "workLocation",
  keyFilingDates = "keyFilingDates",
  lcaFiled = "lcaFiled",
  capGap = "capGap",
  visaAdditionalProcessing = "visaAdditionalProcessing",
  stemExtEligible = "stemExtEligible",
  educationEvaluationNeeded = "educationEvaluationNeeded",
  wageIssues = "wageIssues",
  selection = "selection",
  caseNature = "caseNature",
  registrationCompleted = "registrationCompleted",
  receiptNumber = "receiptNumber",
  currentCaseStatusText = "currentCaseStatusText",
  modifiedDate = "modifiedDate",
  incompleteUscisReceiptNumber = "incompleteUscisReceiptNumber",
  caseStatusHistory = "caseStatusHistory",
  companyAttorneys = "companyAttorneys",
  companyAttorneyIds = "companyAttorneyIds",
  companyParalegals = "companyParalegals",
  companyParalegalIds = "companyParalegalIds",
  companyTotalCases = "companyTotalCases",
  companyTotalOpenCases = "companyTotalOpenCases",
  companyTotalClosedCases = "companyTotalClosedCases",
  companyTotalCompletedCases = "companyTotalCompletedCases",
  companyNationalCount = "companyNationalCount",
  fullTimeEmployeesInUS = "fullTimeEmployeesInUS",
  partTimeEmployeesInUS = "partTimeEmployeesInUS",
  companyActiveNationalCount = "companyActiveNationalCount",
  grossRevenueForMostRecentFiscalYear = "grossRevenueForMostRecentFiscalYear",
  netRevenueForMostRecentFiscalYear = "netRevenueForMostRecentFiscalYear",
  naicsCodeOfCompany = "naicsCodeOfCompany",
  typeOfBusiness = "typeOfBusiness",
  fein = "fein",
  yearCompanyWasFoundedInUS = "yearCompanyWasFoundedInUS",
  aosFilingEligible = "aosFilingEligible",
  requiresMeetingReminder = "requiresMeetingReminder",
  isParent = "isParent",
  isPartnerCompany = "isPartnerCompany",
  companyWhitelistedDomains = "companyWhitelistedDomains",
  companyContactLabel = "companyContactLabel",
  annualMeetingDate = "annualMeetingDate",
  emCompanyNames = "emCompanyNames",
  emCompanyNameSlugs = "emCompanyNameSlugs",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReportEntriesConnection = {
  __typename: "SearchableReportEntriesConnection",
  items:  Array<ReportEntries | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReportFilterInput = {
  id?: ModelIDInput | null,
  templateID?: ModelIDInput | null,
  companyIds?: ModelIDInput | null,
  accessibleIds?: ModelIDInput | null,
  editableIds?: ModelIDInput | null,
  viewAccess?: ModelAccessPermissionInput | null,
  editAccess?: ModelEditPermissionInput | null,
  type?: ModelTemplateTypeInput | null,
  name?: ModelStringInput | null,
  status?: ModelReportStatusInput | null,
  numberOfFilters?: ModelIntInput | null,
  numberOfColumns?: ModelIntInput | null,
  fromTemplate?: ModelBooleanInput | null,
  totalCountCycle?: ModelIntInput | null,
  completedCountCycle?: ModelIntInput | null,
  isCurrent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReportFilterInput | null > | null,
  or?: Array< ModelReportFilterInput | null > | null,
  not?: ModelReportFilterInput | null,
};

export type ModelAccessPermissionInput = {
  eq?: AccessPermission | null,
  ne?: AccessPermission | null,
};

export type ModelEditPermissionInput = {
  eq?: EditPermission | null,
  ne?: EditPermission | null,
};

export type ModelTemplateTypeInput = {
  eq?: TemplateType | null,
  ne?: TemplateType | null,
};

export type ModelReportStatusInput = {
  eq?: ReportStatus | null,
  ne?: ReportStatus | null,
};

export type ModelCustomTemplateFilterInput = {
  id?: ModelIDInput | null,
  teamMemberId?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  accessibleIds?: ModelIDInput | null,
  editableIds?: ModelIDInput | null,
  name?: ModelStringInput | null,
  selectedFields?: ModelStringInput | null,
  includeFN?: ModelBooleanInput | null,
  individualFNCase?: ModelBooleanInput | null,
  includeCases?: ModelBooleanInput | null,
  numberOfFilters?: ModelIntInput | null,
  numberOfColumns?: ModelIntInput | null,
  type?: ModelTemplateTypeInput | null,
  category?: ModelTemplateCategoryInput | null,
  isDeleted?: ModelBooleanInput | null,
  viewAccess?: ModelAccessPermissionInput | null,
  editAccess?: ModelEditPermissionInput | null,
  accessibleCompanyIds?: ModelIDInput | null,
  companyIds?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCustomTemplateFilterInput | null > | null,
  or?: Array< ModelCustomTemplateFilterInput | null > | null,
  not?: ModelCustomTemplateFilterInput | null,
};

export type ModelTemplateCategoryInput = {
  eq?: TemplateCategory | null,
  ne?: TemplateCategory | null,
};

export type SearchableCompanySortInput = {
  field?: SearchableCompanySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCompanySortableFields {
  id = "id",
  name = "name",
  lowerName = "lowerName",
  lowerNameKey = "lowerNameKey",
  displayCompanyName = "displayCompanyName",
  slug = "slug",
  domainWhitelist = "domainWhitelist",
  hasCompletedOnboardingQuestions = "hasCompletedOnboardingQuestions",
  completedOnboardingQuestionsBy = "completedOnboardingQuestionsBy",
  isPartnerCompany = "isPartnerCompany",
  isParent = "isParent",
  parentID = "parentID",
  companyNumber = "companyNumber",
  nationalCount = "nationalCount",
  accountManagerID = "accountManagerID",
  openCaseCount = "openCaseCount",
  closedCaseCount = "closedCaseCount",
  completedCaseCount = "completedCaseCount",
  legalTeamIDs = "legalTeamIDs",
  notes = "notes",
  petitionerParagraph = "petitionerParagraph",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  companyDataId = "companyDataId",
}


export type SearchableCompanyAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableCompanyAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
  cardinality = "cardinality",
}


export enum SearchableCompanyAggregateField {
  id = "id",
  name = "name",
  lowerName = "lowerName",
  lowerNameKey = "lowerNameKey",
  displayCompanyName = "displayCompanyName",
  slug = "slug",
  type = "type",
  domainWhitelist = "domainWhitelist",
  hasCompletedOnboardingQuestions = "hasCompletedOnboardingQuestions",
  completedOnboardingQuestionsBy = "completedOnboardingQuestionsBy",
  isPartnerCompany = "isPartnerCompany",
  isParent = "isParent",
  parentID = "parentID",
  archived = "archived",
  companyNumber = "companyNumber",
  nationalCount = "nationalCount",
  accountManagerID = "accountManagerID",
  openCaseCount = "openCaseCount",
  closedCaseCount = "closedCaseCount",
  completedCaseCount = "completedCaseCount",
  legalTeamIDs = "legalTeamIDs",
  notes = "notes",
  petitionerParagraph = "petitionerParagraph",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  companyDataId = "companyDataId",
}


export type ModelEmployerFilterInput = {
  id?: ModelIDInput | null,
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  type?: ModelPersonTypeInput | null,
  email?: ModelStringInput | null,
  personalEmail?: ModelStringInput | null,
  newsletterModalViewCount?: ModelIntInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  address?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  personalPhone?: ModelStringInput | null,
  title?: ModelStringInput | null,
  companyIDs?: ModelStringInput | null,
  hasCompletedOnboardingQuestions?: ModelBooleanInput | null,
  recentlyViewedCases?: ModelIDInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  invoicingContactCompanyIDs?: ModelIDInput | null,
  isInvoicingContact?: ModelBooleanInput | null,
  primaryContactCompanyIDs?: ModelIDInput | null,
  isPrimaryContact?: ModelBooleanInput | null,
  seniorContactCompanyIDs?: ModelIDInput | null,
  isSeniorContact?: ModelBooleanInput | null,
  signatoryContactCompanyIDs?: ModelIDInput | null,
  isSignatoryContact?: ModelBooleanInput | null,
  assignedCaseIDs?: ModelIDInput | null,
  nationalsWithOpenCases?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmployerFilterInput | null > | null,
  or?: Array< ModelEmployerFilterInput | null > | null,
  not?: ModelEmployerFilterInput | null,
};

export type ModelTeamMemberFilterInput = {
  id?: ModelIDInput | null,
  createdBy?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  userAgreementAcknowledged?: ModelBooleanInput | null,
  userAgreementAcknowledgementDate?: ModelStringInput | null,
  userAgreementAcknowledgementText?: ModelStringInput | null,
  hasLoggedIn?: ModelBooleanInput | null,
  type?: ModelPersonTypeInput | null,
  email?: ModelStringInput | null,
  username?: ModelIDInput | null,
  firstname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  lowerFirst?: ModelStringInput | null,
  lowerLast?: ModelStringInput | null,
  lowerFull?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  position?: ModelPositionInput | null,
  title?: ModelStringInput | null,
  licensingAuthority?: ModelStringInput | null,
  stateBarNumber?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  managerID?: ModelIDInput | null,
  mostRecentlyInvited?: ModelStringInput | null,
  archived?: ModelArchivedStateInput | null,
  recentlyViewedCases?: ModelIDInput | null,
  nationalsWithOpenCases?: ModelIDInput | null,
  companiesAssignedTo?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTeamMemberFilterInput | null > | null,
  or?: Array< ModelTeamMemberFilterInput | null > | null,
  not?: ModelTeamMemberFilterInput | null,
};

export type ModelCompanyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  lowerName?: ModelStringInput | null,
  lowerNameKey?: ModelStringInput | null,
  displayCompanyName?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  type?: ModelCompanyTypeInput | null,
  domainWhitelist?: ModelStringInput | null,
  hasCompletedOnboardingQuestions?: ModelBooleanInput | null,
  completedOnboardingQuestionsBy?: ModelStringInput | null,
  isPartnerCompany?: ModelBooleanInput | null,
  isParent?: ModelBooleanInput | null,
  parentID?: ModelIDInput | null,
  archived?: ModelArchivedStateInput | null,
  companyNumber?: ModelIntInput | null,
  nationalCount?: ModelIntInput | null,
  accountManagerID?: ModelIDInput | null,
  openCaseCount?: ModelIntInput | null,
  closedCaseCount?: ModelIntInput | null,
  completedCaseCount?: ModelIntInput | null,
  legalTeamIDs?: ModelIDInput | null,
  notes?: ModelStringInput | null,
  petitionerParagraph?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCompanyFilterInput | null > | null,
  or?: Array< ModelCompanyFilterInput | null > | null,
  not?: ModelCompanyFilterInput | null,
  companyDataId?: ModelIDInput | null,
};

export type ModelSchedulerFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  eventBridgeschedulerName?: ModelStringInput | null,
  eventBridgeSchedulerID?: ModelStringInput | null,
  description?: ModelStringInput | null,
  schedulerExpression?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  frequencyNumber?: ModelIntInput | null,
  frequencyUnit?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  timeZone?: ModelStringInput | null,
  targetUrl?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  taskDefinitionID?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSchedulerFilterInput | null > | null,
  or?: Array< ModelSchedulerFilterInput | null > | null,
  not?: ModelSchedulerFilterInput | null,
};

export type ModelSchedulerConnection = {
  __typename: "ModelSchedulerConnection",
  items:  Array<Scheduler | null >,
  nextToken?: string | null,
};

export type Scheduler = {
  __typename: "Scheduler",
  id: string,
  name: string,
  eventBridgeschedulerName: string,
  eventBridgeSchedulerID: string,
  description?: string | null,
  schedulerExpression: string,
  endDate: string,
  startTime: string,
  frequencyNumber: number,
  frequencyUnit: string,
  startDate: string,
  timeZone: string,
  targetUrl: string,
  entityID: string,
  taskDefinitionID: string,
  taskDefinition?: TaskDefinition | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type TaskDefinition = {
  __typename: "TaskDefinition",
  id: string,
  taskType: TaskType,
  scheduler?: Scheduler | null,
  payload: string,
  recipientIDs?: Array< string > | null,
  companyIndividualIDs?: Array< string | null > | null,
  individualIDs?: Array< string | null > | null,
  companyIDs?: Array< string > | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export enum TaskType {
  REPORT = "REPORT",
}


export type SearchableCustomTemplateFilterInput = {
  id?: SearchableIDFilterInput | null,
  teamMemberId?: SearchableIDFilterInput | null,
  employerID?: SearchableIDFilterInput | null,
  accessibleIds?: SearchableIDFilterInput | null,
  editableIds?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  selectedFields?: SearchableStringFilterInput | null,
  includeFN?: SearchableBooleanFilterInput | null,
  individualFNCase?: SearchableBooleanFilterInput | null,
  includeCases?: SearchableBooleanFilterInput | null,
  numberOfFilters?: SearchableIntFilterInput | null,
  numberOfColumns?: SearchableIntFilterInput | null,
  isDeleted?: SearchableBooleanFilterInput | null,
  accessibleCompanyIds?: SearchableIDFilterInput | null,
  companyIds?: SearchableIDFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  category?: SearchableStringFilterInput | null,
  viewAccess?: SearchableStringFilterInput | null,
  editAccess?: SearchableStringFilterInput | null,
  and?: Array< SearchableCustomTemplateFilterInput | null > | null,
  or?: Array< SearchableCustomTemplateFilterInput | null > | null,
  not?: SearchableCustomTemplateFilterInput | null,
};

export type SearchableCustomTemplateSortInput = {
  field?: SearchableCustomTemplateSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableCustomTemplateSortableFields {
  id = "id",
  teamMemberId = "teamMemberId",
  employerID = "employerID",
  accessibleIds = "accessibleIds",
  editableIds = "editableIds",
  name = "name",
  selectedFields = "selectedFields",
  includeFN = "includeFN",
  individualFNCase = "individualFNCase",
  includeCases = "includeCases",
  numberOfFilters = "numberOfFilters",
  numberOfColumns = "numberOfColumns",
  isDeleted = "isDeleted",
  accessibleCompanyIds = "accessibleCompanyIds",
  companyIds = "companyIds",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCustomTemplateAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableCustomTemplateAggregateField,
};

export enum SearchableCustomTemplateAggregateField {
  id = "id",
  teamMemberId = "teamMemberId",
  employerID = "employerID",
  accessibleIds = "accessibleIds",
  editableIds = "editableIds",
  name = "name",
  selectedFields = "selectedFields",
  includeFN = "includeFN",
  individualFNCase = "individualFNCase",
  includeCases = "includeCases",
  numberOfFilters = "numberOfFilters",
  numberOfColumns = "numberOfColumns",
  type = "type",
  category = "category",
  isDeleted = "isDeleted",
  viewAccess = "viewAccess",
  editAccess = "editAccess",
  accessibleCompanyIds = "accessibleCompanyIds",
  companyIds = "companyIds",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCustomTemplateConnection = {
  __typename: "SearchableCustomTemplateConnection",
  items:  Array<CustomTemplate | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableEmployerSortInput = {
  field?: SearchableEmployerSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableEmployerSortableFields {
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  email = "email",
  personalEmail = "personalEmail",
  newsletterModalViewCount = "newsletterModalViewCount",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  address = "address",
  phone = "phone",
  personalPhone = "personalPhone",
  title = "title",
  companyIDs = "companyIDs",
  hasCompletedOnboardingQuestions = "hasCompletedOnboardingQuestions",
  recentlyViewedCases = "recentlyViewedCases",
  mostRecentlyInvited = "mostRecentlyInvited",
  invoicingContactCompanyIDs = "invoicingContactCompanyIDs",
  isInvoicingContact = "isInvoicingContact",
  primaryContactCompanyIDs = "primaryContactCompanyIDs",
  isPrimaryContact = "isPrimaryContact",
  seniorContactCompanyIDs = "seniorContactCompanyIDs",
  isSeniorContact = "isSeniorContact",
  signatoryContactCompanyIDs = "signatoryContactCompanyIDs",
  isSignatoryContact = "isSignatoryContact",
  assignedCaseIDs = "assignedCaseIDs",
  nationalsWithOpenCases = "nationalsWithOpenCases",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableEmployerAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableEmployerAggregateField,
};

export enum SearchableEmployerAggregateField {
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  type = "type",
  email = "email",
  personalEmail = "personalEmail",
  newsletterModalViewCount = "newsletterModalViewCount",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  address = "address",
  phone = "phone",
  personalPhone = "personalPhone",
  title = "title",
  companyIDs = "companyIDs",
  hasCompletedOnboardingQuestions = "hasCompletedOnboardingQuestions",
  recentlyViewedCases = "recentlyViewedCases",
  mostRecentlyInvited = "mostRecentlyInvited",
  archived = "archived",
  invoicingContactCompanyIDs = "invoicingContactCompanyIDs",
  isInvoicingContact = "isInvoicingContact",
  primaryContactCompanyIDs = "primaryContactCompanyIDs",
  isPrimaryContact = "isPrimaryContact",
  seniorContactCompanyIDs = "seniorContactCompanyIDs",
  isSeniorContact = "isSeniorContact",
  signatoryContactCompanyIDs = "signatoryContactCompanyIDs",
  isSignatoryContact = "isSignatoryContact",
  assignedCaseIDs = "assignedCaseIDs",
  nationalsWithOpenCases = "nationalsWithOpenCases",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableTeamMemberSortInput = {
  field?: SearchableTeamMemberSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableTeamMemberSortableFields {
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  email = "email",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  phone = "phone",
  title = "title",
  licensingAuthority = "licensingAuthority",
  stateBarNumber = "stateBarNumber",
  isAdmin = "isAdmin",
  managerID = "managerID",
  mostRecentlyInvited = "mostRecentlyInvited",
  recentlyViewedCases = "recentlyViewedCases",
  nationalsWithOpenCases = "nationalsWithOpenCases",
  companiesAssignedTo = "companiesAssignedTo",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableTeamMemberAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableTeamMemberAggregateField,
};

export enum SearchableTeamMemberAggregateField {
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  type = "type",
  email = "email",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  phone = "phone",
  position = "position",
  title = "title",
  licensingAuthority = "licensingAuthority",
  stateBarNumber = "stateBarNumber",
  isAdmin = "isAdmin",
  managerID = "managerID",
  mostRecentlyInvited = "mostRecentlyInvited",
  archived = "archived",
  recentlyViewedCases = "recentlyViewedCases",
  nationalsWithOpenCases = "nationalsWithOpenCases",
  companiesAssignedTo = "companiesAssignedTo",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableSchedulerFilterInput = {
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  eventBridgeschedulerName?: SearchableStringFilterInput | null,
  eventBridgeSchedulerID?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  schedulerExpression?: SearchableStringFilterInput | null,
  endDate?: SearchableStringFilterInput | null,
  startTime?: SearchableStringFilterInput | null,
  frequencyNumber?: SearchableIntFilterInput | null,
  frequencyUnit?: SearchableStringFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  timeZone?: SearchableStringFilterInput | null,
  targetUrl?: SearchableStringFilterInput | null,
  entityID?: SearchableIDFilterInput | null,
  taskDefinitionID?: SearchableIDFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableSchedulerFilterInput | null > | null,
  or?: Array< SearchableSchedulerFilterInput | null > | null,
  not?: SearchableSchedulerFilterInput | null,
};

export type SearchableSchedulerSortInput = {
  field?: SearchableSchedulerSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableSchedulerSortableFields {
  id = "id",
  name = "name",
  eventBridgeschedulerName = "eventBridgeschedulerName",
  eventBridgeSchedulerID = "eventBridgeSchedulerID",
  description = "description",
  schedulerExpression = "schedulerExpression",
  endDate = "endDate",
  startTime = "startTime",
  frequencyNumber = "frequencyNumber",
  frequencyUnit = "frequencyUnit",
  startDate = "startDate",
  timeZone = "timeZone",
  targetUrl = "targetUrl",
  entityID = "entityID",
  taskDefinitionID = "taskDefinitionID",
  updatedAt = "updatedAt",
  createdAt = "createdAt",
}


export type SearchableSchedulerAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableSchedulerAggregateField,
};

export enum SearchableSchedulerAggregateField {
  id = "id",
  name = "name",
  eventBridgeschedulerName = "eventBridgeschedulerName",
  eventBridgeSchedulerID = "eventBridgeSchedulerID",
  description = "description",
  schedulerExpression = "schedulerExpression",
  endDate = "endDate",
  startTime = "startTime",
  frequencyNumber = "frequencyNumber",
  frequencyUnit = "frequencyUnit",
  startDate = "startDate",
  timeZone = "timeZone",
  targetUrl = "targetUrl",
  entityID = "entityID",
  taskDefinitionID = "taskDefinitionID",
  updatedAt = "updatedAt",
  createdAt = "createdAt",
}


export type SearchableSchedulerConnection = {
  __typename: "SearchableSchedulerConnection",
  items:  Array<Scheduler | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type CaseRfgp = {
  __typename: "CaseRfgp",
  id: string,
  caseID: string,
  items:  Array<RfgpItem >,
  status: RfgpStatus,
  jobID?: string | null,
  fileID?: string | null,
  file?: FileData | null,
  usedFileIDs?: Array< string > | null,
  skipped?:  Array<RfgpSkipped > | null,
  errorMessage?: string | null,
  generatedAt?: string | null,
  generatedByID?: string | null,
  generatedBy?: TeamMember | null,
  updatedByID?: string | null,
  updatedBy?: TeamMember | null,
  createdAt: string,
  updatedAt: string,
};

export type RfgpItem = {
  __typename: "RfgpItem",
  itemType: RfgpItemType,
  id: string,
};

export enum RfgpItemType {
  FILE = "FILE",
  FORM = "FORM",
}


export enum RfgpStatus {
  IDLE = "IDLE",
  GENERATING = "GENERATING",
  READY = "READY",
  FAILED = "FAILED",
}


export type RfgpSkipped = {
  __typename: "RfgpSkipped",
  itemType: RfgpItemType,
  id: string,
  reason: string,
};

export type CreateCaseRfgpInput = {
  id?: string | null,
  caseID: string,
  items: Array< RfgpItemInput >,
  status: RfgpStatus,
  jobID?: string | null,
  fileID?: string | null,
  usedFileIDs?: Array< string > | null,
  skipped?: Array< RfgpSkippedInput > | null,
  errorMessage?: string | null,
  generatedAt?: string | null,
  generatedByID?: string | null,
  updatedByID?: string | null,
};

export type RfgpItemInput = {
  itemType: RfgpItemType,
  id: string,
};

export type RfgpSkippedInput = {
  itemType: RfgpItemType,
  id: string,
  reason: string,
};

export type UpdateCaseRfgpInput = {
  id: string,
  caseID?: string | null,
  items?: Array< RfgpItemInput > | null,
  status?: RfgpStatus | null,
  jobID?: string | null,
  fileID?: string | null,
  usedFileIDs?: Array< string > | null,
  skipped?: Array< RfgpSkippedInput > | null,
  errorMessage?: string | null,
  generatedAt?: string | null,
  generatedByID?: string | null,
  updatedByID?: string | null,
};

export type ModelCaseRfgpConditionInput = {
  caseID?: ModelIDInput | null,
  status?: ModelRfgpStatusInput | null,
  jobID?: ModelIDInput | null,
  fileID?: ModelIDInput | null,
  usedFileIDs?: ModelIDInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  generatedByID?: ModelIDInput | null,
  updatedByID?: ModelIDInput | null,
  and?: Array< ModelCaseRfgpConditionInput | null > | null,
  or?: Array< ModelCaseRfgpConditionInput | null > | null,
  not?: ModelCaseRfgpConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelRfgpStatusInput = {
  eq?: RfgpStatus | null,
  ne?: RfgpStatus | null,
};

export type SearchableTaskFilterInput = {
  id?: SearchableIDFilterInput | null,
  action?: SearchableStringFilterInput | null,
  isKeyDate?: SearchableBooleanFilterInput | null,
  keyDateAlternateAction?: SearchableStringFilterInput | null,
  isPaymentStatus?: SearchableBooleanFilterInput | null,
  paymentStatusAlternateAction?: SearchableStringFilterInput | null,
  assignedToID?: SearchableIDFilterInput | null,
  isAssignedToLegalAssistants?: SearchableBooleanFilterInput | null,
  assignedToEmployerID?: SearchableIDFilterInput | null,
  assignedToForeignNationalID?: SearchableIDFilterInput | null,
  assignedToTeamMemberID?: SearchableIDFilterInput | null,
  caseID?: SearchableIDFilterInput | null,
  companyID?: SearchableIDFilterInput | null,
  completeDate?: SearchableStringFilterInput | null,
  deadline?: SearchableStringFilterInput | null,
  deadlineIsManuallySet?: SearchableBooleanFilterInput | null,
  deleteDate?: SearchableStringFilterInput | null,
  deleteReason?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  duration?: SearchableIntFilterInput | null,
  foreignNationalID?: SearchableIDFilterInput | null,
  groupsCanRead?: SearchableStringFilterInput | null,
  isCustom?: SearchableBooleanFilterInput | null,
  isManuallyUnlocked?: SearchableBooleanFilterInput | null,
  prerequisiteID?: SearchableIDFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  templateID?: SearchableIDFilterInput | null,
  assigneeLowerName?: SearchableStringFilterInput | null,
  attorneyLowerFirstName?: SearchableStringFilterInput | null,
  attorneyLowerName?: SearchableStringFilterInput | null,
  paralegalLowerName?: SearchableStringFilterInput | null,
  paralegalLowerFirstName?: SearchableStringFilterInput | null,
  companyLowerName?: SearchableStringFilterInput | null,
  nationalLowerName?: SearchableStringFilterInput | null,
  orderIndex?: SearchableIntFilterInput | null,
  defaultAssignee?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  foreignNationalTasksId?: SearchableIDFilterInput | null,
  employerTasksId?: SearchableIDFilterInput | null,
  caseState?: SearchableStringFilterInput | null,
  category?: SearchableStringFilterInput | null,
  state?: SearchableStringFilterInput | null,
  and?: Array< SearchableTaskFilterInput | null > | null,
  or?: Array< SearchableTaskFilterInput | null > | null,
  not?: SearchableTaskFilterInput | null,
};

export type SearchableTaskSortInput = {
  field?: SearchableTaskSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableTaskSortableFields {
  id = "id",
  action = "action",
  isKeyDate = "isKeyDate",
  keyDateAlternateAction = "keyDateAlternateAction",
  isPaymentStatus = "isPaymentStatus",
  paymentStatusAlternateAction = "paymentStatusAlternateAction",
  assignedToID = "assignedToID",
  isAssignedToLegalAssistants = "isAssignedToLegalAssistants",
  assignedToEmployerID = "assignedToEmployerID",
  assignedToForeignNationalID = "assignedToForeignNationalID",
  assignedToTeamMemberID = "assignedToTeamMemberID",
  caseID = "caseID",
  companyID = "companyID",
  completeDate = "completeDate",
  deadline = "deadline",
  deadlineIsManuallySet = "deadlineIsManuallySet",
  deleteDate = "deleteDate",
  deleteReason = "deleteReason",
  description = "description",
  duration = "duration",
  foreignNationalID = "foreignNationalID",
  groupsCanRead = "groupsCanRead",
  isCustom = "isCustom",
  isManuallyUnlocked = "isManuallyUnlocked",
  prerequisiteID = "prerequisiteID",
  startDate = "startDate",
  templateID = "templateID",
  assigneeLowerName = "assigneeLowerName",
  attorneyLowerFirstName = "attorneyLowerFirstName",
  attorneyLowerName = "attorneyLowerName",
  paralegalLowerName = "paralegalLowerName",
  paralegalLowerFirstName = "paralegalLowerFirstName",
  companyLowerName = "companyLowerName",
  nationalLowerName = "nationalLowerName",
  orderIndex = "orderIndex",
  defaultAssignee = "defaultAssignee",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  foreignNationalTasksId = "foreignNationalTasksId",
  employerTasksId = "employerTasksId",
}


export type SearchableTaskAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableTaskAggregateField,
};

export enum SearchableTaskAggregateField {
  id = "id",
  action = "action",
  isKeyDate = "isKeyDate",
  keyDateAlternateAction = "keyDateAlternateAction",
  isPaymentStatus = "isPaymentStatus",
  paymentStatusAlternateAction = "paymentStatusAlternateAction",
  assignedToID = "assignedToID",
  isAssignedToLegalAssistants = "isAssignedToLegalAssistants",
  assignedToEmployerID = "assignedToEmployerID",
  assignedToForeignNationalID = "assignedToForeignNationalID",
  assignedToTeamMemberID = "assignedToTeamMemberID",
  caseID = "caseID",
  caseState = "caseState",
  category = "category",
  companyID = "companyID",
  completeDate = "completeDate",
  deadline = "deadline",
  deadlineIsManuallySet = "deadlineIsManuallySet",
  deleteDate = "deleteDate",
  deleteReason = "deleteReason",
  description = "description",
  duration = "duration",
  foreignNationalID = "foreignNationalID",
  groupsCanRead = "groupsCanRead",
  isCustom = "isCustom",
  isManuallyUnlocked = "isManuallyUnlocked",
  prerequisiteID = "prerequisiteID",
  startDate = "startDate",
  state = "state",
  templateID = "templateID",
  assigneeLowerName = "assigneeLowerName",
  attorneyLowerFirstName = "attorneyLowerFirstName",
  attorneyLowerName = "attorneyLowerName",
  paralegalLowerName = "paralegalLowerName",
  paralegalLowerFirstName = "paralegalLowerFirstName",
  companyLowerName = "companyLowerName",
  nationalLowerName = "nationalLowerName",
  orderIndex = "orderIndex",
  defaultAssignee = "defaultAssignee",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  foreignNationalTasksId = "foreignNationalTasksId",
  employerTasksId = "employerTasksId",
}


export type SearchableTaskConnection = {
  __typename: "SearchableTaskConnection",
  items:  Array<Task | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type CreatePreparedFormInput = {
  id?: string | null,
  caseID?: string | null,
  companyID?: string | null,
  foreignNationalID: string,
  relativeAdmins?: Array< string > | null,
  state: PreparedFormState,
  preparerID?: string | null,
  templateID?: string | null,
  template?: PreparedFormTemplateInput | null,
  completedFormID?: string | null,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  rejectedDate?: string | null,
  rejectedByID?: string | null,
  rejectedByEmployerID?: string | null,
  rejectedByNationalID?: string | null,
  rejectedByTeamMemberID?: string | null,
  requiresAttorneyApproval?: boolean | null,
  attorneyApproverID?: string | null,
  attorneyApprovalDate?: string | null,
  requiresSponsorApproval?: boolean | null,
  sponsorApproverID?: string | null,
  sponsorApproverEmployerID?: string | null,
  sponsorApproverNationalID?: string | null,
  sponsorApprovalDate?: string | null,
  requiresNationalApproval?: boolean | null,
  nationalApproverID?: string | null,
  nationalApprovalDate?: string | null,
  finalCaseManagerApproverID?: string | null,
  finalCaseManagerApprovalDate?: string | null,
  employersCanView?: boolean | null,
  nationalsCanView?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelPreparedFormConditionInput = {
  caseID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  relativeAdmins?: ModelStringInput | null,
  state?: ModelPreparedFormStateInput | null,
  preparerID?: ModelIDInput | null,
  templateID?: ModelIDInput | null,
  completedFormID?: ModelIDInput | null,
  assignedToID?: ModelIDInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToNationalID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  rejectedDate?: ModelStringInput | null,
  rejectedByID?: ModelIDInput | null,
  rejectedByEmployerID?: ModelIDInput | null,
  rejectedByNationalID?: ModelIDInput | null,
  rejectedByTeamMemberID?: ModelIDInput | null,
  requiresAttorneyApproval?: ModelBooleanInput | null,
  attorneyApproverID?: ModelIDInput | null,
  attorneyApprovalDate?: ModelStringInput | null,
  requiresSponsorApproval?: ModelBooleanInput | null,
  sponsorApproverID?: ModelIDInput | null,
  sponsorApproverEmployerID?: ModelIDInput | null,
  sponsorApproverNationalID?: ModelIDInput | null,
  sponsorApprovalDate?: ModelStringInput | null,
  requiresNationalApproval?: ModelBooleanInput | null,
  nationalApproverID?: ModelIDInput | null,
  nationalApprovalDate?: ModelStringInput | null,
  finalCaseManagerApproverID?: ModelIDInput | null,
  finalCaseManagerApprovalDate?: ModelStringInput | null,
  employersCanView?: ModelBooleanInput | null,
  nationalsCanView?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPreparedFormConditionInput | null > | null,
  or?: Array< ModelPreparedFormConditionInput | null > | null,
  not?: ModelPreparedFormConditionInput | null,
};

export type ModelPreparedFormStateInput = {
  eq?: PreparedFormState | null,
  ne?: PreparedFormState | null,
};

export type UpdatePreparedFormInput = {
  id: string,
  caseID?: string | null,
  companyID?: string | null,
  foreignNationalID?: string | null,
  relativeAdmins?: Array< string > | null,
  state?: PreparedFormState | null,
  preparerID?: string | null,
  templateID?: string | null,
  template?: PreparedFormTemplateInput | null,
  completedFormID?: string | null,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  rejectedDate?: string | null,
  rejectedByID?: string | null,
  rejectedByEmployerID?: string | null,
  rejectedByNationalID?: string | null,
  rejectedByTeamMemberID?: string | null,
  requiresAttorneyApproval?: boolean | null,
  attorneyApproverID?: string | null,
  attorneyApprovalDate?: string | null,
  requiresSponsorApproval?: boolean | null,
  sponsorApproverID?: string | null,
  sponsorApproverEmployerID?: string | null,
  sponsorApproverNationalID?: string | null,
  sponsorApprovalDate?: string | null,
  requiresNationalApproval?: boolean | null,
  nationalApproverID?: string | null,
  nationalApprovalDate?: string | null,
  finalCaseManagerApproverID?: string | null,
  finalCaseManagerApprovalDate?: string | null,
  employersCanView?: boolean | null,
  nationalsCanView?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePreparedFormInput = {
  id: string,
};

export type CreateForeignNationalInput = {
  type: PersonType,
  id?: string | null,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  onboardingSections?: NationalOnboardingSectionsInput | null,
  completedOnboardingQuestionsBy?: string | null,
  email?: string | null,
  emailPersonal?: string | null,
  emailWork?: string | null,
  usMailingAddress?: StreetAddressInput | null,
  usResidentialAddress?: StreetAddressInput | null,
  lastAddressOutsideUS?: StreetAddressInput | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  nickname?: string | null,
  employeeId?: string | null,
  additionalFirstnames?: Array< string > | null,
  additionalMiddlenames?: Array< string > | null,
  additionalLastnames?: Array< string > | null,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  maritalStatus?: MaritalStatus | null,
  spouse?: boolean | null,
  dependents?: number | null,
  phone?: string | null,
  phoneWork?: string | null,
  companyID?: string | null,
  companyNationalNumber?: number | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  workLocation?: StreetAddressInput | null,
  relatives?: Array< string > | null,
  relativeAdmins?: Array< string > | null,
  immigrationStatus?: ImmigrationStatusInput | null,
  immigrationVisaStatus?: string | null,
  visaExpiration?: string | null,
  nonImmigrantVisaNumber?: string | null,
  visaIssueDate?: string | null,
  visaConsulate?: string | null,
  immigrantVisaApplicant?: boolean | null,
  immigrantPetitionEverFiled?: boolean | null,
  j1j2?: J1J2Input | null,
  hasHadI485Filed?: BooleanTwoPartInput | null,
  hasPendingETA9089?: boolean | null,
  hasApprovedI140?: I140Input | null,
  aosFilingEligible?: AOSFilingEligibility | null,
  hasValidOrExpiredEAD?: boolean | null,
  hasPendingUSCISApplication?: boolean | null,
  hasHadVisaPetitionRevokedOrDenied?: boolean | null,
  hasBeenArrestedSinceLastUSEntry?: boolean | null,
  criminalHistory?: CriminalHistoryInput | null,
  hasTransportedWeapons?: boolean | null,
  hasParticipatedInArmedGroup?: boolean | null,
  hasDetailedPerson?: boolean | null,
  hasUsedWeapons?: boolean | null,
  hasWeaponsTraining?: boolean | null,
  hasCriminalOffence?: boolean | null,
  hasViolatedVisaTerms?: boolean | null,
  isInRemovalProceedings?: BooleanExplainInput | null,
  hasBeenEmployedSinceLastAdmitted?: BooleanExplainInput | null,
  citizenshipCountry?: Array< CountryCode > | null,
  birthCountry?: CountryCode | null,
  birthState?: string | null,
  birthDate?: string | null,
  birthCity?: string | null,
  jobDescriptionID?: string | null,
  nivMaxout?: string | null,
  offeredSalary?: MoneyInput | null,
  isRemote?: boolean | null,
  loginStatus?: LoginStatusInput | null,
  hasNonUSPassport?: boolean | null,
  passportGender?: PassportGender | null,
  passportIssueDate?: string | null,
  passportExpirationDate?: string | null,
  passportExpirationReminderSentForDate?: string | null,
  passportNumber?: string | null,
  passportCountry?: CountryCode | null,
  usSSN?: string | null,
  hasSSN?: boolean | null,
  aNumber?: string | null,
  lastEntryUS?: string | null,
  i94ArrivalDepartureRecordNumber?: string | null,
  sevisNumber?: string | null,
  eadNumber?: string | null,
  fileRequirements?: Array< FileRequirementInput > | null,
  fileRequirementsManipulated?: string | null,
  test?: string | null,
  notes?: string | null,
  companyName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  eadExpDate?: string | null,
  I797ExpDate?: string | null,
  visaExpDate?: string | null,
  chargeabilityCountry?: CountryCode | null,
  birthCountryCode?: string | null,
  socCode?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  citizenshipEligibilityDate?: string | null,
  startDate?: string | null,
  legalTeamIDs?: Array< string > | null,
};

export type DeleteForeignNationalInput = {
  id: string,
};

export type CreateEmployerInput = {
  id?: string | null,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type: PersonType,
  email?: string | null,
  personalEmail?: string | null,
  newsletterModalViewCount?: number | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname?: string | null,
  middlename?: string | null,
  lastname?: string | null,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  address?: string | null,
  phone?: string | null,
  personalPhone?: string | null,
  title?: string | null,
  companyIDs?: Array< string > | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  recentlyViewedCases?: Array< string > | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  loginStatus?: LoginStatusInput | null,
  invoicingContactCompanyIDs?: Array< string > | null,
  isInvoicingContact?: boolean | null,
  primaryContactCompanyIDs?: Array< string > | null,
  isPrimaryContact?: boolean | null,
  seniorContactCompanyIDs?: Array< string > | null,
  isSeniorContact?: boolean | null,
  signatoryContactCompanyIDs?: Array< string > | null,
  isSignatoryContact?: boolean | null,
  assignedCaseIDs?: Array< string > | null,
  nationalsWithOpenCases?: Array< string > | null,
};

export type DeleteEmployerInput = {
  id: string,
};

export type CreateTeamMemberInput = {
  id?: string | null,
  createdBy?: string | null,
  slug: string,
  userAgreementAcknowledged?: boolean | null,
  userAgreementAcknowledgementDate?: string | null,
  userAgreementAcknowledgementText?: string | null,
  hasLoggedIn?: boolean | null,
  type: PersonType,
  email?: string | null,
  username?: string | null,
  avatar?: PictureInput | null,
  firstname: string,
  middlename?: string | null,
  lastname: string,
  lowerFirst: string,
  lowerLast: string,
  lowerFull: string,
  phone?: string | null,
  position?: Position | null,
  title?: string | null,
  licensingAuthority?: string | null,
  stateBarNumber?: string | null,
  isAdmin?: boolean | null,
  managerID?: string | null,
  mostRecentlyInvited?: string | null,
  archived: ArchivedState,
  loginStatus?: LoginStatusInput | null,
  recentlyViewedCases?: Array< string > | null,
  nationalsWithOpenCases?: Array< string > | null,
  companiesAssignedTo?: Array< string > | null,
};

export type DeleteTeamMemberInput = {
  id: string,
};

export type CreateFamilyRelationshipInput = {
  id?: string | null,
  sourceID: string,
  targetID: string,
  type?: FamilyRelationshipType | null,
};

export type ModelFamilyRelationshipConditionInput = {
  sourceID?: ModelIDInput | null,
  targetID?: ModelIDInput | null,
  type?: ModelFamilyRelationshipTypeInput | null,
  and?: Array< ModelFamilyRelationshipConditionInput | null > | null,
  or?: Array< ModelFamilyRelationshipConditionInput | null > | null,
  not?: ModelFamilyRelationshipConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFamilyRelationshipTypeInput = {
  eq?: FamilyRelationshipType | null,
  ne?: FamilyRelationshipType | null,
};

export type UpdateFamilyRelationshipInput = {
  id: string,
  sourceID?: string | null,
  targetID?: string | null,
  type?: FamilyRelationshipType | null,
};

export type DeleteFamilyRelationshipInput = {
  id: string,
};

export type CreateAttorneyAssignmentInput = {
  id?: string | null,
  companyID: string,
  attorneyID: string,
};

export type ModelAttorneyAssignmentConditionInput = {
  companyID?: ModelIDInput | null,
  attorneyID?: ModelIDInput | null,
  and?: Array< ModelAttorneyAssignmentConditionInput | null > | null,
  or?: Array< ModelAttorneyAssignmentConditionInput | null > | null,
  not?: ModelAttorneyAssignmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAttorneyAssignmentInput = {
  id: string,
  companyID?: string | null,
  attorneyID?: string | null,
};

export type DeleteAttorneyAssignmentInput = {
  id: string,
};

export type CreateParalegalAssignmentInput = {
  id?: string | null,
  companyID: string,
  paralegalID: string,
};

export type ModelParalegalAssignmentConditionInput = {
  companyID?: ModelIDInput | null,
  paralegalID?: ModelIDInput | null,
  and?: Array< ModelParalegalAssignmentConditionInput | null > | null,
  or?: Array< ModelParalegalAssignmentConditionInput | null > | null,
  not?: ModelParalegalAssignmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateParalegalAssignmentInput = {
  id: string,
  companyID?: string | null,
  paralegalID?: string | null,
};

export type DeleteParalegalAssignmentInput = {
  id: string,
};

export type CreateEmployerAssignmentInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelEmployerAssignmentConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelEmployerAssignmentConditionInput | null > | null,
  or?: Array< ModelEmployerAssignmentConditionInput | null > | null,
  not?: ModelEmployerAssignmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateEmployerAssignmentInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeleteEmployerAssignmentInput = {
  id: string,
};

export type CreateEmployerAdminAssignmentInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelEmployerAdminAssignmentConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelEmployerAdminAssignmentConditionInput | null > | null,
  or?: Array< ModelEmployerAdminAssignmentConditionInput | null > | null,
  not?: ModelEmployerAdminAssignmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateEmployerAdminAssignmentInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeleteEmployerAdminAssignmentInput = {
  id: string,
};

export type CreatePrimaryContactInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelPrimaryContactConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelPrimaryContactConditionInput | null > | null,
  or?: Array< ModelPrimaryContactConditionInput | null > | null,
  not?: ModelPrimaryContactConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePrimaryContactInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeletePrimaryContactInput = {
  id: string,
};

export type CreateSeniorContactInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelSeniorContactConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelSeniorContactConditionInput | null > | null,
  or?: Array< ModelSeniorContactConditionInput | null > | null,
  not?: ModelSeniorContactConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateSeniorContactInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeleteSeniorContactInput = {
  id: string,
};

export type CreateInvoicingContactInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelInvoicingContactConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelInvoicingContactConditionInput | null > | null,
  or?: Array< ModelInvoicingContactConditionInput | null > | null,
  not?: ModelInvoicingContactConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateInvoicingContactInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeleteInvoicingContactInput = {
  id: string,
};

export type CreateSignatoryContactInput = {
  id?: string | null,
  companyID: string,
  employerID: string,
};

export type ModelSignatoryContactConditionInput = {
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  and?: Array< ModelSignatoryContactConditionInput | null > | null,
  or?: Array< ModelSignatoryContactConditionInput | null > | null,
  not?: ModelSignatoryContactConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateSignatoryContactInput = {
  id: string,
  companyID?: string | null,
  employerID?: string | null,
};

export type DeleteSignatoryContactInput = {
  id: string,
};

export type CreateCompanyInput = {
  id?: string | null,
  name: string,
  lowerName?: string | null,
  lowerNameKey: string,
  displayCompanyName?: string | null,
  slug: string,
  type: CompanyType,
  logo?: PictureInput | null,
  domainWhitelist?: Array< string > | null,
  onboardingSections?: CompanyOnboardingSectionsInput | null,
  hasCompletedOnboardingQuestions?: boolean | null,
  completedOnboardingQuestionsBy?: string | null,
  isPartnerCompany?: boolean | null,
  isParent?: boolean | null,
  parentID?: string | null,
  archived?: ArchivedState | null,
  companyNumber: number,
  nationalCount?: number | null,
  accountManagerID?: string | null,
  fileRequirements?: Array< FileRequirementInput > | null,
  openCaseCount?: number | null,
  closedCaseCount?: number | null,
  completedCaseCount?: number | null,
  legalTeamIDs?: Array< string > | null,
  notes?: string | null,
  petitionerParagraph?: string | null,
  companyDataId?: string | null,
};

export type DeleteCompanyInput = {
  id: string,
};

export type CreateFirmInput = {
  id?: string | null,
  name: string,
  slug: string,
  logo?: PictureInput | null,
  domainWhitelist?: Array< string > | null,
  address?: StreetAddressInput | null,
  mailingAddress?: StreetAddressInput | null,
  doingBusinessAs?: string | null,
  phone?: string | null,
  fax?: string | null,
  knowledgeCenterLinks?: Array< KnowledgeCenterLinkInput > | null,
  shortcuts?: Array< ShortcutInput > | null,
  holidays?: Array< string > | null,
  companyCount: number,
  nationalCount: number,
  preparedFormTemplates?: Array< PreparedFormTemplateInput > | null,
};

export type DeleteFirmInput = {
  id: string,
};

export type CreateCompanyDataInput = {
  id?: string | null,
  companyID?: string | null,
  addressPrimary?: StreetAddressInput | null,
  addressSecondary?: StreetAddressInput | null,
  allowsEmployeesToTelecommute?: BooleanThreePartInput | null,
  preferredMailingAddress?: CompanyAddressType | null,
  companyNameShowToFN?: CompanyNameShowToFN | null,
  companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
  doingBusinessAs?: string | null,
  educationEvaluation?: EducationEvaluation | null,
  employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
  fein?: string | null,
  fullTimeEmployeesInUS?: number | null,
  grossRevenueForMostRecentFiscalYear?: MoneyInput | null,
  isH1BDependentEmloyer?: boolean | null,
  hasBeenWillfulViolator?: boolean | null,
  employs50OrMore?: BooleanTwoPartInput | null,
  isHigherEd_20_USC_1001_a?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
  isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
  maintainsAWrittenImmigrationPolicy?: boolean | null,
  naicsCodeOfCompany?: string | null,
  netRevenueForMostRecentFiscalYear?: MoneyInput | null,
  partTimeEmployeesInUS?: number | null,
  paymentPreference?: PaymentPreference | null,
  permissionPowerAttorney?: CompanyEmployee | null,
  permissionReleaseApprovalNotices?: boolean | null,
  permissionReleasePetitionsRFE?: boolean | null,
  permissionReleaseLCA?: boolean | null,
  permissionRelease9089?: boolean | null,
  phone?: string | null,
  placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
  preferenceForEmployeesToPayPartOfGreenCard?: BooleanExplainInput | null,
  preferenceForEmployeesToPayPartOfH1B?: BooleanExplainInput | null,
  fax?: string | null,
  preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
  shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
  shippingPreference?: ShippingPreferenceInput | null,
  staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
  typeOfBusiness?: string | null,
  usesWageSurvey?: boolean | null,
  usesApplicantTrackingSystem?: BooleanExplainInput | null,
  usesHRSSystem?: BooleanExplainInput | null,
  usesEVerify?: boolean | null,
  utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
  technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
  yearCompanyWasFoundedInUS?: string | null,
  I9_audit_has_been_completed_in_past_18_months?: boolean | null,
  current_number_of_H1B_employees?: string | null,
  current_number_of_employees_on_L_visas?: string | null,
  other_visa_statuses_sponsored?: string | null,
  email_address_invoices_should_be_addressed_to?: string | null,
  name_invoices_should_be_addressed_to?: string | null,
  companyCoversExpenseOfDependentPetitions?: boolean | null,
  placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
  annualMeetingDate?: string | null,
  requiresMeetingReminder?: boolean | null,
};

export type BooleanThreePartInput = {
  value?: boolean | null,
  followPrompt?: string | null,
  followValue?: boolean | null,
  followPromptSecond?: string | null,
  followValueSecond?: boolean | null,
};

export type ShippingPreferenceInput = {
  preference?: ShippingPaymentPreference | null,
  fedexAccount?: string | null,
  upsAccount?: string | null,
};

export type ModelCompanyDataConditionInput = {
  companyID?: ModelIDInput | null,
  preferredMailingAddress?: ModelCompanyAddressTypeInput | null,
  companyNameShowToFN?: ModelCompanyNameShowToFNInput | null,
  companyCoversExpenseOfDependentPetitionsAndOrEADCards?: ModelBooleanInput | null,
  doingBusinessAs?: ModelStringInput | null,
  educationEvaluation?: ModelEducationEvaluationInput | null,
  employeesEmailMHAttorneysAndParalegalsDirectly?: ModelEmployeesEmailContactDirectlyInput | null,
  fein?: ModelStringInput | null,
  fullTimeEmployeesInUS?: ModelIntInput | null,
  isH1BDependentEmloyer?: ModelBooleanInput | null,
  hasBeenWillfulViolator?: ModelBooleanInput | null,
  isHigherEd_20_USC_1001_a?: ModelBooleanInput | null,
  isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: ModelBooleanInput | null,
  isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: ModelBooleanInput | null,
  isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: ModelBooleanInput | null,
  isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: ModelBooleanInput | null,
  isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: ModelBooleanInput | null,
  maintainsAWrittenImmigrationPolicy?: ModelBooleanInput | null,
  naicsCodeOfCompany?: ModelStringInput | null,
  partTimeEmployeesInUS?: ModelIntInput | null,
  paymentPreference?: ModelPaymentPreferenceInput | null,
  permissionPowerAttorney?: ModelCompanyEmployeeInput | null,
  permissionReleaseApprovalNotices?: ModelBooleanInput | null,
  permissionReleasePetitionsRFE?: ModelBooleanInput | null,
  permissionReleaseLCA?: ModelBooleanInput | null,
  permissionRelease9089?: ModelBooleanInput | null,
  phone?: ModelStringInput | null,
  placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: ModelBooleanInput | null,
  fax?: ModelStringInput | null,
  preferredShippingSpeedForDocuments?: ModelPreferredShippingSpeedForDocumentsInput | null,
  shipOriginalApprovalNotices?: ModelShipOriginalApprovalNoticesInput | null,
  staffsEmployeesAtThirdPartyEndClientSites?: ModelBooleanInput | null,
  typeOfBusiness?: ModelStringInput | null,
  usesWageSurvey?: ModelBooleanInput | null,
  usesEVerify?: ModelBooleanInput | null,
  utilizePremiumProcessingService?: ModelUtilizePremiumProcessingServiceInput | null,
  technologyReleaseLicenseRequirement?: ModelTechnologyReleaseLicenseRequirementInput | null,
  yearCompanyWasFoundedInUS?: ModelStringInput | null,
  I9_audit_has_been_completed_in_past_18_months?: ModelBooleanInput | null,
  current_number_of_H1B_employees?: ModelStringInput | null,
  current_number_of_employees_on_L_visas?: ModelStringInput | null,
  other_visa_statuses_sponsored?: ModelStringInput | null,
  email_address_invoices_should_be_addressed_to?: ModelStringInput | null,
  name_invoices_should_be_addressed_to?: ModelStringInput | null,
  companyCoversExpenseOfDependentPetitions?: ModelBooleanInput | null,
  placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: ModelBooleanInput | null,
  annualMeetingDate?: ModelStringInput | null,
  requiresMeetingReminder?: ModelBooleanInput | null,
  and?: Array< ModelCompanyDataConditionInput | null > | null,
  or?: Array< ModelCompanyDataConditionInput | null > | null,
  not?: ModelCompanyDataConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelCompanyAddressTypeInput = {
  eq?: CompanyAddressType | null,
  ne?: CompanyAddressType | null,
};

export type ModelCompanyNameShowToFNInput = {
  eq?: CompanyNameShowToFN | null,
  ne?: CompanyNameShowToFN | null,
};

export type ModelEducationEvaluationInput = {
  eq?: EducationEvaluation | null,
  ne?: EducationEvaluation | null,
};

export type ModelEmployeesEmailContactDirectlyInput = {
  eq?: EmployeesEmailContactDirectly | null,
  ne?: EmployeesEmailContactDirectly | null,
};

export type ModelPaymentPreferenceInput = {
  eq?: PaymentPreference | null,
  ne?: PaymentPreference | null,
};

export type ModelCompanyEmployeeInput = {
  eq?: CompanyEmployee | null,
  ne?: CompanyEmployee | null,
};

export type ModelPreferredShippingSpeedForDocumentsInput = {
  eq?: PreferredShippingSpeedForDocuments | null,
  ne?: PreferredShippingSpeedForDocuments | null,
};

export type ModelShipOriginalApprovalNoticesInput = {
  eq?: ShipOriginalApprovalNotices | null,
  ne?: ShipOriginalApprovalNotices | null,
};

export type ModelUtilizePremiumProcessingServiceInput = {
  eq?: UtilizePremiumProcessingService | null,
  ne?: UtilizePremiumProcessingService | null,
};

export type ModelTechnologyReleaseLicenseRequirementInput = {
  eq?: TechnologyReleaseLicenseRequirement | null,
  ne?: TechnologyReleaseLicenseRequirement | null,
};

export type UpdateCompanyDataInput = {
  id: string,
  companyID?: string | null,
  addressPrimary?: StreetAddressInput | null,
  addressSecondary?: StreetAddressInput | null,
  allowsEmployeesToTelecommute?: BooleanThreePartInput | null,
  preferredMailingAddress?: CompanyAddressType | null,
  companyNameShowToFN?: CompanyNameShowToFN | null,
  companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
  doingBusinessAs?: string | null,
  educationEvaluation?: EducationEvaluation | null,
  employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
  fein?: string | null,
  fullTimeEmployeesInUS?: number | null,
  grossRevenueForMostRecentFiscalYear?: MoneyInput | null,
  isH1BDependentEmloyer?: boolean | null,
  hasBeenWillfulViolator?: boolean | null,
  employs50OrMore?: BooleanTwoPartInput | null,
  isHigherEd_20_USC_1001_a?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
  isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
  isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
  isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
  maintainsAWrittenImmigrationPolicy?: boolean | null,
  naicsCodeOfCompany?: string | null,
  netRevenueForMostRecentFiscalYear?: MoneyInput | null,
  partTimeEmployeesInUS?: number | null,
  paymentPreference?: PaymentPreference | null,
  permissionPowerAttorney?: CompanyEmployee | null,
  permissionReleaseApprovalNotices?: boolean | null,
  permissionReleasePetitionsRFE?: boolean | null,
  permissionReleaseLCA?: boolean | null,
  permissionRelease9089?: boolean | null,
  phone?: string | null,
  placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
  preferenceForEmployeesToPayPartOfGreenCard?: BooleanExplainInput | null,
  preferenceForEmployeesToPayPartOfH1B?: BooleanExplainInput | null,
  fax?: string | null,
  preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
  shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
  shippingPreference?: ShippingPreferenceInput | null,
  staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
  typeOfBusiness?: string | null,
  usesWageSurvey?: boolean | null,
  usesApplicantTrackingSystem?: BooleanExplainInput | null,
  usesHRSSystem?: BooleanExplainInput | null,
  usesEVerify?: boolean | null,
  utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
  technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
  yearCompanyWasFoundedInUS?: string | null,
  I9_audit_has_been_completed_in_past_18_months?: boolean | null,
  current_number_of_H1B_employees?: string | null,
  current_number_of_employees_on_L_visas?: string | null,
  other_visa_statuses_sponsored?: string | null,
  email_address_invoices_should_be_addressed_to?: string | null,
  name_invoices_should_be_addressed_to?: string | null,
  companyCoversExpenseOfDependentPetitions?: boolean | null,
  placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
  annualMeetingDate?: string | null,
  requiresMeetingReminder?: boolean | null,
};

export type DeleteCompanyDataInput = {
  id: string,
};

export type CreateJobDescriptionInput = {
  companyID?: string | null,
  id?: string | null,
  archived: ArchivedState,
  type: JobDescriptionType,
  foreignNationalID?: string | null,
  title: string,
  officialTitle?: string | null,
  degrees?: Array< Degree > | null,
  requiresBachelors?: boolean | null,
  requiresMasters?: boolean | null,
  requiresPhd?: boolean | null,
  dotNumber?: string | null,
  caseSocCode?: string | null,
  duties?: string | null,
  jobURL?: string | null,
  majors?: string | null,
  specialRequirements?: string | null,
  yearsGeneralExperience?: number | null,
  objectiveSkillSetsRequired?: string | null,
  offeredSalary?: string | null,
  certificationLicenses?: string | null,
  travelIsRequired?: boolean | null,
  travelPercentage?: number | null,
  travelDomestic?: boolean | null,
  travelInternational?: boolean | null,
  supervisesOthers?: boolean | null,
  supervisesOthersCount?: number | null,
  supervisesTitles?: Array< string > | null,
  supervisorTitle?: string | null,
  canWorkFromHome?: boolean | null,
  uploadedDescriptionID?: string | null,
};

export type DeleteJobDescriptionInput = {
  id: string,
};

export type CreateProcessRequestInput = {
  id?: string | null,
  assignedToID?: string | null,
  assignedToEmployerID?: string | null,
  assignedToTeamMemberID?: string | null,
  companyID?: string | null,
  individualSponsored?: boolean | null,
  initiatorID?: string | null,
  jobDescriptionID?: string | null,
  requesterID?: string | null,
  requestDate: string,
  approvalDate?: string | null,
  archivedDate?: string | null,
  cancelDate?: string | null,
  foreignNationalID?: string | null,
  employeeData?: ProcessRequestEmployeeDataInput | null,
  employmentData?: ProcessRequestEmploymentDataInput | null,
  needsEmployerRevision?: boolean | null,
  resumeID?: string | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  slug: string,
  state: ProcessRequestState,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
};

export type DeleteProcessRequestInput = {
  id: string,
};

export type CreateCaseInput = {
  id?: string | null,
  caseNumber?: string | null,
  slug: string,
  attorneyID?: string | null,
  caseManagerID?: string | null,
  complianceListID?: string | null,
  PERMFilingDataID?: string | null,
  pinnedCaseNoteID?: string | null,
  contributorIds?: Array< string | null > | null,
  sponsoringEmployerID?: string | null,
  sponsoringNationalID?: string | null,
  foreignNationalID: string,
  welcomeLetterAcknowledged?: boolean | null,
  welcomeLetterAcknowledgementDate?: string | null,
  welcomeLetterAcknowledgedBy?: string | null,
  welcomeLetterText?: string | null,
  nationalVisaExpiration?: string | null,
  relativeAdmins?: Array< string > | null,
  startDate: string,
  closeDate?: string | null,
  closeReason?: string | null,
  completeDate?: string | null,
  sourceID: string,
  state: CaseState,
  lowerNationalName?: string | null,
  lowerCompanyName?: string | null,
  lowerProcessType?: string | null,
  fileRequirements: Array< FileRequirementInput >,
  currentPhase?: CasePhase | null,
  phaseRequirements: Array< CasePhaseRequirementInput >,
  completedMilestones: Array< CompletedCaseMilestoneInput >,
  prevailingWageCaseNumber?: string | null,
  USCISReceiptNumber?: string | null,
  AOSReceiptNotice?: string | null,
  I485JReceiptNotice?: string | null,
  SelectionNoticeNo?: string | null,
  ETACaseNumber?: string | null,
  shipmentTracking?: Array< CaseShipmentTrackingInput > | null,
  isShipmentTrackingElectronically?: boolean | null,
  companyID?: string | null,
  individualSponsored?: boolean | null,
  jobDescriptionID?: string | null,
  employeeData?: ProcessRequestEmployeeDataInput | null,
  employmentData?: ProcessRequestEmploymentDataInput | null,
  resumeID?: string | null,
  requestedProcess?: VisaStatus | null,
  requestedProcessSubCategory?: VisaSubCategory | null,
  requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
  globalRequestedProcessSubCategory?: string | null,
  globalProcessCountryCode?: CountryCode | null,
  globalProcessDuration?: GlobalProcessDuration | null,
  globalVisaType?: GlobalVisaType | null,
  vendorID?: string | null,
  additionalFieldID?: string | null,
};

export type ModelCaseConditionInput = {
  caseNumber?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  attorneyID?: ModelIDInput | null,
  caseManagerID?: ModelIDInput | null,
  complianceListID?: ModelIDInput | null,
  PERMFilingDataID?: ModelIDInput | null,
  pinnedCaseNoteID?: ModelIDInput | null,
  contributorIds?: ModelStringInput | null,
  sponsoringEmployerID?: ModelIDInput | null,
  sponsoringNationalID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  welcomeLetterAcknowledged?: ModelBooleanInput | null,
  welcomeLetterAcknowledgementDate?: ModelStringInput | null,
  welcomeLetterAcknowledgedBy?: ModelIDInput | null,
  welcomeLetterText?: ModelStringInput | null,
  nationalVisaExpiration?: ModelStringInput | null,
  relativeAdmins?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  closeDate?: ModelStringInput | null,
  closeReason?: ModelStringInput | null,
  completeDate?: ModelStringInput | null,
  sourceID?: ModelIDInput | null,
  state?: ModelCaseStateInput | null,
  lowerNationalName?: ModelStringInput | null,
  lowerCompanyName?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  currentPhase?: ModelCasePhaseInput | null,
  prevailingWageCaseNumber?: ModelStringInput | null,
  USCISReceiptNumber?: ModelStringInput | null,
  AOSReceiptNotice?: ModelStringInput | null,
  I485JReceiptNotice?: ModelStringInput | null,
  SelectionNoticeNo?: ModelStringInput | null,
  ETACaseNumber?: ModelStringInput | null,
  isShipmentTrackingElectronically?: ModelBooleanInput | null,
  companyID?: ModelIDInput | null,
  individualSponsored?: ModelBooleanInput | null,
  jobDescriptionID?: ModelIDInput | null,
  resumeID?: ModelIDInput | null,
  requestedProcess?: ModelVisaStatusInput | null,
  requestedProcessSubCategory?: ModelVisaSubCategoryInput | null,
  requestedProcessAdditionalProcessing?: ModelVisaAdditionalProcessingListInput | null,
  globalRequestedProcessSubCategory?: ModelStringInput | null,
  globalProcessCountryCode?: ModelCountryCodeInput | null,
  globalProcessDuration?: ModelGlobalProcessDurationInput | null,
  globalVisaType?: ModelGlobalVisaTypeInput | null,
  vendorID?: ModelIDInput | null,
  additionalFieldID?: ModelIDInput | null,
  and?: Array< ModelCaseConditionInput | null > | null,
  or?: Array< ModelCaseConditionInput | null > | null,
  not?: ModelCaseConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DeleteCaseInput = {
  id: string,
};

export type CreateUSCISReceiptDetailsInput = {
  id?: string | null,
  caseID: string,
  receiptType: ReceiptType,
  receiptNumber?: string | null,
  formType?: string | null,
  submittedDate?: string | null,
  modifiedDate?: string | null,
  currentCaseStatusText?: string | null,
  currentCaseStatusDesc?: string | null,
  histCaseStatus?: Array< HitCaseStatusInput > | null,
  message?: string | null,
  isActive?: boolean | null,
  isLatest?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type HitCaseStatusInput = {
  date?: string | null,
  completedText?: string | null,
};

export type ModelUSCISReceiptDetailsConditionInput = {
  caseID?: ModelIDInput | null,
  receiptType?: ModelReceiptTypeInput | null,
  receiptNumber?: ModelStringInput | null,
  formType?: ModelStringInput | null,
  submittedDate?: ModelStringInput | null,
  modifiedDate?: ModelStringInput | null,
  currentCaseStatusText?: ModelStringInput | null,
  currentCaseStatusDesc?: ModelStringInput | null,
  message?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  isLatest?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUSCISReceiptDetailsConditionInput | null > | null,
  or?: Array< ModelUSCISReceiptDetailsConditionInput | null > | null,
  not?: ModelUSCISReceiptDetailsConditionInput | null,
};

export type ModelReceiptTypeInput = {
  eq?: ReceiptType | null,
  ne?: ReceiptType | null,
};

export type UpdateUSCISReceiptDetailsInput = {
  id: string,
  caseID?: string | null,
  receiptType?: ReceiptType | null,
  receiptNumber?: string | null,
  formType?: string | null,
  submittedDate?: string | null,
  modifiedDate?: string | null,
  currentCaseStatusText?: string | null,
  currentCaseStatusDesc?: string | null,
  histCaseStatus?: Array< HitCaseStatusInput > | null,
  message?: string | null,
  isActive?: boolean | null,
  isLatest?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteUSCISReceiptDetailsInput = {
  id: string,
};

export type CreateCaseComplianceListInput = {
  id?: string | null,
  caseID?: string | null,
  educationEvaluationNeeded?: ComplianceCheckList | null,
  stemExtEligible?: ComplianceCheckList | null,
  capGap?: ComplianceCheckList | null,
  wageIssues?: ComplianceCheckList | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelCaseComplianceListConditionInput = {
  caseID?: ModelIDInput | null,
  educationEvaluationNeeded?: ModelComplianceCheckListInput | null,
  stemExtEligible?: ModelComplianceCheckListInput | null,
  capGap?: ModelComplianceCheckListInput | null,
  wageIssues?: ModelComplianceCheckListInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseComplianceListConditionInput | null > | null,
  or?: Array< ModelCaseComplianceListConditionInput | null > | null,
  not?: ModelCaseComplianceListConditionInput | null,
};

export type ModelComplianceCheckListInput = {
  eq?: ComplianceCheckList | null,
  ne?: ComplianceCheckList | null,
};

export type UpdateCaseComplianceListInput = {
  id: string,
  caseID?: string | null,
  educationEvaluationNeeded?: ComplianceCheckList | null,
  stemExtEligible?: ComplianceCheckList | null,
  capGap?: ComplianceCheckList | null,
  wageIssues?: ComplianceCheckList | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCaseComplianceListInput = {
  id: string,
};

export type CreatePERMFilingDataInput = {
  id?: string | null,
  caseID?: string | null,
  PERMFirstPossibleFilingDate?: string | null,
  PERMLastPossibleFilingDate?: string | null,
  applicantsReceived?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelPERMFilingDataConditionInput = {
  caseID?: ModelIDInput | null,
  PERMFirstPossibleFilingDate?: ModelStringInput | null,
  PERMLastPossibleFilingDate?: ModelStringInput | null,
  applicantsReceived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPERMFilingDataConditionInput | null > | null,
  or?: Array< ModelPERMFilingDataConditionInput | null > | null,
  not?: ModelPERMFilingDataConditionInput | null,
};

export type UpdatePERMFilingDataInput = {
  id: string,
  caseID?: string | null,
  PERMFirstPossibleFilingDate?: string | null,
  PERMLastPossibleFilingDate?: string | null,
  applicantsReceived?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePERMFilingDataInput = {
  id: string,
};

export type CreateCaseContributorInput = {
  id?: string | null,
  caseID: string,
  contributorID: string,
  foreignNationalID: string,
  state: CaseState,
  type: PersonType,
};

export type ModelCaseContributorConditionInput = {
  caseID?: ModelIDInput | null,
  contributorID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  state?: ModelCaseStateInput | null,
  type?: ModelPersonTypeInput | null,
  and?: Array< ModelCaseContributorConditionInput | null > | null,
  or?: Array< ModelCaseContributorConditionInput | null > | null,
  not?: ModelCaseContributorConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCaseContributorInput = {
  id: string,
  caseID?: string | null,
  contributorID?: string | null,
  foreignNationalID?: string | null,
  state?: CaseState | null,
  type?: PersonType | null,
};

export type DeleteCaseContributorInput = {
  id: string,
};

export type CreateTaskInput = {
  id?: string | null,
  action: string,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  paymentStatusAlternateAction?: string | null,
  assignedToID?: string | null,
  isAssignedToLegalAssistants?: boolean | null,
  assignedToEmployerID?: string | null,
  assignedToForeignNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  caseID: string,
  caseState?: CaseState | null,
  category: TaskCategory,
  companyID?: string | null,
  completeDate?: string | null,
  deadline: string,
  deadlineIsManuallySet?: boolean | null,
  deleteDate?: string | null,
  deleteReason?: string | null,
  description?: string | null,
  duration?: number | null,
  foreignNationalID: string,
  groupsCanRead?: Array< string > | null,
  isCustom?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  prerequisiteID?: string | null,
  startDate: string,
  state: TaskState,
  templateID?: string | null,
  assigneeLowerName?: string | null,
  attorneyLowerFirstName?: string | null,
  attorneyLowerName?: string | null,
  paralegalLowerName?: string | null,
  paralegalLowerFirstName?: string | null,
  companyLowerName?: string | null,
  nationalLowerName?: string | null,
  orderIndex?: number | null,
  defaultAssignee?: string | null,
  foreignNationalTasksId?: string | null,
  employerTasksId?: string | null,
};

export type ModelTaskConditionInput = {
  action?: ModelStringInput | null,
  isKeyDate?: ModelBooleanInput | null,
  keyDateAlternateAction?: ModelStringInput | null,
  isPaymentStatus?: ModelBooleanInput | null,
  paymentStatusAlternateAction?: ModelStringInput | null,
  assignedToID?: ModelIDInput | null,
  isAssignedToLegalAssistants?: ModelBooleanInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToForeignNationalID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  caseState?: ModelCaseStateInput | null,
  category?: ModelTaskCategoryInput | null,
  companyID?: ModelIDInput | null,
  completeDate?: ModelStringInput | null,
  deadline?: ModelStringInput | null,
  deadlineIsManuallySet?: ModelBooleanInput | null,
  deleteDate?: ModelStringInput | null,
  deleteReason?: ModelStringInput | null,
  description?: ModelStringInput | null,
  duration?: ModelIntInput | null,
  foreignNationalID?: ModelIDInput | null,
  groupsCanRead?: ModelStringInput | null,
  isCustom?: ModelBooleanInput | null,
  isManuallyUnlocked?: ModelBooleanInput | null,
  prerequisiteID?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  state?: ModelTaskStateInput | null,
  templateID?: ModelIDInput | null,
  assigneeLowerName?: ModelStringInput | null,
  attorneyLowerFirstName?: ModelStringInput | null,
  attorneyLowerName?: ModelStringInput | null,
  paralegalLowerName?: ModelStringInput | null,
  paralegalLowerFirstName?: ModelStringInput | null,
  companyLowerName?: ModelStringInput | null,
  nationalLowerName?: ModelStringInput | null,
  orderIndex?: ModelIntInput | null,
  defaultAssignee?: ModelStringInput | null,
  and?: Array< ModelTaskConditionInput | null > | null,
  or?: Array< ModelTaskConditionInput | null > | null,
  not?: ModelTaskConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  foreignNationalTasksId?: ModelIDInput | null,
  employerTasksId?: ModelIDInput | null,
};

export type UpdateTaskInput = {
  id: string,
  action?: string | null,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  paymentStatusAlternateAction?: string | null,
  assignedToID?: string | null,
  isAssignedToLegalAssistants?: boolean | null,
  assignedToEmployerID?: string | null,
  assignedToForeignNationalID?: string | null,
  assignedToTeamMemberID?: string | null,
  caseID?: string | null,
  caseState?: CaseState | null,
  category?: TaskCategory | null,
  companyID?: string | null,
  completeDate?: string | null,
  deadline?: string | null,
  deadlineIsManuallySet?: boolean | null,
  deleteDate?: string | null,
  deleteReason?: string | null,
  description?: string | null,
  duration?: number | null,
  foreignNationalID?: string | null,
  groupsCanRead?: Array< string > | null,
  isCustom?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  prerequisiteID?: string | null,
  startDate?: string | null,
  state?: TaskState | null,
  templateID?: string | null,
  assigneeLowerName?: string | null,
  attorneyLowerFirstName?: string | null,
  attorneyLowerName?: string | null,
  paralegalLowerName?: string | null,
  paralegalLowerFirstName?: string | null,
  companyLowerName?: string | null,
  nationalLowerName?: string | null,
  orderIndex?: number | null,
  defaultAssignee?: string | null,
  foreignNationalTasksId?: string | null,
  employerTasksId?: string | null,
};

export type DeleteTaskInput = {
  id: string,
};

export type CreateTaskTemplateInput = {
  id?: string | null,
  defaultAssignee: TaskAssignmentRole,
  duration?: number | null,
  groupsCanRead?: Array< string > | null,
  lockedByDefault: boolean,
  action: string,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  description?: string | null,
  paymentStatusAlternateAction?: string | null,
  prerequisiteID?: string | null,
  process: VisaStatus,
  category: TaskCategory,
  hidden?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  durationFromStartDate?: boolean | null,
  orderIndex: number,
  startDate?: string | null,
  deadline?: string | null,
};

export enum TaskAssignmentRole {
  CASE_MANAGER = "CASE_MANAGER",
  ATTORNEY = "ATTORNEY",
  SPONSOR = "SPONSOR",
  LEGAL_ASSISTANT = "LEGAL_ASSISTANT",
  FOREIGN_NATIONAL = "FOREIGN_NATIONAL",
}


export type ModelTaskTemplateConditionInput = {
  defaultAssignee?: ModelTaskAssignmentRoleInput | null,
  duration?: ModelIntInput | null,
  groupsCanRead?: ModelStringInput | null,
  lockedByDefault?: ModelBooleanInput | null,
  action?: ModelStringInput | null,
  isKeyDate?: ModelBooleanInput | null,
  keyDateAlternateAction?: ModelStringInput | null,
  isPaymentStatus?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  paymentStatusAlternateAction?: ModelStringInput | null,
  prerequisiteID?: ModelIDInput | null,
  process?: ModelVisaStatusInput | null,
  category?: ModelTaskCategoryInput | null,
  hidden?: ModelBooleanInput | null,
  isManuallyUnlocked?: ModelBooleanInput | null,
  durationFromStartDate?: ModelBooleanInput | null,
  orderIndex?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  deadline?: ModelStringInput | null,
  and?: Array< ModelTaskTemplateConditionInput | null > | null,
  or?: Array< ModelTaskTemplateConditionInput | null > | null,
  not?: ModelTaskTemplateConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTaskAssignmentRoleInput = {
  eq?: TaskAssignmentRole | null,
  ne?: TaskAssignmentRole | null,
};

export type TaskTemplate = {
  __typename: "TaskTemplate",
  id: string,
  defaultAssignee: TaskAssignmentRole,
  duration?: number | null,
  groupsCanRead?: Array< string > | null,
  lockedByDefault: boolean,
  action: string,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  description?: string | null,
  paymentStatusAlternateAction?: string | null,
  prerequisiteID?: string | null,
  process: VisaStatus,
  category: TaskCategory,
  hidden?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  durationFromStartDate?: boolean | null,
  orderIndex: number,
  startDate?: string | null,
  deadline?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTaskTemplateInput = {
  id: string,
  defaultAssignee?: TaskAssignmentRole | null,
  duration?: number | null,
  groupsCanRead?: Array< string > | null,
  lockedByDefault?: boolean | null,
  action?: string | null,
  isKeyDate?: boolean | null,
  keyDateAlternateAction?: string | null,
  isPaymentStatus?: boolean | null,
  description?: string | null,
  paymentStatusAlternateAction?: string | null,
  prerequisiteID?: string | null,
  process?: VisaStatus | null,
  category?: TaskCategory | null,
  hidden?: boolean | null,
  isManuallyUnlocked?: boolean | null,
  durationFromStartDate?: boolean | null,
  orderIndex?: number | null,
  startDate?: string | null,
  deadline?: string | null,
};

export type DeleteTaskTemplateInput = {
  id: string,
};

export type UpdateCommentInput = {
  createdAt?: string | null,
  authorID?: string | null,
  authorEmployerID?: string | null,
  authorForeignNationalID?: string | null,
  authorTeamMemberID?: string | null,
  note?: string | null,
  sourceID?: string | null,
  id: string,
};

export type DeleteCommentInput = {
  id: string,
};

export type DeleteFileDataInput = {
  id: string,
};

export type DeleteCaseRfgpInput = {
  id: string,
};

export type CreateCaseFileInput = {
  id?: string | null,
  fileID: string,
  caseID: string,
};

export type ModelCaseFileConditionInput = {
  fileID?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  and?: Array< ModelCaseFileConditionInput | null > | null,
  or?: Array< ModelCaseFileConditionInput | null > | null,
  not?: ModelCaseFileConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCaseFileInput = {
  id: string,
  fileID?: string | null,
  caseID?: string | null,
};

export type DeleteCaseFileInput = {
  id: string,
};

export type CreateActivityInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  activityType: ActivityType,
  ipAddress?: string | null,
  fieldName?: string | null,
  updatedValue?: string | null,
  actorID: string,
  actorEmployerID?: string | null,
  actorForeignNationalID?: string | null,
  actorTeamMemberID?: string | null,
  actorType?: PersonType | null,
  directTargetID?: string | null,
  directTargetCaseID?: string | null,
  directTargetCompanyID?: string | null,
  directTargetEmployerID?: string | null,
  directTargetFileDataID?: string | null,
  directTargetForeignNationalID?: string | null,
  directTargetProcessRequestID?: string | null,
  directTargetTaskID?: string | null,
  directTargetTeamMemberID?: string | null,
  directTargetReportID?: string | null,
  targetString?: string | null,
  indirectTargetID?: string | null,
  indirectTargetCaseID?: string | null,
  indirectTargetCompanyID?: string | null,
  indirectTargetEmployerID?: string | null,
  indirectTargetForeignNationalID?: string | null,
  indirectTargetProcessRequestID?: string | null,
  indirectTargetTeamMemberID?: string | null,
  indirectTargetReportID?: string | null,
  indirectTargetString?: string | null,
  ownerID?: string | null,
  ownerCaseID?: string | null,
  ownerCompanyID?: string | null,
  ownerEmployerID?: string | null,
  ownerFileDataID?: string | null,
  ownerForeignNationalID?: string | null,
  ownerProcessRequestID?: string | null,
  ownerTeamMemberID?: string | null,
  ownerReportID?: string | null,
};

export type ModelActivityConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  activityType?: ModelActivityTypeInput | null,
  ipAddress?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  updatedValue?: ModelStringInput | null,
  actorID?: ModelIDInput | null,
  actorEmployerID?: ModelIDInput | null,
  actorForeignNationalID?: ModelIDInput | null,
  actorTeamMemberID?: ModelIDInput | null,
  actorType?: ModelPersonTypeInput | null,
  directTargetID?: ModelIDInput | null,
  directTargetCaseID?: ModelIDInput | null,
  directTargetCompanyID?: ModelIDInput | null,
  directTargetEmployerID?: ModelIDInput | null,
  directTargetFileDataID?: ModelIDInput | null,
  directTargetForeignNationalID?: ModelIDInput | null,
  directTargetProcessRequestID?: ModelIDInput | null,
  directTargetTaskID?: ModelIDInput | null,
  directTargetTeamMemberID?: ModelIDInput | null,
  directTargetReportID?: ModelIDInput | null,
  targetString?: ModelStringInput | null,
  indirectTargetID?: ModelIDInput | null,
  indirectTargetCaseID?: ModelIDInput | null,
  indirectTargetCompanyID?: ModelIDInput | null,
  indirectTargetEmployerID?: ModelIDInput | null,
  indirectTargetForeignNationalID?: ModelIDInput | null,
  indirectTargetProcessRequestID?: ModelIDInput | null,
  indirectTargetTeamMemberID?: ModelIDInput | null,
  indirectTargetReportID?: ModelIDInput | null,
  indirectTargetString?: ModelStringInput | null,
  ownerID?: ModelIDInput | null,
  ownerCaseID?: ModelIDInput | null,
  ownerCompanyID?: ModelIDInput | null,
  ownerEmployerID?: ModelIDInput | null,
  ownerFileDataID?: ModelIDInput | null,
  ownerForeignNationalID?: ModelIDInput | null,
  ownerProcessRequestID?: ModelIDInput | null,
  ownerTeamMemberID?: ModelIDInput | null,
  ownerReportID?: ModelIDInput | null,
  and?: Array< ModelActivityConditionInput | null > | null,
  or?: Array< ModelActivityConditionInput | null > | null,
  not?: ModelActivityConditionInput | null,
};

export type ModelActivityTypeInput = {
  eq?: ActivityType | null,
  ne?: ActivityType | null,
};

export type UpdateActivityInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  activityType?: ActivityType | null,
  ipAddress?: string | null,
  fieldName?: string | null,
  updatedValue?: string | null,
  actorID?: string | null,
  actorEmployerID?: string | null,
  actorForeignNationalID?: string | null,
  actorTeamMemberID?: string | null,
  actorType?: PersonType | null,
  directTargetID?: string | null,
  directTargetCaseID?: string | null,
  directTargetCompanyID?: string | null,
  directTargetEmployerID?: string | null,
  directTargetFileDataID?: string | null,
  directTargetForeignNationalID?: string | null,
  directTargetProcessRequestID?: string | null,
  directTargetTaskID?: string | null,
  directTargetTeamMemberID?: string | null,
  directTargetReportID?: string | null,
  targetString?: string | null,
  indirectTargetID?: string | null,
  indirectTargetCaseID?: string | null,
  indirectTargetCompanyID?: string | null,
  indirectTargetEmployerID?: string | null,
  indirectTargetForeignNationalID?: string | null,
  indirectTargetProcessRequestID?: string | null,
  indirectTargetTeamMemberID?: string | null,
  indirectTargetReportID?: string | null,
  indirectTargetString?: string | null,
  ownerID?: string | null,
  ownerCaseID?: string | null,
  ownerCompanyID?: string | null,
  ownerEmployerID?: string | null,
  ownerFileDataID?: string | null,
  ownerForeignNationalID?: string | null,
  ownerProcessRequestID?: string | null,
  ownerTeamMemberID?: string | null,
  ownerReportID?: string | null,
};

export type DeleteActivityInput = {
  id: string,
};

export type CreateNotificationInput = {
  id?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  personID: string,
  activityID: string,
  read: ReadState,
};

export type ModelNotificationConditionInput = {
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  personID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  read?: ModelReadStateInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationInput = {
  id: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  personID?: string | null,
  activityID?: string | null,
  read?: ReadState | null,
};

export type DeleteNotificationInput = {
  id: string,
};

export type CreateAdditionalFieldsInput = {
  id?: string | null,
  caseID: string,
  fields?: string | null,
};

export type DeleteAdditionalFieldsInput = {
  id: string,
};

export type CreateCustomTemplateInput = {
  id?: string | null,
  teamMemberId?: string | null,
  employerID?: string | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  name: string,
  selectedFields?: string | null,
  includeFN?: boolean | null,
  individualFNCase?: boolean | null,
  includeCases?: boolean | null,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  type?: TemplateType | null,
  category?: TemplateCategory | null,
  isDeleted?: boolean | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  accessibleCompanyIds?: Array< string | null > | null,
  companyIds?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelCustomTemplateConditionInput = {
  teamMemberId?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  accessibleIds?: ModelIDInput | null,
  editableIds?: ModelIDInput | null,
  name?: ModelStringInput | null,
  selectedFields?: ModelStringInput | null,
  includeFN?: ModelBooleanInput | null,
  individualFNCase?: ModelBooleanInput | null,
  includeCases?: ModelBooleanInput | null,
  numberOfFilters?: ModelIntInput | null,
  numberOfColumns?: ModelIntInput | null,
  type?: ModelTemplateTypeInput | null,
  category?: ModelTemplateCategoryInput | null,
  isDeleted?: ModelBooleanInput | null,
  viewAccess?: ModelAccessPermissionInput | null,
  editAccess?: ModelEditPermissionInput | null,
  accessibleCompanyIds?: ModelIDInput | null,
  companyIds?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCustomTemplateConditionInput | null > | null,
  or?: Array< ModelCustomTemplateConditionInput | null > | null,
  not?: ModelCustomTemplateConditionInput | null,
};

export type UpdateCustomTemplateInput = {
  id: string,
  teamMemberId?: string | null,
  employerID?: string | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  name?: string | null,
  selectedFields?: string | null,
  includeFN?: boolean | null,
  individualFNCase?: boolean | null,
  includeCases?: boolean | null,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  type?: TemplateType | null,
  category?: TemplateCategory | null,
  isDeleted?: boolean | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  accessibleCompanyIds?: Array< string | null > | null,
  companyIds?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCustomTemplateInput = {
  id: string,
};

export type CreateReportInput = {
  id?: string | null,
  templateID: string,
  companyIds?: Array< string | null > | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  type?: TemplateType | null,
  name: string,
  status: ReportStatus,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  fromTemplate?: boolean | null,
  totalCountCycle?: number | null,
  completedCountCycle?: number | null,
  isCurrent?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReportConditionInput = {
  templateID?: ModelIDInput | null,
  companyIds?: ModelIDInput | null,
  accessibleIds?: ModelIDInput | null,
  editableIds?: ModelIDInput | null,
  viewAccess?: ModelAccessPermissionInput | null,
  editAccess?: ModelEditPermissionInput | null,
  type?: ModelTemplateTypeInput | null,
  name?: ModelStringInput | null,
  status?: ModelReportStatusInput | null,
  numberOfFilters?: ModelIntInput | null,
  numberOfColumns?: ModelIntInput | null,
  fromTemplate?: ModelBooleanInput | null,
  totalCountCycle?: ModelIntInput | null,
  completedCountCycle?: ModelIntInput | null,
  isCurrent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReportConditionInput | null > | null,
  or?: Array< ModelReportConditionInput | null > | null,
  not?: ModelReportConditionInput | null,
};

export type UpdateReportInput = {
  id: string,
  templateID?: string | null,
  companyIds?: Array< string | null > | null,
  accessibleIds?: Array< string | null > | null,
  editableIds?: Array< string | null > | null,
  viewAccess?: AccessPermission | null,
  editAccess?: EditPermission | null,
  type?: TemplateType | null,
  name?: string | null,
  status?: ReportStatus | null,
  numberOfFilters?: number | null,
  numberOfColumns?: number | null,
  fromTemplate?: boolean | null,
  totalCountCycle?: number | null,
  completedCountCycle?: number | null,
  isCurrent?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteReportInput = {
  id: string,
};

export type CreateReportEntriesInput = {
  id?: string | null,
  reportID: string,
  companyID?: string | null,
  foreignNationalID?: string | null,
  fullname?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  middlename?: string | null,
  archived?: string | null,
  email?: string | null,
  personalEmail?: string | null,
  birthDate?: string | null,
  numberOfDependents?: number | null,
  numberOfFamilyContacts?: number | null,
  displayCompanyName?: string | null,
  companyLegalName?: string | null,
  companyFullName?: string | null,
  sponsoringCompanyFullName?: string | null,
  companyDbaName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  birthCountryCode?: string | null,
  citizenshipCountry?: Array< string | null > | null,
  chargeabilityCountry?: string | null,
  passportExpirationDate?: string | null,
  nivMaxout?: string | null,
  visaExpDate?: string | null,
  hasApprovedI140?: boolean | null,
  petitionerI140?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  fnJobTitle?: string | null,
  socCode?: string | null,
  caseSocCode?: string | null,
  fnSalary?: string | null,
  startDate?: string | null,
  fnWorkLocation?: string | null,
  addressPrimary?: string | null,
  addressSecondary?: string | null,
  usResidentialAddress?: string | null,
  lastProcessType?: string | null,
  currentProcessType?: string | null,
  lowerProcessType?: string | null,
  lastPhaseCompleted?: string | null,
  currentPhase?: string | null,
  capType?: string | null,
  eadExpDate?: string | null,
  I797ApprovalExpDate?: string | null,
  I94ExpDate?: string | null,
  I94DS?: string | null,
  greenCardExpDate?: string | null,
  prevailingWageExpDate?: string | null,
  citizenshipEligibilityDate?: string | null,
  rfeDueDate?: string | null,
  dolAuditDueDate?: string | null,
  pwdExpDate?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  agreementExpDate?: string | null,
  agreementEffectiveDate?: string | null,
  mswsowExpDate?: string | null,
  permDueDate?: string | null,
  lotterySelectionDueDate?: string | null,
  advancedParoleExpDate?: string | null,
  reEntryPermitExpDate?: string | null,
  certifiedLcaExpDate?: string | null,
  title?: string | null,
  notes?: string | null,
  DS2019ExpDate?: string | null,
  isRelative?: boolean | null,
  relativeIds?: Array< string | null > | null,
  nextPhase?: string | null,
  requestedProcessSubCategory?: string | null,
  fnNameSlug?: string | null,
  caseSlug?: string | null,
  companyNameSlug?: string | null,
  employerNameSlug?: string | null,
  inviteStatus?: string | null,
  passportNumber?: string | null,
  phoneNumber?: string | null,
  personalPhone?: string | null,
  faxNumber?: string | null,
  passportGender?: string | null,
  preferredMailingAddress?: string | null,
  onboardingSections?: boolean | null,
  lastEntryUS?: string | null,
  employeeId?: string | null,
  caseNumber?: string | null,
  requestedProcess?: string | null,
  attorneyID?: string | null,
  caseAttorney?: string | null,
  sponsoringEmployerID?: string | null,
  sponsoringNationalID?: string | null,
  caseSponsor?: string | null,
  caseSponsorId?: string | null,
  caseManagerID?: string | null,
  caseManager?: string | null,
  contributorIds?: Array< string | null > | null,
  caseContributors?: Array< string | null > | null,
  caseStartDate?: string | null,
  caseOpenDate?: string | null,
  caseSalary?: string | null,
  state?: string | null,
  workLocation?: string | null,
  keyFilingDates?: string | null,
  lcaFiled?: string | null,
  capGap?: string | null,
  visaAdditionalProcessing?: Array< string | null > | null,
  stemExtEligible?: string | null,
  educationEvaluationNeeded?: string | null,
  wageIssues?: string | null,
  selection?: string | null,
  caseNature?: string | null,
  registrationCompleted?: string | null,
  receiptNumber?: string | null,
  currentCaseStatusText?: string | null,
  modifiedDate?: string | null,
  incompleteUscisReceiptNumber?: boolean | null,
  caseStatusHistory?: string | null,
  companyAttorneys?: Array< string | null > | null,
  companyAttorneyIds?: Array< string | null > | null,
  companyParalegals?: Array< string | null > | null,
  companyParalegalIds?: Array< string | null > | null,
  companyTotalCases?: string | null,
  companyTotalOpenCases?: string | null,
  companyTotalClosedCases?: string | null,
  companyTotalCompletedCases?: string | null,
  companyNationalCount?: string | null,
  fullTimeEmployeesInUS?: string | null,
  partTimeEmployeesInUS?: string | null,
  companyActiveNationalCount?: string | null,
  grossRevenueForMostRecentFiscalYear?: string | null,
  netRevenueForMostRecentFiscalYear?: string | null,
  naicsCodeOfCompany?: string | null,
  typeOfBusiness?: string | null,
  fein?: string | null,
  yearCompanyWasFoundedInUS?: string | null,
  aosFilingEligible?: string | null,
  requiresMeetingReminder?: boolean | null,
  isParent?: boolean | null,
  isPartnerCompany?: boolean | null,
  companyWhitelistedDomains?: Array< string | null > | null,
  companyContactLabel?: Array< string | null > | null,
  annualMeetingDate?: string | null,
  emCompanyNames?: Array< string | null > | null,
  emCompanyNameSlugs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelReportEntriesConditionInput = {
  reportID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  fullname?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  archived?: ModelStringInput | null,
  email?: ModelStringInput | null,
  personalEmail?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  numberOfDependents?: ModelIntInput | null,
  numberOfFamilyContacts?: ModelIntInput | null,
  displayCompanyName?: ModelStringInput | null,
  companyLegalName?: ModelStringInput | null,
  companyFullName?: ModelStringInput | null,
  sponsoringCompanyFullName?: ModelStringInput | null,
  companyDbaName?: ModelStringInput | null,
  immigrationCurrentStatus?: ModelStringInput | null,
  immigrationStatusExpiration?: ModelStringInput | null,
  birthCountryCode?: ModelStringInput | null,
  citizenshipCountry?: ModelStringInput | null,
  chargeabilityCountry?: ModelStringInput | null,
  passportExpirationDate?: ModelStringInput | null,
  nivMaxout?: ModelStringInput | null,
  visaExpDate?: ModelStringInput | null,
  hasApprovedI140?: ModelBooleanInput | null,
  petitionerI140?: ModelStringInput | null,
  employmentBasedCategory?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  fnJobTitle?: ModelStringInput | null,
  socCode?: ModelStringInput | null,
  caseSocCode?: ModelStringInput | null,
  fnSalary?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  fnWorkLocation?: ModelStringInput | null,
  addressPrimary?: ModelStringInput | null,
  addressSecondary?: ModelStringInput | null,
  usResidentialAddress?: ModelStringInput | null,
  lastProcessType?: ModelStringInput | null,
  currentProcessType?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  lastPhaseCompleted?: ModelStringInput | null,
  currentPhase?: ModelStringInput | null,
  capType?: ModelStringInput | null,
  eadExpDate?: ModelStringInput | null,
  I797ApprovalExpDate?: ModelStringInput | null,
  I94ExpDate?: ModelStringInput | null,
  I94DS?: ModelStringInput | null,
  greenCardExpDate?: ModelStringInput | null,
  prevailingWageExpDate?: ModelStringInput | null,
  citizenshipEligibilityDate?: ModelStringInput | null,
  rfeDueDate?: ModelStringInput | null,
  dolAuditDueDate?: ModelStringInput | null,
  pwdExpDate?: ModelStringInput | null,
  firstEntryUS?: ModelStringInput | null,
  taxTrackingF1J1?: ModelStringInput | null,
  agreementExpDate?: ModelStringInput | null,
  agreementEffectiveDate?: ModelStringInput | null,
  mswsowExpDate?: ModelStringInput | null,
  permDueDate?: ModelStringInput | null,
  lotterySelectionDueDate?: ModelStringInput | null,
  advancedParoleExpDate?: ModelStringInput | null,
  reEntryPermitExpDate?: ModelStringInput | null,
  certifiedLcaExpDate?: ModelStringInput | null,
  title?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  DS2019ExpDate?: ModelStringInput | null,
  isRelative?: ModelBooleanInput | null,
  relativeIds?: ModelStringInput | null,
  nextPhase?: ModelStringInput | null,
  requestedProcessSubCategory?: ModelStringInput | null,
  fnNameSlug?: ModelStringInput | null,
  caseSlug?: ModelStringInput | null,
  companyNameSlug?: ModelStringInput | null,
  employerNameSlug?: ModelStringInput | null,
  inviteStatus?: ModelStringInput | null,
  passportNumber?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  personalPhone?: ModelStringInput | null,
  faxNumber?: ModelStringInput | null,
  passportGender?: ModelStringInput | null,
  preferredMailingAddress?: ModelStringInput | null,
  onboardingSections?: ModelBooleanInput | null,
  lastEntryUS?: ModelStringInput | null,
  employeeId?: ModelStringInput | null,
  caseNumber?: ModelStringInput | null,
  requestedProcess?: ModelStringInput | null,
  attorneyID?: ModelStringInput | null,
  caseAttorney?: ModelStringInput | null,
  sponsoringEmployerID?: ModelStringInput | null,
  sponsoringNationalID?: ModelStringInput | null,
  caseSponsor?: ModelStringInput | null,
  caseSponsorId?: ModelStringInput | null,
  caseManagerID?: ModelStringInput | null,
  caseManager?: ModelStringInput | null,
  contributorIds?: ModelStringInput | null,
  caseContributors?: ModelStringInput | null,
  caseStartDate?: ModelStringInput | null,
  caseOpenDate?: ModelStringInput | null,
  caseSalary?: ModelStringInput | null,
  state?: ModelStringInput | null,
  workLocation?: ModelStringInput | null,
  keyFilingDates?: ModelStringInput | null,
  lcaFiled?: ModelStringInput | null,
  capGap?: ModelStringInput | null,
  visaAdditionalProcessing?: ModelStringInput | null,
  stemExtEligible?: ModelStringInput | null,
  educationEvaluationNeeded?: ModelStringInput | null,
  wageIssues?: ModelStringInput | null,
  selection?: ModelStringInput | null,
  caseNature?: ModelStringInput | null,
  registrationCompleted?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  currentCaseStatusText?: ModelStringInput | null,
  modifiedDate?: ModelStringInput | null,
  incompleteUscisReceiptNumber?: ModelBooleanInput | null,
  caseStatusHistory?: ModelStringInput | null,
  companyAttorneys?: ModelStringInput | null,
  companyAttorneyIds?: ModelStringInput | null,
  companyParalegals?: ModelStringInput | null,
  companyParalegalIds?: ModelStringInput | null,
  companyTotalCases?: ModelStringInput | null,
  companyTotalOpenCases?: ModelStringInput | null,
  companyTotalClosedCases?: ModelStringInput | null,
  companyTotalCompletedCases?: ModelStringInput | null,
  companyNationalCount?: ModelStringInput | null,
  fullTimeEmployeesInUS?: ModelStringInput | null,
  partTimeEmployeesInUS?: ModelStringInput | null,
  companyActiveNationalCount?: ModelStringInput | null,
  grossRevenueForMostRecentFiscalYear?: ModelStringInput | null,
  netRevenueForMostRecentFiscalYear?: ModelStringInput | null,
  naicsCodeOfCompany?: ModelStringInput | null,
  typeOfBusiness?: ModelStringInput | null,
  fein?: ModelStringInput | null,
  yearCompanyWasFoundedInUS?: ModelStringInput | null,
  aosFilingEligible?: ModelStringInput | null,
  requiresMeetingReminder?: ModelBooleanInput | null,
  isParent?: ModelBooleanInput | null,
  isPartnerCompany?: ModelBooleanInput | null,
  companyWhitelistedDomains?: ModelStringInput | null,
  companyContactLabel?: ModelStringInput | null,
  annualMeetingDate?: ModelStringInput | null,
  emCompanyNames?: ModelStringInput | null,
  emCompanyNameSlugs?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReportEntriesConditionInput | null > | null,
  or?: Array< ModelReportEntriesConditionInput | null > | null,
  not?: ModelReportEntriesConditionInput | null,
};

export type UpdateReportEntriesInput = {
  id: string,
  reportID?: string | null,
  companyID?: string | null,
  foreignNationalID?: string | null,
  fullname?: string | null,
  firstname?: string | null,
  lastname?: string | null,
  middlename?: string | null,
  archived?: string | null,
  email?: string | null,
  personalEmail?: string | null,
  birthDate?: string | null,
  numberOfDependents?: number | null,
  numberOfFamilyContacts?: number | null,
  displayCompanyName?: string | null,
  companyLegalName?: string | null,
  companyFullName?: string | null,
  sponsoringCompanyFullName?: string | null,
  companyDbaName?: string | null,
  immigrationCurrentStatus?: string | null,
  immigrationStatusExpiration?: string | null,
  birthCountryCode?: string | null,
  citizenshipCountry?: Array< string | null > | null,
  chargeabilityCountry?: string | null,
  passportExpirationDate?: string | null,
  nivMaxout?: string | null,
  visaExpDate?: string | null,
  hasApprovedI140?: boolean | null,
  petitionerI140?: string | null,
  employmentBasedCategory?: string | null,
  priorityDate?: string | null,
  fnJobTitle?: string | null,
  socCode?: string | null,
  caseSocCode?: string | null,
  fnSalary?: string | null,
  startDate?: string | null,
  fnWorkLocation?: string | null,
  addressPrimary?: string | null,
  addressSecondary?: string | null,
  usResidentialAddress?: string | null,
  lastProcessType?: string | null,
  currentProcessType?: string | null,
  lowerProcessType?: string | null,
  lastPhaseCompleted?: string | null,
  currentPhase?: string | null,
  capType?: string | null,
  eadExpDate?: string | null,
  I797ApprovalExpDate?: string | null,
  I94ExpDate?: string | null,
  I94DS?: string | null,
  greenCardExpDate?: string | null,
  prevailingWageExpDate?: string | null,
  citizenshipEligibilityDate?: string | null,
  rfeDueDate?: string | null,
  dolAuditDueDate?: string | null,
  pwdExpDate?: string | null,
  firstEntryUS?: string | null,
  taxTrackingF1J1?: string | null,
  agreementExpDate?: string | null,
  agreementEffectiveDate?: string | null,
  mswsowExpDate?: string | null,
  permDueDate?: string | null,
  lotterySelectionDueDate?: string | null,
  advancedParoleExpDate?: string | null,
  reEntryPermitExpDate?: string | null,
  certifiedLcaExpDate?: string | null,
  title?: string | null,
  notes?: string | null,
  DS2019ExpDate?: string | null,
  isRelative?: boolean | null,
  relativeIds?: Array< string | null > | null,
  nextPhase?: string | null,
  requestedProcessSubCategory?: string | null,
  fnNameSlug?: string | null,
  caseSlug?: string | null,
  companyNameSlug?: string | null,
  employerNameSlug?: string | null,
  inviteStatus?: string | null,
  passportNumber?: string | null,
  phoneNumber?: string | null,
  personalPhone?: string | null,
  faxNumber?: string | null,
  passportGender?: string | null,
  preferredMailingAddress?: string | null,
  onboardingSections?: boolean | null,
  lastEntryUS?: string | null,
  employeeId?: string | null,
  caseNumber?: string | null,
  requestedProcess?: string | null,
  attorneyID?: string | null,
  caseAttorney?: string | null,
  sponsoringEmployerID?: string | null,
  sponsoringNationalID?: string | null,
  caseSponsor?: string | null,
  caseSponsorId?: string | null,
  caseManagerID?: string | null,
  caseManager?: string | null,
  contributorIds?: Array< string | null > | null,
  caseContributors?: Array< string | null > | null,
  caseStartDate?: string | null,
  caseOpenDate?: string | null,
  caseSalary?: string | null,
  state?: string | null,
  workLocation?: string | null,
  keyFilingDates?: string | null,
  lcaFiled?: string | null,
  capGap?: string | null,
  visaAdditionalProcessing?: Array< string | null > | null,
  stemExtEligible?: string | null,
  educationEvaluationNeeded?: string | null,
  wageIssues?: string | null,
  selection?: string | null,
  caseNature?: string | null,
  registrationCompleted?: string | null,
  receiptNumber?: string | null,
  currentCaseStatusText?: string | null,
  modifiedDate?: string | null,
  incompleteUscisReceiptNumber?: boolean | null,
  caseStatusHistory?: string | null,
  companyAttorneys?: Array< string | null > | null,
  companyAttorneyIds?: Array< string | null > | null,
  companyParalegals?: Array< string | null > | null,
  companyParalegalIds?: Array< string | null > | null,
  companyTotalCases?: string | null,
  companyTotalOpenCases?: string | null,
  companyTotalClosedCases?: string | null,
  companyTotalCompletedCases?: string | null,
  companyNationalCount?: string | null,
  fullTimeEmployeesInUS?: string | null,
  partTimeEmployeesInUS?: string | null,
  companyActiveNationalCount?: string | null,
  grossRevenueForMostRecentFiscalYear?: string | null,
  netRevenueForMostRecentFiscalYear?: string | null,
  naicsCodeOfCompany?: string | null,
  typeOfBusiness?: string | null,
  fein?: string | null,
  yearCompanyWasFoundedInUS?: string | null,
  aosFilingEligible?: string | null,
  requiresMeetingReminder?: boolean | null,
  isParent?: boolean | null,
  isPartnerCompany?: boolean | null,
  companyWhitelistedDomains?: Array< string | null > | null,
  companyContactLabel?: Array< string | null > | null,
  annualMeetingDate?: string | null,
  emCompanyNames?: Array< string | null > | null,
  emCompanyNameSlugs?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteReportEntriesInput = {
  id: string,
};

export type CreateStandardTemplateInput = {
  id?: string | null,
  fields?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelStandardTemplateConditionInput = {
  fields?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStandardTemplateConditionInput | null > | null,
  or?: Array< ModelStandardTemplateConditionInput | null > | null,
  not?: ModelStandardTemplateConditionInput | null,
};

export type StandardTemplate = {
  __typename: "StandardTemplate",
  id: string,
  fields?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateStandardTemplateInput = {
  id: string,
  fields?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteStandardTemplateInput = {
  id: string,
};

export type CreateSchedulerInput = {
  id?: string | null,
  name: string,
  eventBridgeschedulerName: string,
  eventBridgeSchedulerID: string,
  description?: string | null,
  schedulerExpression: string,
  endDate: string,
  startTime: string,
  frequencyNumber: number,
  frequencyUnit: string,
  startDate: string,
  timeZone: string,
  targetUrl: string,
  entityID: string,
  taskDefinitionID: string,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type ModelSchedulerConditionInput = {
  name?: ModelStringInput | null,
  eventBridgeschedulerName?: ModelStringInput | null,
  eventBridgeSchedulerID?: ModelStringInput | null,
  description?: ModelStringInput | null,
  schedulerExpression?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  startTime?: ModelStringInput | null,
  frequencyNumber?: ModelIntInput | null,
  frequencyUnit?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  timeZone?: ModelStringInput | null,
  targetUrl?: ModelStringInput | null,
  entityID?: ModelIDInput | null,
  taskDefinitionID?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelSchedulerConditionInput | null > | null,
  or?: Array< ModelSchedulerConditionInput | null > | null,
  not?: ModelSchedulerConditionInput | null,
};

export type UpdateSchedulerInput = {
  id: string,
  name?: string | null,
  eventBridgeschedulerName?: string | null,
  eventBridgeSchedulerID?: string | null,
  description?: string | null,
  schedulerExpression?: string | null,
  endDate?: string | null,
  startTime?: string | null,
  frequencyNumber?: number | null,
  frequencyUnit?: string | null,
  startDate?: string | null,
  timeZone?: string | null,
  targetUrl?: string | null,
  entityID?: string | null,
  taskDefinitionID?: string | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type DeleteSchedulerInput = {
  id: string,
};

export type CreateVendorInput = {
  id?: string | null,
  name: string,
  type: VendorType,
  location?: string | null,
  email?: string | null,
  lowerName?: string | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type ModelVendorConditionInput = {
  name?: ModelStringInput | null,
  type?: ModelVendorTypeInput | null,
  location?: ModelStringInput | null,
  email?: ModelStringInput | null,
  lowerName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelVendorConditionInput | null > | null,
  or?: Array< ModelVendorConditionInput | null > | null,
  not?: ModelVendorConditionInput | null,
};

export type ModelVendorTypeInput = {
  eq?: VendorType | null,
  ne?: VendorType | null,
};

export type UpdateVendorInput = {
  id: string,
  name?: string | null,
  type?: VendorType | null,
  location?: string | null,
  email?: string | null,
  lowerName?: string | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type DeleteVendorInput = {
  id: string,
};

export type CreateTaskDefinitionInput = {
  id?: string | null,
  taskType: TaskType,
  payload: string,
  recipientIDs?: Array< string > | null,
  companyIndividualIDs?: Array< string | null > | null,
  individualIDs?: Array< string | null > | null,
  companyIDs?: Array< string > | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type ModelTaskDefinitionConditionInput = {
  taskType?: ModelTaskTypeInput | null,
  payload?: ModelStringInput | null,
  recipientIDs?: ModelIDInput | null,
  companyIndividualIDs?: ModelIDInput | null,
  individualIDs?: ModelIDInput | null,
  companyIDs?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTaskDefinitionConditionInput | null > | null,
  or?: Array< ModelTaskDefinitionConditionInput | null > | null,
  not?: ModelTaskDefinitionConditionInput | null,
};

export type ModelTaskTypeInput = {
  eq?: TaskType | null,
  ne?: TaskType | null,
};

export type UpdateTaskDefinitionInput = {
  id: string,
  taskType?: TaskType | null,
  payload?: string | null,
  recipientIDs?: Array< string > | null,
  companyIndividualIDs?: Array< string | null > | null,
  individualIDs?: Array< string | null > | null,
  companyIDs?: Array< string > | null,
  updatedAt?: string | null,
  createdAt?: string | null,
};

export type DeleteTaskDefinitionInput = {
  id: string,
};

export type ModelPreparedFormFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  relativeAdmins?: ModelStringInput | null,
  state?: ModelPreparedFormStateInput | null,
  preparerID?: ModelIDInput | null,
  templateID?: ModelIDInput | null,
  completedFormID?: ModelIDInput | null,
  assignedToID?: ModelIDInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToNationalID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  rejectedDate?: ModelStringInput | null,
  rejectedByID?: ModelIDInput | null,
  rejectedByEmployerID?: ModelIDInput | null,
  rejectedByNationalID?: ModelIDInput | null,
  rejectedByTeamMemberID?: ModelIDInput | null,
  requiresAttorneyApproval?: ModelBooleanInput | null,
  attorneyApproverID?: ModelIDInput | null,
  attorneyApprovalDate?: ModelStringInput | null,
  requiresSponsorApproval?: ModelBooleanInput | null,
  sponsorApproverID?: ModelIDInput | null,
  sponsorApproverEmployerID?: ModelIDInput | null,
  sponsorApproverNationalID?: ModelIDInput | null,
  sponsorApprovalDate?: ModelStringInput | null,
  requiresNationalApproval?: ModelBooleanInput | null,
  nationalApproverID?: ModelIDInput | null,
  nationalApprovalDate?: ModelStringInput | null,
  finalCaseManagerApproverID?: ModelIDInput | null,
  finalCaseManagerApprovalDate?: ModelStringInput | null,
  employersCanView?: ModelBooleanInput | null,
  nationalsCanView?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPreparedFormFilterInput | null > | null,
  or?: Array< ModelPreparedFormFilterInput | null > | null,
  not?: ModelPreparedFormFilterInput | null,
};

export type SearchableForeignNationalAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableForeignNationalAggregateField,
};

export enum SearchableForeignNationalAggregateField {
  type = "type",
  id = "id",
  createdBy = "createdBy",
  slug = "slug",
  userAgreementAcknowledged = "userAgreementAcknowledged",
  userAgreementAcknowledgementDate = "userAgreementAcknowledgementDate",
  userAgreementAcknowledgementText = "userAgreementAcknowledgementText",
  hasLoggedIn = "hasLoggedIn",
  completedOnboardingQuestionsBy = "completedOnboardingQuestionsBy",
  email = "email",
  emailPersonal = "emailPersonal",
  emailWork = "emailWork",
  username = "username",
  firstname = "firstname",
  middlename = "middlename",
  lastname = "lastname",
  nickname = "nickname",
  employeeId = "employeeId",
  additionalFirstnames = "additionalFirstnames",
  additionalMiddlenames = "additionalMiddlenames",
  additionalLastnames = "additionalLastnames",
  lowerFirst = "lowerFirst",
  lowerLast = "lowerLast",
  lowerFull = "lowerFull",
  maritalStatus = "maritalStatus",
  spouse = "spouse",
  dependents = "dependents",
  phone = "phone",
  phoneWork = "phoneWork",
  companyID = "companyID",
  companyNationalNumber = "companyNationalNumber",
  mostRecentlyInvited = "mostRecentlyInvited",
  archived = "archived",
  relatives = "relatives",
  relativeAdmins = "relativeAdmins",
  immigrationVisaStatus = "immigrationVisaStatus",
  visaExpiration = "visaExpiration",
  nonImmigrantVisaNumber = "nonImmigrantVisaNumber",
  visaIssueDate = "visaIssueDate",
  visaConsulate = "visaConsulate",
  immigrantVisaApplicant = "immigrantVisaApplicant",
  immigrantPetitionEverFiled = "immigrantPetitionEverFiled",
  hasPendingETA9089 = "hasPendingETA9089",
  aosFilingEligible = "aosFilingEligible",
  hasValidOrExpiredEAD = "hasValidOrExpiredEAD",
  hasPendingUSCISApplication = "hasPendingUSCISApplication",
  hasHadVisaPetitionRevokedOrDenied = "hasHadVisaPetitionRevokedOrDenied",
  hasBeenArrestedSinceLastUSEntry = "hasBeenArrestedSinceLastUSEntry",
  hasTransportedWeapons = "hasTransportedWeapons",
  hasParticipatedInArmedGroup = "hasParticipatedInArmedGroup",
  hasDetailedPerson = "hasDetailedPerson",
  hasUsedWeapons = "hasUsedWeapons",
  hasWeaponsTraining = "hasWeaponsTraining",
  hasCriminalOffence = "hasCriminalOffence",
  hasViolatedVisaTerms = "hasViolatedVisaTerms",
  citizenshipCountry = "citizenshipCountry",
  birthCountry = "birthCountry",
  birthState = "birthState",
  birthDate = "birthDate",
  birthCity = "birthCity",
  jobDescriptionID = "jobDescriptionID",
  nivMaxout = "nivMaxout",
  isRemote = "isRemote",
  hasNonUSPassport = "hasNonUSPassport",
  passportGender = "passportGender",
  passportIssueDate = "passportIssueDate",
  passportExpirationDate = "passportExpirationDate",
  passportExpirationReminderSentForDate = "passportExpirationReminderSentForDate",
  passportNumber = "passportNumber",
  passportCountry = "passportCountry",
  usSSN = "usSSN",
  hasSSN = "hasSSN",
  aNumber = "aNumber",
  lastEntryUS = "lastEntryUS",
  i94ArrivalDepartureRecordNumber = "i94ArrivalDepartureRecordNumber",
  sevisNumber = "sevisNumber",
  eadNumber = "eadNumber",
  fileRequirementsManipulated = "fileRequirementsManipulated",
  test = "test",
  notes = "notes",
  companyName = "companyName",
  immigrationCurrentStatus = "immigrationCurrentStatus",
  immigrationStatusExpiration = "immigrationStatusExpiration",
  employmentBasedCategory = "employmentBasedCategory",
  priorityDate = "priorityDate",
  eadExpDate = "eadExpDate",
  I797ExpDate = "I797ExpDate",
  visaExpDate = "visaExpDate",
  chargeabilityCountry = "chargeabilityCountry",
  birthCountryCode = "birthCountryCode",
  socCode = "socCode",
  firstEntryUS = "firstEntryUS",
  taxTrackingF1J1 = "taxTrackingF1J1",
  citizenshipEligibilityDate = "citizenshipEligibilityDate",
  startDate = "startDate",
  legalTeamIDs = "legalTeamIDs",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type ModelTeamMemberAlphaCompositeKeyConditionInput = {
  eq?: ModelTeamMemberAlphaCompositeKeyInput | null,
  le?: ModelTeamMemberAlphaCompositeKeyInput | null,
  lt?: ModelTeamMemberAlphaCompositeKeyInput | null,
  ge?: ModelTeamMemberAlphaCompositeKeyInput | null,
  gt?: ModelTeamMemberAlphaCompositeKeyInput | null,
  between?: Array< ModelTeamMemberAlphaCompositeKeyInput | null > | null,
  beginsWith?: ModelTeamMemberAlphaCompositeKeyInput | null,
};

export type ModelTeamMemberAlphaCompositeKeyInput = {
  archived?: ArchivedState | null,
  lowerFull?: string | null,
};

export type ModelTeamMemberByPositionCompositeKeyConditionInput = {
  eq?: ModelTeamMemberByPositionCompositeKeyInput | null,
  le?: ModelTeamMemberByPositionCompositeKeyInput | null,
  lt?: ModelTeamMemberByPositionCompositeKeyInput | null,
  ge?: ModelTeamMemberByPositionCompositeKeyInput | null,
  gt?: ModelTeamMemberByPositionCompositeKeyInput | null,
  between?: Array< ModelTeamMemberByPositionCompositeKeyInput | null > | null,
  beginsWith?: ModelTeamMemberByPositionCompositeKeyInput | null,
};

export type ModelTeamMemberByPositionCompositeKeyInput = {
  archived?: ArchivedState | null,
  lowerFull?: string | null,
};

export type ModelAttorneyAssignmentFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  attorneyID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAttorneyAssignmentFilterInput | null > | null,
  or?: Array< ModelAttorneyAssignmentFilterInput | null > | null,
  not?: ModelAttorneyAssignmentFilterInput | null,
};

export type ModelParalegalAssignmentFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  paralegalID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelParalegalAssignmentFilterInput | null > | null,
  or?: Array< ModelParalegalAssignmentFilterInput | null > | null,
  not?: ModelParalegalAssignmentFilterInput | null,
};

export type ModelEmployerAssignmentFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmployerAssignmentFilterInput | null > | null,
  or?: Array< ModelEmployerAssignmentFilterInput | null > | null,
  not?: ModelEmployerAssignmentFilterInput | null,
};

export type ModelEmployerAdminAssignmentFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEmployerAdminAssignmentFilterInput | null > | null,
  or?: Array< ModelEmployerAdminAssignmentFilterInput | null > | null,
  not?: ModelEmployerAdminAssignmentFilterInput | null,
};

export type ModelPrimaryContactFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrimaryContactFilterInput | null > | null,
  or?: Array< ModelPrimaryContactFilterInput | null > | null,
  not?: ModelPrimaryContactFilterInput | null,
};

export type ModelSeniorContactFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSeniorContactFilterInput | null > | null,
  or?: Array< ModelSeniorContactFilterInput | null > | null,
  not?: ModelSeniorContactFilterInput | null,
};

export type ModelInvoicingContactFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelInvoicingContactFilterInput | null > | null,
  or?: Array< ModelInvoicingContactFilterInput | null > | null,
  not?: ModelInvoicingContactFilterInput | null,
};

export type ModelSignatoryContactFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  employerID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSignatoryContactFilterInput | null > | null,
  or?: Array< ModelSignatoryContactFilterInput | null > | null,
  not?: ModelSignatoryContactFilterInput | null,
};

export type ModelCompanyAlphaCompositeKeyConditionInput = {
  eq?: ModelCompanyAlphaCompositeKeyInput | null,
  le?: ModelCompanyAlphaCompositeKeyInput | null,
  lt?: ModelCompanyAlphaCompositeKeyInput | null,
  ge?: ModelCompanyAlphaCompositeKeyInput | null,
  gt?: ModelCompanyAlphaCompositeKeyInput | null,
  between?: Array< ModelCompanyAlphaCompositeKeyInput | null > | null,
  beginsWith?: ModelCompanyAlphaCompositeKeyInput | null,
};

export type ModelCompanyAlphaCompositeKeyInput = {
  archived?: ArchivedState | null,
  lowerNameKey?: string | null,
};

export type ModelCompanyCompaniesByParentCompositeKeyConditionInput = {
  eq?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
  le?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
  lt?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
  ge?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
  gt?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
  between?: Array< ModelCompanyCompaniesByParentCompositeKeyInput | null > | null,
  beginsWith?: ModelCompanyCompaniesByParentCompositeKeyInput | null,
};

export type ModelCompanyCompaniesByParentCompositeKeyInput = {
  archived?: ArchivedState | null,
  lowerNameKey?: string | null,
};

export type ModelFirmFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  domainWhitelist?: ModelStringInput | null,
  doingBusinessAs?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  fax?: ModelStringInput | null,
  holidays?: ModelStringInput | null,
  companyCount?: ModelIntInput | null,
  nationalCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFirmFilterInput | null > | null,
  or?: Array< ModelFirmFilterInput | null > | null,
  not?: ModelFirmFilterInput | null,
};

export type ModelFirmConnection = {
  __typename: "ModelFirmConnection",
  items:  Array<Firm | null >,
  nextToken?: string | null,
};

export type ModelJobDescriptionFilterInput = {
  companyID?: ModelIDInput | null,
  id?: ModelIDInput | null,
  archived?: ModelArchivedStateInput | null,
  type?: ModelJobDescriptionTypeInput | null,
  foreignNationalID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  officialTitle?: ModelStringInput | null,
  degrees?: ModelDegreeListInput | null,
  requiresBachelors?: ModelBooleanInput | null,
  requiresMasters?: ModelBooleanInput | null,
  requiresPhd?: ModelBooleanInput | null,
  dotNumber?: ModelStringInput | null,
  caseSocCode?: ModelStringInput | null,
  duties?: ModelStringInput | null,
  jobURL?: ModelStringInput | null,
  majors?: ModelStringInput | null,
  specialRequirements?: ModelStringInput | null,
  yearsGeneralExperience?: ModelIntInput | null,
  objectiveSkillSetsRequired?: ModelStringInput | null,
  offeredSalary?: ModelStringInput | null,
  certificationLicenses?: ModelStringInput | null,
  travelIsRequired?: ModelBooleanInput | null,
  travelPercentage?: ModelIntInput | null,
  travelDomestic?: ModelBooleanInput | null,
  travelInternational?: ModelBooleanInput | null,
  supervisesOthers?: ModelBooleanInput | null,
  supervisesOthersCount?: ModelIntInput | null,
  supervisesTitles?: ModelStringInput | null,
  supervisorTitle?: ModelStringInput | null,
  canWorkFromHome?: ModelBooleanInput | null,
  uploadedDescriptionID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelJobDescriptionFilterInput | null > | null,
  or?: Array< ModelJobDescriptionFilterInput | null > | null,
  not?: ModelJobDescriptionFilterInput | null,
};

export type ModelJobDescriptionByCompanyCompositeKeyConditionInput = {
  eq?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
  le?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
  lt?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
  ge?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
  gt?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
  between?: Array< ModelJobDescriptionByCompanyCompositeKeyInput | null > | null,
  beginsWith?: ModelJobDescriptionByCompanyCompositeKeyInput | null,
};

export type ModelJobDescriptionByCompanyCompositeKeyInput = {
  archived?: ArchivedState | null,
  type?: JobDescriptionType | null,
};

export type ModelJobDescriptionByForeignNationalCompositeKeyConditionInput = {
  eq?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
  le?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
  lt?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
  ge?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
  gt?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
  between?: Array< ModelJobDescriptionByForeignNationalCompositeKeyInput | null > | null,
  beginsWith?: ModelJobDescriptionByForeignNationalCompositeKeyInput | null,
};

export type ModelJobDescriptionByForeignNationalCompositeKeyInput = {
  archived?: ArchivedState | null,
  type?: JobDescriptionType | null,
};

export type ModelProcessRequestFilterInput = {
  id?: ModelIDInput | null,
  assignedToID?: ModelIDInput | null,
  assignedToEmployerID?: ModelIDInput | null,
  assignedToTeamMemberID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  individualSponsored?: ModelBooleanInput | null,
  initiatorID?: ModelIDInput | null,
  jobDescriptionID?: ModelIDInput | null,
  requesterID?: ModelIDInput | null,
  requestDate?: ModelStringInput | null,
  approvalDate?: ModelStringInput | null,
  archivedDate?: ModelStringInput | null,
  cancelDate?: ModelStringInput | null,
  foreignNationalID?: ModelIDInput | null,
  needsEmployerRevision?: ModelBooleanInput | null,
  resumeID?: ModelIDInput | null,
  requestedProcess?: ModelVisaStatusInput | null,
  requestedProcessSubCategory?: ModelVisaSubCategoryInput | null,
  requestedProcessAdditionalProcessing?: ModelVisaAdditionalProcessingListInput | null,
  globalRequestedProcessSubCategory?: ModelStringInput | null,
  globalProcessCountryCode?: ModelCountryCodeInput | null,
  globalProcessDuration?: ModelGlobalProcessDurationInput | null,
  globalVisaType?: ModelGlobalVisaTypeInput | null,
  vendorID?: ModelIDInput | null,
  slug?: ModelStringInput | null,
  state?: ModelProcessRequestStateInput | null,
  lowerNationalName?: ModelStringInput | null,
  lowerCompanyName?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  and?: Array< ModelProcessRequestFilterInput | null > | null,
  or?: Array< ModelProcessRequestFilterInput | null > | null,
  not?: ModelProcessRequestFilterInput | null,
};

export type SearchableProcessRequestAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableProcessRequestAggregateField,
};

export enum SearchableProcessRequestAggregateField {
  id = "id",
  assignedToID = "assignedToID",
  assignedToEmployerID = "assignedToEmployerID",
  assignedToTeamMemberID = "assignedToTeamMemberID",
  companyID = "companyID",
  individualSponsored = "individualSponsored",
  initiatorID = "initiatorID",
  jobDescriptionID = "jobDescriptionID",
  requesterID = "requesterID",
  requestDate = "requestDate",
  approvalDate = "approvalDate",
  archivedDate = "archivedDate",
  cancelDate = "cancelDate",
  foreignNationalID = "foreignNationalID",
  needsEmployerRevision = "needsEmployerRevision",
  resumeID = "resumeID",
  requestedProcess = "requestedProcess",
  requestedProcessSubCategory = "requestedProcessSubCategory",
  requestedProcessAdditionalProcessing = "requestedProcessAdditionalProcessing",
  globalRequestedProcessSubCategory = "globalRequestedProcessSubCategory",
  globalProcessCountryCode = "globalProcessCountryCode",
  globalProcessDuration = "globalProcessDuration",
  globalVisaType = "globalVisaType",
  vendorID = "vendorID",
  slug = "slug",
  state = "state",
  lowerNationalName = "lowerNationalName",
  lowerCompanyName = "lowerCompanyName",
  lowerProcessType = "lowerProcessType",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableCaseAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableCaseAggregateField,
};

export enum SearchableCaseAggregateField {
  id = "id",
  caseNumber = "caseNumber",
  slug = "slug",
  attorneyID = "attorneyID",
  caseManagerID = "caseManagerID",
  complianceListID = "complianceListID",
  PERMFilingDataID = "PERMFilingDataID",
  pinnedCaseNoteID = "pinnedCaseNoteID",
  contributorIds = "contributorIds",
  sponsoringEmployerID = "sponsoringEmployerID",
  sponsoringNationalID = "sponsoringNationalID",
  foreignNationalID = "foreignNationalID",
  welcomeLetterAcknowledged = "welcomeLetterAcknowledged",
  welcomeLetterAcknowledgementDate = "welcomeLetterAcknowledgementDate",
  welcomeLetterAcknowledgedBy = "welcomeLetterAcknowledgedBy",
  welcomeLetterText = "welcomeLetterText",
  nationalVisaExpiration = "nationalVisaExpiration",
  relativeAdmins = "relativeAdmins",
  startDate = "startDate",
  closeDate = "closeDate",
  closeReason = "closeReason",
  completeDate = "completeDate",
  sourceID = "sourceID",
  state = "state",
  lowerNationalName = "lowerNationalName",
  lowerCompanyName = "lowerCompanyName",
  lowerProcessType = "lowerProcessType",
  currentPhase = "currentPhase",
  prevailingWageCaseNumber = "prevailingWageCaseNumber",
  USCISReceiptNumber = "USCISReceiptNumber",
  AOSReceiptNotice = "AOSReceiptNotice",
  I485JReceiptNotice = "I485JReceiptNotice",
  SelectionNoticeNo = "SelectionNoticeNo",
  ETACaseNumber = "ETACaseNumber",
  isShipmentTrackingElectronically = "isShipmentTrackingElectronically",
  companyID = "companyID",
  individualSponsored = "individualSponsored",
  jobDescriptionID = "jobDescriptionID",
  resumeID = "resumeID",
  requestedProcess = "requestedProcess",
  requestedProcessSubCategory = "requestedProcessSubCategory",
  requestedProcessAdditionalProcessing = "requestedProcessAdditionalProcessing",
  globalRequestedProcessSubCategory = "globalRequestedProcessSubCategory",
  globalProcessCountryCode = "globalProcessCountryCode",
  globalProcessDuration = "globalProcessDuration",
  globalVisaType = "globalVisaType",
  vendorID = "vendorID",
  additionalFieldID = "additionalFieldID",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type ModelUSCISReceiptDetailsFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  receiptType?: ModelReceiptTypeInput | null,
  receiptNumber?: ModelStringInput | null,
  formType?: ModelStringInput | null,
  submittedDate?: ModelStringInput | null,
  modifiedDate?: ModelStringInput | null,
  currentCaseStatusText?: ModelStringInput | null,
  currentCaseStatusDesc?: ModelStringInput | null,
  message?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  isLatest?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUSCISReceiptDetailsFilterInput | null > | null,
  or?: Array< ModelUSCISReceiptDetailsFilterInput | null > | null,
  not?: ModelUSCISReceiptDetailsFilterInput | null,
};

export type ModelCaseComplianceListFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  educationEvaluationNeeded?: ModelComplianceCheckListInput | null,
  stemExtEligible?: ModelComplianceCheckListInput | null,
  capGap?: ModelComplianceCheckListInput | null,
  wageIssues?: ModelComplianceCheckListInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseComplianceListFilterInput | null > | null,
  or?: Array< ModelCaseComplianceListFilterInput | null > | null,
  not?: ModelCaseComplianceListFilterInput | null,
};

export type ModelCaseComplianceListConnection = {
  __typename: "ModelCaseComplianceListConnection",
  items:  Array<CaseComplianceList | null >,
  nextToken?: string | null,
};

export type ModelPERMFilingDataFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  PERMFirstPossibleFilingDate?: ModelStringInput | null,
  PERMLastPossibleFilingDate?: ModelStringInput | null,
  applicantsReceived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPERMFilingDataFilterInput | null > | null,
  or?: Array< ModelPERMFilingDataFilterInput | null > | null,
  not?: ModelPERMFilingDataFilterInput | null,
};

export type ModelPERMFilingDataConnection = {
  __typename: "ModelPERMFilingDataConnection",
  items:  Array<PERMFilingData | null >,
  nextToken?: string | null,
};

export type ModelCaseContributorFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  contributorID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  state?: ModelCaseStateInput | null,
  type?: ModelPersonTypeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseContributorFilterInput | null > | null,
  or?: Array< ModelCaseContributorFilterInput | null > | null,
  not?: ModelCaseContributorFilterInput | null,
};

export type ModelTaskTemplateFilterInput = {
  id?: ModelIDInput | null,
  defaultAssignee?: ModelTaskAssignmentRoleInput | null,
  duration?: ModelIntInput | null,
  groupsCanRead?: ModelStringInput | null,
  lockedByDefault?: ModelBooleanInput | null,
  action?: ModelStringInput | null,
  isKeyDate?: ModelBooleanInput | null,
  keyDateAlternateAction?: ModelStringInput | null,
  isPaymentStatus?: ModelBooleanInput | null,
  description?: ModelStringInput | null,
  paymentStatusAlternateAction?: ModelStringInput | null,
  prerequisiteID?: ModelIDInput | null,
  process?: ModelVisaStatusInput | null,
  category?: ModelTaskCategoryInput | null,
  hidden?: ModelBooleanInput | null,
  isManuallyUnlocked?: ModelBooleanInput | null,
  durationFromStartDate?: ModelBooleanInput | null,
  orderIndex?: ModelIntInput | null,
  startDate?: ModelStringInput | null,
  deadline?: ModelStringInput | null,
  and?: Array< ModelTaskTemplateFilterInput | null > | null,
  or?: Array< ModelTaskTemplateFilterInput | null > | null,
  not?: ModelTaskTemplateFilterInput | null,
};

export type ModelTaskTemplateConnection = {
  __typename: "ModelTaskTemplateConnection",
  items:  Array<TaskTemplate | null >,
  nextToken?: string | null,
};

export type ModelFileDataFilterInput = {
  id?: ModelIDInput | null,
  expirationDate?: ModelStringInput | null,
  durationOfStatus?: ModelBooleanInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelFileTypeInput | null,
  fileRequirement?: ModelStringInput | null,
  fileCategory?: ModelStringInput | null,
  contentType?: ModelStringInput | null,
  issueDate?: ModelStringInput | null,
  dueDate?: ModelStringInput | null,
  isFlattened?: ModelBooleanInput | null,
  processRequestID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  ownerNationalID?: ModelIDInput | null,
  sourceID?: ModelIDInput | null,
  uploadDate?: ModelStringInput | null,
  uploaderID?: ModelIDInput | null,
  uploaderEmployerID?: ModelIDInput | null,
  uploaderForeignNationalID?: ModelIDInput | null,
  uploaderTeamMemberID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFileDataFilterInput | null > | null,
  or?: Array< ModelFileDataFilterInput | null > | null,
  not?: ModelFileDataFilterInput | null,
};

export type ModelCaseRfgpFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  status?: ModelRfgpStatusInput | null,
  jobID?: ModelIDInput | null,
  fileID?: ModelIDInput | null,
  usedFileIDs?: ModelIDInput | null,
  errorMessage?: ModelStringInput | null,
  generatedAt?: ModelStringInput | null,
  generatedByID?: ModelIDInput | null,
  updatedByID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCaseRfgpFilterInput | null > | null,
  or?: Array< ModelCaseRfgpFilterInput | null > | null,
  not?: ModelCaseRfgpFilterInput | null,
};

export type ModelCaseRfgpConnection = {
  __typename: "ModelCaseRfgpConnection",
  items:  Array<CaseRfgp | null >,
  nextToken?: string | null,
};

export type ModelActivityFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  activityType?: ModelActivityTypeInput | null,
  ipAddress?: ModelStringInput | null,
  fieldName?: ModelStringInput | null,
  updatedValue?: ModelStringInput | null,
  actorID?: ModelIDInput | null,
  actorEmployerID?: ModelIDInput | null,
  actorForeignNationalID?: ModelIDInput | null,
  actorTeamMemberID?: ModelIDInput | null,
  actorType?: ModelPersonTypeInput | null,
  directTargetID?: ModelIDInput | null,
  directTargetCaseID?: ModelIDInput | null,
  directTargetCompanyID?: ModelIDInput | null,
  directTargetEmployerID?: ModelIDInput | null,
  directTargetFileDataID?: ModelIDInput | null,
  directTargetForeignNationalID?: ModelIDInput | null,
  directTargetProcessRequestID?: ModelIDInput | null,
  directTargetTaskID?: ModelIDInput | null,
  directTargetTeamMemberID?: ModelIDInput | null,
  directTargetReportID?: ModelIDInput | null,
  targetString?: ModelStringInput | null,
  indirectTargetID?: ModelIDInput | null,
  indirectTargetCaseID?: ModelIDInput | null,
  indirectTargetCompanyID?: ModelIDInput | null,
  indirectTargetEmployerID?: ModelIDInput | null,
  indirectTargetForeignNationalID?: ModelIDInput | null,
  indirectTargetProcessRequestID?: ModelIDInput | null,
  indirectTargetTeamMemberID?: ModelIDInput | null,
  indirectTargetReportID?: ModelIDInput | null,
  indirectTargetString?: ModelStringInput | null,
  ownerID?: ModelIDInput | null,
  ownerCaseID?: ModelIDInput | null,
  ownerCompanyID?: ModelIDInput | null,
  ownerEmployerID?: ModelIDInput | null,
  ownerFileDataID?: ModelIDInput | null,
  ownerForeignNationalID?: ModelIDInput | null,
  ownerProcessRequestID?: ModelIDInput | null,
  ownerTeamMemberID?: ModelIDInput | null,
  ownerReportID?: ModelIDInput | null,
  and?: Array< ModelActivityFilterInput | null > | null,
  or?: Array< ModelActivityFilterInput | null > | null,
  not?: ModelActivityFilterInput | null,
};

export type SearchableActivityAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableActivityAggregateField,
};

export enum SearchableActivityAggregateField {
  id = "id",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  activityType = "activityType",
  ipAddress = "ipAddress",
  fieldName = "fieldName",
  updatedValue = "updatedValue",
  actorID = "actorID",
  actorEmployerID = "actorEmployerID",
  actorForeignNationalID = "actorForeignNationalID",
  actorTeamMemberID = "actorTeamMemberID",
  actorType = "actorType",
  directTargetID = "directTargetID",
  directTargetCaseID = "directTargetCaseID",
  directTargetCompanyID = "directTargetCompanyID",
  directTargetEmployerID = "directTargetEmployerID",
  directTargetFileDataID = "directTargetFileDataID",
  directTargetForeignNationalID = "directTargetForeignNationalID",
  directTargetProcessRequestID = "directTargetProcessRequestID",
  directTargetTaskID = "directTargetTaskID",
  directTargetTeamMemberID = "directTargetTeamMemberID",
  directTargetReportID = "directTargetReportID",
  targetString = "targetString",
  indirectTargetID = "indirectTargetID",
  indirectTargetCaseID = "indirectTargetCaseID",
  indirectTargetCompanyID = "indirectTargetCompanyID",
  indirectTargetEmployerID = "indirectTargetEmployerID",
  indirectTargetForeignNationalID = "indirectTargetForeignNationalID",
  indirectTargetProcessRequestID = "indirectTargetProcessRequestID",
  indirectTargetTeamMemberID = "indirectTargetTeamMemberID",
  indirectTargetReportID = "indirectTargetReportID",
  indirectTargetString = "indirectTargetString",
  ownerID = "ownerID",
  ownerCaseID = "ownerCaseID",
  ownerCompanyID = "ownerCompanyID",
  ownerEmployerID = "ownerEmployerID",
  ownerFileDataID = "ownerFileDataID",
  ownerForeignNationalID = "ownerForeignNationalID",
  ownerProcessRequestID = "ownerProcessRequestID",
  ownerTeamMemberID = "ownerTeamMemberID",
  ownerReportID = "ownerReportID",
}


export type ModelNotificationByPersonByReadCompositeKeyConditionInput = {
  eq?: ModelNotificationByPersonByReadCompositeKeyInput | null,
  le?: ModelNotificationByPersonByReadCompositeKeyInput | null,
  lt?: ModelNotificationByPersonByReadCompositeKeyInput | null,
  ge?: ModelNotificationByPersonByReadCompositeKeyInput | null,
  gt?: ModelNotificationByPersonByReadCompositeKeyInput | null,
  between?: Array< ModelNotificationByPersonByReadCompositeKeyInput | null > | null,
  beginsWith?: ModelNotificationByPersonByReadCompositeKeyInput | null,
};

export type ModelNotificationByPersonByReadCompositeKeyInput = {
  read?: ReadState | null,
  createdAt?: string | null,
};

export type ModelAdditionalFieldsFilterInput = {
  id?: ModelIDInput | null,
  caseID?: ModelIDInput | null,
  fields?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAdditionalFieldsFilterInput | null > | null,
  or?: Array< ModelAdditionalFieldsFilterInput | null > | null,
  not?: ModelAdditionalFieldsFilterInput | null,
};

export type ModelAdditionalFieldsConnection = {
  __typename: "ModelAdditionalFieldsConnection",
  items:  Array<AdditionalFields | null >,
  nextToken?: string | null,
};

export type SearchableReportFilterInput = {
  id?: SearchableIDFilterInput | null,
  templateID?: SearchableIDFilterInput | null,
  companyIds?: SearchableIDFilterInput | null,
  accessibleIds?: SearchableIDFilterInput | null,
  editableIds?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  numberOfFilters?: SearchableIntFilterInput | null,
  numberOfColumns?: SearchableIntFilterInput | null,
  fromTemplate?: SearchableBooleanFilterInput | null,
  totalCountCycle?: SearchableIntFilterInput | null,
  completedCountCycle?: SearchableIntFilterInput | null,
  isCurrent?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  viewAccess?: SearchableStringFilterInput | null,
  editAccess?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  status?: SearchableStringFilterInput | null,
  and?: Array< SearchableReportFilterInput | null > | null,
  or?: Array< SearchableReportFilterInput | null > | null,
  not?: SearchableReportFilterInput | null,
};

export type SearchableReportSortInput = {
  field?: SearchableReportSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableReportSortableFields {
  id = "id",
  templateID = "templateID",
  companyIds = "companyIds",
  accessibleIds = "accessibleIds",
  editableIds = "editableIds",
  name = "name",
  numberOfFilters = "numberOfFilters",
  numberOfColumns = "numberOfColumns",
  fromTemplate = "fromTemplate",
  totalCountCycle = "totalCountCycle",
  completedCountCycle = "completedCountCycle",
  isCurrent = "isCurrent",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReportAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReportAggregateField,
};

export enum SearchableReportAggregateField {
  id = "id",
  templateID = "templateID",
  companyIds = "companyIds",
  accessibleIds = "accessibleIds",
  editableIds = "editableIds",
  viewAccess = "viewAccess",
  editAccess = "editAccess",
  type = "type",
  name = "name",
  status = "status",
  numberOfFilters = "numberOfFilters",
  numberOfColumns = "numberOfColumns",
  fromTemplate = "fromTemplate",
  totalCountCycle = "totalCountCycle",
  completedCountCycle = "completedCountCycle",
  isCurrent = "isCurrent",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableReportConnection = {
  __typename: "SearchableReportConnection",
  items:  Array<Report | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelReportEntriesFilterInput = {
  id?: ModelIDInput | null,
  reportID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  foreignNationalID?: ModelIDInput | null,
  fullname?: ModelStringInput | null,
  firstname?: ModelStringInput | null,
  lastname?: ModelStringInput | null,
  middlename?: ModelStringInput | null,
  archived?: ModelStringInput | null,
  email?: ModelStringInput | null,
  personalEmail?: ModelStringInput | null,
  birthDate?: ModelStringInput | null,
  numberOfDependents?: ModelIntInput | null,
  numberOfFamilyContacts?: ModelIntInput | null,
  displayCompanyName?: ModelStringInput | null,
  companyLegalName?: ModelStringInput | null,
  companyFullName?: ModelStringInput | null,
  sponsoringCompanyFullName?: ModelStringInput | null,
  companyDbaName?: ModelStringInput | null,
  immigrationCurrentStatus?: ModelStringInput | null,
  immigrationStatusExpiration?: ModelStringInput | null,
  birthCountryCode?: ModelStringInput | null,
  citizenshipCountry?: ModelStringInput | null,
  chargeabilityCountry?: ModelStringInput | null,
  passportExpirationDate?: ModelStringInput | null,
  nivMaxout?: ModelStringInput | null,
  visaExpDate?: ModelStringInput | null,
  hasApprovedI140?: ModelBooleanInput | null,
  petitionerI140?: ModelStringInput | null,
  employmentBasedCategory?: ModelStringInput | null,
  priorityDate?: ModelStringInput | null,
  fnJobTitle?: ModelStringInput | null,
  socCode?: ModelStringInput | null,
  caseSocCode?: ModelStringInput | null,
  fnSalary?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  fnWorkLocation?: ModelStringInput | null,
  addressPrimary?: ModelStringInput | null,
  addressSecondary?: ModelStringInput | null,
  usResidentialAddress?: ModelStringInput | null,
  lastProcessType?: ModelStringInput | null,
  currentProcessType?: ModelStringInput | null,
  lowerProcessType?: ModelStringInput | null,
  lastPhaseCompleted?: ModelStringInput | null,
  currentPhase?: ModelStringInput | null,
  capType?: ModelStringInput | null,
  eadExpDate?: ModelStringInput | null,
  I797ApprovalExpDate?: ModelStringInput | null,
  I94ExpDate?: ModelStringInput | null,
  I94DS?: ModelStringInput | null,
  greenCardExpDate?: ModelStringInput | null,
  prevailingWageExpDate?: ModelStringInput | null,
  citizenshipEligibilityDate?: ModelStringInput | null,
  rfeDueDate?: ModelStringInput | null,
  dolAuditDueDate?: ModelStringInput | null,
  pwdExpDate?: ModelStringInput | null,
  firstEntryUS?: ModelStringInput | null,
  taxTrackingF1J1?: ModelStringInput | null,
  agreementExpDate?: ModelStringInput | null,
  agreementEffectiveDate?: ModelStringInput | null,
  mswsowExpDate?: ModelStringInput | null,
  permDueDate?: ModelStringInput | null,
  lotterySelectionDueDate?: ModelStringInput | null,
  advancedParoleExpDate?: ModelStringInput | null,
  reEntryPermitExpDate?: ModelStringInput | null,
  certifiedLcaExpDate?: ModelStringInput | null,
  title?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  DS2019ExpDate?: ModelStringInput | null,
  isRelative?: ModelBooleanInput | null,
  relativeIds?: ModelStringInput | null,
  nextPhase?: ModelStringInput | null,
  requestedProcessSubCategory?: ModelStringInput | null,
  fnNameSlug?: ModelStringInput | null,
  caseSlug?: ModelStringInput | null,
  companyNameSlug?: ModelStringInput | null,
  employerNameSlug?: ModelStringInput | null,
  inviteStatus?: ModelStringInput | null,
  passportNumber?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  personalPhone?: ModelStringInput | null,
  faxNumber?: ModelStringInput | null,
  passportGender?: ModelStringInput | null,
  preferredMailingAddress?: ModelStringInput | null,
  onboardingSections?: ModelBooleanInput | null,
  lastEntryUS?: ModelStringInput | null,
  employeeId?: ModelStringInput | null,
  caseNumber?: ModelStringInput | null,
  requestedProcess?: ModelStringInput | null,
  attorneyID?: ModelStringInput | null,
  caseAttorney?: ModelStringInput | null,
  sponsoringEmployerID?: ModelStringInput | null,
  sponsoringNationalID?: ModelStringInput | null,
  caseSponsor?: ModelStringInput | null,
  caseSponsorId?: ModelStringInput | null,
  caseManagerID?: ModelStringInput | null,
  caseManager?: ModelStringInput | null,
  contributorIds?: ModelStringInput | null,
  caseContributors?: ModelStringInput | null,
  caseStartDate?: ModelStringInput | null,
  caseOpenDate?: ModelStringInput | null,
  caseSalary?: ModelStringInput | null,
  state?: ModelStringInput | null,
  workLocation?: ModelStringInput | null,
  keyFilingDates?: ModelStringInput | null,
  lcaFiled?: ModelStringInput | null,
  capGap?: ModelStringInput | null,
  visaAdditionalProcessing?: ModelStringInput | null,
  stemExtEligible?: ModelStringInput | null,
  educationEvaluationNeeded?: ModelStringInput | null,
  wageIssues?: ModelStringInput | null,
  selection?: ModelStringInput | null,
  caseNature?: ModelStringInput | null,
  registrationCompleted?: ModelStringInput | null,
  receiptNumber?: ModelStringInput | null,
  currentCaseStatusText?: ModelStringInput | null,
  modifiedDate?: ModelStringInput | null,
  incompleteUscisReceiptNumber?: ModelBooleanInput | null,
  caseStatusHistory?: ModelStringInput | null,
  companyAttorneys?: ModelStringInput | null,
  companyAttorneyIds?: ModelStringInput | null,
  companyParalegals?: ModelStringInput | null,
  companyParalegalIds?: ModelStringInput | null,
  companyTotalCases?: ModelStringInput | null,
  companyTotalOpenCases?: ModelStringInput | null,
  companyTotalClosedCases?: ModelStringInput | null,
  companyTotalCompletedCases?: ModelStringInput | null,
  companyNationalCount?: ModelStringInput | null,
  fullTimeEmployeesInUS?: ModelStringInput | null,
  partTimeEmployeesInUS?: ModelStringInput | null,
  companyActiveNationalCount?: ModelStringInput | null,
  grossRevenueForMostRecentFiscalYear?: ModelStringInput | null,
  netRevenueForMostRecentFiscalYear?: ModelStringInput | null,
  naicsCodeOfCompany?: ModelStringInput | null,
  typeOfBusiness?: ModelStringInput | null,
  fein?: ModelStringInput | null,
  yearCompanyWasFoundedInUS?: ModelStringInput | null,
  aosFilingEligible?: ModelStringInput | null,
  requiresMeetingReminder?: ModelBooleanInput | null,
  isParent?: ModelBooleanInput | null,
  isPartnerCompany?: ModelBooleanInput | null,
  companyWhitelistedDomains?: ModelStringInput | null,
  companyContactLabel?: ModelStringInput | null,
  annualMeetingDate?: ModelStringInput | null,
  emCompanyNames?: ModelStringInput | null,
  emCompanyNameSlugs?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelReportEntriesFilterInput | null > | null,
  or?: Array< ModelReportEntriesFilterInput | null > | null,
  not?: ModelReportEntriesFilterInput | null,
};

export type SearchableReportEntriesAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableReportEntriesAggregateField,
};

export enum SearchableReportEntriesAggregateField {
  id = "id",
  reportID = "reportID",
  companyID = "companyID",
  foreignNationalID = "foreignNationalID",
  fullname = "fullname",
  firstname = "firstname",
  lastname = "lastname",
  middlename = "middlename",
  archived = "archived",
  email = "email",
  personalEmail = "personalEmail",
  birthDate = "birthDate",
  numberOfDependents = "numberOfDependents",
  numberOfFamilyContacts = "numberOfFamilyContacts",
  displayCompanyName = "displayCompanyName",
  companyLegalName = "companyLegalName",
  companyFullName = "companyFullName",
  sponsoringCompanyFullName = "sponsoringCompanyFullName",
  companyDbaName = "companyDbaName",
  immigrationCurrentStatus = "immigrationCurrentStatus",
  immigrationStatusExpiration = "immigrationStatusExpiration",
  birthCountryCode = "birthCountryCode",
  citizenshipCountry = "citizenshipCountry",
  chargeabilityCountry = "chargeabilityCountry",
  passportExpirationDate = "passportExpirationDate",
  nivMaxout = "nivMaxout",
  visaExpDate = "visaExpDate",
  hasApprovedI140 = "hasApprovedI140",
  petitionerI140 = "petitionerI140",
  employmentBasedCategory = "employmentBasedCategory",
  priorityDate = "priorityDate",
  fnJobTitle = "fnJobTitle",
  socCode = "socCode",
  caseSocCode = "caseSocCode",
  fnSalary = "fnSalary",
  startDate = "startDate",
  fnWorkLocation = "fnWorkLocation",
  addressPrimary = "addressPrimary",
  addressSecondary = "addressSecondary",
  usResidentialAddress = "usResidentialAddress",
  lastProcessType = "lastProcessType",
  currentProcessType = "currentProcessType",
  lowerProcessType = "lowerProcessType",
  lastPhaseCompleted = "lastPhaseCompleted",
  currentPhase = "currentPhase",
  capType = "capType",
  eadExpDate = "eadExpDate",
  I797ApprovalExpDate = "I797ApprovalExpDate",
  I94ExpDate = "I94ExpDate",
  I94DS = "I94DS",
  greenCardExpDate = "greenCardExpDate",
  prevailingWageExpDate = "prevailingWageExpDate",
  citizenshipEligibilityDate = "citizenshipEligibilityDate",
  rfeDueDate = "rfeDueDate",
  dolAuditDueDate = "dolAuditDueDate",
  pwdExpDate = "pwdExpDate",
  firstEntryUS = "firstEntryUS",
  taxTrackingF1J1 = "taxTrackingF1J1",
  agreementExpDate = "agreementExpDate",
  agreementEffectiveDate = "agreementEffectiveDate",
  mswsowExpDate = "mswsowExpDate",
  permDueDate = "permDueDate",
  lotterySelectionDueDate = "lotterySelectionDueDate",
  advancedParoleExpDate = "advancedParoleExpDate",
  reEntryPermitExpDate = "reEntryPermitExpDate",
  certifiedLcaExpDate = "certifiedLcaExpDate",
  title = "title",
  notes = "notes",
  DS2019ExpDate = "DS2019ExpDate",
  isRelative = "isRelative",
  relativeIds = "relativeIds",
  nextPhase = "nextPhase",
  requestedProcessSubCategory = "requestedProcessSubCategory",
  fnNameSlug = "fnNameSlug",
  caseSlug = "caseSlug",
  companyNameSlug = "companyNameSlug",
  employerNameSlug = "employerNameSlug",
  inviteStatus = "inviteStatus",
  passportNumber = "passportNumber",
  phoneNumber = "phoneNumber",
  personalPhone = "personalPhone",
  faxNumber = "faxNumber",
  passportGender = "passportGender",
  preferredMailingAddress = "preferredMailingAddress",
  onboardingSections = "onboardingSections",
  lastEntryUS = "lastEntryUS",
  employeeId = "employeeId",
  caseNumber = "caseNumber",
  requestedProcess = "requestedProcess",
  attorneyID = "attorneyID",
  caseAttorney = "caseAttorney",
  sponsoringEmployerID = "sponsoringEmployerID",
  sponsoringNationalID = "sponsoringNationalID",
  caseSponsor = "caseSponsor",
  caseSponsorId = "caseSponsorId",
  caseManagerID = "caseManagerID",
  caseManager = "caseManager",
  contributorIds = "contributorIds",
  caseContributors = "caseContributors",
  caseStartDate = "caseStartDate",
  caseOpenDate = "caseOpenDate",
  caseSalary = "caseSalary",
  state = "state",
  workLocation = "workLocation",
  keyFilingDates = "keyFilingDates",
  lcaFiled = "lcaFiled",
  capGap = "capGap",
  visaAdditionalProcessing = "visaAdditionalProcessing",
  stemExtEligible = "stemExtEligible",
  educationEvaluationNeeded = "educationEvaluationNeeded",
  wageIssues = "wageIssues",
  selection = "selection",
  caseNature = "caseNature",
  registrationCompleted = "registrationCompleted",
  receiptNumber = "receiptNumber",
  currentCaseStatusText = "currentCaseStatusText",
  modifiedDate = "modifiedDate",
  incompleteUscisReceiptNumber = "incompleteUscisReceiptNumber",
  caseStatusHistory = "caseStatusHistory",
  companyAttorneys = "companyAttorneys",
  companyAttorneyIds = "companyAttorneyIds",
  companyParalegals = "companyParalegals",
  companyParalegalIds = "companyParalegalIds",
  companyTotalCases = "companyTotalCases",
  companyTotalOpenCases = "companyTotalOpenCases",
  companyTotalClosedCases = "companyTotalClosedCases",
  companyTotalCompletedCases = "companyTotalCompletedCases",
  companyNationalCount = "companyNationalCount",
  fullTimeEmployeesInUS = "fullTimeEmployeesInUS",
  partTimeEmployeesInUS = "partTimeEmployeesInUS",
  companyActiveNationalCount = "companyActiveNationalCount",
  grossRevenueForMostRecentFiscalYear = "grossRevenueForMostRecentFiscalYear",
  netRevenueForMostRecentFiscalYear = "netRevenueForMostRecentFiscalYear",
  naicsCodeOfCompany = "naicsCodeOfCompany",
  typeOfBusiness = "typeOfBusiness",
  fein = "fein",
  yearCompanyWasFoundedInUS = "yearCompanyWasFoundedInUS",
  aosFilingEligible = "aosFilingEligible",
  requiresMeetingReminder = "requiresMeetingReminder",
  isParent = "isParent",
  isPartnerCompany = "isPartnerCompany",
  companyWhitelistedDomains = "companyWhitelistedDomains",
  companyContactLabel = "companyContactLabel",
  annualMeetingDate = "annualMeetingDate",
  emCompanyNames = "emCompanyNames",
  emCompanyNameSlugs = "emCompanyNameSlugs",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type ModelStandardTemplateFilterInput = {
  id?: ModelIDInput | null,
  fields?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelStandardTemplateFilterInput | null > | null,
  or?: Array< ModelStandardTemplateFilterInput | null > | null,
  not?: ModelStandardTemplateFilterInput | null,
};

export type ModelStandardTemplateConnection = {
  __typename: "ModelStandardTemplateConnection",
  items:  Array<StandardTemplate | null >,
  nextToken?: string | null,
};

export type SearchableStandardTemplateFilterInput = {
  id?: SearchableIDFilterInput | null,
  fields?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableStandardTemplateFilterInput | null > | null,
  or?: Array< SearchableStandardTemplateFilterInput | null > | null,
  not?: SearchableStandardTemplateFilterInput | null,
};

export type SearchableStandardTemplateSortInput = {
  field?: SearchableStandardTemplateSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableStandardTemplateSortableFields {
  id = "id",
  fields = "fields",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableStandardTemplateAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableStandardTemplateAggregateField,
};

export enum SearchableStandardTemplateAggregateField {
  id = "id",
  fields = "fields",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableStandardTemplateConnection = {
  __typename: "SearchableStandardTemplateConnection",
  items:  Array<StandardTemplate | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelVendorFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelVendorTypeInput | null,
  location?: ModelStringInput | null,
  email?: ModelStringInput | null,
  lowerName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelVendorFilterInput | null > | null,
  or?: Array< ModelVendorFilterInput | null > | null,
  not?: ModelVendorFilterInput | null,
};

export type ModelVendorConnection = {
  __typename: "ModelVendorConnection",
  items:  Array<Vendor | null >,
  nextToken?: string | null,
};

export type SearchableVendorFilterInput = {
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  location?: SearchableStringFilterInput | null,
  email?: SearchableStringFilterInput | null,
  lowerName?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  type?: SearchableStringFilterInput | null,
  and?: Array< SearchableVendorFilterInput | null > | null,
  or?: Array< SearchableVendorFilterInput | null > | null,
  not?: SearchableVendorFilterInput | null,
};

export type SearchableVendorSortInput = {
  field?: SearchableVendorSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableVendorSortableFields {
  id = "id",
  name = "name",
  location = "location",
  email = "email",
  lowerName = "lowerName",
  updatedAt = "updatedAt",
  createdAt = "createdAt",
}


export type SearchableVendorAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableVendorAggregateField,
};

export enum SearchableVendorAggregateField {
  id = "id",
  name = "name",
  type = "type",
  location = "location",
  email = "email",
  lowerName = "lowerName",
  updatedAt = "updatedAt",
  createdAt = "createdAt",
}


export type SearchableVendorConnection = {
  __typename: "SearchableVendorConnection",
  items:  Array<Vendor | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelTaskDefinitionFilterInput = {
  id?: ModelIDInput | null,
  taskType?: ModelTaskTypeInput | null,
  payload?: ModelStringInput | null,
  recipientIDs?: ModelIDInput | null,
  companyIndividualIDs?: ModelIDInput | null,
  individualIDs?: ModelIDInput | null,
  companyIDs?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelTaskDefinitionFilterInput | null > | null,
  or?: Array< ModelTaskDefinitionFilterInput | null > | null,
  not?: ModelTaskDefinitionFilterInput | null,
};

export type ModelTaskDefinitionConnection = {
  __typename: "ModelTaskDefinitionConnection",
  items:  Array<TaskDefinition | null >,
  nextToken?: string | null,
};

export type ModelSubscriptionAdditionalFieldsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  caseID?: ModelSubscriptionIDInput | null,
  fields?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdditionalFieldsFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdditionalFieldsFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionSchedulerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  eventBridgeschedulerName?: ModelSubscriptionStringInput | null,
  eventBridgeSchedulerID?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  schedulerExpression?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  startTime?: ModelSubscriptionStringInput | null,
  frequencyNumber?: ModelSubscriptionIntInput | null,
  frequencyUnit?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  timeZone?: ModelSubscriptionStringInput | null,
  targetUrl?: ModelSubscriptionStringInput | null,
  entityID?: ModelSubscriptionIDInput | null,
  taskDefinitionID?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSchedulerFilterInput | null > | null,
  or?: Array< ModelSubscriptionSchedulerFilterInput | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionVendorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  location?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  lowerName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVendorFilterInput | null > | null,
  or?: Array< ModelSubscriptionVendorFilterInput | null > | null,
};

export type ModelSubscriptionTaskDefinitionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  taskType?: ModelSubscriptionStringInput | null,
  payload?: ModelSubscriptionStringInput | null,
  recipientIDs?: ModelSubscriptionIDInput | null,
  companyIndividualIDs?: ModelSubscriptionIDInput | null,
  individualIDs?: ModelSubscriptionIDInput | null,
  companyIDs?: ModelSubscriptionIDInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTaskDefinitionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTaskDefinitionFilterInput | null > | null,
};

export type GetCompanyForProfileQueryVariables = {
  id: string,
};

export type GetCompanyForProfileQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    displayCompanyName?: string | null,
    lowerNameKey: string,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    domainWhitelist?: Array< string > | null,
    isPartnerCompany?: boolean | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    isParent?: boolean | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    createdAt: string,
    updatedAt: string,
    children?:  {
      __typename: "ModelCompanyConnection",
      items:  Array< {
        __typename: "Company",
        id: string,
        name: string,
        slug: string,
      } | null >,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      slug: string,
      domainWhitelist?: Array< string > | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      items:  Array< {
        __typename: "JobDescription",
        id: string,
        title: string,
      } | null >,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      firstname: string,
      lastname: string,
      id: string,
      slug: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      type: PersonType,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      items:  Array< {
        __typename: "AttorneyAssignment",
        id: string,
        attorney:  {
          __typename: "TeamMember",
          avatar?:  {
            __typename: "Picture",
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              size: number,
            } > | null,
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
          } | null,
          firstname: string,
          lastname: string,
          id: string,
          slug: string,
        },
      } | null >,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      items:  Array< {
        __typename: "ParalegalAssignment",
        id: string,
        paralegal:  {
          __typename: "TeamMember",
          avatar?:  {
            __typename: "Picture",
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              size: number,
            } > | null,
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
          } | null,
          firstname: string,
          lastname: string,
          id: string,
          slug: string,
        },
      } | null >,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAdminAssignment",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      items:  Array< {
        __typename: "InvoicingContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      items:  Array< {
        __typename: "PrimaryContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      items:  Array< {
        __typename: "SeniorContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      items:  Array< {
        __typename: "SignatoryContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        id: string,
        employer?:  {
          __typename: "Employer",
          archived: ArchivedState,
          id: string,
          type: PersonType,
          email?: string | null,
          loginStatus?:  {
            __typename: "LoginStatus",
            isEnabled?: boolean | null,
            status?: UserStatus | null,
          } | null,
          firstname?: string | null,
          mostRecentlyInvited?: string | null,
          username?: string | null,
          lastname?: string | null,
          phone?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              region: string,
              key: string,
              level?: S3Level | null,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              region: string,
              key: string,
              level?: S3Level | null,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
            } > | null,
            thumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
    } > | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        durationOfStatus?: boolean | null,
        dueDate?: string | null,
        issueDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        processRequestID?: string | null,
        companyID?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderID?: string | null,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
    } | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      allowsEmployeesToTelecommute?:  {
        __typename: "BooleanThreePart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
        followPromptSecond?: string | null,
        followValueSecond?: boolean | null,
      } | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      createdAt: string,
      updatedAt: string,
      preferenceForEmployeesToPayPartOfGreenCard?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      preferenceForEmployeesToPayPartOfH1B?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      employs50OrMore?:  {
        __typename: "BooleanTwoPart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
      } | null,
      grossRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      netRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      usesApplicantTrackingSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      usesHRSSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      shippingPreference?:  {
        __typename: "ShippingPreference",
        fedexAccount?: string | null,
        preference?: ShippingPaymentPreference | null,
        upsAccount?: string | null,
      } | null,
      addressSecondary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
      addressPrimary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateCompanyForProfileMutationVariables = {
  input: UpdateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type UpdateCompanyForProfileMutation = {
  updateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    displayCompanyName?: string | null,
    lowerNameKey: string,
    slug: string,
    type: CompanyType,
    notes?: string | null,
    petitionerParagraph?: string | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    domainWhitelist?: Array< string > | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    createdAt: string,
    updatedAt: string,
    children?:  {
      __typename: "ModelCompanyConnection",
      items:  Array< {
        __typename: "Company",
        id: string,
        name: string,
        slug: string,
      } | null >,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      slug: string,
      domainWhitelist?: Array< string > | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      items:  Array< {
        __typename: "JobDescription",
        id: string,
        title: string,
      } | null >,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      firstname: string,
      lastname: string,
      id: string,
      slug: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      type: PersonType,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      items:  Array< {
        __typename: "AttorneyAssignment",
        id: string,
        attorney:  {
          __typename: "TeamMember",
          avatar?:  {
            __typename: "Picture",
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              size: number,
            } > | null,
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
          } | null,
          firstname: string,
          lastname: string,
          id: string,
          slug: string,
        },
      } | null >,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      items:  Array< {
        __typename: "ParalegalAssignment",
        id: string,
        paralegal:  {
          __typename: "TeamMember",
          avatar?:  {
            __typename: "Picture",
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              size: number,
            } > | null,
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
          } | null,
          firstname: string,
          lastname: string,
          id: string,
          slug: string,
        },
      } | null >,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAdminAssignment",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      items:  Array< {
        __typename: "InvoicingContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      items:  Array< {
        __typename: "PrimaryContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      items:  Array< {
        __typename: "SeniorContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      items:  Array< {
        __typename: "SignatoryContact",
        id: string,
        employerID: string,
      } | null >,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        id: string,
        employer?:  {
          __typename: "Employer",
          archived: ArchivedState,
          id: string,
          type: PersonType,
          email?: string | null,
          loginStatus?:  {
            __typename: "LoginStatus",
            isEnabled?: boolean | null,
            status?: UserStatus | null,
          } | null,
          firstname?: string | null,
          mostRecentlyInvited?: string | null,
          username?: string | null,
          lastname?: string | null,
          phone?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              region: string,
              key: string,
              level?: S3Level | null,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              region: string,
              key: string,
              level?: S3Level | null,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
            } > | null,
            thumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
    } > | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        durationOfStatus?: boolean | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        processRequestID?: string | null,
        companyID?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderID?: string | null,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      allowsEmployeesToTelecommute?:  {
        __typename: "BooleanThreePart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
        followPromptSecond?: string | null,
        followValueSecond?: boolean | null,
      } | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      createdAt: string,
      updatedAt: string,
      preferenceForEmployeesToPayPartOfGreenCard?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      preferenceForEmployeesToPayPartOfH1B?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      employs50OrMore?:  {
        __typename: "BooleanTwoPart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
      } | null,
      grossRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      netRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      usesApplicantTrackingSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      usesHRSSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      shippingPreference?:  {
        __typename: "ShippingPreference",
        fedexAccount?: string | null,
        preference?: ShippingPaymentPreference | null,
        upsAccount?: string | null,
      } | null,
      addressSecondary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
      addressPrimary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
    } | null,
  } | null,
};

export type GetFirmForProfileQueryVariables = {
  id: string,
};

export type GetFirmForProfileQuery = {
  getFirm?:  {
    __typename: "Firm",
    id: string,
    slug: string,
    name: string,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
  } | null,
};

export type UpdateFirmForProfileMutationVariables = {
  input: UpdateFirmInput,
  condition?: ModelFirmConditionInput | null,
};

export type UpdateFirmForProfileMutation = {
  updateFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
  } | null,
};

export type CompanySearchForeignNationalsQueryVariables = {
  filter?: SearchableForeignNationalFilterInput | null,
  sort?: Array< SearchableForeignNationalSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type CompanySearchForeignNationalsQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      slug: string,
      firstname?: string | null,
      lastname?: string | null,
      employeeId?: string | null,
      birthCountry?: CountryCode | null,
      citizenshipCountry?: Array< CountryCode > | null,
      jobDescriptionID?: string | null,
      offeredSalary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
        period?: CurrencyPeriod | null,
      } | null,
      files?:  {
        __typename: "ModelFileDataConnection",
        items:  Array< {
          __typename: "FileData",
          fileType?: FileType | null,
        } | null >,
      } | null,
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      workLocation?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        companyAddressType?: CompanyAddressType | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type CustomSearchActivitiesQueryVariables = {
  filter?: SearchableActivityFilterInput | null,
  sort?: Array< SearchableActivitySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type CustomSearchActivitiesQuery = {
  searchActivities?:  {
    __typename: "SearchableActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      actorID: string,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorEmployer?:  {
        __typename: "Employer",
        id: string,
        slug: string,
        firstname?: string | null,
        middlename?: string | null,
        lastname?: string | null,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      actorForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        middlename?: string | null,
        lastname?: string | null,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      actorTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        middlename?: string | null,
        lastname: string,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      targetEmployer?:  {
        __typename: "Employer",
        id: string,
        slug: string,
        firstname?: string | null,
        middlename?: string | null,
        lastname?: string | null,
        type: PersonType,
      } | null,
      targetForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        middlename?: string | null,
        lastname?: string | null,
        type: PersonType,
      } | null,
      targetTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        middlename?: string | null,
        lastname: string,
        type: PersonType,
      } | null,
      targetFileData?:  {
        __typename: "FileData",
        fileName: string,
        fileType?: FileType | null,
        fileRequirement?: string | null,
        fileCategory?: string | null,
      } | null,
      targetCase?:  {
        __typename: "Case",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID: string,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
      } | null,
      targetCompany?:  {
        __typename: "Company",
        id: string,
        name: string,
        slug: string,
      } | null,
      targetProcessRequest?:  {
        __typename: "ProcessRequest",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID?: string | null,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        employeeData?:  {
          __typename: "ProcessRequestEmployeeData",
          firstname: string,
          lastname: string,
        } | null,
      } | null,
      targetTask?:  {
        __typename: "Task",
        action: string,
      } | null,
      indirectTargetCase?:  {
        __typename: "Case",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID: string,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
      } | null,
      indirectTargetCompany?:  {
        __typename: "Company",
        id: string,
        name: string,
        slug: string,
      } | null,
      indirectTargetProcessRequest?:  {
        __typename: "ProcessRequest",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID?: string | null,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        employeeData?:  {
          __typename: "ProcessRequestEmployeeData",
          firstname: string,
          lastname: string,
        } | null,
      } | null,
      indirectTargetEmployer?:  {
        __typename: "Employer",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        type: PersonType,
      } | null,
      indirectTargetForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        type: PersonType,
      } | null,
      indirectTargetTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        slug: string,
        type: PersonType,
      } | null,
      ownerEmployer?:  {
        __typename: "Employer",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        type: PersonType,
      } | null,
      ownerForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        type: PersonType,
      } | null,
      ownerTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        lastname: string,
        type: PersonType,
      } | null,
      ownerCase?:  {
        __typename: "Case",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID: string,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
      } | null,
      ownerProcessRequest?:  {
        __typename: "ProcessRequest",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        foreignNationalID?: string | null,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        employeeData?:  {
          __typename: "ProcessRequestEmployeeData",
          firstname: string,
          lastname: string,
        } | null,
      } | null,
      ownerCompany?:  {
        __typename: "Company",
        id: string,
        slug: string,
        name: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomListNotificationsByPersonAllQueryVariables = {
  personID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListNotificationsByPersonAllQuery = {
  listNotificationsByPersonAll?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      personID: string,
      activityID: string,
      read: ReadState,
      activity?:  {
        __typename: "Activity",
        id: string,
        createdAt?: string | null,
        updatedAt?: string | null,
        activityType: ActivityType,
        actorID: string,
        actorType?: PersonType | null,
        directTargetID?: string | null,
        targetString?: string | null,
        indirectTargetID?: string | null,
        indirectTargetString?: string | null,
        ownerID?: string | null,
        actorEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        actorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        actorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
          type: PersonType,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        targetReport?:  {
          __typename: "Report",
          id: string,
          templateID: string,
          companyIds?: Array< string | null > | null,
          accessibleIds?: Array< string | null > | null,
          editableIds?: Array< string | null > | null,
          type?: TemplateType | null,
          name: string,
          status: ReportStatus,
          numberOfFilters?: number | null,
          numberOfColumns?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
        } | null,
        targetEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        targetForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        targetTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
          type: PersonType,
        } | null,
        targetFileData?:  {
          __typename: "FileData",
          fileName: string,
          fileType?: FileType | null,
          fileRequirement?: string | null,
          fileCategory?: string | null,
        } | null,
        targetCase?:  {
          __typename: "Case",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID: string,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
        } | null,
        targetCompany?:  {
          __typename: "Company",
          id: string,
          name: string,
          slug: string,
        } | null,
        targetProcessRequest?:  {
          __typename: "ProcessRequest",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID?: string | null,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
          employeeData?:  {
            __typename: "ProcessRequestEmployeeData",
            firstname: string,
            lastname: string,
          } | null,
        } | null,
        targetTask?:  {
          __typename: "Task",
          action: string,
        } | null,
        indirectTargetCase?:  {
          __typename: "Case",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID: string,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
        } | null,
        indirectTargetCompany?:  {
          __typename: "Company",
          id: string,
          name: string,
          slug: string,
        } | null,
        indirectTargetProcessRequest?:  {
          __typename: "ProcessRequest",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID?: string | null,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
          employeeData?:  {
            __typename: "ProcessRequestEmployeeData",
            firstname: string,
            lastname: string,
          } | null,
        } | null,
        indirectTargetEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          type: PersonType,
        } | null,
        indirectTargetForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          type: PersonType,
        } | null,
        indirectTargetTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          type: PersonType,
        } | null,
        ownerEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        ownerForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          type: PersonType,
        } | null,
        ownerTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
          type: PersonType,
        } | null,
        ownerCase?:  {
          __typename: "Case",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID: string,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
        } | null,
        ownerProcessRequest?:  {
          __typename: "ProcessRequest",
          id: string,
          slug: string,
          requestedProcess?: VisaStatus | null,
          foreignNationalID?: string | null,
          foreignNational?:  {
            __typename: "ForeignNational",
            id: string,
            slug: string,
            firstname?: string | null,
            lastname?: string | null,
            type: PersonType,
          } | null,
          employeeData?:  {
            __typename: "ProcessRequestEmployeeData",
            firstname: string,
            lastname: string,
          } | null,
        } | null,
        ownerCompany?:  {
          __typename: "Company",
          id: string,
          slug: string,
          name: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomUpdateAdditionalFieldsMutationVariables = {
  input: UpdateAdditionalFieldsInput,
  condition?: ModelAdditionalFieldsConditionInput | null,
};

export type CustomUpdateAdditionalFieldsMutation = {
  updateAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomOnCreateCaseNoteSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type CustomOnCreateCaseNoteSubscription = {
  onCreateCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomOnCreateCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type CustomOnCreateCaseNoteByProcessRequestSubscription = {
  onCreateCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomCreateCaseNoteMutationVariables = {
  input: CreateCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type CustomCreateCaseNoteMutation = {
  createCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomUpdateCaseNoteMutationVariables = {
  input: UpdateCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type CustomUpdateCaseNoteMutation = {
  updateCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomDeleteCaseNoteMutationVariables = {
  input: DeleteCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type CustomDeleteCaseNoteMutation = {
  deleteCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomOnUpdateCaseNoteByCaseSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type CustomOnUpdateCaseNoteByCaseSubscription = {
  onUpdateCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomOnUpdateCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type CustomOnUpdateCaseNoteByProcessRequestSubscription = {
  onUpdateCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomOnDeleteCaseNoteByCaseSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type CustomOnDeleteCaseNoteByCaseSubscription = {
  onDeleteCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomOnDeleteCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type CustomOnDeleteCaseNoteByProcessRequestSubscription = {
  onDeleteCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    authorID?: string | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomCaseBySlugQueryVariables = {
  slug: string,
};

export type CustomCaseBySlugQuery = {
  caseBySlug?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
    } | null >,
  } | null,
};

export type ListCaseMilestonesQueryVariables = {
  id: string,
};

export type ListCaseMilestonesQuery = {
  getCase?:  {
    __typename: "Case",
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completedByID: string,
      completionDate?: string | null,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
  } | null,
};

export type ListCaseFilesQueryVariables = {
  id: string,
  nextToken?: string | null,
};

export type ListCaseFilesQuery = {
  getCase?:  {
    __typename: "Case",
    files?:  {
      __typename: "ModelCaseFileConnection",
      items:  Array< {
        __typename: "CaseFile",
        id: string,
        fileID: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCaseFilesPageQueryVariables = {
  id: string,
  nextToken?: string | null,
};

export type ListCaseFilesPageQuery = {
  getCase?:  {
    __typename: "Case",
    files?:  {
      __typename: "ModelCaseFileConnection",
      items:  Array< {
        __typename: "CaseFile",
        id: string,
        file:  {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          durationOfStatus?: boolean | null,
          issueDate?: string | null,
          dueDate?: string | null,
          fileName: string,
          fileType?: FileType | null,
          fileRequirement?: string | null,
          fileCategory?: string | null,
          contentType?: string | null,
          isFlattened?: boolean | null,
          original:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
            level?: S3Level | null,
            identityId?: string | null,
          },
          processRequestID?: string | null,
          companyID?: string | null,
          sourceID?: string | null,
          ownerNationalID?: string | null,
          uploadDate: string,
          uploaderID?: string | null,
          uploaderEmployer?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            lastname: string,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListCaseFileRequirementsQueryVariables = {
  id: string,
};

export type ListCaseFileRequirementsQuery = {
  getCase?:  {
    __typename: "Case",
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      isAssignedToLegalAssistants?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
  } | null,
};

export type GetRecentlyViewedCaseQueryVariables = {
  id: string,
};

export type GetRecentlyViewedCaseQuery = {
  getCase?:  {
    __typename: "Case",
    id: string,
    slug: string,
    currentPhase?: CasePhase | null,
    caseNumber?: string | null,
    requestedProcess?: VisaStatus | null,
    startDate: string,
    state: CaseState,
    caseManagerID?: string | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        expiration?: string | null,
      } | null,
    } | null,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
  } | null,
};

export type CustomGetCaseQueryVariables = {
  id: string,
  messagesUserGroup?: UserGroup | null,
  filesNextToken?: string | null,
};

export type CustomGetCaseQuery = {
  getCase?:  {
    __typename: "Case",
    id: string,
    slug: string,
    currentPhase?: CasePhase | null,
    caseNumber?: string | null,
    attorneyID?: string | null,
    caseManagerID?: string | null,
    contributorIds?: Array< string | null > | null,
    companyID?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    foreignNationalID: string,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    I485JReceiptNotice?: string | null,
    SelectionNoticeNo?: string | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    AOSReceiptNotice?: string | null,
    individualSponsored?: boolean | null,
    ETACaseNumber?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
    } | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
    } | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      createdAt: string,
      fields?: string | null,
    } | null,
    source?:  {
      __typename: "ProcessRequest",
      id: string,
      individualSponsored?: boolean | null,
      vendor?:  {
        __typename: "Vendor",
        id: string,
        name: string,
        type: VendorType,
        location?: string | null,
        email?: string | null,
      } | null,
    } | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      location?:  {
        __typename: "ProcessRequestLocation",
        remoteAddress?:  {
          __typename: "StreetAddress",
          address?: string | null,
          unitType?: UnitType | null,
        } | null,
        type?: ProcessRequestLocationType | null,
      } | null,
      notes?: string | null,
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      salary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
      } | null,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      canWorkFromHome?: boolean | null,
      certificationLicenses?: string | null,
      companyID?: string | null,
      degrees?: Array< Degree > | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      id: string,
      jobURL?: string | null,
      majors?: string | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      officialTitle?: string | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      title: string,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      type: JobDescriptionType,
      uploadedDescriptionID?: string | null,
      yearsGeneralExperience?: number | null,
      uploadedDescription?:  {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        isFlattened?: boolean | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      specialRequirements?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      fileName: string,
      contentType?: string | null,
      isFlattened?: boolean | null,
      createdAt: string,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
    } | null,
    files?:  {
      __typename: "ModelCaseFileConnection",
      items:  Array< {
        __typename: "CaseFile",
        id: string,
        file:  {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          durationOfStatus?: boolean | null,
          issueDate?: string | null,
          dueDate?: string | null,
          fileName: string,
          fileType?: FileType | null,
          fileRequirement?: string | null,
          fileCategory?: string | null,
          contentType?: string | null,
          isFlattened?: boolean | null,
          original:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
            level?: S3Level | null,
            identityId?: string | null,
          },
          processRequestID?: string | null,
          companyID?: string | null,
          sourceID?: string | null,
          ownerNationalID?: string | null,
          uploadDate: string,
          uploaderID?: string | null,
          uploaderEmployer?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            lastname: string,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      isAssignedToLegalAssistants?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      items:  Array< {
        __typename: "PreparedForm",
        id: string,
        caseID?: string | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          items:  Array< {
            __typename: "Activity",
            id: string,
            activityType: ActivityType,
            actorID: string,
            actorEmployer?:  {
              __typename: "Employer",
              id: string,
              slug: string,
              firstname?: string | null,
              lastname?: string | null,
            } | null,
            actorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              slug: string,
              firstname?: string | null,
              lastname?: string | null,
            } | null,
            actorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              slug: string,
              firstname: string,
              lastname: string,
            } | null,
          } | null >,
        } | null,
        requiresAttorneyApproval?: boolean | null,
        attorneyApprover?:  {
          __typename: "TeamMember",
          firstname: string,
          lastname: string,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        attorneyApprovalDate?: string | null,
        attorneyApproverID?: string | null,
        requiresSponsorApproval?: boolean | null,
        sponsorApprovalDate?: string | null,
        sponsorApproverEmployer?:  {
          __typename: "Employer",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        sponsorApproverNational?:  {
          __typename: "ForeignNational",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        sponsorApproverID?: string | null,
        requiresNationalApproval?: boolean | null,
        nationalApprover?:  {
          __typename: "ForeignNational",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        nationalApprovalDate?: string | null,
        nationalApproverID?: string | null,
        finalCaseManagerApprover?:  {
          __typename: "TeamMember",
          firstname: string,
          lastname: string,
          slug: string,
          id: string,
        } | null,
        finalCaseManagerApprovalDate?: string | null,
        finalCaseManagerApproverID?: string | null,
        employersCanView?: boolean | null,
        nationalsCanView?: boolean | null,
        companyID?: string | null,
        completedFormID?: string | null,
        createdAt?: string | null,
        foreignNationalID: string,
        preparerID?: string | null,
        relativeAdmins?: Array< string > | null,
        state: PreparedFormState,
        templateID?: string | null,
        case?:  {
          __typename: "Case",
          caseManagerID?: string | null,
        } | null,
        preparer?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        completedForm?:  {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          fileName: string,
          fileType?: FileType | null,
          contentType?: string | null,
          isFlattened?: boolean | null,
          original:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
            level?: S3Level | null,
            identityId?: string | null,
          },
          processRequestID?: string | null,
          companyID?: string | null,
          sourceID?: string | null,
          ownerNationalID?: string | null,
          uploadDate: string,
          uploaderID?: string | null,
          uploaderEmployer?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
            } | null,
          } | null,
          uploaderForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            lastname: string,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignedToID?: string | null,
        assignedToEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        assignedToTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
        } | null,
        assignedToNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        rejectedByID?: string | null,
        rejectedDate?: string | null,
        rejectedByEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        rejectedByTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
        } | null,
        rejectedByNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        completedFormHistory?:  {
          __typename: "ModelFileDataConnection",
          items:  Array< {
            __typename: "FileData",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            fileName: string,
            fileType?: FileType | null,
            id: string,
            uploadDate: string,
          } | null >,
        } | null,
        comments?:  {
          __typename: "ModelCommentConnection",
          items:  Array< {
            __typename: "Comment",
            id: string,
          } | null >,
        } | null,
      } | null >,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    sourceID: string,
    state: CaseState,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      lowerNameKey: string,
      slug: string,
      archived?: ArchivedState | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
            } | null,
          } | null,
        } | null >,
      } | null,
      data?:  {
        __typename: "CompanyData",
        I9_audit_has_been_completed_in_past_18_months?: boolean | null,
        current_number_of_H1B_employees?: string | null,
        current_number_of_employees_on_L_visas?: string | null,
        other_visa_statuses_sponsored?: string | null,
        email_address_invoices_should_be_addressed_to?: string | null,
        name_invoices_should_be_addressed_to?: string | null,
        shippingPreference?:  {
          __typename: "ShippingPreference",
          fedexAccount?: string | null,
          preference?: ShippingPaymentPreference | null,
          upsAccount?: string | null,
        } | null,
        yearCompanyWasFoundedInUS?: string | null,
        utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
        usesWageSurvey?: boolean | null,
        usesHRSSystem?:  {
          __typename: "BooleanExplain",
          reason?: string | null,
          value?: boolean | null,
        } | null,
        usesEVerify?: boolean | null,
        usesApplicantTrackingSystem?:  {
          __typename: "BooleanExplain",
          reason?: string | null,
          value?: boolean | null,
        } | null,
        updatedAt: string,
        staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
        shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
        preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
        placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
        phone?: string | null,
        permissionReleasePetitionsRFE?: boolean | null,
        permissionReleaseLCA?: boolean | null,
        permissionReleaseApprovalNotices?: boolean | null,
        permissionRelease9089?: boolean | null,
        permissionPowerAttorney?: CompanyEmployee | null,
        paymentPreference?: PaymentPreference | null,
        partTimeEmployeesInUS?: number | null,
        netRevenueForMostRecentFiscalYear?:  {
          __typename: "Money",
          amount: number,
          currency: Currency,
        } | null,
        naicsCodeOfCompany?: string | null,
        maintainsAWrittenImmigrationPolicy?: boolean | null,
        id: string,
        grossRevenueForMostRecentFiscalYear?:  {
          __typename: "Money",
          amount: number,
          currency: Currency,
        } | null,
        fullTimeEmployeesInUS?: number | null,
        fein?: string | null,
        fax?: string | null,
        employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
        educationEvaluation?: EducationEvaluation | null,
        doingBusinessAs?: string | null,
        createdAt: string,
        companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
        companyCoversExpenseOfDependentPetitions?: boolean | null,
        requiresMeetingReminder?: boolean | null,
        annualMeetingDate?: string | null,
        placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
        isH1BDependentEmloyer?: boolean | null,
        hasBeenWillfulViolator?: boolean | null,
        isHigherEd_20_USC_1001_a?: boolean | null,
        isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
        isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
        isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
        isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
        isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
        technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
        employs50OrMore?:  {
          __typename: "BooleanTwoPart",
          value?: boolean | null,
          followPrompt?: string | null,
          followValue?: boolean | null,
        } | null,
        allowsEmployeesToTelecommute?:  {
          __typename: "BooleanThreePart",
          value?: boolean | null,
          followPrompt?: string | null,
          followValue?: boolean | null,
          followPromptSecond?: string | null,
          followValueSecond?: boolean | null,
        } | null,
        preferenceForEmployeesToPayPartOfGreenCard?:  {
          __typename: "BooleanExplain",
          value?: boolean | null,
          reason?: string | null,
        } | null,
        preferenceForEmployeesToPayPartOfH1B?:  {
          __typename: "BooleanExplain",
          value?: boolean | null,
          reason?: string | null,
        } | null,
      } | null,
    } | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      slug: string,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      employeeId?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaExpiration?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthCity?: string | null,
      birthDate?: string | null,
      jobDescriptionID?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        items:  Array< {
          __typename: "Case",
          id: string,
          slug: string,
          state: CaseState,
          startDate: string,
          requestedProcess?: VisaStatus | null,
          requestedProcessSubCategory?: VisaSubCategory | null,
          requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
          globalRequestedProcessSubCategory?: string | null,
          globalProcessCountryCode?: CountryCode | null,
          source?:  {
            __typename: "ProcessRequest",
            requestedProcess?: VisaStatus | null,
          } | null,
        } | null >,
      } | null,
      relativesAsSource?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          id: string,
          type?: FamilyRelationshipType | null,
          target:  {
            __typename: "ForeignNational",
            firstname?: string | null,
            id: string,
            lastname?: string | null,
            slug: string,
            birthDate?: string | null,
            immigrationStatus?:  {
              __typename: "ImmigrationStatus",
              status?: VisaStatus | null,
              expiration?: string | null,
            } | null,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                size: number,
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  identityId?: string | null,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                },
              } > | null,
            } | null,
            cases?:  {
              __typename: "ModelCaseConnection",
              items:  Array< {
                __typename: "Case",
                id: string,
                slug: string,
                state: CaseState,
                startDate: string,
                requestedProcess?: VisaStatus | null,
                requestedProcessSubCategory?: VisaSubCategory | null,
                requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
                globalRequestedProcessSubCategory?: string | null,
                globalProcessCountryCode?: CountryCode | null,
                source?:  {
                  __typename: "ProcessRequest",
                  requestedProcess?: VisaStatus | null,
                } | null,
              } | null >,
            } | null,
          },
        } | null >,
      } | null,
      relativesAsTarget?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          id: string,
          type?: FamilyRelationshipType | null,
          source?:  {
            __typename: "ForeignNational",
            firstname?: string | null,
            id: string,
            lastname?: string | null,
            slug: string,
            birthDate?: string | null,
            immigrationStatus?:  {
              __typename: "ImmigrationStatus",
              status?: VisaStatus | null,
              expiration?: string | null,
            } | null,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                size: number,
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  identityId?: string | null,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                },
              } > | null,
            } | null,
            cases?:  {
              __typename: "ModelCaseConnection",
              items:  Array< {
                __typename: "Case",
                id: string,
                slug: string,
                state: CaseState,
                startDate: string,
                requestedProcess?: VisaStatus | null,
                requestedProcessSubCategory?: VisaSubCategory | null,
                requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
                globalRequestedProcessSubCategory?: string | null,
                globalProcessCountryCode?: CountryCode | null,
                source?:  {
                  __typename: "ProcessRequest",
                  requestedProcess?: VisaStatus | null,
                } | null,
              } | null >,
            } | null,
          } | null,
        } | null >,
      } | null,
    } | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      email?: string | null,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      items:  Array< {
        __typename: "CaseNote",
        authorID?: string | null,
        authorEmployerID?: string | null,
        authorEmployer?:  {
          __typename: "Employer",
          id: string,
          lastname?: string | null,
          firstname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        authorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          lastname: string,
          firstname: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        id: string,
        createdAt?: string | null,
        updatedAt: string,
        note?: string | null,
      } | null >,
    } | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      items:  Array< {
        __typename: "CaseContributor",
        id: string,
        contributorID: string,
        contributorEmployer?:  {
          __typename: "Employer",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        contributorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        contributorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          type: PersonType,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        action: string,
        category: TaskCategory,
        deadline: string,
        deadlineIsManuallySet?: boolean | null,
        description?: string | null,
        duration?: number | null,
        groupsCanRead?: Array< string > | null,
        isCustom?: boolean | null,
        isKeyDate?: boolean | null,
        keyDateAlternateAction?: string | null,
        isPaymentStatus?: boolean | null,
        paymentStatusAlternateAction?: string | null,
        orderIndex?: number | null,
        assignedToID?: string | null,
        isAssignedToLegalAssistants?: boolean | null,
        assignedToTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          type: PersonType,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        assignedToForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        assignedToEmployer?:  {
          __typename: "Employer",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        caseID: string,
        case:  {
          __typename: "Case",
          attorneyID?: string | null,
          caseManagerID?: string | null,
        },
        caseState?: CaseState | null,
        state: TaskState,
        startDate: string,
        completeDate?: string | null,
        id: string,
        prerequisiteID?: string | null,
        prerequisite?:  {
          __typename: "Task",
          action: string,
          category: TaskCategory,
          orderIndex?: number | null,
        } | null,
        dependencies?:  {
          __typename: "ModelTaskConnection",
          items:  Array< {
            __typename: "Task",
            id: string,
            state: TaskState,
            deadline: string,
            duration?: number | null,
            templateID?: string | null,
            startDate: string,
            prerequisiteID?: string | null,
            action: string,
            completeDate?: string | null,
          } | null >,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type CustomUpdateCaseMutationVariables = {
  input: UpdateCaseInput,
  messagesUserGroup: UserGroup,
};

export type CustomUpdateCaseMutation = {
  updateCase?:  {
    __typename: "Case",
    id: string,
    slug: string,
    currentPhase?: CasePhase | null,
    caseNumber?: string | null,
    attorneyID?: string | null,
    caseManagerID?: string | null,
    companyID?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    individualSponsored?: boolean | null,
    foreignNationalID: string,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    SelectionNoticeNo?: string | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    AOSReceiptNotice?: string | null,
    I485JReceiptNotice?: string | null,
    ETACaseNumber?: string | null,
    complianceListID?: string | null,
    PERMFilingDataID?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
    } | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
    } | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      createdAt: string,
      fields?: string | null,
    } | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      location?:  {
        __typename: "ProcessRequestLocation",
        remoteAddress?:  {
          __typename: "StreetAddress",
          address?: string | null,
          unitType?: UnitType | null,
        } | null,
        type?: ProcessRequestLocationType | null,
      } | null,
      notes?: string | null,
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      salary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
      } | null,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      canWorkFromHome?: boolean | null,
      certificationLicenses?: string | null,
      companyID?: string | null,
      degrees?: Array< Degree > | null,
      dotNumber?: string | null,
      duties?: string | null,
      id: string,
      jobURL?: string | null,
      majors?: string | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      officialTitle?: string | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      title: string,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      type: JobDescriptionType,
      uploadedDescriptionID?: string | null,
      yearsGeneralExperience?: number | null,
      uploadedDescription?:  {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        isFlattened?: boolean | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      specialRequirements?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      fileName: string,
      contentType?: string | null,
      isFlattened?: boolean | null,
      createdAt: string,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
    } | null,
    files?:  {
      __typename: "ModelCaseFileConnection",
      items:  Array< {
        __typename: "CaseFile",
        id: string,
        file:  {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          durationOfStatus?: boolean | null,
          issueDate?: string | null,
          dueDate?: string | null,
          fileName: string,
          fileType?: FileType | null,
          fileRequirement?: string | null,
          fileCategory?: string | null,
          contentType?: string | null,
          isFlattened?: boolean | null,
          original:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
            level?: S3Level | null,
            identityId?: string | null,
          },
          processRequestID?: string | null,
          companyID?: string | null,
          sourceID?: string | null,
          ownerNationalID?: string | null,
          uploadDate: string,
          uploaderID?: string | null,
          uploaderEmployer?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            lastname: string,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
    } | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      isAssignedToLegalAssistants?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      items:  Array< {
        __typename: "PreparedForm",
        id: string,
        caseID?: string | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          items:  Array< {
            __typename: "Activity",
            id: string,
            activityType: ActivityType,
            actorID: string,
            actorEmployer?:  {
              __typename: "Employer",
              id: string,
              slug: string,
              firstname?: string | null,
              lastname?: string | null,
            } | null,
            actorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              slug: string,
              firstname?: string | null,
              lastname?: string | null,
            } | null,
            actorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              slug: string,
              firstname: string,
              lastname: string,
            } | null,
          } | null >,
        } | null,
        requiresAttorneyApproval?: boolean | null,
        attorneyApprover?:  {
          __typename: "TeamMember",
          firstname: string,
          lastname: string,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        attorneyApprovalDate?: string | null,
        attorneyApproverID?: string | null,
        requiresSponsorApproval?: boolean | null,
        sponsorApprovalDate?: string | null,
        sponsorApproverEmployer?:  {
          __typename: "Employer",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        sponsorApproverNational?:  {
          __typename: "ForeignNational",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        sponsorApproverID?: string | null,
        requiresNationalApproval?: boolean | null,
        nationalApprover?:  {
          __typename: "ForeignNational",
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          id: string,
          username?: string | null,
        } | null,
        nationalApprovalDate?: string | null,
        nationalApproverID?: string | null,
        finalCaseManagerApprover?:  {
          __typename: "TeamMember",
          firstname: string,
          lastname: string,
          slug: string,
          id: string,
        } | null,
        finalCaseManagerApprovalDate?: string | null,
        finalCaseManagerApproverID?: string | null,
        employersCanView?: boolean | null,
        nationalsCanView?: boolean | null,
        companyID?: string | null,
        completedFormID?: string | null,
        createdAt?: string | null,
        foreignNationalID: string,
        preparerID?: string | null,
        relativeAdmins?: Array< string > | null,
        state: PreparedFormState,
        templateID?: string | null,
        case?:  {
          __typename: "Case",
          caseManagerID?: string | null,
        } | null,
        preparer?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        completedForm?:  {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          fileName: string,
          fileType?: FileType | null,
          contentType?: string | null,
          isFlattened?: boolean | null,
          original:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
            level?: S3Level | null,
            identityId?: string | null,
          },
          processRequestID?: string | null,
          companyID?: string | null,
          sourceID?: string | null,
          ownerNationalID?: string | null,
          uploadDate: string,
          uploaderID?: string | null,
          uploaderEmployer?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
            } | null,
          } | null,
          uploaderForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          uploaderTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            lastname: string,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assignedToID?: string | null,
        assignedToEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        assignedToTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
        } | null,
        assignedToNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        rejectedByID?: string | null,
        rejectedDate?: string | null,
        rejectedByEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        rejectedByTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
        } | null,
        rejectedByNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
        } | null,
        completedFormHistory?:  {
          __typename: "ModelFileDataConnection",
          items:  Array< {
            __typename: "FileData",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            fileName: string,
            fileType?: FileType | null,
            id: string,
            uploadDate: string,
          } | null >,
        } | null,
        comments?:  {
          __typename: "ModelCommentConnection",
          items:  Array< {
            __typename: "Comment",
            id: string,
          } | null >,
        } | null,
      } | null >,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    sourceID: string,
    state: CaseState,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      lowerNameKey: string,
      slug: string,
      archived?: ArchivedState | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            lowerFull: string,
            slug: string,
            type: PersonType,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
            } | null,
          } | null,
        } | null >,
      } | null,
      data?:  {
        __typename: "CompanyData",
        shippingPreference?:  {
          __typename: "ShippingPreference",
          fedexAccount?: string | null,
          preference?: ShippingPaymentPreference | null,
          upsAccount?: string | null,
        } | null,
        yearCompanyWasFoundedInUS?: string | null,
        utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
        usesWageSurvey?: boolean | null,
        usesHRSSystem?:  {
          __typename: "BooleanExplain",
          reason?: string | null,
          value?: boolean | null,
        } | null,
        usesEVerify?: boolean | null,
        usesApplicantTrackingSystem?:  {
          __typename: "BooleanExplain",
          reason?: string | null,
          value?: boolean | null,
        } | null,
        updatedAt: string,
        staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
        shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
        preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
        placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
        phone?: string | null,
        permissionReleasePetitionsRFE?: boolean | null,
        permissionReleaseLCA?: boolean | null,
        permissionReleaseApprovalNotices?: boolean | null,
        permissionRelease9089?: boolean | null,
        permissionPowerAttorney?: CompanyEmployee | null,
        paymentPreference?: PaymentPreference | null,
        partTimeEmployeesInUS?: number | null,
        netRevenueForMostRecentFiscalYear?:  {
          __typename: "Money",
          amount: number,
          currency: Currency,
        } | null,
        naicsCodeOfCompany?: string | null,
        maintainsAWrittenImmigrationPolicy?: boolean | null,
        id: string,
        grossRevenueForMostRecentFiscalYear?:  {
          __typename: "Money",
          amount: number,
          currency: Currency,
        } | null,
        fullTimeEmployeesInUS?: number | null,
        fein?: string | null,
        fax?: string | null,
        employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
        educationEvaluation?: EducationEvaluation | null,
        doingBusinessAs?: string | null,
        createdAt: string,
        companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
        companyCoversExpenseOfDependentPetitions?: boolean | null,
        placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
        isH1BDependentEmloyer?: boolean | null,
        hasBeenWillfulViolator?: boolean | null,
        isHigherEd_20_USC_1001_a?: boolean | null,
        isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
        isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
        isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
        isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
        isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
        technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
        employs50OrMore?:  {
          __typename: "BooleanTwoPart",
          value?: boolean | null,
          followPrompt?: string | null,
          followValue?: boolean | null,
        } | null,
        allowsEmployeesToTelecommute?:  {
          __typename: "BooleanThreePart",
          value?: boolean | null,
          followPrompt?: string | null,
          followValue?: boolean | null,
          followPromptSecond?: string | null,
          followValueSecond?: boolean | null,
        } | null,
        preferenceForEmployeesToPayPartOfGreenCard?:  {
          __typename: "BooleanExplain",
          value?: boolean | null,
          reason?: string | null,
        } | null,
        preferenceForEmployeesToPayPartOfH1B?:  {
          __typename: "BooleanExplain",
          value?: boolean | null,
          reason?: string | null,
        } | null,
      } | null,
    } | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      slug: string,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      employeeId?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaExpiration?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthCity?: string | null,
      birthDate?: string | null,
      jobDescriptionID?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        items:  Array< {
          __typename: "Case",
          id: string,
          slug: string,
          state: CaseState,
          startDate: string,
          requestedProcess?: VisaStatus | null,
          requestedProcessSubCategory?: VisaSubCategory | null,
          requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
          globalRequestedProcessSubCategory?: string | null,
          globalProcessCountryCode?: CountryCode | null,
          source?:  {
            __typename: "ProcessRequest",
            requestedProcess?: VisaStatus | null,
          } | null,
        } | null >,
      } | null,
      relativesAsSource?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          id: string,
          type?: FamilyRelationshipType | null,
          target:  {
            __typename: "ForeignNational",
            firstname?: string | null,
            id: string,
            lastname?: string | null,
            slug: string,
            birthDate?: string | null,
            immigrationStatus?:  {
              __typename: "ImmigrationStatus",
              status?: VisaStatus | null,
              expiration?: string | null,
            } | null,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                size: number,
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  identityId?: string | null,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                },
              } > | null,
            } | null,
            cases?:  {
              __typename: "ModelCaseConnection",
              items:  Array< {
                __typename: "Case",
                id: string,
                slug: string,
                state: CaseState,
                startDate: string,
                requestedProcess?: VisaStatus | null,
                requestedProcessSubCategory?: VisaSubCategory | null,
                requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
                globalRequestedProcessSubCategory?: string | null,
                globalProcessCountryCode?: CountryCode | null,
                source?:  {
                  __typename: "ProcessRequest",
                  requestedProcess?: VisaStatus | null,
                } | null,
              } | null >,
            } | null,
          },
        } | null >,
      } | null,
      relativesAsTarget?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          id: string,
          type?: FamilyRelationshipType | null,
          source?:  {
            __typename: "ForeignNational",
            firstname?: string | null,
            id: string,
            lastname?: string | null,
            slug: string,
            birthDate?: string | null,
            immigrationStatus?:  {
              __typename: "ImmigrationStatus",
              status?: VisaStatus | null,
              expiration?: string | null,
            } | null,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                level?: S3Level | null,
                region: string,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                size: number,
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  identityId?: string | null,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                },
              } > | null,
            } | null,
            cases?:  {
              __typename: "ModelCaseConnection",
              items:  Array< {
                __typename: "Case",
                id: string,
                slug: string,
                state: CaseState,
                startDate: string,
                requestedProcess?: VisaStatus | null,
                requestedProcessSubCategory?: VisaSubCategory | null,
                requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
                globalRequestedProcessSubCategory?: string | null,
                globalProcessCountryCode?: CountryCode | null,
                source?:  {
                  __typename: "ProcessRequest",
                  requestedProcess?: VisaStatus | null,
                } | null,
              } | null >,
            } | null,
          } | null,
        } | null >,
      } | null,
    } | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      email?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      items:  Array< {
        __typename: "CaseNote",
        authorEmployer?:  {
          __typename: "Employer",
          id: string,
          lastname?: string | null,
          firstname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        authorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          lastname: string,
          firstname: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        id: string,
        createdAt?: string | null,
        note?: string | null,
      } | null >,
    } | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      items:  Array< {
        __typename: "CaseContributor",
        id: string,
        contributorID: string,
        contributorEmployer?:  {
          __typename: "Employer",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        contributorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        contributorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          type: PersonType,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        action: string,
        category: TaskCategory,
        deadline: string,
        deadlineIsManuallySet?: boolean | null,
        description?: string | null,
        duration?: number | null,
        groupsCanRead?: Array< string > | null,
        isCustom?: boolean | null,
        isKeyDate?: boolean | null,
        keyDateAlternateAction?: string | null,
        isPaymentStatus?: boolean | null,
        paymentStatusAlternateAction?: string | null,
        orderIndex?: number | null,
        assignedToID?: string | null,
        isAssignedToLegalAssistants?: boolean | null,
        assignedToTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          type: PersonType,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        assignedToForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        assignedToEmployer?:  {
          __typename: "Employer",
          id: string,
          type: PersonType,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        caseID: string,
        case:  {
          __typename: "Case",
          attorneyID?: string | null,
          caseManagerID?: string | null,
        },
        caseState?: CaseState | null,
        dependencies?:  {
          __typename: "ModelTaskConnection",
          items:  Array< {
            __typename: "Task",
            id: string,
            state: TaskState,
            deadline: string,
            duration?: number | null,
            templateID?: string | null,
            startDate: string,
            prerequisiteID?: string | null,
            action: string,
            completeDate?: string | null,
          } | null >,
        } | null,
        state: TaskState,
        startDate: string,
        id: string,
        prerequisiteID?: string | null,
        prerequisite?:  {
          __typename: "Task",
          action: string,
          category: TaskCategory,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type CustomSearchCasesQueryVariables = {
  filter?: SearchableCaseFilterInput | null,
  sort?: Array< SearchableCaseSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type CustomSearchCasesQuery = {
  searchCases?:  {
    __typename: "SearchableCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      slug: string,
      caseNumber?: string | null,
      requestedProcess?: VisaStatus | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      lowerCompanyName?: string | null,
      lowerNationalName?: string | null,
      lowerProcessType?: string | null,
      nationalVisaExpiration?: string | null,
      currentPhase?: CasePhase | null,
      caseManager?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        lastname: string,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        displayCompanyName?: string | null,
        slug: string,
      } | null,
      foreignNationalID: string,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        immigrationStatus?:  {
          __typename: "ImmigrationStatus",
          expiration?: string | null,
        } | null,
      } | null,
      phaseRequirements:  Array< {
        __typename: "CasePhaseRequirement",
        phase: CasePhase,
        milestones: Array< CaseMilestone >,
      } >,
      completedMilestones:  Array< {
        __typename: "CompletedCaseMilestone",
        completionDate?: string | null,
        completedByID: string,
        milestone: CaseMilestone,
        receiptNumber?: string | null,
      } >,
      startDate: string,
      state: CaseState,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type CustomOnCreateCaseFileSubscriptionVariables = {
  caseID: string,
};

export type CustomOnCreateCaseFileSubscription = {
  onCreateCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    createdAt: string,
    updatedAt: string,
    case:  {
      __typename: "Case",
      id: string,
    },
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      isFlattened?: boolean | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
      processRequestID?: string | null,
      companyID?: string | null,
      sourceID?: string | null,
      ownerNationalID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployer?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        lowerFull: string,
        slug: string,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      uploaderForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        lowerFull: string,
        slug: string,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      uploaderTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        lowerFull: string,
        slug: string,
        type: PersonType,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
  } | null,
};

export type CaseCompanyDataQueryVariables = {
  id: string,
};

export type CaseCompanyDataQuery = {
  getCase?:  {
    __typename: "Case",
    requestedProcess?: VisaStatus | null,
    company?:  {
      __typename: "Company",
      id: string,
      files?:  {
        __typename: "ModelFileDataConnection",
        items:  Array< {
          __typename: "FileData",
          id: string,
          fileType?: FileType | null,
          ownerNationalID?: string | null,
          uploaderID?: string | null,
          uploaderTeamMemberID?: string | null,
          uploaderForeignNationalID?: string | null,
          uploaderEmployerID?: string | null,
        } | null >,
      } | null,
      fileRequirements?:  Array< {
        __typename: "FileRequirement",
        type: FileType,
        assignedToID?: string | null,
        isAssignedToLegalAssistants?: boolean | null,
        expirationDateRequired?: boolean | null,
        durationOfStatus?: boolean | null,
        issueDateRequired?: boolean | null,
        isApproved?: boolean | null,
        isRequested?: boolean | null,
        hidden?: boolean | null,
      } > | null,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      files?:  {
        __typename: "ModelFileDataConnection",
        items:  Array< {
          __typename: "FileData",
          id: string,
          fileType?: FileType | null,
          uploaderID?: string | null,
          uploaderTeamMemberID?: string | null,
          uploaderForeignNationalID?: string | null,
          uploaderEmployerID?: string | null,
        } | null >,
      } | null,
      fileRequirements?:  Array< {
        __typename: "FileRequirement",
        type: FileType,
        assignedToID?: string | null,
        isAssignedToLegalAssistants?: boolean | null,
        expirationDateRequired?: boolean | null,
        durationOfStatus?: boolean | null,
        issueDateRequired?: boolean | null,
        isApproved?: boolean | null,
        isRequested?: boolean | null,
        hidden?: boolean | null,
      } > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CustomListCasesQueryVariables = {
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListCasesQuery = {
  listCases?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomCreateFileDataMutationVariables = {
  input: CreateFileDataInput,
  condition?: ModelFileDataConditionInput | null,
};

export type CustomCreateFileDataMutation = {
  createFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    dueDate?: string | null,
    issueDate?: string | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    sourceID?: string | null,
    ownerNationalID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    createdAt: string,
    updatedAt: string,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type CustomUpdateFileDataMutationVariables = {
  input: UpdateFileDataInput,
  condition?: ModelFileDataConditionInput | null,
};

export type CustomUpdateFileDataMutation = {
  updateFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    dueDate?: string | null,
    issueDate?: string | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    sourceID?: string | null,
    ownerNationalID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    createdAt: string,
    updatedAt: string,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
  } | null,
};

export type ContainerGetEmployerQueryVariables = {
  id: string,
};

export type ContainerGetEmployerQuery = {
  getEmployer?:  {
    __typename: "Employer",
    id: string,
    slug: string,
    email?: string | null,
    username?: string | null,
    type: PersonType,
    userAgreementAcknowledged?: boolean | null,
    newsletterModalViewCount?: number | null,
    personalEmail?: string | null,
    personalPhone?: string | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    mostRecentlyInvited?: string | null,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        id: string,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          displayCompanyName?: string | null,
          slug: string,
        } | null,
      } | null >,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      items:  Array< {
        __typename: "CaseContributor",
        case:  {
          __typename: "Case",
          id: string,
          slug: string,
          foreignNational?:  {
            __typename: "ForeignNational",
            firstname?: string | null,
            lastname?: string | null,
          } | null,
          phaseRequirements:  Array< {
            __typename: "CasePhaseRequirement",
            phase: CasePhase,
            milestones: Array< CaseMilestone >,
          } >,
          completedMilestones:  Array< {
            __typename: "CompletedCaseMilestone",
            completionDate?: string | null,
            completedByID: string,
            milestone: CaseMilestone,
            receiptNumber?: string | null,
          } >,
          startDate: string,
          state: CaseState,
        },
      } | null >,
    } | null,
  } | null,
};

export type ContainerUpdateEmployerMutationVariables = {
  input: UpdateEmployerInput,
  condition?: ModelEmployerConditionInput | null,
};

export type ContainerUpdateEmployerMutation = {
  updateEmployer?:  {
    __typename: "Employer",
    id: string,
    slug: string,
    email?: string | null,
    username?: string | null,
    type: PersonType,
    personalEmail?: string | null,
    personalPhone?: string | null,
    newsletterModalViewCount?: number | null,
    userAgreementAcknowledged?: boolean | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        id: string,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          displayCompanyName?: string | null,
          slug: string,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type ContainerGetForeignNationalQueryVariables = {
  id: string,
};

export type ContainerGetForeignNationalQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    username?: string | null,
    slug: string,
    employeeId?: string | null,
    userAgreementAcknowledged?: boolean | null,
    email?: string | null,
    legalTeamIDs?: Array< string > | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    createdBy?: string | null,
    fileRequirementsManipulated?: string | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    notes?: string | null,
    nickname?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    chargeabilityCountry?: CountryCode | null,
    citizenshipEligibilityDate?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    startDate?: string | null,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        target:  {
          __typename: "ForeignNational",
          id: string,
          relativeAdmins?: Array< string > | null,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        source?:  {
          __typename: "ForeignNational",
          id: string,
          relativeAdmins?: Array< string > | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaExpiration?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      priorityDate?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      petitionerI140?: string | null,
    } | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthCity?: string | null,
    birthDate?: string | null,
    jobDescriptionID?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    nivMaxout?: string | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      lowerName?: string | null,
      lowerNameKey: string,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      accountManagerID?: string | null,
      assignedAttorneys?:  {
        __typename: "ModelAttorneyAssignmentConnection",
        items:  Array< {
          __typename: "AttorneyAssignment",
          attorney:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedParalegals?:  {
        __typename: "ModelParalegalAssignmentConnection",
        items:  Array< {
          __typename: "ParalegalAssignment",
          paralegal:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
          } | null,
        } | null >,
      } | null,
      logo?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        slug: string,
        startDate: string,
        requestedProcess?: VisaStatus | null,
        requestedProcessSubCategory?: VisaSubCategory | null,
        requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
        globalRequestedProcessSubCategory?: string | null,
        globalProcessCountryCode?: CountryCode | null,
        caseNumber?: string | null,
        files?:  {
          __typename: "ModelCaseFileConnection",
          items:  Array< {
            __typename: "CaseFile",
            id: string,
            fileID: string,
            caseID: string,
            file:  {
              __typename: "FileData",
              id: string,
              fileType?: FileType | null,
            },
          } | null >,
        } | null,
        fileRequirements:  Array< {
          __typename: "FileRequirement",
          type: FileType,
          assignedToID?: string | null,
          isAssignedToLegalAssistants?: boolean | null,
          expirationDateRequired?: boolean | null,
          issueDateRequired?: boolean | null,
          isApproved?: boolean | null,
          isRequested?: boolean | null,
          hidden?: boolean | null,
          durationOfStatus?: boolean | null,
        } >,
        state: CaseState,
        currentPhase?: CasePhase | null,
        company?:  {
          __typename: "Company",
          name: string,
          displayCompanyName?: string | null,
        } | null,
        phaseRequirements:  Array< {
          __typename: "CasePhaseRequirement",
          phase: CasePhase,
          milestones: Array< CaseMilestone >,
        } >,
        completedMilestones:  Array< {
          __typename: "CompletedCaseMilestone",
          completionDate?: string | null,
          completedByID: string,
          milestone: CaseMilestone,
          receiptNumber?: string | null,
        } >,
        contributors?:  {
          __typename: "ModelCaseContributorConnection",
          items:  Array< {
            __typename: "CaseContributor",
            id: string,
            contributorID: string,
            contributorEmployer?:  {
              __typename: "Employer",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              type: PersonType,
              firstname: string,
              lastname: string,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
          } | null >,
        } | null,
        sponsoringEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        attorney?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        caseManager?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        durationOfStatus?: boolean | null,
        issueDate?: string | null,
        dueDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        processRequestID?: string | null,
        companyID?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderID?: string | null,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
    } | null,
  } | null,
};

export type ContainerUpdateForeignNationalMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type ContainerUpdateForeignNationalMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    username?: string | null,
    immigrationVisaStatus?: string | null,
    slug: string,
    employeeId?: string | null,
    userAgreementAcknowledged?: boolean | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    createdBy?: string | null,
    fileRequirementsManipulated?: string | null,
    citizenshipEligibilityDate?: string | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    notes?: string | null,
    nickname?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    chargeabilityCountry?: CountryCode | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    startDate?: string | null,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        target:  {
          __typename: "ForeignNational",
          id: string,
          relativeAdmins?: Array< string > | null,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        source?:  {
          __typename: "ForeignNational",
          id: string,
          relativeAdmins?: Array< string > | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaExpiration?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      priorityDate?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      petitionerI140?: string | null,
    } | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthCity?: string | null,
    birthDate?: string | null,
    jobDescriptionID?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    nivMaxout?: string | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    createdAt: string,
    updatedAt: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      lowerName?: string | null,
      lowerNameKey: string,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      accountManagerID?: string | null,
      assignedAttorneys?:  {
        __typename: "ModelAttorneyAssignmentConnection",
        items:  Array< {
          __typename: "AttorneyAssignment",
          attorney:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedParalegals?:  {
        __typename: "ModelParalegalAssignmentConnection",
        items:  Array< {
          __typename: "ParalegalAssignment",
          paralegal:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
          } | null,
        } | null >,
      } | null,
      logo?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      items:  Array< {
        __typename: "ProcessRequest",
        id: string,
        requestedProcess?: VisaStatus | null,
        slug: string,
        requestedProcessSubCategory?: VisaSubCategory | null,
        requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
        globalRequestedProcessSubCategory?: string | null,
        globalProcessCountryCode?: CountryCode | null,
        requestDate: string,
        state: ProcessRequestState,
        initiator?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
        } | null,
        requester?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
      } | null >,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        slug: string,
        startDate: string,
        requestedProcess?: VisaStatus | null,
        requestedProcessSubCategory?: VisaSubCategory | null,
        requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
        globalRequestedProcessSubCategory?: string | null,
        globalProcessCountryCode?: CountryCode | null,
        caseNumber?: string | null,
        files?:  {
          __typename: "ModelCaseFileConnection",
          items:  Array< {
            __typename: "CaseFile",
            id: string,
            file:  {
              __typename: "FileData",
              id: string,
              fileType?: FileType | null,
            },
          } | null >,
        } | null,
        fileRequirements:  Array< {
          __typename: "FileRequirement",
          type: FileType,
          assignedToID?: string | null,
          isAssignedToLegalAssistants?: boolean | null,
          expirationDateRequired?: boolean | null,
          issueDateRequired?: boolean | null,
          isApproved?: boolean | null,
          isRequested?: boolean | null,
          hidden?: boolean | null,
          durationOfStatus?: boolean | null,
        } >,
        state: CaseState,
        currentPhase?: CasePhase | null,
        company?:  {
          __typename: "Company",
          name: string,
          displayCompanyName?: string | null,
        } | null,
        phaseRequirements:  Array< {
          __typename: "CasePhaseRequirement",
          phase: CasePhase,
          milestones: Array< CaseMilestone >,
        } >,
        completedMilestones:  Array< {
          __typename: "CompletedCaseMilestone",
          completionDate?: string | null,
          completedByID: string,
          milestone: CaseMilestone,
          receiptNumber?: string | null,
        } >,
        contributors?:  {
          __typename: "ModelCaseContributorConnection",
          items:  Array< {
            __typename: "CaseContributor",
            id: string,
            contributorID: string,
            contributorEmployer?:  {
              __typename: "Employer",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              type: PersonType,
              firstname: string,
              lastname: string,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
          } | null >,
        } | null,
        sponsoringEmployer?:  {
          __typename: "Employer",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        attorney?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        caseManager?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        durationOfStatus?: boolean | null,
        issueDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        processRequestID?: string | null,
        companyID?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderID?: string | null,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
    } | null,
  } | null,
};

export type customGetForeignNationalFilesQueryVariables = {
  id: string,
};

export type customGetForeignNationalFilesQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    spouse?: boolean | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        issueDate?: string | null,
        fileType?: FileType | null,
        dueDate?: string | null,
        durationOfStatus?: boolean | null,
      } | null >,
    } | null,
  } | null,
};

export type updateForeignNationalFilesMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type updateForeignNationalFilesMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    citizenshipEligibilityDate?: string | null,
    spouse?: boolean | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        issueDate?: string | null,
        fileType?: FileType | null,
        dueDate?: string | null,
        durationOfStatus?: boolean | null,
      } | null >,
    } | null,
  } | null,
};

export type ContainerGetForeignNationalNotesQueryVariables = {
  id: string,
};

export type ContainerGetForeignNationalNotesQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    notes?: string | null,
  } | null,
};

export type ContainerUpdateForeignNationalNotesMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type ContainerUpdateForeignNationalNotesMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    notes?: string | null,
  } | null,
};

export type GetCustomTeamMemberQueryVariables = {
  id: string,
};

export type GetCustomTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    slug: string,
    firstname: string,
    lastname: string,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
  } | null,
};

export type ContainerGetTeamMemberQueryVariables = {
  id: string,
};

export type ContainerGetTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    slug: string,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    userAgreementAcknowledged?: boolean | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    managerID?: string | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ContainerUpdateTeamMemberMutationVariables = {
  input: UpdateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type ContainerUpdateTeamMemberMutation = {
  updateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    slug: string,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    userAgreementAcknowledged?: boolean | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    managerID?: string | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      slug: string,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CustomSearchForeignNationalsQueryVariables = {
  filter?: SearchableForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sort?: Array< SearchableForeignNationalSortInput | null > | null,
};

export type CustomSearchForeignNationalsQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      immigrationCurrentStatus?: string | null,
      visaExpDate?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      birthCountryCode?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      username?: string | null,
      slug: string,
      companyName?: string | null,
      employeeId?: string | null,
      userAgreementAcknowledged?: boolean | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      createdBy?: string | null,
      onboardingSections?:  {
        __typename: "NationalOnboardingSections",
        background?: boolean | null,
        contact?: boolean | null,
        employment?: boolean | null,
        family?: boolean | null,
        immigration?: boolean | null,
        personal?: boolean | null,
      } | null,
      completedOnboardingQuestionsBy?: string | null,
      usMailingAddress?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        companyAddressType?: CompanyAddressType | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
      usResidentialAddress?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        companyAddressType?: CompanyAddressType | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
      lastAddressOutsideUS?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        companyAddressType?: CompanyAddressType | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      workLocation?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        companyAddressType?: CompanyAddressType | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      relativesAsSource?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          target:  {
            __typename: "ForeignNational",
            id: string,
            relativeAdmins?: Array< string > | null,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
      relativesAsTarget?:  {
        __typename: "ModelFamilyRelationshipConnection",
        items:  Array< {
          __typename: "FamilyRelationship",
          source?:  {
            __typename: "ForeignNational",
            id: string,
            relativeAdmins?: Array< string > | null,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        doesNotExpire?: boolean | null,
        expiration?: string | null,
      } | null,
      immigrationVisaStatus?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaExpiration?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      j1j2?:  {
        __typename: "J1J2",
        hasHad?: boolean | null,
        start?: string | null,
        end?: string | null,
      } | null,
      hasHadI485Filed?:  {
        __typename: "BooleanTwoPart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
      } | null,
      hasPendingETA9089?: boolean | null,
      hasApprovedI140?:  {
        __typename: "I140",
        hasApproved?: boolean | null,
        classification?: string | null,
        priorityDate?: string | null,
      } | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      criminalHistory?:  {
        __typename: "CriminalHistory",
        tortureGenocide?: boolean | null,
        killing?: boolean | null,
        severeInjuring?: boolean | null,
        nonconsensualSex?: boolean | null,
        religiousBelief?: boolean | null,
      } | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      isInRemovalProceedings?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      hasBeenEmployedSinceLastAdmitted?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthCity?: string | null,
      birthDate?: string | null,
      jobDescriptionID?: string | null,
      offeredSalary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
        period?: CurrencyPeriod | null,
      } | null,
      isRemote?: boolean | null,
      loginStatus?:  {
        __typename: "LoginStatus",
        isEnabled?: boolean | null,
        status?: UserStatus | null,
      } | null,
      hasNonUSPassport?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      nivMaxout?: string | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      createdAt: string,
      updatedAt: string,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        displayCompanyName?: string | null,
        lowerName?: string | null,
        lowerNameKey: string,
        slug: string,
        type: CompanyType,
        domainWhitelist?: Array< string > | null,
        isPartnerCompany?: boolean | null,
        isParent?: boolean | null,
        parentID?: string | null,
        archived?: ArchivedState | null,
        accountManagerID?: string | null,
        assignedAttorneys?:  {
          __typename: "ModelAttorneyAssignmentConnection",
          items:  Array< {
            __typename: "AttorneyAssignment",
            attorney:  {
              __typename: "TeamMember",
              id: string,
            },
          } | null >,
        } | null,
        assignedParalegals?:  {
          __typename: "ModelParalegalAssignmentConnection",
          items:  Array< {
            __typename: "ParalegalAssignment",
            paralegal:  {
              __typename: "TeamMember",
              id: string,
            },
          } | null >,
        } | null,
        assignedEmployers?:  {
          __typename: "ModelEmployerAssignmentConnection",
          items:  Array< {
            __typename: "EmployerAssignment",
            employer?:  {
              __typename: "Employer",
              id: string,
            } | null,
          } | null >,
        } | null,
        logo?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          square?:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          } | null,
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            size: number,
          } > | null,
        } | null,
        fileRequirements?:  Array< {
          __typename: "FileRequirement",
          type: FileType,
          assignedToID?: string | null,
          expirationDateRequired?: boolean | null,
          issueDateRequired?: boolean | null,
          isApproved?: boolean | null,
          durationOfStatus?: boolean | null,
        } > | null,
        files?:  {
          __typename: "ModelFileDataConnection",
          items:  Array< {
            __typename: "FileData",
            id: string,
            expirationDate?: string | null,
            issueDate?: string | null,
            fileName: string,
            fileType?: FileType | null,
            contentType?: string | null,
            original:  {
              __typename: "S3Object",
              bucket: string,
              region: string,
              key: string,
              level?: S3Level | null,
              identityId?: string | null,
            },
            processRequestID?: string | null,
            companyID?: string | null,
            sourceID?: string | null,
            ownerNationalID?: string | null,
            uploadDate: string,
            uploaderID?: string | null,
            uploaderEmployer?:  {
              __typename: "ForeignNational",
              id: string,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            uploaderForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            uploaderTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              firstname: string,
              lastname: string,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                square?:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                } | null,
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
        } | null,
      } | null,
      files?:  {
        __typename: "ModelFileDataConnection",
        items:  Array< {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          issueDate?: string | null,
          fileType?: FileType | null,
          dueDate?: string | null,
        } | null >,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomUpdateForeignNationalMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type CustomUpdateForeignNationalMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    username?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    immigrationVisaStatus?: string | null,
    slug: string,
    employeeId?: string | null,
    archived: ArchivedState,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
  } | null,
};

export type CustomUpdateForeignNationalfilterFieldsMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type CustomUpdateForeignNationalfilterFieldsMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    firstname?: string | null,
    lastname?: string | null,
    visaExpDate?: string | null,
    companyName?: string | null,
  } | null,
};

export type CustomUpdateForeignNationalAgreementMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type CustomUpdateForeignNationalAgreementMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
  } | null,
};

export type SidebarSearchProcessRequestsQueryVariables = {
  filter?: SearchableProcessRequestFilterInput | null,
  sort?: Array< SearchableProcessRequestSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SidebarSearchProcessRequestsQuery = {
  searchProcessRequests?:  {
    __typename: "SearchableProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      companyID?: string | null,
      company?:  {
        __typename: "Company",
        name: string,
        displayCompanyName?: string | null,
      } | null,
      initiatorID?: string | null,
      initiator?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        lastname: string,
      } | null,
      requesterID?: string | null,
      requester?:  {
        __typename: "Employer",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
      } | null,
      requestDate: string,
      employeeData?:  {
        __typename: "ProcessRequestEmployeeData",
        email?: string | null,
        firstname: string,
        lastname: string,
      } | null,
      employmentData?:  {
        __typename: "ProcessRequestEmploymentData",
        startDate?: string | null,
      } | null,
      lowerNationalName?: string | null,
      foreignNationalID?: string | null,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        email?: string | null,
        firstname?: string | null,
        lastname?: string | null,
        spouse?: boolean | null,
        dependents?: number | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          square?:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          } | null,
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
        company?:  {
          __typename: "Company",
          name: string,
          displayCompanyName?: string | null,
        } | null,
        immigrationStatus?:  {
          __typename: "ImmigrationStatus",
          status?: VisaStatus | null,
          expiration?: string | null,
        } | null,
      } | null,
      requestedProcess?: VisaStatus | null,
      slug: string,
      state: ProcessRequestState,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomProcessBySlugQueryVariables = {
  slug: string,
};

export type CustomProcessBySlugQuery = {
  processBySlug?:  {
    __typename: "ModelProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
    } | null >,
  } | null,
};

export type CustomGetProcessRequestQueryVariables = {
  id: string,
};

export type CustomGetProcessRequestQuery = {
  getProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      slug: string,
      id: string,
      name: string,
      displayCompanyName?: string | null,
      primaryContacts?:  {
        __typename: "ModelPrimaryContactConnection",
        items:  Array< {
          __typename: "PrimaryContact",
          employerID: string,
        } | null >,
      } | null,
      data?:  {
        __typename: "CompanyData",
        addressPrimary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
          companyAddressType?: CompanyAddressType | null,
        } | null,
        addressSecondary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
          companyAddressType?: CompanyAddressType | null,
        } | null,
      } | null,
      accountManagerID?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    initiatorID?: string | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      employeeId?: string | null,
      email?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      location?:  {
        __typename: "ProcessRequestLocation",
        remoteAddress?:  {
          __typename: "StreetAddress",
          address?: string | null,
          unitType?: UnitType | null,
        } | null,
        type?: ProcessRequestLocationType | null,
      } | null,
      notes?: string | null,
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      salary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
      } | null,
    } | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      slug: string,
      firstname: string,
      lastname: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    requestDate: string,
    lowerNationalName?: string | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      archived: ArchivedState,
      slug: string,
      email?: string | null,
      firstname?: string | null,
      employeeId?: string | null,
      lastname?: string | null,
      spouse?: boolean | null,
      dependents?: number | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      items:  Array< {
        __typename: "CaseNote",
        authorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          lastname: string,
          firstname: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        id: string,
        createdAt?: string | null,
        note?: string | null,
      } | null >,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        fileType?: FileType | null,
        contentType?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      canWorkFromHome?: boolean | null,
      certificationLicenses?: string | null,
      companyID?: string | null,
      degrees?: Array< Degree > | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      id: string,
      jobURL?: string | null,
      majors?: string | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      officialTitle?: string | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      title: string,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      type: JobDescriptionType,
      uploadedDescriptionID?: string | null,
      yearsGeneralExperience?: number | null,
      uploadedDescription?:  {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      specialRequirements?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      fileName: string,
      contentType?: string | null,
      createdAt: string,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
    } | null,
    slug: string,
    state: ProcessRequestState,
  } | null,
};

export type CustomUpdateProcessRequestMutationVariables = {
  input: UpdateProcessRequestInput,
  condition?: ModelProcessRequestConditionInput | null,
};

export type CustomUpdateProcessRequestMutation = {
  updateProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      slug: string,
      id: string,
      name: string,
      displayCompanyName?: string | null,
      primaryContacts?:  {
        __typename: "ModelPrimaryContactConnection",
        items:  Array< {
          __typename: "PrimaryContact",
          employerID: string,
        } | null >,
      } | null,
      data?:  {
        __typename: "CompanyData",
        addressPrimary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
          companyAddressType?: CompanyAddressType | null,
        } | null,
        addressSecondary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
          companyAddressType?: CompanyAddressType | null,
        } | null,
      } | null,
      accountManagerID?: string | null,
    } | null,
    assignedToID?: string | null,
    initiatorID?: string | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      email?: string | null,
      tempID: string,
      employeeId?: string | null,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      location?:  {
        __typename: "ProcessRequestLocation",
        remoteAddress?:  {
          __typename: "StreetAddress",
          address?: string | null,
          unitType?: UnitType | null,
        } | null,
        type?: ProcessRequestLocationType | null,
      } | null,
      notes?: string | null,
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      salary?:  {
        __typename: "Money",
        currency: Currency,
        amount: number,
      } | null,
    } | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      slug: string,
      firstname: string,
      lastname: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null,
    requestDate: string,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      archived: ArchivedState,
      slug: string,
      email?: string | null,
      employeeId?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      spouse?: boolean | null,
      dependents?: number | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      items:  Array< {
        __typename: "CaseNote",
        authorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          lastname: string,
          firstname: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        id: string,
        createdAt?: string | null,
        note?: string | null,
      } | null >,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
          level?: S3Level | null,
          identityId?: string | null,
        },
        fileType?: FileType | null,
        contentType?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        uploaderEmployer?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          firstname?: string | null,
          lastname?: string | null,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
        uploaderTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          firstname: string,
          lastname: string,
          slug: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
            version: number,
          } | null,
        } | null,
      } | null >,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      title: string,
      degrees?: Array< Degree > | null,
      duties?: string | null,
      majors?: string | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      jobURL?: string | null,
      uploadedDescriptionID?: string | null,
      uploadedDescription?:  {
        __typename: "FileData",
        id: string,
        expirationDate?: string | null,
        fileName: string,
        fileType?: FileType | null,
        contentType?: string | null,
        sourceID?: string | null,
        ownerNationalID?: string | null,
        uploadDate: string,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
      specialRequirements?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      fileName: string,
      contentType?: string | null,
      createdAt: string,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
    } | null,
    slug: string,
    state: ProcessRequestState,
  } | null,
};

export type CustomSearchProcessRequestsQueryVariables = {
  and?: Array< SearchableProcessRequestFilterInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomSearchProcessRequestsQuery = {
  searchProcessRequests?:  {
    __typename: "SearchableProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      companyID?: string | null,
      company?:  {
        __typename: "Company",
        name: string,
        displayCompanyName?: string | null,
      } | null,
      initiatorID?: string | null,
      initiator?:  {
        __typename: "TeamMember",
        id: string,
        slug: string,
        firstname: string,
        lastname: string,
      } | null,
      requesterID?: string | null,
      requester?:  {
        __typename: "Employer",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
      } | null,
      requestDate: string,
      employeeData?:  {
        __typename: "ProcessRequestEmployeeData",
        email?: string | null,
        firstname: string,
        lastname: string,
      } | null,
      employmentData?:  {
        __typename: "ProcessRequestEmploymentData",
        startDate?: string | null,
      } | null,
      foreignNationalID?: string | null,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        email?: string | null,
        firstname?: string | null,
        lastname?: string | null,
        spouse?: boolean | null,
        dependents?: number | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          square?:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          } | null,
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
        company?:  {
          __typename: "Company",
          name: string,
          displayCompanyName?: string | null,
        } | null,
        immigrationStatus?:  {
          __typename: "ImmigrationStatus",
          status?: VisaStatus | null,
          expiration?: string | null,
        } | null,
      } | null,
      requestedProcess?: VisaStatus | null,
      slug: string,
      state: ProcessRequestState,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type CustomListForeignNationalsQueryVariables = {
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListForeignNationalsQuery = {
  listForeignNationals?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      immigrationVisaStatus?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        doesNotExpire?: boolean | null,
        expiration?: string | null,
      } | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      hasApprovedI140?:  {
        __typename: "I140",
        hasApproved?: boolean | null,
        classification?: string | null,
        priorityDate?: string | null,
        employmentBasedCategory?: EmploymentBasedCategory | null,
      } | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      birthCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      files?:  {
        __typename: "ModelFileDataConnection",
        items:  Array< {
          __typename: "FileData",
          id: string,
          expirationDate?: string | null,
          fileType?: FileType | null,
        } | null >,
      } | null,
      companyID?: string | null,
      companyName?: string | null,
      company?:  {
        __typename: "Company",
        name: string,
        displayCompanyName?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CheckEmployerAssignmentsQueryVariables = {
  companyID?: string | null,
  employerID?: string | null,
};

export type CheckEmployerAssignmentsQuery = {
  listEmployerAssignments?:  {
    __typename: "ModelEmployerAssignmentConnection",
    items:  Array< {
      __typename: "EmployerAssignment",
      id: string,
    } | null >,
  } | null,
};

export type GetCompanyAttorneyAssignmentQueryVariables = {
  companyID: string,
  attorneyID: string,
};

export type GetCompanyAttorneyAssignmentQuery = {
  getCompany?:  {
    __typename: "Company",
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      items:  Array< {
        __typename: "AttorneyAssignment",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type GetCompanyEmployerAdminAssignmentQueryVariables = {
  companyID: string,
  employerID: string,
};

export type GetCompanyEmployerAdminAssignmentQuery = {
  getCompany?:  {
    __typename: "Company",
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAdminAssignment",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type GetCompanyParalegalAssignmentQueryVariables = {
  companyID: string,
  paralegalID: string,
};

export type GetCompanyParalegalAssignmentQuery = {
  getCompany?:  {
    __typename: "Company",
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      items:  Array< {
        __typename: "ParalegalAssignment",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type ListCompanyJobDescriptionsQueryVariables = {
  id?: string | null,
};

export type ListCompanyJobDescriptionsQuery = {
  getCompany?:  {
    __typename: "Company",
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      items:  Array< {
        __typename: "JobDescription",
        archived: ArchivedState,
        canWorkFromHome?: boolean | null,
        certificationLicenses?: string | null,
        companyID?: string | null,
        createdAt: string,
        degrees?: Array< Degree > | null,
        dotNumber?: string | null,
        caseSocCode?: string | null,
        duties?: string | null,
        id: string,
        majors?: string | null,
        objectiveSkillSetsRequired?: string | null,
        offeredSalary?: string | null,
        officialTitle?: string | null,
        specialRequirements?: string | null,
        supervisesOthers?: boolean | null,
        supervisesOthersCount?: number | null,
        supervisesTitles?: Array< string > | null,
        supervisorTitle?: string | null,
        title: string,
        travelDomestic?: boolean | null,
        travelInternational?: boolean | null,
        travelIsRequired?: boolean | null,
        travelPercentage?: number | null,
        type: JobDescriptionType,
        yearsGeneralExperience?: number | null,
      } | null >,
    } | null,
  } | null,
};

export type PopulateCreateCompanyFormQueryVariables = {
};

export type PopulateCreateCompanyFormQuery = {
  attorneys?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      type: PersonType,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
  paralegals?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      type: PersonType,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type CheckForCompanySlugQueryVariables = {
  slug: string,
};

export type CheckForCompanySlugQuery = {
  companiesBySlug?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
    } | null >,
  } | null,
};

export type PeopleByEmailQueryVariables = {
  email: string,
};

export type PeopleByEmailQuery = {
  employersByEmail?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      type: PersonType,
      username?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      firstname?: string | null,
      lastname?: string | null,
    } | null >,
  } | null,
  nationalsByEmail?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      id: string,
      type: PersonType,
      username?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      firstname?: string | null,
      lastname?: string | null,
    } | null >,
  } | null,
  teamByEmail?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      type: PersonType,
      username?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
      firstname: string,
      lastname: string,
    } | null >,
  } | null,
};

export type PeopleBySlugQueryVariables = {
  slug: string,
};

export type PeopleBySlugQuery = {
  employersBySlug?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
    } | null >,
  } | null,
  nationalsBySlug?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
    } | null >,
  } | null,
  teamBySlug?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null >,
  } | null,
};

export type GetCurrentTeamMemberQueryVariables = {
  id: string,
};

export type GetCurrentTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    type: PersonType,
    id: string,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    hasLoggedIn?: boolean | null,
    email?: string | null,
    position?: Position | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname: string,
    lastname: string,
    username?: string | null,
  } | null,
};

export type GetCurrentEmployerQueryVariables = {
  id: string,
};

export type GetCurrentEmployerQuery = {
  getEmployer?:  {
    __typename: "Employer",
    type: PersonType,
    id: string,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    newsletterModalViewCount?: number | null,
    hasLoggedIn?: boolean | null,
    nationalsWithOpenCases?: Array< string > | null,
    email?: string | null,
    isPrimaryContact?: boolean | null,
    companyIDs?: Array< string > | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      items:  Array< {
        __typename: "PrimaryContact",
        id: string,
        companyID: string,
        employerID: string,
      } | null >,
    } | null,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAdminAssignment",
        id: string,
        employerID: string,
        companyID: string,
        company?:  {
          __typename: "Company",
          name: string,
          displayCompanyName?: string | null,
          hasCompletedOnboardingQuestions?: boolean | null,
          onboardingSections?:  {
            __typename: "CompanyOnboardingSections",
            companyInfo?: boolean | null,
            contactInfo?: boolean | null,
            companyPreferences?: boolean | null,
            immigrationPreferences?: boolean | null,
            paymentPreferences?: boolean | null,
            questions?: boolean | null,
            employeeInformation?: boolean | null,
          } | null,
          primaryContacts?:  {
            __typename: "ModelPrimaryContactConnection",
            items:  Array< {
              __typename: "PrimaryContact",
              id: string,
              companyID: string,
              employerID: string,
            } | null >,
          } | null,
        } | null,
      } | null >,
    } | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        company?:  {
          __typename: "Company",
          id: string,
          slug: string,
          name: string,
          displayCompanyName?: string | null,
          onboardingSections?:  {
            __typename: "CompanyOnboardingSections",
            companyInfo?: boolean | null,
            contactInfo?: boolean | null,
            companyPreferences?: boolean | null,
            immigrationPreferences?: boolean | null,
            paymentPreferences?: boolean | null,
            questions?: boolean | null,
          } | null,
          primaryContacts?:  {
            __typename: "ModelPrimaryContactConnection",
            items:  Array< {
              __typename: "PrimaryContact",
              id: string,
              companyID: string,
              employerID: string,
            } | null >,
          } | null,
          accountManagerID?: string | null,
          data?:  {
            __typename: "CompanyData",
            addressPrimary?:  {
              __typename: "StreetAddress",
              careOf?: string | null,
              address?: string | null,
              unitNumber?: string | null,
              unitType?: UnitType | null,
              adminArea?: string | null,
              state?: StateCode | null,
              city?: string | null,
              country?: CountryCode | null,
              postalCode?: string | null,
              title?: string | null,
            } | null,
            addressSecondary?:  {
              __typename: "StreetAddress",
              careOf?: string | null,
              address?: string | null,
              unitNumber?: string | null,
              unitType?: UnitType | null,
              adminArea?: string | null,
              state?: StateCode | null,
              city?: string | null,
              country?: CountryCode | null,
              postalCode?: string | null,
              title?: string | null,
            } | null,
          } | null,
        } | null,
      } | null >,
    } | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        size: number,
      } > | null,
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    username?: string | null,
    phone?: string | null,
    title?: string | null,
    hasCompletedOnboardingQuestions?: boolean | null,
  } | null,
};

export type GetEmployerCompanyNamesQueryVariables = {
  id?: string | null,
};

export type GetEmployerCompanyNamesQuery = {
  getEmployer?:  {
    __typename: "Employer",
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          displayCompanyName?: string | null,
          slug: string,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type GetCompanyHookQueryVariables = {
  id: string,
};

export type GetCompanyHookQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      addressPrimary?:  {
        __typename: "StreetAddress",
        address?: string | null,
        adminArea?: string | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
      addressSecondary?:  {
        __typename: "StreetAddress",
        address?: string | null,
        adminArea?: string | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
      } | null,
    } | null,
  } | null,
};

export type getCustomDataCompanyQueryVariables = {
  id: string,
};

export type getCustomDataCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      thumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } > | null,
    } | null,
    domainWhitelist?: Array< string > | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      allowsEmployeesToTelecommute?:  {
        __typename: "BooleanThreePart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
        followPromptSecond?: string | null,
        followValueSecond?: boolean | null,
      } | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      createdAt: string,
      updatedAt: string,
      preferenceForEmployeesToPayPartOfGreenCard?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      preferenceForEmployeesToPayPartOfH1B?:  {
        __typename: "BooleanExplain",
        value?: boolean | null,
        reason?: string | null,
      } | null,
      employs50OrMore?:  {
        __typename: "BooleanTwoPart",
        value?: boolean | null,
        followPrompt?: string | null,
        followValue?: boolean | null,
      } | null,
      grossRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      netRevenueForMostRecentFiscalYear?:  {
        __typename: "Money",
        amount: number,
        currency: Currency,
      } | null,
      usesApplicantTrackingSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      usesHRSSystem?:  {
        __typename: "BooleanExplain",
        reason?: string | null,
        value?: boolean | null,
      } | null,
      shippingPreference?:  {
        __typename: "ShippingPreference",
        fedexAccount?: string | null,
        preference?: ShippingPaymentPreference | null,
        upsAccount?: string | null,
      } | null,
      addressSecondary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
      addressPrimary?:  {
        __typename: "StreetAddress",
        careOf?: string | null,
        address?: string | null,
        unitNumber?: string | null,
        unitType?: UnitType | null,
        adminArea?: string | null,
        state?: StateCode | null,
        city?: string | null,
        country?: CountryCode | null,
        postalCode?: string | null,
        title?: string | null,
        companyAddressType?: CompanyAddressType | null,
      } | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type GetNationalHookQueryVariables = {
  id: string,
};

export type GetNationalHookQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    email?: string | null,
    avatar?:  {
      __typename: "Picture",
      original:  {
        __typename: "S3Object",
        bucket: string,
        identityId?: string | null,
        key: string,
        level?: S3Level | null,
        region: string,
      },
      square?:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      } | null,
      squareThumbnails?:  Array< {
        __typename: "Thumbnail",
        size: number,
        image:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          region: string,
          level?: S3Level | null,
        },
      } > | null,
    } | null,
    firstname?: string | null,
    lastname?: string | null,
    lowerFull: string,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
    } | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    offeredSalary?:  {
      __typename: "Money",
      amount: number,
      currency: Currency,
    } | null,
    isRemote?: boolean | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      slug: string,
      accountManagerID?: string | null,
      assignedAttorneys?:  {
        __typename: "ModelAttorneyAssignmentConnection",
        items:  Array< {
          __typename: "AttorneyAssignment",
          attorney:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedParalegals?:  {
        __typename: "ModelParalegalAssignmentConnection",
        items:  Array< {
          __typename: "ParalegalAssignment",
          paralegal:  {
            __typename: "TeamMember",
            id: string,
          },
        } | null >,
      } | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
          } | null,
        } | null >,
      } | null,
      data?:  {
        __typename: "CompanyData",
        addressPrimary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
        } | null,
        addressSecondary?:  {
          __typename: "StreetAddress",
          careOf?: string | null,
          address?: string | null,
          unitNumber?: string | null,
          unitType?: UnitType | null,
          adminArea?: string | null,
          state?: StateCode | null,
          city?: string | null,
          country?: CountryCode | null,
          postalCode?: string | null,
          title?: string | null,
        } | null,
      } | null,
    } | null,
  } | null,
};

export type GetRelativesQueryVariables = {
  id?: string | null,
};

export type GetRelativesQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        id: string,
        type?: FamilyRelationshipType | null,
        target:  {
          __typename: "ForeignNational",
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                region: string,
                level?: S3Level | null,
              },
            } > | null,
          } | null,
          type: PersonType,
          email?: string | null,
          firstname?: string | null,
          id: string,
          lastname?: string | null,
          companyID?: string | null,
          slug: string,
          cases?:  {
            __typename: "ModelCaseConnection",
            items:  Array< {
              __typename: "Case",
              id: string,
              slug: string,
              caseNumber?: string | null,
              startDate: string,
              requestedProcess?: VisaStatus | null,
              state: CaseState,
              currentPhase?: CasePhase | null,
              company?:  {
                __typename: "Company",
                name: string,
                displayCompanyName?: string | null,
              } | null,
              phaseRequirements:  Array< {
                __typename: "CasePhaseRequirement",
                phase: CasePhase,
                milestones: Array< CaseMilestone >,
              } >,
              completedMilestones:  Array< {
                __typename: "CompletedCaseMilestone",
                completionDate?: string | null,
                completedByID: string,
                milestone: CaseMilestone,
                receiptNumber?: string | null,
              } >,
            } | null >,
          } | null,
          username?: string | null,
          birthCountry?: CountryCode | null,
          citizenshipCountry?: Array< CountryCode > | null,
          aosFilingEligible?: AOSFilingEligibility | null,
          hasApprovedI140?:  {
            __typename: "I140",
            hasApproved?: boolean | null,
          } | null,
          loginStatus?:  {
            __typename: "LoginStatus",
            isEnabled?: boolean | null,
            status?: UserStatus | null,
          } | null,
          relativeAdmins?: Array< string > | null,
          immigrationStatus?:  {
            __typename: "ImmigrationStatus",
            expiration?: string | null,
            status?: VisaStatus | null,
          } | null,
          files?:  {
            __typename: "ModelFileDataConnection",
            items:  Array< {
              __typename: "FileData",
              fileType?: FileType | null,
            } | null >,
          } | null,
        },
      } | null >,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        id: string,
        type?: FamilyRelationshipType | null,
        source?:  {
          __typename: "ForeignNational",
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                region: string,
                level?: S3Level | null,
              },
            } > | null,
          } | null,
          type: PersonType,
          email?: string | null,
          firstname?: string | null,
          id: string,
          lastname?: string | null,
          companyID?: string | null,
          slug: string,
          cases?:  {
            __typename: "ModelCaseConnection",
            items:  Array< {
              __typename: "Case",
              id: string,
              slug: string,
              caseNumber?: string | null,
              requestedProcess?: VisaStatus | null,
              startDate: string,
              state: CaseState,
              caseManagerID?: string | null,
              caseManager?:  {
                __typename: "TeamMember",
                id: string,
                firstname: string,
                lastname: string,
                slug: string,
              } | null,
              companyID?: string | null,
              company?:  {
                __typename: "Company",
                id: string,
                name: string,
                displayCompanyName?: string | null,
              } | null,
              foreignNationalID: string,
              foreignNational?:  {
                __typename: "ForeignNational",
                id: string,
                firstname?: string | null,
                lastname?: string | null,
                slug: string,
                immigrationStatus?:  {
                  __typename: "ImmigrationStatus",
                  expiration?: string | null,
                } | null,
              } | null,
              phaseRequirements:  Array< {
                __typename: "CasePhaseRequirement",
                phase: CasePhase,
                milestones: Array< CaseMilestone >,
              } >,
              completedMilestones:  Array< {
                __typename: "CompletedCaseMilestone",
                completionDate?: string | null,
                completedByID: string,
                milestone: CaseMilestone,
                receiptNumber?: string | null,
              } >,
            } | null >,
          } | null,
          username?: string | null,
          birthCountry?: CountryCode | null,
          citizenshipCountry?: Array< CountryCode > | null,
          hasApprovedI140?:  {
            __typename: "I140",
            hasApproved?: boolean | null,
          } | null,
          aosFilingEligible?: AOSFilingEligibility | null,
          loginStatus?:  {
            __typename: "LoginStatus",
            isEnabled?: boolean | null,
            status?: UserStatus | null,
          } | null,
          relativeAdmins?: Array< string > | null,
          immigrationStatus?:  {
            __typename: "ImmigrationStatus",
            expiration?: string | null,
            status?: VisaStatus | null,
          } | null,
          files?:  {
            __typename: "ModelFileDataConnection",
            items:  Array< {
              __typename: "FileData",
              fileType?: FileType | null,
            } | null >,
          } | null,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type ListCompanyEmployersQueryVariables = {
  id: string,
};

export type ListCompanyEmployersQuery = {
  getCompany?:  {
    __typename: "Company",
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        employer?:  {
          __typename: "Employer",
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            square?:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            } | null,
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              size: number,
              image:  {
                __typename: "S3Object",
                bucket: string,
                identityId?: string | null,
                key: string,
                region: string,
                level?: S3Level | null,
              },
            } > | null,
          } | null,
          firstname?: string | null,
          id: string,
          lastname?: string | null,
          type: PersonType,
        } | null,
      } | null >,
    } | null,
  } | null,
};

export type GetFirmCompanyCountQueryVariables = {
  id: string,
};

export type GetFirmCompanyCountQuery = {
  getFirm?:  {
    __typename: "Firm",
    companyCount: number,
  } | null,
};

export type UpdateFirmCompanyCountMutationVariables = {
  id: string,
  companyCount: number,
};

export type UpdateFirmCompanyCountMutation = {
  updateFirm?:  {
    __typename: "Firm",
    companyCount: number,
  } | null,
};

export type ListPreparedFormTemplatesQueryVariables = {
  id: string,
};

export type ListPreparedFormTemplatesQuery = {
  getFirm?:  {
    __typename: "Firm",
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
      file:  {
        __typename: "S3Object",
        bucket: string,
        identityId?: string | null,
        key: string,
        level?: S3Level | null,
        region: string,
      },
    } > | null,
  } | null,
};

export type ListFirmContactsQueryVariables = {
};

export type ListFirmContactsQuery = {
  listTeamMembersAlpha?:  {
    __typename: "ModelTeamMemberConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "TeamMember",
      email?: string | null,
      firstname: string,
      lastname: string,
      lowerFull: string,
      id: string,
      type: PersonType,
      loginStatus?:  {
        __typename: "LoginStatus",
        isEnabled?: boolean | null,
        status?: UserStatus | null,
      } | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      manager?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          square?:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          } | null,
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            size: number,
            image:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
          } > | null,
        } | null,
      } | null,
      mostRecentlyInvited?: string | null,
      position?: Position | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
      } | null,
      slug: string,
      title?: string | null,
      username?: string | null,
    } | null >,
  } | null,
};

export type ListAttorneysAndParalegalsQueryVariables = {
  nextToken?: string | null,
};

export type ListAttorneysAndParalegalsQuery = {
  listTeamMembersAlpha?:  {
    __typename: "ModelTeamMemberConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
      } | null,
      id: string,
      type: PersonType,
    } | null >,
  } | null,
};

export type ListLegalAssistantIDsQueryVariables = {
  nextToken?: string | null,
};

export type ListLegalAssistantIDsQuery = {
  listTeamMembersByPosition?:  {
    __typename: "ModelTeamMemberConnection",
    nextToken?: string | null,
    items:  Array< {
      __typename: "TeamMember",
      id: string,
    } | null >,
  } | null,
};

export type SearchCompanyNamesQueryVariables = {
  and?: Array< SearchableCompanyFilterInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchCompanyNamesQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    nextToken?: string | null,
    total?: number | null,
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      isParent?: boolean | null,
      parentID?: string | null,
      data?:  {
        __typename: "CompanyData",
        doingBusinessAs?: string | null,
      } | null,
    } | null >,
  } | null,
};

export type SearchCompanyDomainsQueryVariables = {
  domain?: string | null,
  nextToken?: string | null,
};

export type SearchCompanyDomainsQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    nextToken?: string | null,
    total?: number | null,
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
    } | null >,
  } | null,
};

export type SearchEmployerNamesQueryVariables = {
  and?: Array< SearchableEmployerFilterInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchEmployerNamesQuery = {
  searchEmployers?:  {
    __typename: "SearchableEmployerConnection",
    total?: number | null,
    nextToken?: string | null,
    items:  Array< {
      __typename: "Employer",
      id: string,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      lowerFull: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type SearchForeignNationalNamesQueryVariables = {
  and?: Array< SearchableForeignNationalFilterInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchForeignNationalNamesQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    total?: number | null,
    nextToken?: string | null,
    items:  Array< {
      __typename: "ForeignNational",
      id: string,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      lowerFull: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type SearchTeamMemberNamesQueryVariables = {
  and?: Array< SearchableTeamMemberFilterInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchTeamMemberNamesQuery = {
  searchTeamMembers?:  {
    __typename: "SearchableTeamMemberConnection",
    nextToken?: string | null,
    total?: number | null,
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      email?: string | null,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type ListForeignNationalsByVisaExpirationQueryVariables = {
  gte?: string | null,
  and?: Array< SearchableForeignNationalFilterInput | null > | null,
};

export type ListForeignNationalsByVisaExpirationQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      id: string,
      email?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
      company?:  {
        __typename: "Company",
        name: string,
        displayCompanyName?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmployerSnapshotCountQueryVariables = {
  id: string,
};

export type GetEmployerSnapshotCountQuery = {
  getEmployer?:  {
    __typename: "Employer",
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      items:  Array< {
        __typename: "CaseContributor",
        caseID: string,
        case:  {
          __typename: "Case",
          id: string,
        },
      } | null >,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
      } | null >,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      items:  Array< {
        __typename: "ProcessRequest",
        id: string,
      } | null >,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type GetTeamMemberSnapshotCountQueryVariables = {
  id: string,
};

export type GetTeamMemberSnapshotCountQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    attorneyCases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
      } | null >,
    } | null,
    caseManagerCases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
      } | null >,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      items:  Array< {
        __typename: "CaseContributor",
        case:  {
          __typename: "Case",
          id: string,
        },
      } | null >,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      items:  Array< {
        __typename: "ProcessRequest",
        id: string,
      } | null >,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type GetForeignNationalSnapshotCountQueryVariables = {
  id: string,
};

export type GetForeignNationalSnapshotCountQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    id: string,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      isApproved?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        id: string,
        fileType?: FileType | null,
      } | null >,
    } | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      items:  Array< {
        __typename: "Case",
        id: string,
        slug: string,
        startDate: string,
        requestedProcess?: VisaStatus | null,
        requestedProcessSubCategory?: VisaSubCategory | null,
        requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
        globalRequestedProcessSubCategory?: string | null,
        globalProcessCountryCode?: CountryCode | null,
        caseNumber?: string | null,
        fileRequirements:  Array< {
          __typename: "FileRequirement",
          type: FileType,
          assignedToID?: string | null,
          isAssignedToLegalAssistants?: boolean | null,
          expirationDateRequired?: boolean | null,
          issueDateRequired?: boolean | null,
          isApproved?: boolean | null,
          isRequested?: boolean | null,
          durationOfStatus?: boolean | null,
        } >,
      } | null >,
    } | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      items:  Array< {
        __typename: "FamilyRelationship",
        target:  {
          __typename: "ForeignNational",
          id: string,
          relativeAdmins?: Array< string > | null,
        },
      } | null >,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type CustomCreateCommentMutationVariables = {
  input: CreateCommentInput,
  condition?: ModelCommentConditionInput | null,
};

export type CustomCreateCommentMutation = {
  createComment?:  {
    __typename: "Comment",
    authorID: string,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      lastname?: string | null,
      firstname?: string | null,
      slug: string,
      type: PersonType,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorForeignNational?:  {
      __typename: "ForeignNational",
      id: string,
      lastname?: string | null,
      firstname?: string | null,
      slug: string,
      type: PersonType,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      lastname: string,
      firstname: string,
      slug: string,
      type: PersonType,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      archived: ArchivedState,
      createdAt: string,
      updatedAt: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            region: string,
            level?: S3Level | null,
            key: string,
            identityId?: string | null,
            bucket: string,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    id: string,
    sourceID: string,
    createdAt?: string | null,
    updatedAt: string,
    note?: string | null,
  } | null,
};

export type CustomGetFirmQueryVariables = {
  id: string,
};

export type CustomGetFirmQuery = {
  getFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomUpdateFirmMutationVariables = {
  input: UpdateFirmInput,
  condition?: ModelFirmConditionInput | null,
};

export type CustomUpdateFirmMutation = {
  updateFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskForCountQueryVariables = {
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskForCountQuery = {
  listTasks?:  {
    __typename: "ModelTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      action: string,
      description?: string | null,
      orderIndex?: number | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      prerequisite?:  {
        __typename: "Task",
        action: string,
        category: TaskCategory,
      } | null,
      dependencies?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          caseState?: CaseState | null,
          state: TaskState,
          deadline: string,
          orderIndex?: number | null,
          duration?: number | null,
          templateID?: string | null,
          startDate: string,
          prerequisiteID?: string | null,
          action: string,
          completeDate?: string | null,
        } | null >,
      } | null,
      assignedToEmployer?:  {
        __typename: "Employer",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      assignedToTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        position?: Position | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      assignedToForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      caseID: string,
      caseState?: CaseState | null,
      case:  {
        __typename: "Case",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        attorneyID?: string | null,
        caseManagerID?: string | null,
        companyID?: string | null,
        state: CaseState,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          items:  Array< {
            __typename: "Task",
            action: string,
            category: TaskCategory,
            state: TaskState,
          } | null >,
        } | null,
        contributors?:  {
          __typename: "ModelCaseContributorConnection",
          items:  Array< {
            __typename: "CaseContributor",
            id: string,
            contributorID: string,
            contributorEmployer?:  {
              __typename: "Employer",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              type: PersonType,
              firstname: string,
              lastname: string,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
          } | null >,
        } | null,
      },
      category: TaskCategory,
      companyID?: string | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        displayCompanyName?: string | null,
        slug: string,
      } | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      duration?: number | null,
      groupsCanRead?: Array< string > | null,
      foreignNationalID: string,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomUpdateJobDescriptionMutationVariables = {
  input: UpdateJobDescriptionInput,
  condition?: ModelJobDescriptionConditionInput | null,
};

export type CustomUpdateJobDescriptionMutation = {
  updateJobDescription?:  {
    __typename: "JobDescription",
    companyID?: string | null,
    id: string,
    archived: ArchivedState,
    type: JobDescriptionType,
    foreignNationalID?: string | null,
    title: string,
    officialTitle?: string | null,
    degrees?: Array< Degree > | null,
    requiresBachelors?: boolean | null,
    requiresMasters?: boolean | null,
    requiresPhd?: boolean | null,
    dotNumber?: string | null,
    caseSocCode?: string | null,
    duties?: string | null,
    jobURL?: string | null,
    majors?: string | null,
    specialRequirements?: string | null,
    yearsGeneralExperience?: number | null,
    objectiveSkillSetsRequired?: string | null,
    offeredSalary?: string | null,
    certificationLicenses?: string | null,
    travelIsRequired?: boolean | null,
    travelPercentage?: number | null,
    travelDomestic?: boolean | null,
    travelInternational?: boolean | null,
    supervisesOthers?: boolean | null,
    supervisesOthersCount?: number | null,
    supervisesTitles?: Array< string > | null,
    supervisorTitle?: string | null,
    canWorkFromHome?: boolean | null,
    uploadedDescriptionID?: string | null,
    uploadedDescription?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomlistForeignNationalsQueryVariables = {
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomlistForeignNationalsQuery = {
  listForeignNationals?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
      immigrationVisaStatus?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetlistForeignNationalsQueryVariables = {
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetlistForeignNationalsQuery = {
  listForeignNationals?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      visaExpiration?: string | null,
      visaExpDate?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyForeignNationalsQueryVariables = {
  id?: string | null,
};

export type GetCompanyForeignNationalsQuery = {
  getCompany?:  {
    __typename: "Company",
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      items:  Array< {
        __typename: "ForeignNational",
        companyName?: string | null,
        id: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type listCompaniesQueryVariables = {
  nextToken?: string | null,
  limit?: number | null,
};

export type listCompaniesQuery = {
  listCompanies?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      name: string,
      displayCompanyName?: string | null,
      id: string,
      data?:  {
        __typename: "CompanyData",
        doingBusinessAs?: string | null,
      } | null,
      assignedEmployerAdmins?:  {
        __typename: "ModelEmployerAdminAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAdminAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            middlename?: string | null,
          } | null,
        } | null >,
      } | null,
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            id: string,
            firstname?: string | null,
            lastname?: string | null,
            middlename?: string | null,
          } | null,
        } | null >,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmployerCompaniesQueryVariables = {
  id: string,
  nextToken?: string | null,
};

export type GetEmployerCompaniesQuery = {
  getEmployer?:  {
    __typename: "Employer",
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          displayCompanyName?: string | null,
          archived?: ArchivedState | null,
          data?:  {
            __typename: "CompanyData",
            doingBusinessAs?: string | null,
          } | null,
          accountManager?:  {
            __typename: "TeamMember",
            firstname: string,
            lastname: string,
            middlename?: string | null,
            id: string,
          } | null,
          assignedAttorneys?:  {
            __typename: "ModelAttorneyAssignmentConnection",
            items:  Array< {
              __typename: "AttorneyAssignment",
              attorney:  {
                __typename: "TeamMember",
                id: string,
                lastname: string,
                firstname: string,
                middlename?: string | null,
              },
            } | null >,
          } | null,
          assignedParalegals?:  {
            __typename: "ModelParalegalAssignmentConnection",
            items:  Array< {
              __typename: "ParalegalAssignment",
              paralegal:  {
                __typename: "TeamMember",
                id: string,
                firstname: string,
                lastname: string,
                middlename?: string | null,
              },
            } | null >,
          } | null,
          assignedEmployers?:  {
            __typename: "ModelEmployerAssignmentConnection",
            items:  Array< {
              __typename: "EmployerAssignment",
              employer?:  {
                __typename: "Employer",
                middlename?: string | null,
                lastname?: string | null,
                firstname?: string | null,
                id: string,
                slug: string,
                avatar?:  {
                  __typename: "Picture",
                  original:  {
                    __typename: "S3Object",
                    bucket: string,
                    identityId?: string | null,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                  },
                  square?:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  } | null,
                  squareThumbnails?:  Array< {
                    __typename: "Thumbnail",
                    image:  {
                      __typename: "S3Object",
                      bucket: string,
                      identityId?: string | null,
                      key: string,
                      level?: S3Level | null,
                      region: string,
                    },
                    size: number,
                  } > | null,
                  version: number,
                } | null,
              } | null,
            } | null >,
          } | null,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListAllTeamMembersQueryVariables = {
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAllTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      middlename?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSelectedFieldsQueryVariables = {
  id: string,
};

export type GetSelectedFieldsQuery = {
  getReports?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    customTemplate:  {
      __typename: "CustomTemplate",
      accessibleCompanyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      category?: TemplateCategory | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      editAccess?: EditPermission | null,
      editableIds?: Array< string | null > | null,
      employerID?: string | null,
      id: string,
      includeCases?: boolean | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      isDeleted?: boolean | null,
      name: string,
      numberOfColumns?: number | null,
      numberOfFilters?: number | null,
      selectedFields?: string | null,
      teamMemberId?: string | null,
      type?: TemplateType | null,
      updatedAt?: string | null,
      viewAccess?: AccessPermission | null,
    },
  } | null,
};

export type CustomSearchReportEntriesQueryVariables = {
  filter?: SearchableReportEntriesFilterInput | null,
  sort?: Array< SearchableReportEntriesSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomSearchReportEntriesQuery = {
  searchReportEntries?:  {
    __typename: "SearchableReportEntriesConnection",
    items:  Array< {
      __typename: "ReportEntries",
      id: string,
      reportID: string,
      companyID?: string | null,
      foreignNationalID?: string | null,
      fullname?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      middlename?: string | null,
      archived?: string | null,
      email?: string | null,
      personalEmail?: string | null,
      birthDate?: string | null,
      numberOfDependents?: number | null,
      numberOfFamilyContacts?: number | null,
      displayCompanyName?: string | null,
      companyLegalName?: string | null,
      companyFullName?: string | null,
      companyDbaName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      birthCountryCode?: string | null,
      citizenshipCountry?: Array< string | null > | null,
      chargeabilityCountry?: string | null,
      passportExpirationDate?: string | null,
      nivMaxout?: string | null,
      visaExpDate?: string | null,
      hasApprovedI140?: boolean | null,
      aosFilingEligible?: string | null,
      requiresMeetingReminder?: boolean | null,
      annualMeetingDate?: string | null,
      isParent?: boolean | null,
      isPartnerCompany?: boolean | null,
      petitionerI140?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      fnJobTitle?: string | null,
      socCode?: string | null,
      caseSocCode?: string | null,
      fnSalary?: string | null,
      startDate?: string | null,
      fnWorkLocation?: string | null,
      addressPrimary?: string | null,
      addressSecondary?: string | null,
      workLocation?: string | null,
      usResidentialAddress?: string | null,
      lastProcessType?: string | null,
      lowerProcessType?: string | null,
      currentProcessType?: string | null,
      lastPhaseCompleted?: string | null,
      currentPhase?: string | null,
      capType?: string | null,
      eadExpDate?: string | null,
      I797ApprovalExpDate?: string | null,
      I94ExpDate?: string | null,
      I94DS?: string | null,
      greenCardExpDate?: string | null,
      prevailingWageExpDate?: string | null,
      citizenshipEligibilityDate?: string | null,
      rfeDueDate?: string | null,
      dolAuditDueDate?: string | null,
      pwdExpDate?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      agreementExpDate?: string | null,
      agreementEffectiveDate?: string | null,
      mswsowExpDate?: string | null,
      permDueDate?: string | null,
      lotterySelectionDueDate?: string | null,
      advancedParoleExpDate?: string | null,
      reEntryPermitExpDate?: string | null,
      certifiedLcaExpDate?: string | null,
      title?: string | null,
      notes?: string | null,
      DS2019ExpDate?: string | null,
      isRelative?: boolean | null,
      relativeIds?: Array< string | null > | null,
      nextPhase?: string | null,
      requestedProcessSubCategory?: string | null,
      fnNameSlug?: string | null,
      companyNameSlug?: string | null,
      employerNameSlug?: string | null,
      caseSlug?: string | null,
      inviteStatus?: string | null,
      passportGender?: string | null,
      passportNumber?: string | null,
      phoneNumber?: string | null,
      personalPhone?: string | null,
      faxNumber?: string | null,
      companyAttorneys?: Array< string | null > | null,
      companyAttorneyIds?: Array< string | null > | null,
      companyParalegals?: Array< string | null > | null,
      companyParalegalIds?: Array< string | null > | null,
      companyTotalCases?: string | null,
      companyTotalOpenCases?: string | null,
      companyTotalClosedCases?: string | null,
      companyTotalCompletedCases?: string | null,
      companyNationalCount?: string | null,
      companyActiveNationalCount?: string | null,
      fullTimeEmployeesInUS?: string | null,
      partTimeEmployeesInUS?: string | null,
      preferredMailingAddress?: string | null,
      companyWhitelistedDomains?: Array< string | null > | null,
      typeOfBusiness?: string | null,
      fein?: string | null,
      naicsCodeOfCompany?: string | null,
      yearCompanyWasFoundedInUS?: string | null,
      grossRevenueForMostRecentFiscalYear?: string | null,
      netRevenueForMostRecentFiscalYear?: string | null,
      onboardingSections?: boolean | null,
      lastEntryUS?: string | null,
      employeeId?: string | null,
      caseNumber?: string | null,
      requestedProcess?: string | null,
      attorneyID?: string | null,
      caseAttorney?: string | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      caseSponsor?: string | null,
      caseManagerID?: string | null,
      caseManager?: string | null,
      contributorIds?: Array< string | null > | null,
      caseContributors?: Array< string | null > | null,
      caseStartDate?: string | null,
      caseOpenDate?: string | null,
      caseSalary?: string | null,
      state?: string | null,
      sponsoringCompanyFullName?: string | null,
      keyFilingDates?: string | null,
      selection?: string | null,
      registrationCompleted?: string | null,
      lcaFiled?: string | null,
      caseNature?: string | null,
      capGap?: string | null,
      visaAdditionalProcessing?: Array< string | null > | null,
      stemExtEligible?: string | null,
      educationEvaluationNeeded?: string | null,
      wageIssues?: string | null,
      receiptNumber?: string | null,
      currentCaseStatusText?: string | null,
      modifiedDate?: string | null,
      incompleteUscisReceiptNumber?: boolean | null,
      caseStatusHistory?: string | null,
      emCompanyNames?: Array< string | null > | null,
      emCompanyNameSlugs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type ListAllReportsQueryVariables = {
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAllReportsQuery = {
  listReports?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      companyIds?: Array< string | null > | null,
      id: string,
      createdAt?: string | null,
      name: string,
      status: ReportStatus,
      templateID: string,
      updatedAt?: string | null,
      accessibleIds?: Array< string | null > | null,
      customTemplate:  {
        __typename: "CustomTemplate",
        selectedFields?: string | null,
      },
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListMyTemplatesQueryVariables = {
  filter?: ModelCustomTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMyTemplatesQuery = {
  listCustomTemplate?:  {
    __typename: "ModelCustomTemplateConnection",
    items:  Array< {
      __typename: "CustomTemplate",
      id: string,
      name: string,
      employer?:  {
        __typename: "Employer",
        firstname?: string | null,
        lastname?: string | null,
      } | null,
      teamMember?:  {
        __typename: "TeamMember",
        lastname: string,
        firstname: string,
      } | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCompanyCasesQueryVariables = {
  filter?: SearchableCompanyFilterInput | null,
  sort?: Array< SearchableCompanySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCompanyAggregationInput | null > | null,
};

export type SearchCompanyCasesQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    items:  Array< {
      __typename: "Company",
      name: string,
      displayCompanyName?: string | null,
      legalTeamIDs?: Array< string > | null,
      cases?:  {
        __typename: "ModelCaseConnection",
        items:  Array< {
          __typename: "Case",
          sponsoringEmployer?:  {
            __typename: "Employer",
            id: string,
            firstname?: string | null,
            middlename?: string | null,
            lastname?: string | null,
          } | null,
          contributors?:  {
            __typename: "ModelCaseContributorConnection",
            items:  Array< {
              __typename: "CaseContributor",
              contributorTeamMember?:  {
                __typename: "TeamMember",
                id: string,
                firstname: string,
                middlename?: string | null,
                lastname: string,
              } | null,
              contributorEmployer?:  {
                __typename: "Employer",
                id: string,
                firstname?: string | null,
                middlename?: string | null,
                lastname?: string | null,
              } | null,
            } | null >,
          } | null,
          caseManager?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            middlename?: string | null,
            lastname: string,
          } | null,
          attorney?:  {
            __typename: "TeamMember",
            id: string,
            firstname: string,
            middlename?: string | null,
            lastname: string,
          } | null,
        } | null >,
      } | null,
    } | null >,
  } | null,
};

export type CustomListEmployersQueryVariables = {
  filter?: ModelEmployerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListEmployersQuery = {
  listEmployers?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      slug: string,
      companies?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          company?:  {
            __typename: "Company",
            displayCompanyName?: string | null,
            name: string,
            id: string,
          } | null,
        } | null >,
      } | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomListTeamMembersQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyAllEmployersQueryVariables = {
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyAllEmployersQuery = {
  listCompanies?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      assignedEmployers?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          employer?:  {
            __typename: "Employer",
            firstname?: string | null,
            middlename?: string | null,
            lastname?: string | null,
            id: string,
          } | null,
        } | null >,
      } | null,
      legalTeamIDs?: Array< string > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomListSchedulersQueryVariables = {
  filter?: ModelSchedulerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomListSchedulersQuery = {
  listSchedulers?:  {
    __typename: "ModelSchedulerConnection",
    items:  Array< {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      description?: string | null,
      startDate: string,
      endDate: string,
      timeZone: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      entityID: string,
      taskDefinition?:  {
        __typename: "TaskDefinition",
        id: string,
        recipientIDs?: Array< string > | null,
        individualIDs?: Array< string | null > | null,
        companyIDs?: Array< string > | null,
      } | null,
    } | null >,
  } | null,
};

export type CustomSearchTemplatesQueryVariables = {
  filter?: SearchableCustomTemplateFilterInput | null,
  sort?: Array< SearchableCustomTemplateSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCustomTemplateAggregationInput | null > | null,
};

export type CustomSearchTemplatesQuery = {
  searchCustomTemplates?:  {
    __typename: "SearchableCustomTemplateConnection",
    items:  Array< {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      templateReports?:  {
        __typename: "ModelReportConnection",
        items:  Array< {
          __typename: "Report",
          id: string,
          status: ReportStatus,
          createdAt?: string | null,
        } | null >,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type CustomSearchCompaniesQueryVariables = {
  filter?: SearchableCompanyFilterInput | null,
  sort?: Array< SearchableCompanySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCompanyAggregationInput | null > | null,
};

export type CustomSearchCompaniesQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      legalTeamIDs?: Array< string > | null,
      companyDataId?: string | null,
      data?:  {
        __typename: "CompanyData",
        doingBusinessAs?: string | null,
      } | null,
      logo?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        thumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type SearchCustomEmployersQueryVariables = {
  filter?: SearchableEmployerFilterInput | null,
  sort?: Array< SearchableEmployerSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableEmployerAggregationInput | null > | null,
};

export type SearchCustomEmployersQuery = {
  searchEmployers?:  {
    __typename: "SearchableEmployerConnection",
    total?: number | null,
    nextToken?: string | null,
    items:  Array< {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      middlename?: string | null,
      slug: string,
      companies?:  {
        __typename: "ModelEmployerAssignmentConnection",
        items:  Array< {
          __typename: "EmployerAssignment",
          company?:  {
            __typename: "Company",
            displayCompanyName?: string | null,
            name: string,
            id: string,
          } | null,
        } | null >,
      } | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type CustomSearchTeamMembersQueryVariables = {
  filter?: SearchableTeamMemberFilterInput | null,
  sort?: Array< SearchableTeamMemberSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTeamMemberAggregationInput | null > | null,
};

export type CustomSearchTeamMembersQuery = {
  searchTeamMembers?:  {
    __typename: "SearchableTeamMemberConnection",
    total?: number | null,
    nextToken?: string | null,
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      middlename?: string | null,
      slug: string,
      position?: Position | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        square?:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        } | null,
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
          size: number,
        } > | null,
        version: number,
      } | null,
    } | null >,
  } | null,
};

export type CustomGetForeignNationalQueryVariables = {
  id: string,
};

export type CustomGetForeignNationalQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    nickname?: string | null,
    employeeId?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    companyNationalNumber?: number | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    immigrationVisaStatus?: string | null,
    visaExpiration?: string | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      priorityDate?: string | null,
      petitionerI140?: string | null,
    } | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthCity?: string | null,
    birthDate?: string | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nivMaxout?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    fileRequirementsManipulated?: string | null,
    test?: string | null,
    notes?: string | null,
    companyName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    visaExpDate?: string | null,
    chargeabilityCountry?: CountryCode | null,
    birthCountryCode?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    startDate?: string | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomSearchSchedulersQueryVariables = {
  filter?: SearchableSchedulerFilterInput | null,
  sort?: Array< SearchableSchedulerSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSchedulerAggregationInput | null > | null,
};

export type CustomSearchSchedulersQuery = {
  searchSchedulers?:  {
    __typename: "SearchableSchedulerConnection",
    items:  Array< {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      description?: string | null,
      startDate: string,
      endDate: string,
      timeZone: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      entityID: string,
      taskDefinition?:  {
        __typename: "TaskDefinition",
        id: string,
        recipientIDs?: Array< string > | null,
        individualIDs?: Array< string | null > | null,
        companyIDs?: Array< string > | null,
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type GetReportStatusQueryVariables = {
  id: string,
};

export type GetReportStatusQuery = {
  getReports?:  {
    __typename: "Report",
    id: string,
    status: ReportStatus,
  } | null,
};

export type CustomGetCaseRfgpQueryVariables = {
  id: string,
};

export type CustomGetCaseRfgpQuery = {
  getCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      isFlattened?: boolean | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
      uploadDate: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomCreateCaseRfgpMutationVariables = {
  input: CreateCaseRfgpInput,
};

export type CustomCreateCaseRfgpMutation = {
  createCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      isFlattened?: boolean | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
      uploadDate: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomUpdateCaseRfgpMutationVariables = {
  input: UpdateCaseRfgpInput,
  condition?: ModelCaseRfgpConditionInput | null,
};

export type CustomUpdateCaseRfgpMutation = {
  updateCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      isFlattened?: boolean | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
      uploadDate: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type SidebarSearchForeignNationalsQueryVariables = {
  filter?: SearchableForeignNationalFilterInput | null,
  sort?: Array< SearchableForeignNationalSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SidebarSearchForeignNationalsQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      lowerFull: string,
      slug: string,
      email?: string | null,
      company?:  {
        __typename: "Company",
        name: string,
        displayCompanyName?: string | null,
      } | null,
      immigrationStatus?:  {
        __typename: "ImmigrationStatus",
        status?: VisaStatus | null,
        expiration?: string | null,
      } | null,
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        square?:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        } | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SidebarSearchEmployersQueryVariables = {
  filter?: SearchableEmployerFilterInput | null,
  sort?: Array< SearchableEmployerSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SidebarSearchEmployersQuery = {
  searchEmployers?:  {
    __typename: "SearchableEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      title?: string | null,
      slug: string,
      email?: string | null,
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        square?:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        } | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SidebarSearchTeamMembersQueryVariables = {
  filter?: SearchableTeamMemberFilterInput | null,
  sort?: Array< SearchableTeamMemberSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SidebarSearchTeamMembersQuery = {
  searchTeamMembers?:  {
    __typename: "SearchableTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      title?: string | null,
      slug: string,
      email?: string | null,
      avatar?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        square?:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        } | null,
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type SidebarSearchCompaniesQueryVariables = {
  filter?: SearchableCompanyFilterInput | null,
  sort?: Array< SearchableCompanySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
};

export type SidebarSearchCompaniesQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      slug: string,
      logo?:  {
        __typename: "Picture",
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        thumbnails?:  Array< {
          __typename: "Thumbnail",
          size: number,
          image:  {
            __typename: "S3Object",
            bucket: string,
            identityId?: string | null,
            key: string,
            level?: S3Level | null,
            region: string,
          },
        } > | null,
        original:  {
          __typename: "S3Object",
          region: string,
          level?: S3Level | null,
          key: string,
          identityId?: string | null,
          bucket: string,
        },
      } | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
  } | null,
};

export type CustomSearchTasksQueryVariables = {
  filter?: SearchableTaskFilterInput | null,
  sort?: Array< SearchableTaskSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTaskAggregationInput | null > | null,
};

export type CustomSearchTasksQuery = {
  searchTasks?:  {
    __typename: "SearchableTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      action: string,
      description?: string | null,
      orderIndex?: number | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      prerequisite?:  {
        __typename: "Task",
        action: string,
        category: TaskCategory,
      } | null,
      dependencies?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          id: string,
          caseState?: CaseState | null,
          state: TaskState,
          deadline: string,
          orderIndex?: number | null,
          duration?: number | null,
          templateID?: string | null,
          startDate: string,
          prerequisiteID?: string | null,
          action: string,
          completeDate?: string | null,
        } | null >,
      } | null,
      assignedToEmployer?:  {
        __typename: "Employer",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      assignedToTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        position?: Position | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      assignedToForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      caseID: string,
      caseState?: CaseState | null,
      case:  {
        __typename: "Case",
        id: string,
        slug: string,
        requestedProcess?: VisaStatus | null,
        attorneyID?: string | null,
        caseManagerID?: string | null,
        companyID?: string | null,
        state: CaseState,
        foreignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        tasks?:  {
          __typename: "ModelTaskConnection",
          items:  Array< {
            __typename: "Task",
            action: string,
            category: TaskCategory,
            state: TaskState,
          } | null >,
        } | null,
        contributors?:  {
          __typename: "ModelCaseContributorConnection",
          items:  Array< {
            __typename: "CaseContributor",
            id: string,
            contributorID: string,
            contributorEmployer?:  {
              __typename: "Employer",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorForeignNational?:  {
              __typename: "ForeignNational",
              id: string,
              type: PersonType,
              firstname?: string | null,
              lastname?: string | null,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
            contributorTeamMember?:  {
              __typename: "TeamMember",
              id: string,
              type: PersonType,
              firstname: string,
              lastname: string,
              slug: string,
              avatar?:  {
                __typename: "Picture",
                original:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                squareThumbnails?:  Array< {
                  __typename: "Thumbnail",
                  image:  {
                    __typename: "S3Object",
                    bucket: string,
                    key: string,
                    level?: S3Level | null,
                    region: string,
                    identityId?: string | null,
                  },
                  size: number,
                } > | null,
                version: number,
              } | null,
            } | null,
          } | null >,
        } | null,
      },
      category: TaskCategory,
      companyID?: string | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        displayCompanyName?: string | null,
        slug: string,
      } | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      duration?: number | null,
      groupsCanRead?: Array< string > | null,
      foreignNationalID: string,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
    } | null >,
  } | null,
};

export type CustomOnUpdateTaskSubscriptionVariables = {
  id: string,
};

export type CustomOnUpdateTaskSubscription = {
  onUpdateTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    description?: string | null,
    orderIndex?: number | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      action: string,
      category: TaskCategory,
    } | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        state: TaskState,
        caseState?: CaseState | null,
        deadline: string,
        duration?: number | null,
        orderIndex?: number | null,
        templateID?: string | null,
        startDate: string,
        prerequisiteID?: string | null,
        action: string,
        completeDate?: string | null,
      } | null >,
    } | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      position?: Position | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    caseID: string,
    caseState?: CaseState | null,
    case:  {
      __typename: "Case",
      id: string,
      slug: string,
      requestedProcess?: VisaStatus | null,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      companyID?: string | null,
      state: CaseState,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          action: string,
          category: TaskCategory,
          caseState?: CaseState | null,
          state: TaskState,
          orderIndex?: number | null,
        } | null >,
      } | null,
      contributors?:  {
        __typename: "ModelCaseContributorConnection",
        items:  Array< {
          __typename: "CaseContributor",
          id: string,
          contributorID: string,
          contributorEmployer?:  {
            __typename: "Employer",
            id: string,
            type: PersonType,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          contributorForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            type: PersonType,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          contributorTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            type: PersonType,
            firstname: string,
            lastname: string,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
        } | null >,
      } | null,
    },
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      slug: string,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    duration?: number | null,
    groupsCanRead?: Array< string > | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      slug: string,
      firstname?: string | null,
      lastname?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CustomOnUpdateTaskByCaseIdSubscriptionVariables = {
  caseID: string,
};

export type CustomOnUpdateTaskByCaseIdSubscription = {
  onUpdateTaskByCaseID?:  {
    __typename: "Task",
    id: string,
    action: string,
    description?: string | null,
    orderIndex?: number | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    isKeyDate?: boolean | null,
    isPaymentStatus?: boolean | null,
    keyDateAlternateAction?: string | null,
    paymentStatusAlternateAction?: string | null,
    prerequisite?:  {
      __typename: "Task",
      action: string,
      category: TaskCategory,
    } | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      items:  Array< {
        __typename: "Task",
        id: string,
        state: TaskState,
        caseState?: CaseState | null,
        deadline: string,
        duration?: number | null,
        templateID?: string | null,
        startDate: string,
        prerequisiteID?: string | null,
        action: string,
        completeDate?: string | null,
        orderIndex?: number | null,
      } | null >,
    } | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      position?: Position | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    caseID: string,
    caseState?: CaseState | null,
    case:  {
      __typename: "Case",
      id: string,
      slug: string,
      requestedProcess?: VisaStatus | null,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      companyID?: string | null,
      foreignNational?:  {
        __typename: "ForeignNational",
        id: string,
        slug: string,
        firstname?: string | null,
        lastname?: string | null,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      tasks?:  {
        __typename: "ModelTaskConnection",
        items:  Array< {
          __typename: "Task",
          action: string,
          category: TaskCategory,
          state: TaskState,
          caseState?: CaseState | null,
          orderIndex?: number | null,
        } | null >,
      } | null,
      contributors?:  {
        __typename: "ModelCaseContributorConnection",
        items:  Array< {
          __typename: "CaseContributor",
          id: string,
          contributorID: string,
          contributorEmployer?:  {
            __typename: "Employer",
            id: string,
            type: PersonType,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          contributorForeignNational?:  {
            __typename: "ForeignNational",
            id: string,
            type: PersonType,
            firstname?: string | null,
            lastname?: string | null,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
          contributorTeamMember?:  {
            __typename: "TeamMember",
            id: string,
            type: PersonType,
            firstname: string,
            lastname: string,
            slug: string,
            avatar?:  {
              __typename: "Picture",
              original:  {
                __typename: "S3Object",
                bucket: string,
                key: string,
                level?: S3Level | null,
                region: string,
                identityId?: string | null,
              },
              squareThumbnails?:  Array< {
                __typename: "Thumbnail",
                image:  {
                  __typename: "S3Object",
                  bucket: string,
                  key: string,
                  level?: S3Level | null,
                  region: string,
                  identityId?: string | null,
                },
                size: number,
              } > | null,
              version: number,
            } | null,
          } | null,
        } | null >,
      } | null,
    },
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      displayCompanyName?: string | null,
      slug: string,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    duration?: number | null,
    groupsCanRead?: Array< string > | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      slug: string,
      firstname?: string | null,
      lastname?: string | null,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTeamMembersAndCompanyEmployersQueryVariables = {
  companyID?: string | null,
};

export type ListTeamMembersAndCompanyEmployersQuery = {
  searchEmployers?:  {
    __typename: "SearchableEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      type: PersonType,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null >,
  } | null,
  searchTeamMembers?:  {
    __typename: "SearchableTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      type: PersonType,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null >,
  } | null,
};

export type CreatePreparedFormMutationVariables = {
  input: CreatePreparedFormInput,
  condition?: ModelPreparedFormConditionInput | null,
};

export type CreatePreparedFormMutation = {
  createPreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    companyID?: string | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    templateID?: string | null,
    template?:  {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } | null,
    completedFormID?: string | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedDate?: string | null,
    rejectedByID?: string | null,
    rejectedByEmployerID?: string | null,
    rejectedByNationalID?: string | null,
    rejectedByTeamMemberID?: string | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApproverID?: string | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    attorneyApprovalDate?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApproverID?: string | null,
    sponsorApproverEmployerID?: string | null,
    sponsorApproverNationalID?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApprovalDate?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApproverID?: string | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nationalApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdatePreparedFormMutationVariables = {
  input: UpdatePreparedFormInput,
  condition?: ModelPreparedFormConditionInput | null,
};

export type UpdatePreparedFormMutation = {
  updatePreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    companyID?: string | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    templateID?: string | null,
    template?:  {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } | null,
    completedFormID?: string | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedDate?: string | null,
    rejectedByID?: string | null,
    rejectedByEmployerID?: string | null,
    rejectedByNationalID?: string | null,
    rejectedByTeamMemberID?: string | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApproverID?: string | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    attorneyApprovalDate?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApproverID?: string | null,
    sponsorApproverEmployerID?: string | null,
    sponsorApproverNationalID?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApprovalDate?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApproverID?: string | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nationalApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeletePreparedFormMutationVariables = {
  input: DeletePreparedFormInput,
  condition?: ModelPreparedFormConditionInput | null,
};

export type DeletePreparedFormMutation = {
  deletePreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    companyID?: string | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    templateID?: string | null,
    template?:  {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } | null,
    completedFormID?: string | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedDate?: string | null,
    rejectedByID?: string | null,
    rejectedByEmployerID?: string | null,
    rejectedByNationalID?: string | null,
    rejectedByTeamMemberID?: string | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApproverID?: string | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    attorneyApprovalDate?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApproverID?: string | null,
    sponsorApproverEmployerID?: string | null,
    sponsorApproverNationalID?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApprovalDate?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApproverID?: string | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nationalApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateForeignNationalMutationVariables = {
  input: CreateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type CreateForeignNationalMutation = {
  createForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    nickname?: string | null,
    employeeId?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    companyNationalNumber?: number | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    immigrationVisaStatus?: string | null,
    visaExpiration?: string | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      priorityDate?: string | null,
      petitionerI140?: string | null,
    } | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthDate?: string | null,
    birthCity?: string | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nivMaxout?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportExpirationReminderSentForDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    fileRequirementsManipulated?: string | null,
    test?: string | null,
    notes?: string | null,
    companyName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    visaExpDate?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    chargeabilityCountry?: CountryCode | null,
    birthCountryCode?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    citizenshipEligibilityDate?: string | null,
    startDate?: string | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateForeignNationalMutationVariables = {
  input: UpdateForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type UpdateForeignNationalMutation = {
  updateForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    nickname?: string | null,
    employeeId?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    companyNationalNumber?: number | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    immigrationVisaStatus?: string | null,
    visaExpiration?: string | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      priorityDate?: string | null,
      petitionerI140?: string | null,
    } | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthDate?: string | null,
    birthCity?: string | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nivMaxout?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportExpirationReminderSentForDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    fileRequirementsManipulated?: string | null,
    test?: string | null,
    notes?: string | null,
    companyName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    visaExpDate?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    chargeabilityCountry?: CountryCode | null,
    birthCountryCode?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    citizenshipEligibilityDate?: string | null,
    startDate?: string | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteForeignNationalMutationVariables = {
  input: DeleteForeignNationalInput,
  condition?: ModelForeignNationalConditionInput | null,
};

export type DeleteForeignNationalMutation = {
  deleteForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    nickname?: string | null,
    employeeId?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    companyNationalNumber?: number | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    immigrationVisaStatus?: string | null,
    visaExpiration?: string | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      priorityDate?: string | null,
      petitionerI140?: string | null,
    } | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthDate?: string | null,
    birthCity?: string | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nivMaxout?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportExpirationReminderSentForDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    fileRequirementsManipulated?: string | null,
    test?: string | null,
    notes?: string | null,
    companyName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    visaExpDate?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    chargeabilityCountry?: CountryCode | null,
    birthCountryCode?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    citizenshipEligibilityDate?: string | null,
    startDate?: string | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEmployerMutationVariables = {
  input: CreateEmployerInput,
  condition?: ModelEmployerConditionInput | null,
};

export type CreateEmployerMutation = {
  createEmployer?:  {
    __typename: "Employer",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    personalEmail?: string | null,
    newsletterModalViewCount?: number | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    personalPhone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanies?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContactCompanies?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContactCompanies?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    recentlyViewedCases?: Array< string > | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanyIDs?: Array< string > | null,
    isInvoicingContact?: boolean | null,
    primaryContactCompanyIDs?: Array< string > | null,
    isPrimaryContact?: boolean | null,
    seniorContactCompanyIDs?: Array< string > | null,
    isSeniorContact?: boolean | null,
    signatoryContactCompanyIDs?: Array< string > | null,
    isSignatoryContact?: boolean | null,
    assignedCaseIDs?: Array< string > | null,
    nationalsWithOpenCases?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEmployerMutationVariables = {
  input: UpdateEmployerInput,
  condition?: ModelEmployerConditionInput | null,
};

export type UpdateEmployerMutation = {
  updateEmployer?:  {
    __typename: "Employer",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    personalEmail?: string | null,
    newsletterModalViewCount?: number | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    personalPhone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanies?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContactCompanies?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContactCompanies?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    recentlyViewedCases?: Array< string > | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanyIDs?: Array< string > | null,
    isInvoicingContact?: boolean | null,
    primaryContactCompanyIDs?: Array< string > | null,
    isPrimaryContact?: boolean | null,
    seniorContactCompanyIDs?: Array< string > | null,
    isSeniorContact?: boolean | null,
    signatoryContactCompanyIDs?: Array< string > | null,
    isSignatoryContact?: boolean | null,
    assignedCaseIDs?: Array< string > | null,
    nationalsWithOpenCases?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEmployerMutationVariables = {
  input: DeleteEmployerInput,
  condition?: ModelEmployerConditionInput | null,
};

export type DeleteEmployerMutation = {
  deleteEmployer?:  {
    __typename: "Employer",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    personalEmail?: string | null,
    newsletterModalViewCount?: number | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    personalPhone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanies?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContactCompanies?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContactCompanies?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    recentlyViewedCases?: Array< string > | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanyIDs?: Array< string > | null,
    isInvoicingContact?: boolean | null,
    primaryContactCompanyIDs?: Array< string > | null,
    isPrimaryContact?: boolean | null,
    seniorContactCompanyIDs?: Array< string > | null,
    isSeniorContact?: boolean | null,
    signatoryContactCompanyIDs?: Array< string > | null,
    isSignatoryContact?: boolean | null,
    assignedCaseIDs?: Array< string > | null,
    nationalsWithOpenCases?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTeamMemberMutationVariables = {
  input: CreateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type CreateTeamMemberMutation = {
  createTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    managerID?: string | null,
    attorneyAssignments?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    paralegalAssignments?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerAssignments?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    attorneyCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    caseManagerCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    recentlyViewedCases?: Array< string > | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    nationalsWithOpenCases?: Array< string > | null,
    companiesAssignedTo?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTeamMemberMutationVariables = {
  input: UpdateTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type UpdateTeamMemberMutation = {
  updateTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    managerID?: string | null,
    attorneyAssignments?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    paralegalAssignments?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerAssignments?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    attorneyCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    caseManagerCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    recentlyViewedCases?: Array< string > | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    nationalsWithOpenCases?: Array< string > | null,
    companiesAssignedTo?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTeamMemberMutationVariables = {
  input: DeleteTeamMemberInput,
  condition?: ModelTeamMemberConditionInput | null,
};

export type DeleteTeamMemberMutation = {
  deleteTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    managerID?: string | null,
    attorneyAssignments?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    paralegalAssignments?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerAssignments?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    attorneyCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    caseManagerCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    recentlyViewedCases?: Array< string > | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    nationalsWithOpenCases?: Array< string > | null,
    companiesAssignedTo?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateFamilyRelationshipMutationVariables = {
  input: CreateFamilyRelationshipInput,
  condition?: ModelFamilyRelationshipConditionInput | null,
};

export type CreateFamilyRelationshipMutation = {
  createFamilyRelationship?:  {
    __typename: "FamilyRelationship",
    id: string,
    sourceID: string,
    source?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetID: string,
    target:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    type?: FamilyRelationshipType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFamilyRelationshipMutationVariables = {
  input: UpdateFamilyRelationshipInput,
  condition?: ModelFamilyRelationshipConditionInput | null,
};

export type UpdateFamilyRelationshipMutation = {
  updateFamilyRelationship?:  {
    __typename: "FamilyRelationship",
    id: string,
    sourceID: string,
    source?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetID: string,
    target:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    type?: FamilyRelationshipType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFamilyRelationshipMutationVariables = {
  input: DeleteFamilyRelationshipInput,
  condition?: ModelFamilyRelationshipConditionInput | null,
};

export type DeleteFamilyRelationshipMutation = {
  deleteFamilyRelationship?:  {
    __typename: "FamilyRelationship",
    id: string,
    sourceID: string,
    source?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetID: string,
    target:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    type?: FamilyRelationshipType | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAttorneyAssignmentMutationVariables = {
  input: CreateAttorneyAssignmentInput,
  condition?: ModelAttorneyAssignmentConditionInput | null,
};

export type CreateAttorneyAssignmentMutation = {
  createAttorneyAssignment?:  {
    __typename: "AttorneyAssignment",
    id: string,
    companyID: string,
    attorneyID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    attorney:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAttorneyAssignmentMutationVariables = {
  input: UpdateAttorneyAssignmentInput,
  condition?: ModelAttorneyAssignmentConditionInput | null,
};

export type UpdateAttorneyAssignmentMutation = {
  updateAttorneyAssignment?:  {
    __typename: "AttorneyAssignment",
    id: string,
    companyID: string,
    attorneyID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    attorney:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAttorneyAssignmentMutationVariables = {
  input: DeleteAttorneyAssignmentInput,
  condition?: ModelAttorneyAssignmentConditionInput | null,
};

export type DeleteAttorneyAssignmentMutation = {
  deleteAttorneyAssignment?:  {
    __typename: "AttorneyAssignment",
    id: string,
    companyID: string,
    attorneyID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    attorney:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateParalegalAssignmentMutationVariables = {
  input: CreateParalegalAssignmentInput,
  condition?: ModelParalegalAssignmentConditionInput | null,
};

export type CreateParalegalAssignmentMutation = {
  createParalegalAssignment?:  {
    __typename: "ParalegalAssignment",
    id: string,
    companyID: string,
    paralegalID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    paralegal:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateParalegalAssignmentMutationVariables = {
  input: UpdateParalegalAssignmentInput,
  condition?: ModelParalegalAssignmentConditionInput | null,
};

export type UpdateParalegalAssignmentMutation = {
  updateParalegalAssignment?:  {
    __typename: "ParalegalAssignment",
    id: string,
    companyID: string,
    paralegalID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    paralegal:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteParalegalAssignmentMutationVariables = {
  input: DeleteParalegalAssignmentInput,
  condition?: ModelParalegalAssignmentConditionInput | null,
};

export type DeleteParalegalAssignmentMutation = {
  deleteParalegalAssignment?:  {
    __typename: "ParalegalAssignment",
    id: string,
    companyID: string,
    paralegalID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    paralegal:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEmployerAssignmentMutationVariables = {
  input: CreateEmployerAssignmentInput,
  condition?: ModelEmployerAssignmentConditionInput | null,
};

export type CreateEmployerAssignmentMutation = {
  createEmployerAssignment?:  {
    __typename: "EmployerAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEmployerAssignmentMutationVariables = {
  input: UpdateEmployerAssignmentInput,
  condition?: ModelEmployerAssignmentConditionInput | null,
};

export type UpdateEmployerAssignmentMutation = {
  updateEmployerAssignment?:  {
    __typename: "EmployerAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEmployerAssignmentMutationVariables = {
  input: DeleteEmployerAssignmentInput,
  condition?: ModelEmployerAssignmentConditionInput | null,
};

export type DeleteEmployerAssignmentMutation = {
  deleteEmployerAssignment?:  {
    __typename: "EmployerAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEmployerAdminAssignmentMutationVariables = {
  input: CreateEmployerAdminAssignmentInput,
  condition?: ModelEmployerAdminAssignmentConditionInput | null,
};

export type CreateEmployerAdminAssignmentMutation = {
  createEmployerAdminAssignment?:  {
    __typename: "EmployerAdminAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEmployerAdminAssignmentMutationVariables = {
  input: UpdateEmployerAdminAssignmentInput,
  condition?: ModelEmployerAdminAssignmentConditionInput | null,
};

export type UpdateEmployerAdminAssignmentMutation = {
  updateEmployerAdminAssignment?:  {
    __typename: "EmployerAdminAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEmployerAdminAssignmentMutationVariables = {
  input: DeleteEmployerAdminAssignmentInput,
  condition?: ModelEmployerAdminAssignmentConditionInput | null,
};

export type DeleteEmployerAdminAssignmentMutation = {
  deleteEmployerAdminAssignment?:  {
    __typename: "EmployerAdminAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrimaryContactMutationVariables = {
  input: CreatePrimaryContactInput,
  condition?: ModelPrimaryContactConditionInput | null,
};

export type CreatePrimaryContactMutation = {
  createPrimaryContact?:  {
    __typename: "PrimaryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrimaryContactMutationVariables = {
  input: UpdatePrimaryContactInput,
  condition?: ModelPrimaryContactConditionInput | null,
};

export type UpdatePrimaryContactMutation = {
  updatePrimaryContact?:  {
    __typename: "PrimaryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrimaryContactMutationVariables = {
  input: DeletePrimaryContactInput,
  condition?: ModelPrimaryContactConditionInput | null,
};

export type DeletePrimaryContactMutation = {
  deletePrimaryContact?:  {
    __typename: "PrimaryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSeniorContactMutationVariables = {
  input: CreateSeniorContactInput,
  condition?: ModelSeniorContactConditionInput | null,
};

export type CreateSeniorContactMutation = {
  createSeniorContact?:  {
    __typename: "SeniorContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSeniorContactMutationVariables = {
  input: UpdateSeniorContactInput,
  condition?: ModelSeniorContactConditionInput | null,
};

export type UpdateSeniorContactMutation = {
  updateSeniorContact?:  {
    __typename: "SeniorContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSeniorContactMutationVariables = {
  input: DeleteSeniorContactInput,
  condition?: ModelSeniorContactConditionInput | null,
};

export type DeleteSeniorContactMutation = {
  deleteSeniorContact?:  {
    __typename: "SeniorContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInvoicingContactMutationVariables = {
  input: CreateInvoicingContactInput,
  condition?: ModelInvoicingContactConditionInput | null,
};

export type CreateInvoicingContactMutation = {
  createInvoicingContact?:  {
    __typename: "InvoicingContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInvoicingContactMutationVariables = {
  input: UpdateInvoicingContactInput,
  condition?: ModelInvoicingContactConditionInput | null,
};

export type UpdateInvoicingContactMutation = {
  updateInvoicingContact?:  {
    __typename: "InvoicingContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInvoicingContactMutationVariables = {
  input: DeleteInvoicingContactInput,
  condition?: ModelInvoicingContactConditionInput | null,
};

export type DeleteInvoicingContactMutation = {
  deleteInvoicingContact?:  {
    __typename: "InvoicingContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSignatoryContactMutationVariables = {
  input: CreateSignatoryContactInput,
  condition?: ModelSignatoryContactConditionInput | null,
};

export type CreateSignatoryContactMutation = {
  createSignatoryContact?:  {
    __typename: "SignatoryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSignatoryContactMutationVariables = {
  input: UpdateSignatoryContactInput,
  condition?: ModelSignatoryContactConditionInput | null,
};

export type UpdateSignatoryContactMutation = {
  updateSignatoryContact?:  {
    __typename: "SignatoryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSignatoryContactMutationVariables = {
  input: DeleteSignatoryContactInput,
  condition?: ModelSignatoryContactConditionInput | null,
};

export type DeleteSignatoryContactMutation = {
  deleteSignatoryContact?:  {
    __typename: "SignatoryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCompanyMutationVariables = {
  input: CreateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type CreateCompanyMutation = {
  createCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    displayCompanyName?: string | null,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    completedOnboardingQuestionsBy?: string | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type UpdateCompanyMutationVariables = {
  input: UpdateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type UpdateCompanyMutation = {
  updateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    displayCompanyName?: string | null,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    completedOnboardingQuestionsBy?: string | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type DeleteCompanyMutationVariables = {
  input: DeleteCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type DeleteCompanyMutation = {
  deleteCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    displayCompanyName?: string | null,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    completedOnboardingQuestionsBy?: string | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type CreateFirmMutationVariables = {
  input: CreateFirmInput,
  condition?: ModelFirmConditionInput | null,
};

export type CreateFirmMutation = {
  createFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFirmMutationVariables = {
  input: UpdateFirmInput,
  condition?: ModelFirmConditionInput | null,
};

export type UpdateFirmMutation = {
  updateFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFirmMutationVariables = {
  input: DeleteFirmInput,
  condition?: ModelFirmConditionInput | null,
};

export type DeleteFirmMutation = {
  deleteFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCompanyDataMutationVariables = {
  input: CreateCompanyDataInput,
  condition?: ModelCompanyDataConditionInput | null,
};

export type CreateCompanyDataMutation = {
  createCompanyData?:  {
    __typename: "CompanyData",
    id: string,
    companyID?: string | null,
    addressPrimary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    addressSecondary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    allowsEmployeesToTelecommute?:  {
      __typename: "BooleanThreePart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
      followPromptSecond?: string | null,
      followValueSecond?: boolean | null,
    } | null,
    preferredMailingAddress?: CompanyAddressType | null,
    companyNameShowToFN?: CompanyNameShowToFN | null,
    companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
    doingBusinessAs?: string | null,
    educationEvaluation?: EducationEvaluation | null,
    employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
    fein?: string | null,
    fullTimeEmployeesInUS?: number | null,
    grossRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isH1BDependentEmloyer?: boolean | null,
    hasBeenWillfulViolator?: boolean | null,
    employs50OrMore?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    isHigherEd_20_USC_1001_a?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
    maintainsAWrittenImmigrationPolicy?: boolean | null,
    naicsCodeOfCompany?: string | null,
    netRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    partTimeEmployeesInUS?: number | null,
    paymentPreference?: PaymentPreference | null,
    permissionPowerAttorney?: CompanyEmployee | null,
    permissionReleaseApprovalNotices?: boolean | null,
    permissionReleasePetitionsRFE?: boolean | null,
    permissionReleaseLCA?: boolean | null,
    permissionRelease9089?: boolean | null,
    phone?: string | null,
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
    preferenceForEmployeesToPayPartOfGreenCard?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    preferenceForEmployeesToPayPartOfH1B?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    fax?: string | null,
    preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
    shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
    shippingPreference?:  {
      __typename: "ShippingPreference",
      preference?: ShippingPaymentPreference | null,
      fedexAccount?: string | null,
      upsAccount?: string | null,
    } | null,
    staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
    typeOfBusiness?: string | null,
    usesWageSurvey?: boolean | null,
    usesApplicantTrackingSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesHRSSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesEVerify?: boolean | null,
    utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
    technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
    yearCompanyWasFoundedInUS?: string | null,
    I9_audit_has_been_completed_in_past_18_months?: boolean | null,
    current_number_of_H1B_employees?: string | null,
    current_number_of_employees_on_L_visas?: string | null,
    other_visa_statuses_sponsored?: string | null,
    email_address_invoices_should_be_addressed_to?: string | null,
    name_invoices_should_be_addressed_to?: string | null,
    companyCoversExpenseOfDependentPetitions?: boolean | null,
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
    annualMeetingDate?: string | null,
    requiresMeetingReminder?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyDataMutationVariables = {
  input: UpdateCompanyDataInput,
  condition?: ModelCompanyDataConditionInput | null,
};

export type UpdateCompanyDataMutation = {
  updateCompanyData?:  {
    __typename: "CompanyData",
    id: string,
    companyID?: string | null,
    addressPrimary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    addressSecondary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    allowsEmployeesToTelecommute?:  {
      __typename: "BooleanThreePart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
      followPromptSecond?: string | null,
      followValueSecond?: boolean | null,
    } | null,
    preferredMailingAddress?: CompanyAddressType | null,
    companyNameShowToFN?: CompanyNameShowToFN | null,
    companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
    doingBusinessAs?: string | null,
    educationEvaluation?: EducationEvaluation | null,
    employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
    fein?: string | null,
    fullTimeEmployeesInUS?: number | null,
    grossRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isH1BDependentEmloyer?: boolean | null,
    hasBeenWillfulViolator?: boolean | null,
    employs50OrMore?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    isHigherEd_20_USC_1001_a?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
    maintainsAWrittenImmigrationPolicy?: boolean | null,
    naicsCodeOfCompany?: string | null,
    netRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    partTimeEmployeesInUS?: number | null,
    paymentPreference?: PaymentPreference | null,
    permissionPowerAttorney?: CompanyEmployee | null,
    permissionReleaseApprovalNotices?: boolean | null,
    permissionReleasePetitionsRFE?: boolean | null,
    permissionReleaseLCA?: boolean | null,
    permissionRelease9089?: boolean | null,
    phone?: string | null,
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
    preferenceForEmployeesToPayPartOfGreenCard?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    preferenceForEmployeesToPayPartOfH1B?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    fax?: string | null,
    preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
    shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
    shippingPreference?:  {
      __typename: "ShippingPreference",
      preference?: ShippingPaymentPreference | null,
      fedexAccount?: string | null,
      upsAccount?: string | null,
    } | null,
    staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
    typeOfBusiness?: string | null,
    usesWageSurvey?: boolean | null,
    usesApplicantTrackingSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesHRSSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesEVerify?: boolean | null,
    utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
    technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
    yearCompanyWasFoundedInUS?: string | null,
    I9_audit_has_been_completed_in_past_18_months?: boolean | null,
    current_number_of_H1B_employees?: string | null,
    current_number_of_employees_on_L_visas?: string | null,
    other_visa_statuses_sponsored?: string | null,
    email_address_invoices_should_be_addressed_to?: string | null,
    name_invoices_should_be_addressed_to?: string | null,
    companyCoversExpenseOfDependentPetitions?: boolean | null,
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
    annualMeetingDate?: string | null,
    requiresMeetingReminder?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyDataMutationVariables = {
  input: DeleteCompanyDataInput,
  condition?: ModelCompanyDataConditionInput | null,
};

export type DeleteCompanyDataMutation = {
  deleteCompanyData?:  {
    __typename: "CompanyData",
    id: string,
    companyID?: string | null,
    addressPrimary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    addressSecondary?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    allowsEmployeesToTelecommute?:  {
      __typename: "BooleanThreePart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
      followPromptSecond?: string | null,
      followValueSecond?: boolean | null,
    } | null,
    preferredMailingAddress?: CompanyAddressType | null,
    companyNameShowToFN?: CompanyNameShowToFN | null,
    companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
    doingBusinessAs?: string | null,
    educationEvaluation?: EducationEvaluation | null,
    employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
    fein?: string | null,
    fullTimeEmployeesInUS?: number | null,
    grossRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isH1BDependentEmloyer?: boolean | null,
    hasBeenWillfulViolator?: boolean | null,
    employs50OrMore?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    isHigherEd_20_USC_1001_a?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
    isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
    isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
    isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
    maintainsAWrittenImmigrationPolicy?: boolean | null,
    naicsCodeOfCompany?: string | null,
    netRevenueForMostRecentFiscalYear?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    partTimeEmployeesInUS?: number | null,
    paymentPreference?: PaymentPreference | null,
    permissionPowerAttorney?: CompanyEmployee | null,
    permissionReleaseApprovalNotices?: boolean | null,
    permissionReleasePetitionsRFE?: boolean | null,
    permissionReleaseLCA?: boolean | null,
    permissionRelease9089?: boolean | null,
    phone?: string | null,
    placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
    preferenceForEmployeesToPayPartOfGreenCard?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    preferenceForEmployeesToPayPartOfH1B?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    fax?: string | null,
    preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
    shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
    shippingPreference?:  {
      __typename: "ShippingPreference",
      preference?: ShippingPaymentPreference | null,
      fedexAccount?: string | null,
      upsAccount?: string | null,
    } | null,
    staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
    typeOfBusiness?: string | null,
    usesWageSurvey?: boolean | null,
    usesApplicantTrackingSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesHRSSystem?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    usesEVerify?: boolean | null,
    utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
    technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
    yearCompanyWasFoundedInUS?: string | null,
    I9_audit_has_been_completed_in_past_18_months?: boolean | null,
    current_number_of_H1B_employees?: string | null,
    current_number_of_employees_on_L_visas?: string | null,
    other_visa_statuses_sponsored?: string | null,
    email_address_invoices_should_be_addressed_to?: string | null,
    name_invoices_should_be_addressed_to?: string | null,
    companyCoversExpenseOfDependentPetitions?: boolean | null,
    placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
    annualMeetingDate?: string | null,
    requiresMeetingReminder?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateJobDescriptionMutationVariables = {
  input: CreateJobDescriptionInput,
  condition?: ModelJobDescriptionConditionInput | null,
};

export type CreateJobDescriptionMutation = {
  createJobDescription?:  {
    __typename: "JobDescription",
    companyID?: string | null,
    id: string,
    archived: ArchivedState,
    type: JobDescriptionType,
    foreignNationalID?: string | null,
    title: string,
    officialTitle?: string | null,
    degrees?: Array< Degree > | null,
    requiresBachelors?: boolean | null,
    requiresMasters?: boolean | null,
    requiresPhd?: boolean | null,
    dotNumber?: string | null,
    caseSocCode?: string | null,
    duties?: string | null,
    jobURL?: string | null,
    majors?: string | null,
    specialRequirements?: string | null,
    yearsGeneralExperience?: number | null,
    objectiveSkillSetsRequired?: string | null,
    offeredSalary?: string | null,
    certificationLicenses?: string | null,
    travelIsRequired?: boolean | null,
    travelPercentage?: number | null,
    travelDomestic?: boolean | null,
    travelInternational?: boolean | null,
    supervisesOthers?: boolean | null,
    supervisesOthersCount?: number | null,
    supervisesTitles?: Array< string > | null,
    supervisorTitle?: string | null,
    canWorkFromHome?: boolean | null,
    uploadedDescriptionID?: string | null,
    uploadedDescription?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateJobDescriptionMutationVariables = {
  input: UpdateJobDescriptionInput,
  condition?: ModelJobDescriptionConditionInput | null,
};

export type UpdateJobDescriptionMutation = {
  updateJobDescription?:  {
    __typename: "JobDescription",
    companyID?: string | null,
    id: string,
    archived: ArchivedState,
    type: JobDescriptionType,
    foreignNationalID?: string | null,
    title: string,
    officialTitle?: string | null,
    degrees?: Array< Degree > | null,
    requiresBachelors?: boolean | null,
    requiresMasters?: boolean | null,
    requiresPhd?: boolean | null,
    dotNumber?: string | null,
    caseSocCode?: string | null,
    duties?: string | null,
    jobURL?: string | null,
    majors?: string | null,
    specialRequirements?: string | null,
    yearsGeneralExperience?: number | null,
    objectiveSkillSetsRequired?: string | null,
    offeredSalary?: string | null,
    certificationLicenses?: string | null,
    travelIsRequired?: boolean | null,
    travelPercentage?: number | null,
    travelDomestic?: boolean | null,
    travelInternational?: boolean | null,
    supervisesOthers?: boolean | null,
    supervisesOthersCount?: number | null,
    supervisesTitles?: Array< string > | null,
    supervisorTitle?: string | null,
    canWorkFromHome?: boolean | null,
    uploadedDescriptionID?: string | null,
    uploadedDescription?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteJobDescriptionMutationVariables = {
  input: DeleteJobDescriptionInput,
  condition?: ModelJobDescriptionConditionInput | null,
};

export type DeleteJobDescriptionMutation = {
  deleteJobDescription?:  {
    __typename: "JobDescription",
    companyID?: string | null,
    id: string,
    archived: ArchivedState,
    type: JobDescriptionType,
    foreignNationalID?: string | null,
    title: string,
    officialTitle?: string | null,
    degrees?: Array< Degree > | null,
    requiresBachelors?: boolean | null,
    requiresMasters?: boolean | null,
    requiresPhd?: boolean | null,
    dotNumber?: string | null,
    caseSocCode?: string | null,
    duties?: string | null,
    jobURL?: string | null,
    majors?: string | null,
    specialRequirements?: string | null,
    yearsGeneralExperience?: number | null,
    objectiveSkillSetsRequired?: string | null,
    offeredSalary?: string | null,
    certificationLicenses?: string | null,
    travelIsRequired?: boolean | null,
    travelPercentage?: number | null,
    travelDomestic?: boolean | null,
    travelInternational?: boolean | null,
    supervisesOthers?: boolean | null,
    supervisesOthersCount?: number | null,
    supervisesTitles?: Array< string > | null,
    supervisorTitle?: string | null,
    canWorkFromHome?: boolean | null,
    uploadedDescriptionID?: string | null,
    uploadedDescription?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProcessRequestMutationVariables = {
  input: CreateProcessRequestInput,
  condition?: ModelProcessRequestConditionInput | null,
};

export type CreateProcessRequestMutation = {
  createProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    initiatorID?: string | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestDate: string,
    approvalDate?: string | null,
    archivedDate?: string | null,
    cancelDate?: string | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    needsEmployerRevision?: boolean | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    slug: string,
    state: ProcessRequestState,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProcessRequestMutationVariables = {
  input: UpdateProcessRequestInput,
  condition?: ModelProcessRequestConditionInput | null,
};

export type UpdateProcessRequestMutation = {
  updateProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    initiatorID?: string | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestDate: string,
    approvalDate?: string | null,
    archivedDate?: string | null,
    cancelDate?: string | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    needsEmployerRevision?: boolean | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    slug: string,
    state: ProcessRequestState,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProcessRequestMutationVariables = {
  input: DeleteProcessRequestInput,
  condition?: ModelProcessRequestConditionInput | null,
};

export type DeleteProcessRequestMutation = {
  deleteProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    initiatorID?: string | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestDate: string,
    approvalDate?: string | null,
    archivedDate?: string | null,
    cancelDate?: string | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    needsEmployerRevision?: boolean | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    slug: string,
    state: ProcessRequestState,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCaseNoteMutationVariables = {
  input: CreateCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type CreateCaseNoteMutation = {
  createCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateCaseNoteMutationVariables = {
  input: UpdateCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type UpdateCaseNoteMutation = {
  updateCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteCaseNoteMutationVariables = {
  input: DeleteCaseNoteInput,
  condition?: ModelCaseNoteConditionInput | null,
};

export type DeleteCaseNoteMutation = {
  deleteCaseNote?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateCaseMutationVariables = {
  input: CreateCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type CreateCaseMutation = {
  createCase?:  {
    __typename: "Case",
    id: string,
    caseNumber?: string | null,
    slug: string,
    attorneyID?: string | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseManagerID?: string | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    complianceListID?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    PERMFilingDataID?: string | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    pinnedCaseNoteID?: string | null,
    contributorIds?: Array< string | null > | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    sponsoringEmployerID?: string | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsoringNationalID?: string | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    welcomeLetterText?: string | null,
    nationalVisaExpiration?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    sourceID: string,
    source?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    currentPhase?: CasePhase | null,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    files?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      nextToken?: string | null,
    } | null,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    USCISReceiptDetails?:  {
      __typename: "ModelUSCISReceiptDetailsConnection",
      nextToken?: string | null,
    } | null,
    AOSReceiptNotice?: string | null,
    I485JReceiptNotice?: string | null,
    SelectionNoticeNo?: string | null,
    ETACaseNumber?: string | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    additionalFieldID?: string | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      fields?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseMutationVariables = {
  input: UpdateCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type UpdateCaseMutation = {
  updateCase?:  {
    __typename: "Case",
    id: string,
    caseNumber?: string | null,
    slug: string,
    attorneyID?: string | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseManagerID?: string | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    complianceListID?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    PERMFilingDataID?: string | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    pinnedCaseNoteID?: string | null,
    contributorIds?: Array< string | null > | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    sponsoringEmployerID?: string | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsoringNationalID?: string | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    welcomeLetterText?: string | null,
    nationalVisaExpiration?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    sourceID: string,
    source?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    currentPhase?: CasePhase | null,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    files?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      nextToken?: string | null,
    } | null,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    USCISReceiptDetails?:  {
      __typename: "ModelUSCISReceiptDetailsConnection",
      nextToken?: string | null,
    } | null,
    AOSReceiptNotice?: string | null,
    I485JReceiptNotice?: string | null,
    SelectionNoticeNo?: string | null,
    ETACaseNumber?: string | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    additionalFieldID?: string | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      fields?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseMutationVariables = {
  input: DeleteCaseInput,
  condition?: ModelCaseConditionInput | null,
};

export type DeleteCaseMutation = {
  deleteCase?:  {
    __typename: "Case",
    id: string,
    caseNumber?: string | null,
    slug: string,
    attorneyID?: string | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseManagerID?: string | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    complianceListID?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    PERMFilingDataID?: string | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    pinnedCaseNoteID?: string | null,
    contributorIds?: Array< string | null > | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    sponsoringEmployerID?: string | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsoringNationalID?: string | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    welcomeLetterText?: string | null,
    nationalVisaExpiration?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    sourceID: string,
    source?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    currentPhase?: CasePhase | null,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    files?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      nextToken?: string | null,
    } | null,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    USCISReceiptDetails?:  {
      __typename: "ModelUSCISReceiptDetailsConnection",
      nextToken?: string | null,
    } | null,
    AOSReceiptNotice?: string | null,
    I485JReceiptNotice?: string | null,
    SelectionNoticeNo?: string | null,
    ETACaseNumber?: string | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    additionalFieldID?: string | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      fields?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUSCISReceiptDetailsMutationVariables = {
  input: CreateUSCISReceiptDetailsInput,
  condition?: ModelUSCISReceiptDetailsConditionInput | null,
};

export type CreateUSCISReceiptDetailsMutation = {
  createUSCISReceiptDetails?:  {
    __typename: "USCISReceiptDetails",
    id: string,
    caseID: string,
    receiptType: ReceiptType,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptNumber?: string | null,
    formType?: string | null,
    submittedDate?: string | null,
    modifiedDate?: string | null,
    currentCaseStatusText?: string | null,
    currentCaseStatusDesc?: string | null,
    histCaseStatus?:  Array< {
      __typename: "HitCaseStatus",
      date?: string | null,
      completedText?: string | null,
    } > | null,
    message?: string | null,
    isActive?: boolean | null,
    isLatest?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateUSCISReceiptDetailsMutationVariables = {
  input: UpdateUSCISReceiptDetailsInput,
  condition?: ModelUSCISReceiptDetailsConditionInput | null,
};

export type UpdateUSCISReceiptDetailsMutation = {
  updateUSCISReceiptDetails?:  {
    __typename: "USCISReceiptDetails",
    id: string,
    caseID: string,
    receiptType: ReceiptType,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptNumber?: string | null,
    formType?: string | null,
    submittedDate?: string | null,
    modifiedDate?: string | null,
    currentCaseStatusText?: string | null,
    currentCaseStatusDesc?: string | null,
    histCaseStatus?:  Array< {
      __typename: "HitCaseStatus",
      date?: string | null,
      completedText?: string | null,
    } > | null,
    message?: string | null,
    isActive?: boolean | null,
    isLatest?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteUSCISReceiptDetailsMutationVariables = {
  input: DeleteUSCISReceiptDetailsInput,
  condition?: ModelUSCISReceiptDetailsConditionInput | null,
};

export type DeleteUSCISReceiptDetailsMutation = {
  deleteUSCISReceiptDetails?:  {
    __typename: "USCISReceiptDetails",
    id: string,
    caseID: string,
    receiptType: ReceiptType,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptNumber?: string | null,
    formType?: string | null,
    submittedDate?: string | null,
    modifiedDate?: string | null,
    currentCaseStatusText?: string | null,
    currentCaseStatusDesc?: string | null,
    histCaseStatus?:  Array< {
      __typename: "HitCaseStatus",
      date?: string | null,
      completedText?: string | null,
    } > | null,
    message?: string | null,
    isActive?: boolean | null,
    isLatest?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateCaseComplianceListMutationVariables = {
  input: CreateCaseComplianceListInput,
  condition?: ModelCaseComplianceListConditionInput | null,
};

export type CreateCaseComplianceListMutation = {
  createCaseComplianceList?:  {
    __typename: "CaseComplianceList",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    educationEvaluationNeeded?: ComplianceCheckList | null,
    stemExtEligible?: ComplianceCheckList | null,
    capGap?: ComplianceCheckList | null,
    wageIssues?: ComplianceCheckList | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateCaseComplianceListMutationVariables = {
  input: UpdateCaseComplianceListInput,
  condition?: ModelCaseComplianceListConditionInput | null,
};

export type UpdateCaseComplianceListMutation = {
  updateCaseComplianceList?:  {
    __typename: "CaseComplianceList",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    educationEvaluationNeeded?: ComplianceCheckList | null,
    stemExtEligible?: ComplianceCheckList | null,
    capGap?: ComplianceCheckList | null,
    wageIssues?: ComplianceCheckList | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteCaseComplianceListMutationVariables = {
  input: DeleteCaseComplianceListInput,
  condition?: ModelCaseComplianceListConditionInput | null,
};

export type DeleteCaseComplianceListMutation = {
  deleteCaseComplianceList?:  {
    __typename: "CaseComplianceList",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    educationEvaluationNeeded?: ComplianceCheckList | null,
    stemExtEligible?: ComplianceCheckList | null,
    capGap?: ComplianceCheckList | null,
    wageIssues?: ComplianceCheckList | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreatePERMFilingDataMutationVariables = {
  input: CreatePERMFilingDataInput,
  condition?: ModelPERMFilingDataConditionInput | null,
};

export type CreatePERMFilingDataMutation = {
  createPERMFilingData?:  {
    __typename: "PERMFilingData",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    PERMFirstPossibleFilingDate?: string | null,
    PERMLastPossibleFilingDate?: string | null,
    applicantsReceived?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdatePERMFilingDataMutationVariables = {
  input: UpdatePERMFilingDataInput,
  condition?: ModelPERMFilingDataConditionInput | null,
};

export type UpdatePERMFilingDataMutation = {
  updatePERMFilingData?:  {
    __typename: "PERMFilingData",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    PERMFirstPossibleFilingDate?: string | null,
    PERMLastPossibleFilingDate?: string | null,
    applicantsReceived?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeletePERMFilingDataMutationVariables = {
  input: DeletePERMFilingDataInput,
  condition?: ModelPERMFilingDataConditionInput | null,
};

export type DeletePERMFilingDataMutation = {
  deletePERMFilingData?:  {
    __typename: "PERMFilingData",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    PERMFirstPossibleFilingDate?: string | null,
    PERMLastPossibleFilingDate?: string | null,
    applicantsReceived?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateCaseContributorMutationVariables = {
  input: CreateCaseContributorInput,
  condition?: ModelCaseContributorConditionInput | null,
};

export type CreateCaseContributorMutation = {
  createCaseContributor?:  {
    __typename: "CaseContributor",
    id: string,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    contributorID: string,
    contributorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    type: PersonType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseContributorMutationVariables = {
  input: UpdateCaseContributorInput,
  condition?: ModelCaseContributorConditionInput | null,
};

export type UpdateCaseContributorMutation = {
  updateCaseContributor?:  {
    __typename: "CaseContributor",
    id: string,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    contributorID: string,
    contributorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    type: PersonType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseContributorMutationVariables = {
  input: DeleteCaseContributorInput,
  condition?: ModelCaseContributorConditionInput | null,
};

export type DeleteCaseContributorMutation = {
  deleteCaseContributor?:  {
    __typename: "CaseContributor",
    id: string,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    contributorID: string,
    contributorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    contributorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    type: PersonType,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskMutationVariables = {
  input: CreateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type CreateTaskMutation = {
  createTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type UpdateTaskMutationVariables = {
  input: UpdateTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type UpdateTaskMutation = {
  updateTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type DeleteTaskMutationVariables = {
  input: DeleteTaskInput,
  condition?: ModelTaskConditionInput | null,
};

export type DeleteTaskMutation = {
  deleteTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type CreateTaskTemplateMutationVariables = {
  input: CreateTaskTemplateInput,
  condition?: ModelTaskTemplateConditionInput | null,
};

export type CreateTaskTemplateMutation = {
  createTaskTemplate?:  {
    __typename: "TaskTemplate",
    id: string,
    defaultAssignee: TaskAssignmentRole,
    duration?: number | null,
    groupsCanRead?: Array< string > | null,
    lockedByDefault: boolean,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    description?: string | null,
    paymentStatusAlternateAction?: string | null,
    prerequisiteID?: string | null,
    process: VisaStatus,
    category: TaskCategory,
    hidden?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    durationFromStartDate?: boolean | null,
    orderIndex: number,
    startDate?: string | null,
    deadline?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskTemplateMutationVariables = {
  input: UpdateTaskTemplateInput,
  condition?: ModelTaskTemplateConditionInput | null,
};

export type UpdateTaskTemplateMutation = {
  updateTaskTemplate?:  {
    __typename: "TaskTemplate",
    id: string,
    defaultAssignee: TaskAssignmentRole,
    duration?: number | null,
    groupsCanRead?: Array< string > | null,
    lockedByDefault: boolean,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    description?: string | null,
    paymentStatusAlternateAction?: string | null,
    prerequisiteID?: string | null,
    process: VisaStatus,
    category: TaskCategory,
    hidden?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    durationFromStartDate?: boolean | null,
    orderIndex: number,
    startDate?: string | null,
    deadline?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskTemplateMutationVariables = {
  input: DeleteTaskTemplateInput,
  condition?: ModelTaskTemplateConditionInput | null,
};

export type DeleteTaskTemplateMutation = {
  deleteTaskTemplate?:  {
    __typename: "TaskTemplate",
    id: string,
    defaultAssignee: TaskAssignmentRole,
    duration?: number | null,
    groupsCanRead?: Array< string > | null,
    lockedByDefault: boolean,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    description?: string | null,
    paymentStatusAlternateAction?: string | null,
    prerequisiteID?: string | null,
    process: VisaStatus,
    category: TaskCategory,
    hidden?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    durationFromStartDate?: boolean | null,
    orderIndex: number,
    startDate?: string | null,
    deadline?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCommentMutationVariables = {
  input: CreateCommentInput,
  condition?: ModelCommentConditionInput | null,
};

export type CreateCommentMutation = {
  createComment?:  {
    __typename: "Comment",
    createdAt?: string | null,
    authorID: string,
    authorEmployerID?: string | null,
    authorForeignNationalID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    note?: string | null,
    sourceID: string,
    id: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateCommentMutationVariables = {
  input: UpdateCommentInput,
  condition?: ModelCommentConditionInput | null,
};

export type UpdateCommentMutation = {
  updateComment?:  {
    __typename: "Comment",
    createdAt?: string | null,
    authorID: string,
    authorEmployerID?: string | null,
    authorForeignNationalID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    note?: string | null,
    sourceID: string,
    id: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteCommentMutationVariables = {
  input: DeleteCommentInput,
  condition?: ModelCommentConditionInput | null,
};

export type DeleteCommentMutation = {
  deleteComment?:  {
    __typename: "Comment",
    createdAt?: string | null,
    authorID: string,
    authorEmployerID?: string | null,
    authorForeignNationalID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    note?: string | null,
    sourceID: string,
    id: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateFileDataMutationVariables = {
  input: CreateFileDataInput,
  condition?: ModelFileDataConditionInput | null,
};

export type CreateFileDataMutation = {
  createFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    issueDate?: string | null,
    dueDate?: string | null,
    isFlattened?: boolean | null,
    processRequestID?: string | null,
    companyID?: string | null,
    ownerNationalID?: string | null,
    sourceID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    uploaderEmployerID?: string | null,
    uploaderForeignNationalID?: string | null,
    uploaderTeamMemberID?: string | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateFileDataMutationVariables = {
  input: UpdateFileDataInput,
  condition?: ModelFileDataConditionInput | null,
};

export type UpdateFileDataMutation = {
  updateFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    issueDate?: string | null,
    dueDate?: string | null,
    isFlattened?: boolean | null,
    processRequestID?: string | null,
    companyID?: string | null,
    ownerNationalID?: string | null,
    sourceID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    uploaderEmployerID?: string | null,
    uploaderForeignNationalID?: string | null,
    uploaderTeamMemberID?: string | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteFileDataMutationVariables = {
  input: DeleteFileDataInput,
  condition?: ModelFileDataConditionInput | null,
};

export type DeleteFileDataMutation = {
  deleteFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    issueDate?: string | null,
    dueDate?: string | null,
    isFlattened?: boolean | null,
    processRequestID?: string | null,
    companyID?: string | null,
    ownerNationalID?: string | null,
    sourceID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    uploaderEmployerID?: string | null,
    uploaderForeignNationalID?: string | null,
    uploaderTeamMemberID?: string | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCaseRfgpMutationVariables = {
  input: CreateCaseRfgpInput,
  condition?: ModelCaseRfgpConditionInput | null,
};

export type CreateCaseRfgpMutation = {
  createCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseRfgpMutationVariables = {
  input: UpdateCaseRfgpInput,
  condition?: ModelCaseRfgpConditionInput | null,
};

export type UpdateCaseRfgpMutation = {
  updateCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseRfgpMutationVariables = {
  input: DeleteCaseRfgpInput,
  condition?: ModelCaseRfgpConditionInput | null,
};

export type DeleteCaseRfgpMutation = {
  deleteCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCaseFileMutationVariables = {
  input: CreateCaseFileInput,
  condition?: ModelCaseFileConditionInput | null,
};

export type CreateCaseFileMutation = {
  createCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCaseFileMutationVariables = {
  input: UpdateCaseFileInput,
  condition?: ModelCaseFileConditionInput | null,
};

export type UpdateCaseFileMutation = {
  updateCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCaseFileMutationVariables = {
  input: DeleteCaseFileInput,
  condition?: ModelCaseFileConditionInput | null,
};

export type DeleteCaseFileMutation = {
  deleteCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActivityMutationVariables = {
  input: CreateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type CreateActivityMutation = {
  createActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    activityType: ActivityType,
    ipAddress?: string | null,
    fieldName?: string | null,
    updatedValue?: string | null,
    actorID: string,
    actorEmployerID?: string | null,
    actorForeignNationalID?: string | null,
    actorTeamMemberID?: string | null,
    actorType?: PersonType | null,
    actorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    directTargetID?: string | null,
    directTargetCaseID?: string | null,
    directTargetCompanyID?: string | null,
    directTargetEmployerID?: string | null,
    directTargetFileDataID?: string | null,
    directTargetForeignNationalID?: string | null,
    directTargetProcessRequestID?: string | null,
    directTargetTaskID?: string | null,
    directTargetTeamMemberID?: string | null,
    directTargetReportID?: string | null,
    targetString?: string | null,
    targetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    targetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetTask?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    targetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    indirectTargetID?: string | null,
    indirectTargetCaseID?: string | null,
    indirectTargetCompanyID?: string | null,
    indirectTargetEmployerID?: string | null,
    indirectTargetForeignNationalID?: string | null,
    indirectTargetProcessRequestID?: string | null,
    indirectTargetTeamMemberID?: string | null,
    indirectTargetReportID?: string | null,
    indirectTargetString?: string | null,
    indirectTargetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    indirectTargetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    ownerID?: string | null,
    ownerCaseID?: string | null,
    ownerCompanyID?: string | null,
    ownerEmployerID?: string | null,
    ownerFileDataID?: string | null,
    ownerForeignNationalID?: string | null,
    ownerProcessRequestID?: string | null,
    ownerTeamMemberID?: string | null,
    ownerReportID?: string | null,
    ownerCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    ownerEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
  } | null,
};

export type UpdateActivityMutationVariables = {
  input: UpdateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type UpdateActivityMutation = {
  updateActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    activityType: ActivityType,
    ipAddress?: string | null,
    fieldName?: string | null,
    updatedValue?: string | null,
    actorID: string,
    actorEmployerID?: string | null,
    actorForeignNationalID?: string | null,
    actorTeamMemberID?: string | null,
    actorType?: PersonType | null,
    actorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    directTargetID?: string | null,
    directTargetCaseID?: string | null,
    directTargetCompanyID?: string | null,
    directTargetEmployerID?: string | null,
    directTargetFileDataID?: string | null,
    directTargetForeignNationalID?: string | null,
    directTargetProcessRequestID?: string | null,
    directTargetTaskID?: string | null,
    directTargetTeamMemberID?: string | null,
    directTargetReportID?: string | null,
    targetString?: string | null,
    targetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    targetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetTask?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    targetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    indirectTargetID?: string | null,
    indirectTargetCaseID?: string | null,
    indirectTargetCompanyID?: string | null,
    indirectTargetEmployerID?: string | null,
    indirectTargetForeignNationalID?: string | null,
    indirectTargetProcessRequestID?: string | null,
    indirectTargetTeamMemberID?: string | null,
    indirectTargetReportID?: string | null,
    indirectTargetString?: string | null,
    indirectTargetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    indirectTargetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    ownerID?: string | null,
    ownerCaseID?: string | null,
    ownerCompanyID?: string | null,
    ownerEmployerID?: string | null,
    ownerFileDataID?: string | null,
    ownerForeignNationalID?: string | null,
    ownerProcessRequestID?: string | null,
    ownerTeamMemberID?: string | null,
    ownerReportID?: string | null,
    ownerCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    ownerEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
  } | null,
};

export type DeleteActivityMutationVariables = {
  input: DeleteActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type DeleteActivityMutation = {
  deleteActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    activityType: ActivityType,
    ipAddress?: string | null,
    fieldName?: string | null,
    updatedValue?: string | null,
    actorID: string,
    actorEmployerID?: string | null,
    actorForeignNationalID?: string | null,
    actorTeamMemberID?: string | null,
    actorType?: PersonType | null,
    actorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    directTargetID?: string | null,
    directTargetCaseID?: string | null,
    directTargetCompanyID?: string | null,
    directTargetEmployerID?: string | null,
    directTargetFileDataID?: string | null,
    directTargetForeignNationalID?: string | null,
    directTargetProcessRequestID?: string | null,
    directTargetTaskID?: string | null,
    directTargetTeamMemberID?: string | null,
    directTargetReportID?: string | null,
    targetString?: string | null,
    targetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    targetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetTask?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    targetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    indirectTargetID?: string | null,
    indirectTargetCaseID?: string | null,
    indirectTargetCompanyID?: string | null,
    indirectTargetEmployerID?: string | null,
    indirectTargetForeignNationalID?: string | null,
    indirectTargetProcessRequestID?: string | null,
    indirectTargetTeamMemberID?: string | null,
    indirectTargetReportID?: string | null,
    indirectTargetString?: string | null,
    indirectTargetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    indirectTargetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    ownerID?: string | null,
    ownerCaseID?: string | null,
    ownerCompanyID?: string | null,
    ownerEmployerID?: string | null,
    ownerFileDataID?: string | null,
    ownerForeignNationalID?: string | null,
    ownerProcessRequestID?: string | null,
    ownerTeamMemberID?: string | null,
    ownerReportID?: string | null,
    ownerCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    ownerEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    personID: string,
    activityID: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null,
    read: ReadState,
    personNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    personID: string,
    activityID: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null,
    read: ReadState,
    personNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type DeleteNotificationMutation = {
  deleteNotification?:  {
    __typename: "Notification",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    personID: string,
    activityID: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null,
    read: ReadState,
    personNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateAdditionalFieldsMutationVariables = {
  input: CreateAdditionalFieldsInput,
  condition?: ModelAdditionalFieldsConditionInput | null,
};

export type CreateAdditionalFieldsMutation = {
  createAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAdditionalFieldsMutationVariables = {
  input: UpdateAdditionalFieldsInput,
  condition?: ModelAdditionalFieldsConditionInput | null,
};

export type UpdateAdditionalFieldsMutation = {
  updateAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAdditionalFieldsMutationVariables = {
  input: DeleteAdditionalFieldsInput,
  condition?: ModelAdditionalFieldsConditionInput | null,
};

export type DeleteAdditionalFieldsMutation = {
  deleteAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomTemplateMutationVariables = {
  input: CreateCustomTemplateInput,
  condition?: ModelCustomTemplateConditionInput | null,
};

export type CreateCustomTemplateMutation = {
  createCustomTemplate?:  {
    __typename: "CustomTemplate",
    id: string,
    teamMemberId?: string | null,
    teamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employerID?: string | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    templateReports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    name: string,
    selectedFields?: string | null,
    includeFN?: boolean | null,
    individualFNCase?: boolean | null,
    includeCases?: boolean | null,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    type?: TemplateType | null,
    category?: TemplateCategory | null,
    isDeleted?: boolean | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    accessibleCompanyIds?: Array< string | null > | null,
    companyIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateCustomTemplateMutationVariables = {
  input: UpdateCustomTemplateInput,
  condition?: ModelCustomTemplateConditionInput | null,
};

export type UpdateCustomTemplateMutation = {
  updateCustomTemplate?:  {
    __typename: "CustomTemplate",
    id: string,
    teamMemberId?: string | null,
    teamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employerID?: string | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    templateReports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    name: string,
    selectedFields?: string | null,
    includeFN?: boolean | null,
    individualFNCase?: boolean | null,
    includeCases?: boolean | null,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    type?: TemplateType | null,
    category?: TemplateCategory | null,
    isDeleted?: boolean | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    accessibleCompanyIds?: Array< string | null > | null,
    companyIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteCustomTemplateMutationVariables = {
  input: DeleteCustomTemplateInput,
  condition?: ModelCustomTemplateConditionInput | null,
};

export type DeleteCustomTemplateMutation = {
  deleteCustomTemplate?:  {
    __typename: "CustomTemplate",
    id: string,
    teamMemberId?: string | null,
    teamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employerID?: string | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    templateReports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    name: string,
    selectedFields?: string | null,
    includeFN?: boolean | null,
    individualFNCase?: boolean | null,
    includeCases?: boolean | null,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    type?: TemplateType | null,
    category?: TemplateCategory | null,
    isDeleted?: boolean | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    accessibleCompanyIds?: Array< string | null > | null,
    companyIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateReportMutationVariables = {
  input: CreateReportInput,
  condition?: ModelReportConditionInput | null,
};

export type CreateReportMutation = {
  createReport?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    template?:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    customTemplate:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    },
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    companyIds?: Array< string | null > | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    type?: TemplateType | null,
    name: string,
    status: ReportStatus,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    fromTemplate?: boolean | null,
    totalCountCycle?: number | null,
    completedCountCycle?: number | null,
    isCurrent?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateReportMutationVariables = {
  input: UpdateReportInput,
  condition?: ModelReportConditionInput | null,
};

export type UpdateReportMutation = {
  updateReport?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    template?:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    customTemplate:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    },
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    companyIds?: Array< string | null > | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    type?: TemplateType | null,
    name: string,
    status: ReportStatus,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    fromTemplate?: boolean | null,
    totalCountCycle?: number | null,
    completedCountCycle?: number | null,
    isCurrent?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteReportMutationVariables = {
  input: DeleteReportInput,
  condition?: ModelReportConditionInput | null,
};

export type DeleteReportMutation = {
  deleteReport?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    template?:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    customTemplate:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    },
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    companyIds?: Array< string | null > | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    type?: TemplateType | null,
    name: string,
    status: ReportStatus,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    fromTemplate?: boolean | null,
    totalCountCycle?: number | null,
    completedCountCycle?: number | null,
    isCurrent?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateReportEntriesMutationVariables = {
  input: CreateReportEntriesInput,
  condition?: ModelReportEntriesConditionInput | null,
};

export type CreateReportEntriesMutation = {
  createReportEntries?:  {
    __typename: "ReportEntries",
    id: string,
    reportID: string,
    report?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fullname?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    archived?: string | null,
    email?: string | null,
    personalEmail?: string | null,
    birthDate?: string | null,
    numberOfDependents?: number | null,
    numberOfFamilyContacts?: number | null,
    displayCompanyName?: string | null,
    companyLegalName?: string | null,
    companyFullName?: string | null,
    sponsoringCompanyFullName?: string | null,
    companyDbaName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    birthCountryCode?: string | null,
    citizenshipCountry?: Array< string | null > | null,
    chargeabilityCountry?: string | null,
    passportExpirationDate?: string | null,
    nivMaxout?: string | null,
    visaExpDate?: string | null,
    hasApprovedI140?: boolean | null,
    petitionerI140?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    fnJobTitle?: string | null,
    socCode?: string | null,
    caseSocCode?: string | null,
    fnSalary?: string | null,
    startDate?: string | null,
    fnWorkLocation?: string | null,
    addressPrimary?: string | null,
    addressSecondary?: string | null,
    usResidentialAddress?: string | null,
    lastProcessType?: string | null,
    currentProcessType?: string | null,
    lowerProcessType?: string | null,
    lastPhaseCompleted?: string | null,
    currentPhase?: string | null,
    capType?: string | null,
    eadExpDate?: string | null,
    I797ApprovalExpDate?: string | null,
    I94ExpDate?: string | null,
    I94DS?: string | null,
    greenCardExpDate?: string | null,
    prevailingWageExpDate?: string | null,
    citizenshipEligibilityDate?: string | null,
    rfeDueDate?: string | null,
    dolAuditDueDate?: string | null,
    pwdExpDate?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    agreementExpDate?: string | null,
    agreementEffectiveDate?: string | null,
    mswsowExpDate?: string | null,
    permDueDate?: string | null,
    lotterySelectionDueDate?: string | null,
    advancedParoleExpDate?: string | null,
    reEntryPermitExpDate?: string | null,
    certifiedLcaExpDate?: string | null,
    title?: string | null,
    notes?: string | null,
    DS2019ExpDate?: string | null,
    isRelative?: boolean | null,
    relativeIds?: Array< string | null > | null,
    nextPhase?: string | null,
    requestedProcessSubCategory?: string | null,
    fnNameSlug?: string | null,
    caseSlug?: string | null,
    companyNameSlug?: string | null,
    employerNameSlug?: string | null,
    inviteStatus?: string | null,
    passportNumber?: string | null,
    phoneNumber?: string | null,
    personalPhone?: string | null,
    faxNumber?: string | null,
    passportGender?: string | null,
    preferredMailingAddress?: string | null,
    onboardingSections?: boolean | null,
    lastEntryUS?: string | null,
    employeeId?: string | null,
    caseNumber?: string | null,
    requestedProcess?: string | null,
    attorneyID?: string | null,
    caseAttorney?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    caseSponsor?: string | null,
    caseSponsorId?: string | null,
    caseManagerID?: string | null,
    caseManager?: string | null,
    contributorIds?: Array< string | null > | null,
    caseContributors?: Array< string | null > | null,
    caseStartDate?: string | null,
    caseOpenDate?: string | null,
    caseSalary?: string | null,
    state?: string | null,
    workLocation?: string | null,
    keyFilingDates?: string | null,
    lcaFiled?: string | null,
    capGap?: string | null,
    visaAdditionalProcessing?: Array< string | null > | null,
    stemExtEligible?: string | null,
    educationEvaluationNeeded?: string | null,
    wageIssues?: string | null,
    selection?: string | null,
    caseNature?: string | null,
    registrationCompleted?: string | null,
    receiptNumber?: string | null,
    currentCaseStatusText?: string | null,
    modifiedDate?: string | null,
    incompleteUscisReceiptNumber?: boolean | null,
    caseStatusHistory?: string | null,
    companyAttorneys?: Array< string | null > | null,
    companyAttorneyIds?: Array< string | null > | null,
    companyParalegals?: Array< string | null > | null,
    companyParalegalIds?: Array< string | null > | null,
    companyTotalCases?: string | null,
    companyTotalOpenCases?: string | null,
    companyTotalClosedCases?: string | null,
    companyTotalCompletedCases?: string | null,
    companyNationalCount?: string | null,
    fullTimeEmployeesInUS?: string | null,
    partTimeEmployeesInUS?: string | null,
    companyActiveNationalCount?: string | null,
    grossRevenueForMostRecentFiscalYear?: string | null,
    netRevenueForMostRecentFiscalYear?: string | null,
    naicsCodeOfCompany?: string | null,
    typeOfBusiness?: string | null,
    fein?: string | null,
    yearCompanyWasFoundedInUS?: string | null,
    aosFilingEligible?: string | null,
    requiresMeetingReminder?: boolean | null,
    isParent?: boolean | null,
    isPartnerCompany?: boolean | null,
    companyWhitelistedDomains?: Array< string | null > | null,
    companyContactLabel?: Array< string | null > | null,
    annualMeetingDate?: string | null,
    emCompanyNames?: Array< string | null > | null,
    emCompanyNameSlugs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateReportEntriesMutationVariables = {
  input: UpdateReportEntriesInput,
  condition?: ModelReportEntriesConditionInput | null,
};

export type UpdateReportEntriesMutation = {
  updateReportEntries?:  {
    __typename: "ReportEntries",
    id: string,
    reportID: string,
    report?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fullname?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    archived?: string | null,
    email?: string | null,
    personalEmail?: string | null,
    birthDate?: string | null,
    numberOfDependents?: number | null,
    numberOfFamilyContacts?: number | null,
    displayCompanyName?: string | null,
    companyLegalName?: string | null,
    companyFullName?: string | null,
    sponsoringCompanyFullName?: string | null,
    companyDbaName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    birthCountryCode?: string | null,
    citizenshipCountry?: Array< string | null > | null,
    chargeabilityCountry?: string | null,
    passportExpirationDate?: string | null,
    nivMaxout?: string | null,
    visaExpDate?: string | null,
    hasApprovedI140?: boolean | null,
    petitionerI140?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    fnJobTitle?: string | null,
    socCode?: string | null,
    caseSocCode?: string | null,
    fnSalary?: string | null,
    startDate?: string | null,
    fnWorkLocation?: string | null,
    addressPrimary?: string | null,
    addressSecondary?: string | null,
    usResidentialAddress?: string | null,
    lastProcessType?: string | null,
    currentProcessType?: string | null,
    lowerProcessType?: string | null,
    lastPhaseCompleted?: string | null,
    currentPhase?: string | null,
    capType?: string | null,
    eadExpDate?: string | null,
    I797ApprovalExpDate?: string | null,
    I94ExpDate?: string | null,
    I94DS?: string | null,
    greenCardExpDate?: string | null,
    prevailingWageExpDate?: string | null,
    citizenshipEligibilityDate?: string | null,
    rfeDueDate?: string | null,
    dolAuditDueDate?: string | null,
    pwdExpDate?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    agreementExpDate?: string | null,
    agreementEffectiveDate?: string | null,
    mswsowExpDate?: string | null,
    permDueDate?: string | null,
    lotterySelectionDueDate?: string | null,
    advancedParoleExpDate?: string | null,
    reEntryPermitExpDate?: string | null,
    certifiedLcaExpDate?: string | null,
    title?: string | null,
    notes?: string | null,
    DS2019ExpDate?: string | null,
    isRelative?: boolean | null,
    relativeIds?: Array< string | null > | null,
    nextPhase?: string | null,
    requestedProcessSubCategory?: string | null,
    fnNameSlug?: string | null,
    caseSlug?: string | null,
    companyNameSlug?: string | null,
    employerNameSlug?: string | null,
    inviteStatus?: string | null,
    passportNumber?: string | null,
    phoneNumber?: string | null,
    personalPhone?: string | null,
    faxNumber?: string | null,
    passportGender?: string | null,
    preferredMailingAddress?: string | null,
    onboardingSections?: boolean | null,
    lastEntryUS?: string | null,
    employeeId?: string | null,
    caseNumber?: string | null,
    requestedProcess?: string | null,
    attorneyID?: string | null,
    caseAttorney?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    caseSponsor?: string | null,
    caseSponsorId?: string | null,
    caseManagerID?: string | null,
    caseManager?: string | null,
    contributorIds?: Array< string | null > | null,
    caseContributors?: Array< string | null > | null,
    caseStartDate?: string | null,
    caseOpenDate?: string | null,
    caseSalary?: string | null,
    state?: string | null,
    workLocation?: string | null,
    keyFilingDates?: string | null,
    lcaFiled?: string | null,
    capGap?: string | null,
    visaAdditionalProcessing?: Array< string | null > | null,
    stemExtEligible?: string | null,
    educationEvaluationNeeded?: string | null,
    wageIssues?: string | null,
    selection?: string | null,
    caseNature?: string | null,
    registrationCompleted?: string | null,
    receiptNumber?: string | null,
    currentCaseStatusText?: string | null,
    modifiedDate?: string | null,
    incompleteUscisReceiptNumber?: boolean | null,
    caseStatusHistory?: string | null,
    companyAttorneys?: Array< string | null > | null,
    companyAttorneyIds?: Array< string | null > | null,
    companyParalegals?: Array< string | null > | null,
    companyParalegalIds?: Array< string | null > | null,
    companyTotalCases?: string | null,
    companyTotalOpenCases?: string | null,
    companyTotalClosedCases?: string | null,
    companyTotalCompletedCases?: string | null,
    companyNationalCount?: string | null,
    fullTimeEmployeesInUS?: string | null,
    partTimeEmployeesInUS?: string | null,
    companyActiveNationalCount?: string | null,
    grossRevenueForMostRecentFiscalYear?: string | null,
    netRevenueForMostRecentFiscalYear?: string | null,
    naicsCodeOfCompany?: string | null,
    typeOfBusiness?: string | null,
    fein?: string | null,
    yearCompanyWasFoundedInUS?: string | null,
    aosFilingEligible?: string | null,
    requiresMeetingReminder?: boolean | null,
    isParent?: boolean | null,
    isPartnerCompany?: boolean | null,
    companyWhitelistedDomains?: Array< string | null > | null,
    companyContactLabel?: Array< string | null > | null,
    annualMeetingDate?: string | null,
    emCompanyNames?: Array< string | null > | null,
    emCompanyNameSlugs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteReportEntriesMutationVariables = {
  input: DeleteReportEntriesInput,
  condition?: ModelReportEntriesConditionInput | null,
};

export type DeleteReportEntriesMutation = {
  deleteReportEntries?:  {
    __typename: "ReportEntries",
    id: string,
    reportID: string,
    report?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fullname?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    archived?: string | null,
    email?: string | null,
    personalEmail?: string | null,
    birthDate?: string | null,
    numberOfDependents?: number | null,
    numberOfFamilyContacts?: number | null,
    displayCompanyName?: string | null,
    companyLegalName?: string | null,
    companyFullName?: string | null,
    sponsoringCompanyFullName?: string | null,
    companyDbaName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    birthCountryCode?: string | null,
    citizenshipCountry?: Array< string | null > | null,
    chargeabilityCountry?: string | null,
    passportExpirationDate?: string | null,
    nivMaxout?: string | null,
    visaExpDate?: string | null,
    hasApprovedI140?: boolean | null,
    petitionerI140?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    fnJobTitle?: string | null,
    socCode?: string | null,
    caseSocCode?: string | null,
    fnSalary?: string | null,
    startDate?: string | null,
    fnWorkLocation?: string | null,
    addressPrimary?: string | null,
    addressSecondary?: string | null,
    usResidentialAddress?: string | null,
    lastProcessType?: string | null,
    currentProcessType?: string | null,
    lowerProcessType?: string | null,
    lastPhaseCompleted?: string | null,
    currentPhase?: string | null,
    capType?: string | null,
    eadExpDate?: string | null,
    I797ApprovalExpDate?: string | null,
    I94ExpDate?: string | null,
    I94DS?: string | null,
    greenCardExpDate?: string | null,
    prevailingWageExpDate?: string | null,
    citizenshipEligibilityDate?: string | null,
    rfeDueDate?: string | null,
    dolAuditDueDate?: string | null,
    pwdExpDate?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    agreementExpDate?: string | null,
    agreementEffectiveDate?: string | null,
    mswsowExpDate?: string | null,
    permDueDate?: string | null,
    lotterySelectionDueDate?: string | null,
    advancedParoleExpDate?: string | null,
    reEntryPermitExpDate?: string | null,
    certifiedLcaExpDate?: string | null,
    title?: string | null,
    notes?: string | null,
    DS2019ExpDate?: string | null,
    isRelative?: boolean | null,
    relativeIds?: Array< string | null > | null,
    nextPhase?: string | null,
    requestedProcessSubCategory?: string | null,
    fnNameSlug?: string | null,
    caseSlug?: string | null,
    companyNameSlug?: string | null,
    employerNameSlug?: string | null,
    inviteStatus?: string | null,
    passportNumber?: string | null,
    phoneNumber?: string | null,
    personalPhone?: string | null,
    faxNumber?: string | null,
    passportGender?: string | null,
    preferredMailingAddress?: string | null,
    onboardingSections?: boolean | null,
    lastEntryUS?: string | null,
    employeeId?: string | null,
    caseNumber?: string | null,
    requestedProcess?: string | null,
    attorneyID?: string | null,
    caseAttorney?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    caseSponsor?: string | null,
    caseSponsorId?: string | null,
    caseManagerID?: string | null,
    caseManager?: string | null,
    contributorIds?: Array< string | null > | null,
    caseContributors?: Array< string | null > | null,
    caseStartDate?: string | null,
    caseOpenDate?: string | null,
    caseSalary?: string | null,
    state?: string | null,
    workLocation?: string | null,
    keyFilingDates?: string | null,
    lcaFiled?: string | null,
    capGap?: string | null,
    visaAdditionalProcessing?: Array< string | null > | null,
    stemExtEligible?: string | null,
    educationEvaluationNeeded?: string | null,
    wageIssues?: string | null,
    selection?: string | null,
    caseNature?: string | null,
    registrationCompleted?: string | null,
    receiptNumber?: string | null,
    currentCaseStatusText?: string | null,
    modifiedDate?: string | null,
    incompleteUscisReceiptNumber?: boolean | null,
    caseStatusHistory?: string | null,
    companyAttorneys?: Array< string | null > | null,
    companyAttorneyIds?: Array< string | null > | null,
    companyParalegals?: Array< string | null > | null,
    companyParalegalIds?: Array< string | null > | null,
    companyTotalCases?: string | null,
    companyTotalOpenCases?: string | null,
    companyTotalClosedCases?: string | null,
    companyTotalCompletedCases?: string | null,
    companyNationalCount?: string | null,
    fullTimeEmployeesInUS?: string | null,
    partTimeEmployeesInUS?: string | null,
    companyActiveNationalCount?: string | null,
    grossRevenueForMostRecentFiscalYear?: string | null,
    netRevenueForMostRecentFiscalYear?: string | null,
    naicsCodeOfCompany?: string | null,
    typeOfBusiness?: string | null,
    fein?: string | null,
    yearCompanyWasFoundedInUS?: string | null,
    aosFilingEligible?: string | null,
    requiresMeetingReminder?: boolean | null,
    isParent?: boolean | null,
    isPartnerCompany?: boolean | null,
    companyWhitelistedDomains?: Array< string | null > | null,
    companyContactLabel?: Array< string | null > | null,
    annualMeetingDate?: string | null,
    emCompanyNames?: Array< string | null > | null,
    emCompanyNameSlugs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateStandardTemplateMutationVariables = {
  input: CreateStandardTemplateInput,
  condition?: ModelStandardTemplateConditionInput | null,
};

export type CreateStandardTemplateMutation = {
  createStandardTemplate?:  {
    __typename: "StandardTemplate",
    id: string,
    fields?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateStandardTemplateMutationVariables = {
  input: UpdateStandardTemplateInput,
  condition?: ModelStandardTemplateConditionInput | null,
};

export type UpdateStandardTemplateMutation = {
  updateStandardTemplate?:  {
    __typename: "StandardTemplate",
    id: string,
    fields?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteStandardTemplateMutationVariables = {
  input: DeleteStandardTemplateInput,
  condition?: ModelStandardTemplateConditionInput | null,
};

export type DeleteStandardTemplateMutation = {
  deleteStandardTemplate?:  {
    __typename: "StandardTemplate",
    id: string,
    fields?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateSchedulerMutationVariables = {
  input: CreateSchedulerInput,
  condition?: ModelSchedulerConditionInput | null,
};

export type CreateSchedulerMutation = {
  createScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type UpdateSchedulerMutationVariables = {
  input: UpdateSchedulerInput,
  condition?: ModelSchedulerConditionInput | null,
};

export type UpdateSchedulerMutation = {
  updateScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type DeleteSchedulerMutationVariables = {
  input: DeleteSchedulerInput,
  condition?: ModelSchedulerConditionInput | null,
};

export type DeleteSchedulerMutation = {
  deleteScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type CreateVendorMutationVariables = {
  input: CreateVendorInput,
  condition?: ModelVendorConditionInput | null,
};

export type CreateVendorMutation = {
  createVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type UpdateVendorMutationVariables = {
  input: UpdateVendorInput,
  condition?: ModelVendorConditionInput | null,
};

export type UpdateVendorMutation = {
  updateVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type DeleteVendorMutationVariables = {
  input: DeleteVendorInput,
  condition?: ModelVendorConditionInput | null,
};

export type DeleteVendorMutation = {
  deleteVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type CreateTaskDefinitionMutationVariables = {
  input: CreateTaskDefinitionInput,
  condition?: ModelTaskDefinitionConditionInput | null,
};

export type CreateTaskDefinitionMutation = {
  createTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type UpdateTaskDefinitionMutationVariables = {
  input: UpdateTaskDefinitionInput,
  condition?: ModelTaskDefinitionConditionInput | null,
};

export type UpdateTaskDefinitionMutation = {
  updateTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type DeleteTaskDefinitionMutationVariables = {
  input: DeleteTaskDefinitionInput,
  condition?: ModelTaskDefinitionConditionInput | null,
};

export type DeleteTaskDefinitionMutation = {
  deleteTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type CustomOnUpdatePreparedFormSubscriptionVariables = {
  id: string,
};

export type CustomOnUpdatePreparedFormSubscription = {
  onUpdatePreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    companyID?: string | null,
    foreignNationalID: string,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    templateID?: string | null,
    completedFormID?: string | null,
    assignedToID?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        activityType: ActivityType,
        actorID: string,
        actorEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        actorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        actorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
        } | null,
      } | null >,
    } | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      id: string,
      slug: string,
      firstname?: string | null,
      lastname?: string | null,
    } | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      slug: string,
      firstname: string,
      lastname: string,
    } | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      firstname?: string | null,
      lastname?: string | null,
      id: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      id: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      id: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      slug: string,
      id: string,
    } | null,
    attorneyApprovalDate?: string | null,
    attorneyApproverID?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApprovalDate?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    sponsorApproverID?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    nationalApprovalDate?: string | null,
    nationalApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      slug: string,
      id: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      sourceID?: string | null,
      ownerNationalID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        key: string,
        level?: S3Level | null,
        region: string,
        identityId?: string | null,
      },
    } | null,
    rejectedByID?: string | null,
    rejectedDate?: string | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
    } | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      items:  Array< {
        __typename: "FileData",
        original:  {
          __typename: "S3Object",
          bucket: string,
          identityId?: string | null,
          key: string,
          level?: S3Level | null,
          region: string,
        },
        fileName: string,
        fileType?: FileType | null,
        id: string,
        uploadDate: string,
      } | null >,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      items:  Array< {
        __typename: "Comment",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type CustomUpdatePreparedFormMutationVariables = {
  input: UpdatePreparedFormInput,
  condition?: ModelPreparedFormConditionInput | null,
};

export type CustomUpdatePreparedFormMutation = {
  updatePreparedForm?:  {
    __typename: "PreparedForm",
    caseID?: string | null,
    companyID?: string | null,
    completedFormID?: string | null,
    createdAt?: string | null,
    id: string,
    foreignNationalID: string,
    preparerID?: string | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    templateID?: string | null,
    updatedAt?: string | null,
    assignedToID?: string | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        activityType: ActivityType,
        actorID: string,
        actorEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        actorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        actorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
        } | null,
        targetEmployer?:  {
          __typename: "Employer",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        targetForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          slug: string,
          firstname?: string | null,
          lastname?: string | null,
        } | null,
        targetTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          slug: string,
          firstname: string,
          lastname: string,
        } | null,
        ownerCase?:  {
          __typename: "Case",
          sourceID: string,
          state: CaseState,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null >,
    } | null,
    case?:  {
      __typename: "Case",
      caseManagerID?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      items:  Array< {
        __typename: "Comment",
        id: string,
      } | null >,
    } | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
      avatar?:  {
        __typename: "Picture",
        original:  {
          __typename: "S3Object",
          bucket: string,
          key: string,
          level?: S3Level | null,
          region: string,
          identityId?: string | null,
        },
        squareThumbnails?:  Array< {
          __typename: "Thumbnail",
          image:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          size: number,
        } > | null,
      } | null,
    } | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      fileName: string,
      fileType?: FileType | null,
      contentType?: string | null,
      isFlattened?: boolean | null,
      original:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        level?: S3Level | null,
        identityId?: string | null,
      },
      processRequestID?: string | null,
      companyID?: string | null,
      sourceID?: string | null,
      ownerNationalID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployer?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
        } | null,
      } | null,
      uploaderForeignNational?:  {
        __typename: "ForeignNational",
        id: string,
        firstname?: string | null,
        lastname?: string | null,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      uploaderTeamMember?:  {
        __typename: "TeamMember",
        id: string,
        firstname: string,
        lastname: string,
        slug: string,
        avatar?:  {
          __typename: "Picture",
          original:  {
            __typename: "S3Object",
            bucket: string,
            key: string,
            level?: S3Level | null,
            region: string,
            identityId?: string | null,
          },
          squareThumbnails?:  Array< {
            __typename: "Thumbnail",
            image:  {
              __typename: "S3Object",
              bucket: string,
              key: string,
              level?: S3Level | null,
              region: string,
              identityId?: string | null,
            },
            size: number,
          } > | null,
          version: number,
        } | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      firstname?: string | null,
      lastname?: string | null,
      id: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      id: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      id: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      slug: string,
      id: string,
    } | null,
    attorneyApprovalDate?: string | null,
    attorneyApproverID?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApprovalDate?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    sponsorApproverID?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
      id: string,
    } | null,
    nationalApprovalDate?: string | null,
    nationalApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      firstname: string,
      lastname: string,
      slug: string,
      id: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    rejectedByID?: string | null,
    rejectedDate?: string | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      firstname: string,
      lastname: string,
      slug: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
    } | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      firstname?: string | null,
      lastname?: string | null,
      slug: string,
    } | null,
  } | null,
};

export type ListFormCommentsQueryVariables = {
  id: string,
};

export type ListFormCommentsQuery = {
  getPreparedForm?:  {
    __typename: "PreparedForm",
    comments?:  {
      __typename: "ModelCommentConnection",
      items:  Array< {
        __typename: "Comment",
        authorID: string,
        authorEmployer?:  {
          __typename: "Employer",
          id: string,
          lastname?: string | null,
          firstname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        authorForeignNational?:  {
          __typename: "ForeignNational",
          id: string,
          lastname?: string | null,
          firstname?: string | null,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        authorTeamMember?:  {
          __typename: "TeamMember",
          id: string,
          lastname: string,
          firstname: string,
          avatar?:  {
            __typename: "Picture",
            original:  {
              __typename: "S3Object",
              bucket: string,
              identityId?: string | null,
              key: string,
              level?: S3Level | null,
              region: string,
            },
            squareThumbnails?:  Array< {
              __typename: "Thumbnail",
              image:  {
                __typename: "S3Object",
                region: string,
                level?: S3Level | null,
                key: string,
                identityId?: string | null,
                bucket: string,
              },
              size: number,
            } > | null,
          } | null,
        } | null,
        id: string,
        createdAt?: string | null,
        note?: string | null,
      } | null >,
    } | null,
  } | null,
};

export type GetPreparedFormQueryVariables = {
  id: string,
};

export type GetPreparedFormQuery = {
  getPreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    companyID?: string | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    templateID?: string | null,
    template?:  {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } | null,
    completedFormID?: string | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedDate?: string | null,
    rejectedByID?: string | null,
    rejectedByEmployerID?: string | null,
    rejectedByNationalID?: string | null,
    rejectedByTeamMemberID?: string | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApproverID?: string | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    attorneyApprovalDate?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApproverID?: string | null,
    sponsorApproverEmployerID?: string | null,
    sponsorApproverNationalID?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApprovalDate?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApproverID?: string | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nationalApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListPreparedFormsQueryVariables = {
  filter?: ModelPreparedFormFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPreparedFormsQuery = {
  listPreparedForms?:  {
    __typename: "ModelPreparedFormConnection",
    items:  Array< {
      __typename: "PreparedForm",
      id: string,
      caseID?: string | null,
      companyID?: string | null,
      foreignNationalID: string,
      relativeAdmins?: Array< string > | null,
      state: PreparedFormState,
      preparerID?: string | null,
      templateID?: string | null,
      completedFormID?: string | null,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      rejectedDate?: string | null,
      rejectedByID?: string | null,
      rejectedByEmployerID?: string | null,
      rejectedByNationalID?: string | null,
      rejectedByTeamMemberID?: string | null,
      requiresAttorneyApproval?: boolean | null,
      attorneyApproverID?: string | null,
      attorneyApprovalDate?: string | null,
      requiresSponsorApproval?: boolean | null,
      sponsorApproverID?: string | null,
      sponsorApproverEmployerID?: string | null,
      sponsorApproverNationalID?: string | null,
      sponsorApprovalDate?: string | null,
      requiresNationalApproval?: boolean | null,
      nationalApproverID?: string | null,
      nationalApprovalDate?: string | null,
      finalCaseManagerApproverID?: string | null,
      finalCaseManagerApprovalDate?: string | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetForeignNationalQueryVariables = {
  id: string,
};

export type GetForeignNationalQuery = {
  getForeignNational?:  {
    __typename: "ForeignNational",
    type: PersonType,
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    onboardingSections?:  {
      __typename: "NationalOnboardingSections",
      background?: boolean | null,
      contact?: boolean | null,
      employment?: boolean | null,
      family?: boolean | null,
      immigration?: boolean | null,
      personal?: boolean | null,
    } | null,
    completedOnboardingQuestionsBy?: string | null,
    email?: string | null,
    emailPersonal?: string | null,
    emailWork?: string | null,
    usMailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    usResidentialAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    lastAddressOutsideUS?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    nickname?: string | null,
    employeeId?: string | null,
    additionalFirstnames?: Array< string > | null,
    additionalMiddlenames?: Array< string > | null,
    additionalLastnames?: Array< string > | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    maritalStatus?: MaritalStatus | null,
    spouse?: boolean | null,
    dependents?: number | null,
    phone?: string | null,
    phoneWork?: string | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    companyNationalNumber?: number | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    workLocation?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    relativesAsSource?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relativesAsTarget?:  {
      __typename: "ModelFamilyRelationshipConnection",
      nextToken?: string | null,
    } | null,
    relatives?: Array< string > | null,
    relativeAdmins?: Array< string > | null,
    immigrationStatus?:  {
      __typename: "ImmigrationStatus",
      status?: VisaStatus | null,
      doesNotExpire?: boolean | null,
      expiration?: string | null,
    } | null,
    immigrationVisaStatus?: string | null,
    visaExpiration?: string | null,
    nonImmigrantVisaNumber?: string | null,
    visaIssueDate?: string | null,
    visaConsulate?: string | null,
    immigrantVisaApplicant?: boolean | null,
    immigrantPetitionEverFiled?: boolean | null,
    j1j2?:  {
      __typename: "J1J2",
      hasHad?: boolean | null,
      start?: string | null,
      end?: string | null,
    } | null,
    hasHadI485Filed?:  {
      __typename: "BooleanTwoPart",
      value?: boolean | null,
      followPrompt?: string | null,
      followValue?: boolean | null,
    } | null,
    hasPendingETA9089?: boolean | null,
    hasApprovedI140?:  {
      __typename: "I140",
      hasApproved?: boolean | null,
      classification?: string | null,
      employmentBasedCategory?: EmploymentBasedCategory | null,
      priorityDate?: string | null,
      petitionerI140?: string | null,
    } | null,
    aosFilingEligible?: AOSFilingEligibility | null,
    hasValidOrExpiredEAD?: boolean | null,
    hasPendingUSCISApplication?: boolean | null,
    hasHadVisaPetitionRevokedOrDenied?: boolean | null,
    hasBeenArrestedSinceLastUSEntry?: boolean | null,
    criminalHistory?:  {
      __typename: "CriminalHistory",
      tortureGenocide?: boolean | null,
      killing?: boolean | null,
      severeInjuring?: boolean | null,
      nonconsensualSex?: boolean | null,
      religiousBelief?: boolean | null,
    } | null,
    hasTransportedWeapons?: boolean | null,
    hasParticipatedInArmedGroup?: boolean | null,
    hasDetailedPerson?: boolean | null,
    hasUsedWeapons?: boolean | null,
    hasWeaponsTraining?: boolean | null,
    hasCriminalOffence?: boolean | null,
    hasViolatedVisaTerms?: boolean | null,
    isInRemovalProceedings?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    hasBeenEmployedSinceLastAdmitted?:  {
      __typename: "BooleanExplain",
      value?: boolean | null,
      reason?: string | null,
    } | null,
    citizenshipCountry?: Array< CountryCode > | null,
    birthCountry?: CountryCode | null,
    birthState?: string | null,
    birthDate?: string | null,
    birthCity?: string | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nivMaxout?: string | null,
    offeredSalary?:  {
      __typename: "Money",
      currency: Currency,
      amount: number,
      period?: CurrencyPeriod | null,
    } | null,
    isRemote?: boolean | null,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    hasNonUSPassport?: boolean | null,
    passportGender?: PassportGender | null,
    passportIssueDate?: string | null,
    passportExpirationDate?: string | null,
    passportExpirationReminderSentForDate?: string | null,
    passportNumber?: string | null,
    passportCountry?: CountryCode | null,
    usSSN?: string | null,
    hasSSN?: boolean | null,
    aNumber?: string | null,
    lastEntryUS?: string | null,
    i94ArrivalDepartureRecordNumber?: string | null,
    sevisNumber?: string | null,
    eadNumber?: string | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    fileRequirementsManipulated?: string | null,
    test?: string | null,
    notes?: string | null,
    companyName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    eadExpDate?: string | null,
    I797ExpDate?: string | null,
    visaExpDate?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    chargeabilityCountry?: CountryCode | null,
    birthCountryCode?: string | null,
    socCode?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    citizenshipEligibilityDate?: string | null,
    startDate?: string | null,
    legalTeamIDs?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListForeignNationalsQueryVariables = {
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListForeignNationalsQuery = {
  listForeignNationals?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NationalsBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NationalsBySlugQuery = {
  nationalsBySlug?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NationalsByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelForeignNationalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NationalsByEmailQuery = {
  nationalsByEmail?:  {
    __typename: "ModelForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchForeignNationalsQueryVariables = {
  filter?: SearchableForeignNationalFilterInput | null,
  sort?: Array< SearchableForeignNationalSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableForeignNationalAggregationInput | null > | null,
};

export type SearchForeignNationalsQuery = {
  searchForeignNationals?:  {
    __typename: "SearchableForeignNationalConnection",
    items:  Array< {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetEmployerQueryVariables = {
  id: string,
};

export type GetEmployerQuery = {
  getEmployer?:  {
    __typename: "Employer",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    personalEmail?: string | null,
    newsletterModalViewCount?: number | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname?: string | null,
    middlename?: string | null,
    lastname?: string | null,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    address?: string | null,
    phone?: string | null,
    personalPhone?: string | null,
    title?: string | null,
    companyIDs?: Array< string > | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanies?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContactCompanies?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContactCompanies?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    sponsoredCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    recentlyViewedCases?: Array< string > | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    invoicingContactCompanyIDs?: Array< string > | null,
    isInvoicingContact?: boolean | null,
    primaryContactCompanyIDs?: Array< string > | null,
    isPrimaryContact?: boolean | null,
    seniorContactCompanyIDs?: Array< string > | null,
    isSeniorContact?: boolean | null,
    signatoryContactCompanyIDs?: Array< string > | null,
    isSignatoryContact?: boolean | null,
    assignedCaseIDs?: Array< string > | null,
    nationalsWithOpenCases?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEmployersQueryVariables = {
  filter?: ModelEmployerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEmployersQuery = {
  listEmployers?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmployersBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmployerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmployersBySlugQuery = {
  employersBySlug?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EmployersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEmployerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EmployersByEmailQuery = {
  employersByEmail?:  {
    __typename: "ModelEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchEmployersQueryVariables = {
  filter?: SearchableEmployerFilterInput | null,
  sort?: Array< SearchableEmployerSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableEmployerAggregationInput | null > | null,
};

export type SearchEmployersQuery = {
  searchEmployers?:  {
    __typename: "SearchableEmployerConnection",
    items:  Array< {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetTeamMemberQueryVariables = {
  id: string,
};

export type GetTeamMemberQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    id: string,
    createdBy?: string | null,
    slug: string,
    userAgreementAcknowledged?: boolean | null,
    userAgreementAcknowledgementDate?: string | null,
    userAgreementAcknowledgementText?: string | null,
    hasLoggedIn?: boolean | null,
    type: PersonType,
    email?: string | null,
    username?: string | null,
    avatar?:  {
      __typename: "Picture",
      version: number,
    } | null,
    firstname: string,
    middlename?: string | null,
    lastname: string,
    lowerFirst: string,
    lowerLast: string,
    lowerFull: string,
    phone?: string | null,
    position?: Position | null,
    title?: string | null,
    licensingAuthority?: string | null,
    stateBarNumber?: string | null,
    isAdmin?: boolean | null,
    manager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    managerID?: string | null,
    attorneyAssignments?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    paralegalAssignments?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerAssignments?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    attorneyCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    caseManagerCases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    contributorCases?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    processRequestAssignments?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    mostRecentlyInvited?: string | null,
    archived: ArchivedState,
    loginStatus?:  {
      __typename: "LoginStatus",
      isEnabled?: boolean | null,
      status?: UserStatus | null,
    } | null,
    recentlyViewedCases?: Array< string > | null,
    customTemplates?:  {
      __typename: "ModelCustomTemplateConnection",
      nextToken?: string | null,
    } | null,
    nationalsWithOpenCases?: Array< string > | null,
    companiesAssignedTo?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTeamMembersQueryVariables = {
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersQuery = {
  listTeamMembers?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TeamBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TeamBySlugQuery = {
  teamBySlug?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMembersAlphaQueryVariables = {
  type: PersonType,
  archivedLowerFull?: ModelTeamMemberAlphaCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersAlphaQuery = {
  listTeamMembersAlpha?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TeamByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TeamByEmailQuery = {
  teamByEmail?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListTeamMembersByPositionQueryVariables = {
  position: Position,
  archivedLowerFull?: ModelTeamMemberByPositionCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTeamMemberFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTeamMembersByPositionQuery = {
  listTeamMembersByPosition?:  {
    __typename: "ModelTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchTeamMembersQueryVariables = {
  filter?: SearchableTeamMemberFilterInput | null,
  sort?: Array< SearchableTeamMemberSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTeamMemberAggregationInput | null > | null,
};

export type SearchTeamMembersQuery = {
  searchTeamMembers?:  {
    __typename: "SearchableTeamMemberConnection",
    items:  Array< {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetAttorneyAssignmentQueryVariables = {
  id: string,
};

export type GetAttorneyAssignmentQuery = {
  getAttorneyAssignment?:  {
    __typename: "AttorneyAssignment",
    id: string,
    companyID: string,
    attorneyID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    attorney:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAttorneyAssignmentsQueryVariables = {
  filter?: ModelAttorneyAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttorneyAssignmentsQuery = {
  listAttorneyAssignments?:  {
    __typename: "ModelAttorneyAssignmentConnection",
    items:  Array< {
      __typename: "AttorneyAssignment",
      id: string,
      companyID: string,
      attorneyID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetParalegalAssignmentQueryVariables = {
  id: string,
};

export type GetParalegalAssignmentQuery = {
  getParalegalAssignment?:  {
    __typename: "ParalegalAssignment",
    id: string,
    companyID: string,
    paralegalID: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    },
    paralegal:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListParalegalAssignmentsQueryVariables = {
  filter?: ModelParalegalAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListParalegalAssignmentsQuery = {
  listParalegalAssignments?:  {
    __typename: "ModelParalegalAssignmentConnection",
    items:  Array< {
      __typename: "ParalegalAssignment",
      id: string,
      companyID: string,
      paralegalID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmployerAssignmentQueryVariables = {
  id: string,
};

export type GetEmployerAssignmentQuery = {
  getEmployerAssignment?:  {
    __typename: "EmployerAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEmployerAssignmentsQueryVariables = {
  filter?: ModelEmployerAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEmployerAssignmentsQuery = {
  listEmployerAssignments?:  {
    __typename: "ModelEmployerAssignmentConnection",
    items:  Array< {
      __typename: "EmployerAssignment",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEmployerAdminAssignmentQueryVariables = {
  id: string,
};

export type GetEmployerAdminAssignmentQuery = {
  getEmployerAdminAssignment?:  {
    __typename: "EmployerAdminAssignment",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEmployerAdminAssignmentsQueryVariables = {
  filter?: ModelEmployerAdminAssignmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEmployerAdminAssignmentsQuery = {
  listEmployerAdminAssignments?:  {
    __typename: "ModelEmployerAdminAssignmentConnection",
    items:  Array< {
      __typename: "EmployerAdminAssignment",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrimaryContactQueryVariables = {
  id: string,
};

export type GetPrimaryContactQuery = {
  getPrimaryContact?:  {
    __typename: "PrimaryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrimaryContactsQueryVariables = {
  filter?: ModelPrimaryContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrimaryContactsQuery = {
  listPrimaryContacts?:  {
    __typename: "ModelPrimaryContactConnection",
    items:  Array< {
      __typename: "PrimaryContact",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSeniorContactQueryVariables = {
  id: string,
};

export type GetSeniorContactQuery = {
  getSeniorContact?:  {
    __typename: "SeniorContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSeniorContactsQueryVariables = {
  filter?: ModelSeniorContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSeniorContactsQuery = {
  listSeniorContacts?:  {
    __typename: "ModelSeniorContactConnection",
    items:  Array< {
      __typename: "SeniorContact",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetInvoicingContactQueryVariables = {
  id: string,
};

export type GetInvoicingContactQuery = {
  getInvoicingContact?:  {
    __typename: "InvoicingContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInvoicingContactsQueryVariables = {
  filter?: ModelInvoicingContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInvoicingContactsQuery = {
  listInvoicingContacts?:  {
    __typename: "ModelInvoicingContactConnection",
    items:  Array< {
      __typename: "InvoicingContact",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSignatoryContactQueryVariables = {
  id: string,
};

export type GetSignatoryContactQuery = {
  getSignatoryContact?:  {
    __typename: "SignatoryContact",
    id: string,
    companyID: string,
    employerID: string,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSignatoryContactsQueryVariables = {
  filter?: ModelSignatoryContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSignatoryContactsQuery = {
  listSignatoryContacts?:  {
    __typename: "ModelSignatoryContactConnection",
    items:  Array< {
      __typename: "SignatoryContact",
      id: string,
      companyID: string,
      employerID: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
};

export type GetCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    displayCompanyName?: string | null,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    completedOnboardingQuestionsBy?: string | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type ListCompaniesQueryVariables = {
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompaniesQuery = {
  listCompanies?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CompaniesBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CompaniesBySlugQuery = {
  companiesBySlug?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesAlphaQueryVariables = {
  type: CompanyType,
  archivedLowerNameKey?: ModelCompanyAlphaCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompaniesAlphaQuery = {
  listCompaniesAlpha?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CompaniesByParentQueryVariables = {
  parentID: string,
  archivedLowerNameKey?: ModelCompanyCompaniesByParentCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CompaniesByParentQuery = {
  companiesByParent?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCompaniesQueryVariables = {
  filter?: SearchableCompanyFilterInput | null,
  sort?: Array< SearchableCompanySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCompanyAggregationInput | null > | null,
};

export type SearchCompaniesQuery = {
  searchCompanies?:  {
    __typename: "SearchableCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetFirmQueryVariables = {
  id: string,
};

export type GetFirmQuery = {
  getFirm?:  {
    __typename: "Firm",
    id: string,
    name: string,
    slug: string,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    address?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    mailingAddress?:  {
      __typename: "StreetAddress",
      careOf?: string | null,
      address?: string | null,
      companyAddressType?: CompanyAddressType | null,
      unitNumber?: string | null,
      unitType?: UnitType | null,
      adminArea?: string | null,
      state?: StateCode | null,
      city?: string | null,
      country?: CountryCode | null,
      postalCode?: string | null,
      title?: string | null,
    } | null,
    doingBusinessAs?: string | null,
    phone?: string | null,
    fax?: string | null,
    knowledgeCenterLinks?:  Array< {
      __typename: "KnowledgeCenterLink",
      id: string,
      text: string,
      roles?: Array< Role | null > | null,
    } > | null,
    shortcuts?:  Array< {
      __typename: "Shortcut",
      id: string,
      text: string,
      link: string,
      roles: Array< Role >,
    } > | null,
    holidays?: Array< string > | null,
    companyCount: number,
    nationalCount: number,
    preparedFormTemplates?:  Array< {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFirmsQueryVariables = {
  filter?: ModelFirmFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFirmsQuery = {
  listFirms?:  {
    __typename: "ModelFirmConnection",
    items:  Array< {
      __typename: "Firm",
      id: string,
      name: string,
      slug: string,
      domainWhitelist?: Array< string > | null,
      doingBusinessAs?: string | null,
      phone?: string | null,
      fax?: string | null,
      holidays?: Array< string > | null,
      companyCount: number,
      nationalCount: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetJobDescriptionQueryVariables = {
  id: string,
};

export type GetJobDescriptionQuery = {
  getJobDescription?:  {
    __typename: "JobDescription",
    companyID?: string | null,
    id: string,
    archived: ArchivedState,
    type: JobDescriptionType,
    foreignNationalID?: string | null,
    title: string,
    officialTitle?: string | null,
    degrees?: Array< Degree > | null,
    requiresBachelors?: boolean | null,
    requiresMasters?: boolean | null,
    requiresPhd?: boolean | null,
    dotNumber?: string | null,
    caseSocCode?: string | null,
    duties?: string | null,
    jobURL?: string | null,
    majors?: string | null,
    specialRequirements?: string | null,
    yearsGeneralExperience?: number | null,
    objectiveSkillSetsRequired?: string | null,
    offeredSalary?: string | null,
    certificationLicenses?: string | null,
    travelIsRequired?: boolean | null,
    travelPercentage?: number | null,
    travelDomestic?: boolean | null,
    travelInternational?: boolean | null,
    supervisesOthers?: boolean | null,
    supervisesOthersCount?: number | null,
    supervisesTitles?: Array< string > | null,
    supervisorTitle?: string | null,
    canWorkFromHome?: boolean | null,
    uploadedDescriptionID?: string | null,
    uploadedDescription?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListJobDescriptionsQueryVariables = {
  filter?: ModelJobDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJobDescriptionsQuery = {
  listJobDescriptions?:  {
    __typename: "ModelJobDescriptionConnection",
    items:  Array< {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type JobsByCompanyTitleQueryVariables = {
  companyID: string,
  title?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobsByCompanyTitleQuery = {
  jobsByCompanyTitle?:  {
    __typename: "ModelJobDescriptionConnection",
    items:  Array< {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type JobsByCompanyQueryVariables = {
  companyID: string,
  archivedType?: ModelJobDescriptionByCompanyCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JobsByCompanyQuery = {
  jobsByCompany?:  {
    __typename: "ModelJobDescriptionConnection",
    items:  Array< {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJobsByForeignNationalQueryVariables = {
  foreignNationalID: string,
  archivedType?: ModelJobDescriptionByForeignNationalCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJobsByForeignNationalQuery = {
  listJobsByForeignNational?:  {
    __typename: "ModelJobDescriptionConnection",
    items:  Array< {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProcessRequestQueryVariables = {
  id: string,
};

export type GetProcessRequestQuery = {
  getProcessRequest?:  {
    __typename: "ProcessRequest",
    id: string,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    initiatorID?: string | null,
    initiator?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requesterID?: string | null,
    requester?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestDate: string,
    approvalDate?: string | null,
    archivedDate?: string | null,
    cancelDate?: string | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    needsEmployerRevision?: boolean | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    resumeID?: string | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    vendor?:  {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    slug: string,
    state: ProcessRequestState,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ProcessBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProcessRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProcessBySlugQuery = {
  processBySlug?:  {
    __typename: "ModelProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProcessesByStateQueryVariables = {
  state: ProcessRequestState,
  requestDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProcessRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProcessesByStateQuery = {
  listProcessesByState?:  {
    __typename: "ModelProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchProcessRequestsQueryVariables = {
  filter?: SearchableProcessRequestFilterInput | null,
  sort?: Array< SearchableProcessRequestSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableProcessRequestAggregationInput | null > | null,
};

export type SearchProcessRequestsQuery = {
  searchProcessRequests?:  {
    __typename: "SearchableProcessRequestConnection",
    items:  Array< {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetCaseQueryVariables = {
  id: string,
};

export type GetCaseQuery = {
  getCase?:  {
    __typename: "Case",
    id: string,
    caseNumber?: string | null,
    slug: string,
    attorneyID?: string | null,
    attorney?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseManagerID?: string | null,
    caseManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    complianceListID?: string | null,
    complianceList?:  {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    PERMFilingDataID?: string | null,
    PERMFilingData?:  {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    caseNotes?:  {
      __typename: "ModelCaseNoteConnection",
      nextToken?: string | null,
    } | null,
    pinnedCaseNoteID?: string | null,
    contributorIds?: Array< string | null > | null,
    contributors?:  {
      __typename: "ModelCaseContributorConnection",
      nextToken?: string | null,
    } | null,
    sponsoringEmployerID?: string | null,
    sponsoringEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsoringNationalID?: string | null,
    sponsoringNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    welcomeLetterAcknowledged?: boolean | null,
    welcomeLetterAcknowledgementDate?: string | null,
    welcomeLetterAcknowledgedBy?: string | null,
    welcomeLetterText?: string | null,
    nationalVisaExpiration?: string | null,
    relativeAdmins?: Array< string > | null,
    startDate: string,
    closeDate?: string | null,
    closeReason?: string | null,
    completeDate?: string | null,
    sourceID: string,
    source?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    state: CaseState,
    tasks?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    lowerNationalName?: string | null,
    lowerCompanyName?: string | null,
    lowerProcessType?: string | null,
    fileRequirements:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } >,
    currentPhase?: CasePhase | null,
    phaseRequirements:  Array< {
      __typename: "CasePhaseRequirement",
      phase: CasePhase,
      milestones: Array< CaseMilestone >,
    } >,
    completedMilestones:  Array< {
      __typename: "CompletedCaseMilestone",
      completionDate?: string | null,
      completedByID: string,
      milestone: CaseMilestone,
      receiptNumber?: string | null,
    } >,
    files?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    preparedForms?:  {
      __typename: "ModelPreparedFormConnection",
      nextToken?: string | null,
    } | null,
    prevailingWageCaseNumber?: string | null,
    USCISReceiptNumber?: string | null,
    USCISReceiptDetails?:  {
      __typename: "ModelUSCISReceiptDetailsConnection",
      nextToken?: string | null,
    } | null,
    AOSReceiptNotice?: string | null,
    I485JReceiptNotice?: string | null,
    SelectionNoticeNo?: string | null,
    ETACaseNumber?: string | null,
    shipmentTracking?:  Array< {
      __typename: "CaseShipmentTracking",
      id: string,
      item?: string | null,
      date?: string | null,
      trackingNumber?: string | null,
      provider?: CaseShippingProvider | null,
    } > | null,
    isShipmentTrackingElectronically?: boolean | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    individualSponsored?: boolean | null,
    jobDescriptionID?: string | null,
    jobDescription?:  {
      __typename: "JobDescription",
      companyID?: string | null,
      id: string,
      archived: ArchivedState,
      type: JobDescriptionType,
      foreignNationalID?: string | null,
      title: string,
      officialTitle?: string | null,
      degrees?: Array< Degree > | null,
      requiresBachelors?: boolean | null,
      requiresMasters?: boolean | null,
      requiresPhd?: boolean | null,
      dotNumber?: string | null,
      caseSocCode?: string | null,
      duties?: string | null,
      jobURL?: string | null,
      majors?: string | null,
      specialRequirements?: string | null,
      yearsGeneralExperience?: number | null,
      objectiveSkillSetsRequired?: string | null,
      offeredSalary?: string | null,
      certificationLicenses?: string | null,
      travelIsRequired?: boolean | null,
      travelPercentage?: number | null,
      travelDomestic?: boolean | null,
      travelInternational?: boolean | null,
      supervisesOthers?: boolean | null,
      supervisesOthersCount?: number | null,
      supervisesTitles?: Array< string > | null,
      supervisorTitle?: string | null,
      canWorkFromHome?: boolean | null,
      uploadedDescriptionID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employeeData?:  {
      __typename: "ProcessRequestEmployeeData",
      firstname: string,
      lastname: string,
      middlename?: string | null,
      email?: string | null,
      employeeId?: string | null,
      tempID: string,
      spouse?: boolean | null,
      dependents?: number | null,
    } | null,
    employmentData?:  {
      __typename: "ProcessRequestEmploymentData",
      premiumProcessing?: boolean | null,
      startDate?: string | null,
      notes?: string | null,
    } | null,
    resumeID?: string | null,
    resume?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestedProcess?: VisaStatus | null,
    requestedProcessSubCategory?: VisaSubCategory | null,
    requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
    globalRequestedProcessSubCategory?: string | null,
    globalProcessCountryCode?: CountryCode | null,
    globalProcessDuration?: GlobalProcessDuration | null,
    globalVisaType?: GlobalVisaType | null,
    vendorID?: string | null,
    additionalFieldID?: string | null,
    additionalFields?:  {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      fields?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCasesQueryVariables = {
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCasesQuery = {
  listCases?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CaseBySlugQueryVariables = {
  slug: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CaseBySlugQuery = {
  caseBySlug?:  {
    __typename: "ModelCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCasesQueryVariables = {
  filter?: SearchableCaseFilterInput | null,
  sort?: Array< SearchableCaseSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCaseAggregationInput | null > | null,
};

export type SearchCasesQuery = {
  searchCases?:  {
    __typename: "SearchableCaseConnection",
    items:  Array< {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUSCISReceiptDetailsQueryVariables = {
  id: string,
};

export type GetUSCISReceiptDetailsQuery = {
  getUSCISReceiptDetails?:  {
    __typename: "USCISReceiptDetails",
    id: string,
    caseID: string,
    receiptType: ReceiptType,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    receiptNumber?: string | null,
    formType?: string | null,
    submittedDate?: string | null,
    modifiedDate?: string | null,
    currentCaseStatusText?: string | null,
    currentCaseStatusDesc?: string | null,
    histCaseStatus?:  Array< {
      __typename: "HitCaseStatus",
      date?: string | null,
      completedText?: string | null,
    } > | null,
    message?: string | null,
    isActive?: boolean | null,
    isLatest?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListUSCISReceiptDetailsQueryVariables = {
  filter?: ModelUSCISReceiptDetailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUSCISReceiptDetailsQuery = {
  listUSCISReceiptDetails?:  {
    __typename: "ModelUSCISReceiptDetailsConnection",
    items:  Array< {
      __typename: "USCISReceiptDetails",
      id: string,
      caseID: string,
      receiptType: ReceiptType,
      receiptNumber?: string | null,
      formType?: string | null,
      submittedDate?: string | null,
      modifiedDate?: string | null,
      currentCaseStatusText?: string | null,
      currentCaseStatusDesc?: string | null,
      message?: string | null,
      isActive?: boolean | null,
      isLatest?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCaseComplianceListQueryVariables = {
  filter?: ModelCaseComplianceListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCaseComplianceListQuery = {
  listCaseComplianceList?:  {
    __typename: "ModelCaseComplianceListConnection",
    items:  Array< {
      __typename: "CaseComplianceList",
      id: string,
      caseID?: string | null,
      educationEvaluationNeeded?: ComplianceCheckList | null,
      stemExtEligible?: ComplianceCheckList | null,
      capGap?: ComplianceCheckList | null,
      wageIssues?: ComplianceCheckList | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPERMFilingDataQueryVariables = {
  filter?: ModelPERMFilingDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPERMFilingDataQuery = {
  listPERMFilingData?:  {
    __typename: "ModelPERMFilingDataConnection",
    items:  Array< {
      __typename: "PERMFilingData",
      id: string,
      caseID?: string | null,
      PERMFirstPossibleFilingDate?: string | null,
      PERMLastPossibleFilingDate?: string | null,
      applicantsReceived?: boolean | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCaseContributorsQueryVariables = {
  filter?: ModelCaseContributorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCaseContributorsQuery = {
  listCaseContributors?:  {
    __typename: "ModelCaseContributorConnection",
    items:  Array< {
      __typename: "CaseContributor",
      id: string,
      caseID: string,
      contributorID: string,
      foreignNationalID: string,
      state: CaseState,
      type: PersonType,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskQueryVariables = {
  id: string,
};

export type GetTaskQuery = {
  getTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type ListTasksQueryVariables = {
  filter?: ModelTaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTasksQuery = {
  listTasks?:  {
    __typename: "ModelTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchTasksQueryVariables = {
  filter?: SearchableTaskFilterInput | null,
  sort?: Array< SearchableTaskSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableTaskAggregationInput | null > | null,
};

export type SearchTasksQuery = {
  searchTasks?:  {
    __typename: "SearchableTaskConnection",
    items:  Array< {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type ListTaskTemplatesByProcessQueryVariables = {
  process: VisaStatus,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskTemplatesByProcessQuery = {
  listTaskTemplatesByProcess?:  {
    __typename: "ModelTaskTemplateConnection",
    items:  Array< {
      __typename: "TaskTemplate",
      id: string,
      defaultAssignee: TaskAssignmentRole,
      duration?: number | null,
      groupsCanRead?: Array< string > | null,
      lockedByDefault: boolean,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      description?: string | null,
      paymentStatusAlternateAction?: string | null,
      prerequisiteID?: string | null,
      process: VisaStatus,
      category: TaskCategory,
      hidden?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      durationFromStartDate?: boolean | null,
      orderIndex: number,
      startDate?: string | null,
      deadline?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFileDataQueryVariables = {
  id: string,
};

export type GetFileDataQuery = {
  getFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    issueDate?: string | null,
    dueDate?: string | null,
    isFlattened?: boolean | null,
    processRequestID?: string | null,
    companyID?: string | null,
    ownerNationalID?: string | null,
    sourceID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    uploaderEmployerID?: string | null,
    uploaderForeignNationalID?: string | null,
    uploaderTeamMemberID?: string | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListFileDataQueryVariables = {
  filter?: ModelFileDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFileDataQuery = {
  listFileData?:  {
    __typename: "ModelFileDataConnection",
    items:  Array< {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type FileDataBySourceQueryVariables = {
  sourceID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFileDataFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type FileDataBySourceQuery = {
  fileDataBySource?:  {
    __typename: "ModelFileDataConnection",
    items:  Array< {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCaseRfgpQueryVariables = {
  id: string,
};

export type GetCaseRfgpQuery = {
  getCaseRfgp?:  {
    __typename: "CaseRfgp",
    id: string,
    caseID: string,
    items:  Array< {
      __typename: "RfgpItem",
      itemType: RfgpItemType,
      id: string,
    } >,
    status: RfgpStatus,
    jobID?: string | null,
    fileID?: string | null,
    file?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    usedFileIDs?: Array< string > | null,
    skipped?:  Array< {
      __typename: "RfgpSkipped",
      itemType: RfgpItemType,
      id: string,
      reason: string,
    } > | null,
    errorMessage?: string | null,
    generatedAt?: string | null,
    generatedByID?: string | null,
    generatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    updatedByID?: string | null,
    updatedBy?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCaseRfgpsQueryVariables = {
  filter?: ModelCaseRfgpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCaseRfgpsQuery = {
  listCaseRfgps?:  {
    __typename: "ModelCaseRfgpConnection",
    items:  Array< {
      __typename: "CaseRfgp",
      id: string,
      caseID: string,
      status: RfgpStatus,
      jobID?: string | null,
      fileID?: string | null,
      usedFileIDs?: Array< string > | null,
      errorMessage?: string | null,
      generatedAt?: string | null,
      generatedByID?: string | null,
      updatedByID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActivityQueryVariables = {
  id: string,
};

export type GetActivityQuery = {
  getActivity?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    activityType: ActivityType,
    ipAddress?: string | null,
    fieldName?: string | null,
    updatedValue?: string | null,
    actorID: string,
    actorEmployerID?: string | null,
    actorForeignNationalID?: string | null,
    actorTeamMemberID?: string | null,
    actorType?: PersonType | null,
    actorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    directTargetID?: string | null,
    directTargetCaseID?: string | null,
    directTargetCompanyID?: string | null,
    directTargetEmployerID?: string | null,
    directTargetFileDataID?: string | null,
    directTargetForeignNationalID?: string | null,
    directTargetProcessRequestID?: string | null,
    directTargetTaskID?: string | null,
    directTargetTeamMemberID?: string | null,
    directTargetReportID?: string | null,
    targetString?: string | null,
    targetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    targetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetTask?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    targetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    indirectTargetID?: string | null,
    indirectTargetCaseID?: string | null,
    indirectTargetCompanyID?: string | null,
    indirectTargetEmployerID?: string | null,
    indirectTargetForeignNationalID?: string | null,
    indirectTargetProcessRequestID?: string | null,
    indirectTargetTeamMemberID?: string | null,
    indirectTargetReportID?: string | null,
    indirectTargetString?: string | null,
    indirectTargetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    indirectTargetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    ownerID?: string | null,
    ownerCaseID?: string | null,
    ownerCompanyID?: string | null,
    ownerEmployerID?: string | null,
    ownerFileDataID?: string | null,
    ownerForeignNationalID?: string | null,
    ownerProcessRequestID?: string | null,
    ownerTeamMemberID?: string | null,
    ownerReportID?: string | null,
    ownerCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    ownerEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
  } | null,
};

export type ListActivitiesQueryVariables = {
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivitiesQuery = {
  listActivities?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchActivitiesQueryVariables = {
  filter?: SearchableActivityFilterInput | null,
  sort?: Array< SearchableActivitySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableActivityAggregationInput | null > | null,
};

export type SearchActivitiesQuery = {
  searchActivities?:  {
    __typename: "SearchableActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetNotificationQueryVariables = {
  id: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    personID: string,
    activityID: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null,
    read: ReadState,
    personNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      personID: string,
      activityID: string,
      read: ReadState,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotificationsByPersonByReadQueryVariables = {
  personID: string,
  readCreatedAt?: ModelNotificationByPersonByReadCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsByPersonByReadQuery = {
  listNotificationsByPersonByRead?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      personID: string,
      activityID: string,
      read: ReadState,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListNotificationsByPersonAllQueryVariables = {
  personID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsByPersonAllQuery = {
  listNotificationsByPersonAll?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      personID: string,
      activityID: string,
      read: ReadState,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAdditionalFieldsQueryVariables = {
  id: string,
};

export type GetAdditionalFieldsQuery = {
  getAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAdditionalFieldsQueryVariables = {
  filter?: ModelAdditionalFieldsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdditionalFieldsQuery = {
  listAdditionalFields?:  {
    __typename: "ModelAdditionalFieldsConnection",
    items:  Array< {
      __typename: "AdditionalFields",
      id: string,
      caseID: string,
      fields?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCustomTemplateQueryVariables = {
  id: string,
};

export type GetCustomTemplateQuery = {
  getCustomTemplate?:  {
    __typename: "CustomTemplate",
    id: string,
    teamMemberId?: string | null,
    teamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employerID?: string | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    templateReports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    name: string,
    selectedFields?: string | null,
    includeFN?: boolean | null,
    individualFNCase?: boolean | null,
    includeCases?: boolean | null,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    type?: TemplateType | null,
    category?: TemplateCategory | null,
    isDeleted?: boolean | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    accessibleCompanyIds?: Array< string | null > | null,
    companyIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListCustomTemplateQueryVariables = {
  filter?: ModelCustomTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomTemplateQuery = {
  listCustomTemplate?:  {
    __typename: "ModelCustomTemplateConnection",
    items:  Array< {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchCustomTemplatesQueryVariables = {
  filter?: SearchableCustomTemplateFilterInput | null,
  sort?: Array< SearchableCustomTemplateSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableCustomTemplateAggregationInput | null > | null,
};

export type SearchCustomTemplatesQuery = {
  searchCustomTemplates?:  {
    __typename: "SearchableCustomTemplateConnection",
    items:  Array< {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReportsQueryVariables = {
  id: string,
};

export type GetReportsQuery = {
  getReports?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    template?:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    customTemplate:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    },
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    companyIds?: Array< string | null > | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    type?: TemplateType | null,
    name: string,
    status: ReportStatus,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    fromTemplate?: boolean | null,
    totalCountCycle?: number | null,
    completedCountCycle?: number | null,
    isCurrent?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListReportsQueryVariables = {
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportsQuery = {
  listReports?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ReportsByTemplateIDQueryVariables = {
  templateID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ReportsByTemplateIDQuery = {
  reportsByTemplateID?:  {
    __typename: "ModelReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReportsQueryVariables = {
  filter?: SearchableReportFilterInput | null,
  sort?: Array< SearchableReportSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReportAggregationInput | null > | null,
};

export type SearchReportsQuery = {
  searchReports?:  {
    __typename: "SearchableReportConnection",
    items:  Array< {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetReportEntriesQueryVariables = {
  id: string,
};

export type GetReportEntriesQuery = {
  getReportEntries?:  {
    __typename: "ReportEntries",
    id: string,
    reportID: string,
    report?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    foreignNationalID?: string | null,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fullname?: string | null,
    firstname?: string | null,
    lastname?: string | null,
    middlename?: string | null,
    archived?: string | null,
    email?: string | null,
    personalEmail?: string | null,
    birthDate?: string | null,
    numberOfDependents?: number | null,
    numberOfFamilyContacts?: number | null,
    displayCompanyName?: string | null,
    companyLegalName?: string | null,
    companyFullName?: string | null,
    sponsoringCompanyFullName?: string | null,
    companyDbaName?: string | null,
    immigrationCurrentStatus?: string | null,
    immigrationStatusExpiration?: string | null,
    birthCountryCode?: string | null,
    citizenshipCountry?: Array< string | null > | null,
    chargeabilityCountry?: string | null,
    passportExpirationDate?: string | null,
    nivMaxout?: string | null,
    visaExpDate?: string | null,
    hasApprovedI140?: boolean | null,
    petitionerI140?: string | null,
    employmentBasedCategory?: string | null,
    priorityDate?: string | null,
    fnJobTitle?: string | null,
    socCode?: string | null,
    caseSocCode?: string | null,
    fnSalary?: string | null,
    startDate?: string | null,
    fnWorkLocation?: string | null,
    addressPrimary?: string | null,
    addressSecondary?: string | null,
    usResidentialAddress?: string | null,
    lastProcessType?: string | null,
    currentProcessType?: string | null,
    lowerProcessType?: string | null,
    lastPhaseCompleted?: string | null,
    currentPhase?: string | null,
    capType?: string | null,
    eadExpDate?: string | null,
    I797ApprovalExpDate?: string | null,
    I94ExpDate?: string | null,
    I94DS?: string | null,
    greenCardExpDate?: string | null,
    prevailingWageExpDate?: string | null,
    citizenshipEligibilityDate?: string | null,
    rfeDueDate?: string | null,
    dolAuditDueDate?: string | null,
    pwdExpDate?: string | null,
    firstEntryUS?: string | null,
    taxTrackingF1J1?: string | null,
    agreementExpDate?: string | null,
    agreementEffectiveDate?: string | null,
    mswsowExpDate?: string | null,
    permDueDate?: string | null,
    lotterySelectionDueDate?: string | null,
    advancedParoleExpDate?: string | null,
    reEntryPermitExpDate?: string | null,
    certifiedLcaExpDate?: string | null,
    title?: string | null,
    notes?: string | null,
    DS2019ExpDate?: string | null,
    isRelative?: boolean | null,
    relativeIds?: Array< string | null > | null,
    nextPhase?: string | null,
    requestedProcessSubCategory?: string | null,
    fnNameSlug?: string | null,
    caseSlug?: string | null,
    companyNameSlug?: string | null,
    employerNameSlug?: string | null,
    inviteStatus?: string | null,
    passportNumber?: string | null,
    phoneNumber?: string | null,
    personalPhone?: string | null,
    faxNumber?: string | null,
    passportGender?: string | null,
    preferredMailingAddress?: string | null,
    onboardingSections?: boolean | null,
    lastEntryUS?: string | null,
    employeeId?: string | null,
    caseNumber?: string | null,
    requestedProcess?: string | null,
    attorneyID?: string | null,
    caseAttorney?: string | null,
    sponsoringEmployerID?: string | null,
    sponsoringNationalID?: string | null,
    caseSponsor?: string | null,
    caseSponsorId?: string | null,
    caseManagerID?: string | null,
    caseManager?: string | null,
    contributorIds?: Array< string | null > | null,
    caseContributors?: Array< string | null > | null,
    caseStartDate?: string | null,
    caseOpenDate?: string | null,
    caseSalary?: string | null,
    state?: string | null,
    workLocation?: string | null,
    keyFilingDates?: string | null,
    lcaFiled?: string | null,
    capGap?: string | null,
    visaAdditionalProcessing?: Array< string | null > | null,
    stemExtEligible?: string | null,
    educationEvaluationNeeded?: string | null,
    wageIssues?: string | null,
    selection?: string | null,
    caseNature?: string | null,
    registrationCompleted?: string | null,
    receiptNumber?: string | null,
    currentCaseStatusText?: string | null,
    modifiedDate?: string | null,
    incompleteUscisReceiptNumber?: boolean | null,
    caseStatusHistory?: string | null,
    companyAttorneys?: Array< string | null > | null,
    companyAttorneyIds?: Array< string | null > | null,
    companyParalegals?: Array< string | null > | null,
    companyParalegalIds?: Array< string | null > | null,
    companyTotalCases?: string | null,
    companyTotalOpenCases?: string | null,
    companyTotalClosedCases?: string | null,
    companyTotalCompletedCases?: string | null,
    companyNationalCount?: string | null,
    fullTimeEmployeesInUS?: string | null,
    partTimeEmployeesInUS?: string | null,
    companyActiveNationalCount?: string | null,
    grossRevenueForMostRecentFiscalYear?: string | null,
    netRevenueForMostRecentFiscalYear?: string | null,
    naicsCodeOfCompany?: string | null,
    typeOfBusiness?: string | null,
    fein?: string | null,
    yearCompanyWasFoundedInUS?: string | null,
    aosFilingEligible?: string | null,
    requiresMeetingReminder?: boolean | null,
    isParent?: boolean | null,
    isPartnerCompany?: boolean | null,
    companyWhitelistedDomains?: Array< string | null > | null,
    companyContactLabel?: Array< string | null > | null,
    annualMeetingDate?: string | null,
    emCompanyNames?: Array< string | null > | null,
    emCompanyNameSlugs?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListReportEntriesQueryVariables = {
  filter?: ModelReportEntriesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportEntriesQuery = {
  listReportEntries?:  {
    __typename: "ModelReportEntriesConnection",
    items:  Array< {
      __typename: "ReportEntries",
      id: string,
      reportID: string,
      companyID?: string | null,
      foreignNationalID?: string | null,
      fullname?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      middlename?: string | null,
      archived?: string | null,
      email?: string | null,
      personalEmail?: string | null,
      birthDate?: string | null,
      numberOfDependents?: number | null,
      numberOfFamilyContacts?: number | null,
      displayCompanyName?: string | null,
      companyLegalName?: string | null,
      companyFullName?: string | null,
      sponsoringCompanyFullName?: string | null,
      companyDbaName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      birthCountryCode?: string | null,
      citizenshipCountry?: Array< string | null > | null,
      chargeabilityCountry?: string | null,
      passportExpirationDate?: string | null,
      nivMaxout?: string | null,
      visaExpDate?: string | null,
      hasApprovedI140?: boolean | null,
      petitionerI140?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      fnJobTitle?: string | null,
      socCode?: string | null,
      caseSocCode?: string | null,
      fnSalary?: string | null,
      startDate?: string | null,
      fnWorkLocation?: string | null,
      addressPrimary?: string | null,
      addressSecondary?: string | null,
      usResidentialAddress?: string | null,
      lastProcessType?: string | null,
      currentProcessType?: string | null,
      lowerProcessType?: string | null,
      lastPhaseCompleted?: string | null,
      currentPhase?: string | null,
      capType?: string | null,
      eadExpDate?: string | null,
      I797ApprovalExpDate?: string | null,
      I94ExpDate?: string | null,
      I94DS?: string | null,
      greenCardExpDate?: string | null,
      prevailingWageExpDate?: string | null,
      citizenshipEligibilityDate?: string | null,
      rfeDueDate?: string | null,
      dolAuditDueDate?: string | null,
      pwdExpDate?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      agreementExpDate?: string | null,
      agreementEffectiveDate?: string | null,
      mswsowExpDate?: string | null,
      permDueDate?: string | null,
      lotterySelectionDueDate?: string | null,
      advancedParoleExpDate?: string | null,
      reEntryPermitExpDate?: string | null,
      certifiedLcaExpDate?: string | null,
      title?: string | null,
      notes?: string | null,
      DS2019ExpDate?: string | null,
      isRelative?: boolean | null,
      relativeIds?: Array< string | null > | null,
      nextPhase?: string | null,
      requestedProcessSubCategory?: string | null,
      fnNameSlug?: string | null,
      caseSlug?: string | null,
      companyNameSlug?: string | null,
      employerNameSlug?: string | null,
      inviteStatus?: string | null,
      passportNumber?: string | null,
      phoneNumber?: string | null,
      personalPhone?: string | null,
      faxNumber?: string | null,
      passportGender?: string | null,
      preferredMailingAddress?: string | null,
      onboardingSections?: boolean | null,
      lastEntryUS?: string | null,
      employeeId?: string | null,
      caseNumber?: string | null,
      requestedProcess?: string | null,
      attorneyID?: string | null,
      caseAttorney?: string | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      caseSponsor?: string | null,
      caseSponsorId?: string | null,
      caseManagerID?: string | null,
      caseManager?: string | null,
      contributorIds?: Array< string | null > | null,
      caseContributors?: Array< string | null > | null,
      caseStartDate?: string | null,
      caseOpenDate?: string | null,
      caseSalary?: string | null,
      state?: string | null,
      workLocation?: string | null,
      keyFilingDates?: string | null,
      lcaFiled?: string | null,
      capGap?: string | null,
      visaAdditionalProcessing?: Array< string | null > | null,
      stemExtEligible?: string | null,
      educationEvaluationNeeded?: string | null,
      wageIssues?: string | null,
      selection?: string | null,
      caseNature?: string | null,
      registrationCompleted?: string | null,
      receiptNumber?: string | null,
      currentCaseStatusText?: string | null,
      modifiedDate?: string | null,
      incompleteUscisReceiptNumber?: boolean | null,
      caseStatusHistory?: string | null,
      companyAttorneys?: Array< string | null > | null,
      companyAttorneyIds?: Array< string | null > | null,
      companyParalegals?: Array< string | null > | null,
      companyParalegalIds?: Array< string | null > | null,
      companyTotalCases?: string | null,
      companyTotalOpenCases?: string | null,
      companyTotalClosedCases?: string | null,
      companyTotalCompletedCases?: string | null,
      companyNationalCount?: string | null,
      fullTimeEmployeesInUS?: string | null,
      partTimeEmployeesInUS?: string | null,
      companyActiveNationalCount?: string | null,
      grossRevenueForMostRecentFiscalYear?: string | null,
      netRevenueForMostRecentFiscalYear?: string | null,
      naicsCodeOfCompany?: string | null,
      typeOfBusiness?: string | null,
      fein?: string | null,
      yearCompanyWasFoundedInUS?: string | null,
      aosFilingEligible?: string | null,
      requiresMeetingReminder?: boolean | null,
      isParent?: boolean | null,
      isPartnerCompany?: boolean | null,
      companyWhitelistedDomains?: Array< string | null > | null,
      companyContactLabel?: Array< string | null > | null,
      annualMeetingDate?: string | null,
      emCompanyNames?: Array< string | null > | null,
      emCompanyNameSlugs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EntriesByReportIDQueryVariables = {
  reportID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelReportEntriesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EntriesByReportIDQuery = {
  entriesByReportID?:  {
    __typename: "ModelReportEntriesConnection",
    items:  Array< {
      __typename: "ReportEntries",
      id: string,
      reportID: string,
      companyID?: string | null,
      foreignNationalID?: string | null,
      fullname?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      middlename?: string | null,
      archived?: string | null,
      email?: string | null,
      personalEmail?: string | null,
      birthDate?: string | null,
      numberOfDependents?: number | null,
      numberOfFamilyContacts?: number | null,
      displayCompanyName?: string | null,
      companyLegalName?: string | null,
      companyFullName?: string | null,
      sponsoringCompanyFullName?: string | null,
      companyDbaName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      birthCountryCode?: string | null,
      citizenshipCountry?: Array< string | null > | null,
      chargeabilityCountry?: string | null,
      passportExpirationDate?: string | null,
      nivMaxout?: string | null,
      visaExpDate?: string | null,
      hasApprovedI140?: boolean | null,
      petitionerI140?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      fnJobTitle?: string | null,
      socCode?: string | null,
      caseSocCode?: string | null,
      fnSalary?: string | null,
      startDate?: string | null,
      fnWorkLocation?: string | null,
      addressPrimary?: string | null,
      addressSecondary?: string | null,
      usResidentialAddress?: string | null,
      lastProcessType?: string | null,
      currentProcessType?: string | null,
      lowerProcessType?: string | null,
      lastPhaseCompleted?: string | null,
      currentPhase?: string | null,
      capType?: string | null,
      eadExpDate?: string | null,
      I797ApprovalExpDate?: string | null,
      I94ExpDate?: string | null,
      I94DS?: string | null,
      greenCardExpDate?: string | null,
      prevailingWageExpDate?: string | null,
      citizenshipEligibilityDate?: string | null,
      rfeDueDate?: string | null,
      dolAuditDueDate?: string | null,
      pwdExpDate?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      agreementExpDate?: string | null,
      agreementEffectiveDate?: string | null,
      mswsowExpDate?: string | null,
      permDueDate?: string | null,
      lotterySelectionDueDate?: string | null,
      advancedParoleExpDate?: string | null,
      reEntryPermitExpDate?: string | null,
      certifiedLcaExpDate?: string | null,
      title?: string | null,
      notes?: string | null,
      DS2019ExpDate?: string | null,
      isRelative?: boolean | null,
      relativeIds?: Array< string | null > | null,
      nextPhase?: string | null,
      requestedProcessSubCategory?: string | null,
      fnNameSlug?: string | null,
      caseSlug?: string | null,
      companyNameSlug?: string | null,
      employerNameSlug?: string | null,
      inviteStatus?: string | null,
      passportNumber?: string | null,
      phoneNumber?: string | null,
      personalPhone?: string | null,
      faxNumber?: string | null,
      passportGender?: string | null,
      preferredMailingAddress?: string | null,
      onboardingSections?: boolean | null,
      lastEntryUS?: string | null,
      employeeId?: string | null,
      caseNumber?: string | null,
      requestedProcess?: string | null,
      attorneyID?: string | null,
      caseAttorney?: string | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      caseSponsor?: string | null,
      caseSponsorId?: string | null,
      caseManagerID?: string | null,
      caseManager?: string | null,
      contributorIds?: Array< string | null > | null,
      caseContributors?: Array< string | null > | null,
      caseStartDate?: string | null,
      caseOpenDate?: string | null,
      caseSalary?: string | null,
      state?: string | null,
      workLocation?: string | null,
      keyFilingDates?: string | null,
      lcaFiled?: string | null,
      capGap?: string | null,
      visaAdditionalProcessing?: Array< string | null > | null,
      stemExtEligible?: string | null,
      educationEvaluationNeeded?: string | null,
      wageIssues?: string | null,
      selection?: string | null,
      caseNature?: string | null,
      registrationCompleted?: string | null,
      receiptNumber?: string | null,
      currentCaseStatusText?: string | null,
      modifiedDate?: string | null,
      incompleteUscisReceiptNumber?: boolean | null,
      caseStatusHistory?: string | null,
      companyAttorneys?: Array< string | null > | null,
      companyAttorneyIds?: Array< string | null > | null,
      companyParalegals?: Array< string | null > | null,
      companyParalegalIds?: Array< string | null > | null,
      companyTotalCases?: string | null,
      companyTotalOpenCases?: string | null,
      companyTotalClosedCases?: string | null,
      companyTotalCompletedCases?: string | null,
      companyNationalCount?: string | null,
      fullTimeEmployeesInUS?: string | null,
      partTimeEmployeesInUS?: string | null,
      companyActiveNationalCount?: string | null,
      grossRevenueForMostRecentFiscalYear?: string | null,
      netRevenueForMostRecentFiscalYear?: string | null,
      naicsCodeOfCompany?: string | null,
      typeOfBusiness?: string | null,
      fein?: string | null,
      yearCompanyWasFoundedInUS?: string | null,
      aosFilingEligible?: string | null,
      requiresMeetingReminder?: boolean | null,
      isParent?: boolean | null,
      isPartnerCompany?: boolean | null,
      companyWhitelistedDomains?: Array< string | null > | null,
      companyContactLabel?: Array< string | null > | null,
      annualMeetingDate?: string | null,
      emCompanyNames?: Array< string | null > | null,
      emCompanyNameSlugs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchReportEntriesQueryVariables = {
  filter?: SearchableReportEntriesFilterInput | null,
  sort?: Array< SearchableReportEntriesSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableReportEntriesAggregationInput | null > | null,
};

export type SearchReportEntriesQuery = {
  searchReportEntries?:  {
    __typename: "SearchableReportEntriesConnection",
    items:  Array< {
      __typename: "ReportEntries",
      id: string,
      reportID: string,
      companyID?: string | null,
      foreignNationalID?: string | null,
      fullname?: string | null,
      firstname?: string | null,
      lastname?: string | null,
      middlename?: string | null,
      archived?: string | null,
      email?: string | null,
      personalEmail?: string | null,
      birthDate?: string | null,
      numberOfDependents?: number | null,
      numberOfFamilyContacts?: number | null,
      displayCompanyName?: string | null,
      companyLegalName?: string | null,
      companyFullName?: string | null,
      sponsoringCompanyFullName?: string | null,
      companyDbaName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      birthCountryCode?: string | null,
      citizenshipCountry?: Array< string | null > | null,
      chargeabilityCountry?: string | null,
      passportExpirationDate?: string | null,
      nivMaxout?: string | null,
      visaExpDate?: string | null,
      hasApprovedI140?: boolean | null,
      petitionerI140?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      fnJobTitle?: string | null,
      socCode?: string | null,
      caseSocCode?: string | null,
      fnSalary?: string | null,
      startDate?: string | null,
      fnWorkLocation?: string | null,
      addressPrimary?: string | null,
      addressSecondary?: string | null,
      usResidentialAddress?: string | null,
      lastProcessType?: string | null,
      currentProcessType?: string | null,
      lowerProcessType?: string | null,
      lastPhaseCompleted?: string | null,
      currentPhase?: string | null,
      capType?: string | null,
      eadExpDate?: string | null,
      I797ApprovalExpDate?: string | null,
      I94ExpDate?: string | null,
      I94DS?: string | null,
      greenCardExpDate?: string | null,
      prevailingWageExpDate?: string | null,
      citizenshipEligibilityDate?: string | null,
      rfeDueDate?: string | null,
      dolAuditDueDate?: string | null,
      pwdExpDate?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      agreementExpDate?: string | null,
      agreementEffectiveDate?: string | null,
      mswsowExpDate?: string | null,
      permDueDate?: string | null,
      lotterySelectionDueDate?: string | null,
      advancedParoleExpDate?: string | null,
      reEntryPermitExpDate?: string | null,
      certifiedLcaExpDate?: string | null,
      title?: string | null,
      notes?: string | null,
      DS2019ExpDate?: string | null,
      isRelative?: boolean | null,
      relativeIds?: Array< string | null > | null,
      nextPhase?: string | null,
      requestedProcessSubCategory?: string | null,
      fnNameSlug?: string | null,
      caseSlug?: string | null,
      companyNameSlug?: string | null,
      employerNameSlug?: string | null,
      inviteStatus?: string | null,
      passportNumber?: string | null,
      phoneNumber?: string | null,
      personalPhone?: string | null,
      faxNumber?: string | null,
      passportGender?: string | null,
      preferredMailingAddress?: string | null,
      onboardingSections?: boolean | null,
      lastEntryUS?: string | null,
      employeeId?: string | null,
      caseNumber?: string | null,
      requestedProcess?: string | null,
      attorneyID?: string | null,
      caseAttorney?: string | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      caseSponsor?: string | null,
      caseSponsorId?: string | null,
      caseManagerID?: string | null,
      caseManager?: string | null,
      contributorIds?: Array< string | null > | null,
      caseContributors?: Array< string | null > | null,
      caseStartDate?: string | null,
      caseOpenDate?: string | null,
      caseSalary?: string | null,
      state?: string | null,
      workLocation?: string | null,
      keyFilingDates?: string | null,
      lcaFiled?: string | null,
      capGap?: string | null,
      visaAdditionalProcessing?: Array< string | null > | null,
      stemExtEligible?: string | null,
      educationEvaluationNeeded?: string | null,
      wageIssues?: string | null,
      selection?: string | null,
      caseNature?: string | null,
      registrationCompleted?: string | null,
      receiptNumber?: string | null,
      currentCaseStatusText?: string | null,
      modifiedDate?: string | null,
      incompleteUscisReceiptNumber?: boolean | null,
      caseStatusHistory?: string | null,
      companyAttorneys?: Array< string | null > | null,
      companyAttorneyIds?: Array< string | null > | null,
      companyParalegals?: Array< string | null > | null,
      companyParalegalIds?: Array< string | null > | null,
      companyTotalCases?: string | null,
      companyTotalOpenCases?: string | null,
      companyTotalClosedCases?: string | null,
      companyTotalCompletedCases?: string | null,
      companyNationalCount?: string | null,
      fullTimeEmployeesInUS?: string | null,
      partTimeEmployeesInUS?: string | null,
      companyActiveNationalCount?: string | null,
      grossRevenueForMostRecentFiscalYear?: string | null,
      netRevenueForMostRecentFiscalYear?: string | null,
      naicsCodeOfCompany?: string | null,
      typeOfBusiness?: string | null,
      fein?: string | null,
      yearCompanyWasFoundedInUS?: string | null,
      aosFilingEligible?: string | null,
      requiresMeetingReminder?: boolean | null,
      isParent?: boolean | null,
      isPartnerCompany?: boolean | null,
      companyWhitelistedDomains?: Array< string | null > | null,
      companyContactLabel?: Array< string | null > | null,
      annualMeetingDate?: string | null,
      emCompanyNames?: Array< string | null > | null,
      emCompanyNameSlugs?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetStandardTemplateQueryVariables = {
  id: string,
};

export type GetStandardTemplateQuery = {
  getStandardTemplate?:  {
    __typename: "StandardTemplate",
    id: string,
    fields?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListStandardTemplateQueryVariables = {
  filter?: ModelStandardTemplateFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStandardTemplateQuery = {
  listStandardTemplate?:  {
    __typename: "ModelStandardTemplateConnection",
    items:  Array< {
      __typename: "StandardTemplate",
      id: string,
      fields?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchStandardTemplateQueryVariables = {
  filter?: SearchableStandardTemplateFilterInput | null,
  sort?: Array< SearchableStandardTemplateSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableStandardTemplateAggregationInput | null > | null,
};

export type SearchStandardTemplateQuery = {
  searchStandardTemplate?:  {
    __typename: "SearchableStandardTemplateConnection",
    items:  Array< {
      __typename: "StandardTemplate",
      id: string,
      fields?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetSchedulerQueryVariables = {
  id: string,
};

export type GetSchedulerQuery = {
  getScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type ListSchedulersQueryVariables = {
  filter?: ModelSchedulerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSchedulersQuery = {
  listSchedulers?:  {
    __typename: "ModelSchedulerConnection",
    items:  Array< {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchSchedulersQueryVariables = {
  filter?: SearchableSchedulerFilterInput | null,
  sort?: Array< SearchableSchedulerSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableSchedulerAggregationInput | null > | null,
};

export type SearchSchedulersQuery = {
  searchSchedulers?:  {
    __typename: "SearchableSchedulerConnection",
    items:  Array< {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetVendorQueryVariables = {
  id: string,
};

export type GetVendorQuery = {
  getVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type ListVendorsQueryVariables = {
  filter?: ModelVendorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVendorsQuery = {
  listVendors?:  {
    __typename: "ModelVendorConnection",
    items:  Array< {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchVendorsQueryVariables = {
  filter?: SearchableVendorFilterInput | null,
  sort?: Array< SearchableVendorSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableVendorAggregationInput | null > | null,
};

export type SearchVendorsQuery = {
  searchVendors?:  {
    __typename: "SearchableVendorConnection",
    items:  Array< {
      __typename: "Vendor",
      id: string,
      name: string,
      type: VendorType,
      location?: string | null,
      email?: string | null,
      lowerName?: string | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetTaskDefinitionQueryVariables = {
  id: string,
};

export type GetTaskDefinitionQuery = {
  getTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type ListTaskDefinitionsQueryVariables = {
  filter?: ModelTaskDefinitionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskDefinitionsQuery = {
  listTaskDefinitions?:  {
    __typename: "ModelTaskDefinitionConnection",
    items:  Array< {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateCaseNoteByCaseSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type OnCreateCaseNoteByCaseSubscription = {
  onCreateCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type OnCreateCaseNoteByProcessRequestSubscription = {
  onCreateCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateCaseNoteByCaseSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type OnUpdateCaseNoteByCaseSubscription = {
  onUpdateCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type OnUpdateCaseNoteByProcessRequestSubscription = {
  onUpdateCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteCaseNoteByCaseSubscriptionVariables = {
  caseID: string,
  userGroup: UserGroup,
};

export type OnDeleteCaseNoteByCaseSubscription = {
  onDeleteCaseNoteByCase?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteCaseNoteByProcessRequestSubscriptionVariables = {
  processRequestID: string,
  userGroup: UserGroup,
};

export type OnDeleteCaseNoteByProcessRequestSubscription = {
  onDeleteCaseNoteByProcessRequest?:  {
    __typename: "CaseNote",
    id: string,
    createdAt?: string | null,
    postDate?: string | null,
    authorID?: string | null,
    authorEmployerID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    isPinned?: boolean | null,
    note?: string | null,
    caseID?: string | null,
    processRequestID?: string | null,
    companyID?: string | null,
    userGroup: UserGroup,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateCommentSubscriptionVariables = {
  sourceID: string,
};

export type OnCreateCommentSubscription = {
  onCreateComment?:  {
    __typename: "Comment",
    createdAt?: string | null,
    authorID: string,
    authorEmployerID?: string | null,
    authorForeignNationalID?: string | null,
    authorTeamMemberID?: string | null,
    authorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    note?: string | null,
    sourceID: string,
    id: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  personID?: string | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    personID: string,
    activityID: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      activityType: ActivityType,
      ipAddress?: string | null,
      fieldName?: string | null,
      updatedValue?: string | null,
      actorID: string,
      actorEmployerID?: string | null,
      actorForeignNationalID?: string | null,
      actorTeamMemberID?: string | null,
      actorType?: PersonType | null,
      directTargetID?: string | null,
      directTargetCaseID?: string | null,
      directTargetCompanyID?: string | null,
      directTargetEmployerID?: string | null,
      directTargetFileDataID?: string | null,
      directTargetForeignNationalID?: string | null,
      directTargetProcessRequestID?: string | null,
      directTargetTaskID?: string | null,
      directTargetTeamMemberID?: string | null,
      directTargetReportID?: string | null,
      targetString?: string | null,
      indirectTargetID?: string | null,
      indirectTargetCaseID?: string | null,
      indirectTargetCompanyID?: string | null,
      indirectTargetEmployerID?: string | null,
      indirectTargetForeignNationalID?: string | null,
      indirectTargetProcessRequestID?: string | null,
      indirectTargetTeamMemberID?: string | null,
      indirectTargetReportID?: string | null,
      indirectTargetString?: string | null,
      ownerID?: string | null,
      ownerCaseID?: string | null,
      ownerCompanyID?: string | null,
      ownerEmployerID?: string | null,
      ownerFileDataID?: string | null,
      ownerForeignNationalID?: string | null,
      ownerProcessRequestID?: string | null,
      ownerTeamMemberID?: string | null,
      ownerReportID?: string | null,
    } | null,
    read: ReadState,
    personNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    personTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateFileDataSubscriptionVariables = {
  id: string,
};

export type OnUpdateFileDataSubscription = {
  onUpdateFileData?:  {
    __typename: "FileData",
    id: string,
    expirationDate?: string | null,
    durationOfStatus?: boolean | null,
    fileName: string,
    original:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      level?: S3Level | null,
      identityId?: string | null,
    },
    fileType?: FileType | null,
    fileRequirement?: string | null,
    fileCategory?: string | null,
    contentType?: string | null,
    issueDate?: string | null,
    dueDate?: string | null,
    isFlattened?: boolean | null,
    processRequestID?: string | null,
    companyID?: string | null,
    ownerNationalID?: string | null,
    sourceID?: string | null,
    uploadDate: string,
    uploaderID?: string | null,
    uploaderEmployerID?: string | null,
    uploaderForeignNationalID?: string | null,
    uploaderTeamMemberID?: string | null,
    uploaderForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    uploaderEmployer?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cases?:  {
      __typename: "ModelCaseFileConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanySubscriptionVariables = {
  id: string,
};

export type OnUpdateCompanySubscription = {
  onUpdateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    lowerName?: string | null,
    lowerNameKey: string,
    displayCompanyName?: string | null,
    slug: string,
    type: CompanyType,
    logo?:  {
      __typename: "Picture",
      version: number,
    } | null,
    domainWhitelist?: Array< string > | null,
    onboardingSections?:  {
      __typename: "CompanyOnboardingSections",
      companyInfo?: boolean | null,
      contactInfo?: boolean | null,
      companyPreferences?: boolean | null,
      immigrationPreferences?: boolean | null,
      paymentPreferences?: boolean | null,
      questions?: boolean | null,
      employeeInformation?: boolean | null,
    } | null,
    hasCompletedOnboardingQuestions?: boolean | null,
    completedOnboardingQuestionsBy?: string | null,
    isPartnerCompany?: boolean | null,
    isParent?: boolean | null,
    children?:  {
      __typename: "ModelCompanyConnection",
      nextToken?: string | null,
    } | null,
    parent?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    parentID?: string | null,
    archived?: ArchivedState | null,
    companyNumber: number,
    nationalCount?: number | null,
    foreignNationals?:  {
      __typename: "ModelForeignNationalConnection",
      nextToken?: string | null,
    } | null,
    assignedAttorneys?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedParalegals?:  {
      __typename: "ModelParalegalAssignmentConnection",
      nextToken?: string | null,
    } | null,
    accountManagerID?: string | null,
    accountManager?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedEmployers?:  {
      __typename: "ModelEmployerAssignmentConnection",
      nextToken?: string | null,
    } | null,
    assignedEmployerAdmins?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      nextToken?: string | null,
    } | null,
    invoicingContacts?:  {
      __typename: "ModelInvoicingContactConnection",
      nextToken?: string | null,
    } | null,
    primaryContacts?:  {
      __typename: "ModelPrimaryContactConnection",
      nextToken?: string | null,
    } | null,
    seniorContacts?:  {
      __typename: "ModelSeniorContactConnection",
      nextToken?: string | null,
    } | null,
    signatoryContacts?:  {
      __typename: "ModelSignatoryContactConnection",
      nextToken?: string | null,
    } | null,
    data?:  {
      __typename: "CompanyData",
      id: string,
      companyID?: string | null,
      preferredMailingAddress?: CompanyAddressType | null,
      companyNameShowToFN?: CompanyNameShowToFN | null,
      companyCoversExpenseOfDependentPetitionsAndOrEADCards?: boolean | null,
      doingBusinessAs?: string | null,
      educationEvaluation?: EducationEvaluation | null,
      employeesEmailMHAttorneysAndParalegalsDirectly?: EmployeesEmailContactDirectly | null,
      fein?: string | null,
      fullTimeEmployeesInUS?: number | null,
      isH1BDependentEmloyer?: boolean | null,
      hasBeenWillfulViolator?: boolean | null,
      isHigherEd_20_USC_1001_a?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_19_iii_B?: boolean | null,
      isHigherEdNonProfit_8_CFR_214_2_h_8_ii_F_2?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_19_iii_C?: boolean | null,
      isNonProfitResearch_8_CFR_214_2_h_8_ii_F_3?: boolean | null,
      isQualifyingCapExempt_8_CFR_214_2_h_8_ii_F_4?: boolean | null,
      maintainsAWrittenImmigrationPolicy?: boolean | null,
      naicsCodeOfCompany?: string | null,
      partTimeEmployeesInUS?: number | null,
      paymentPreference?: PaymentPreference | null,
      permissionPowerAttorney?: CompanyEmployee | null,
      permissionReleaseApprovalNotices?: boolean | null,
      permissionReleasePetitionsRFE?: boolean | null,
      permissionReleaseLCA?: boolean | null,
      permissionRelease9089?: boolean | null,
      phone?: string | null,
      placesEmployeesAtClientSitesForMoreThanACoupleOfDaysAtATime?: boolean | null,
      fax?: string | null,
      preferredShippingSpeedForDocuments?: PreferredShippingSpeedForDocuments | null,
      shipOriginalApprovalNotices?: ShipOriginalApprovalNotices | null,
      staffsEmployeesAtThirdPartyEndClientSites?: boolean | null,
      typeOfBusiness?: string | null,
      usesWageSurvey?: boolean | null,
      usesEVerify?: boolean | null,
      utilizePremiumProcessingService?: UtilizePremiumProcessingService | null,
      technologyReleaseLicenseRequirement?: TechnologyReleaseLicenseRequirement | null,
      yearCompanyWasFoundedInUS?: string | null,
      I9_audit_has_been_completed_in_past_18_months?: boolean | null,
      current_number_of_H1B_employees?: string | null,
      current_number_of_employees_on_L_visas?: string | null,
      other_visa_statuses_sponsored?: string | null,
      email_address_invoices_should_be_addressed_to?: string | null,
      name_invoices_should_be_addressed_to?: string | null,
      companyCoversExpenseOfDependentPetitions?: boolean | null,
      placesEmployeesAtClientSitesForMoreThan30DaysAtATime?: boolean | null,
      annualMeetingDate?: string | null,
      requiresMeetingReminder?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    jobDescriptions?:  {
      __typename: "ModelJobDescriptionConnection",
      nextToken?: string | null,
    } | null,
    files?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    fileRequirements?:  Array< {
      __typename: "FileRequirement",
      type: FileType,
      fileType?: string | null,
      fileCategory?: string | null,
      fileInstruction?: string | null,
      defaultStorage?: string | null,
      visibility?: Array< Role | null > | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      expirationDateRequired?: boolean | null,
      issueDateRequired?: boolean | null,
      dueDateRequired?: boolean | null,
      isApproved?: boolean | null,
      isRequested?: boolean | null,
      hidden?: boolean | null,
      durationOfStatus?: boolean | null,
    } > | null,
    cases?:  {
      __typename: "ModelCaseConnection",
      nextToken?: string | null,
    } | null,
    openCaseCount?: number | null,
    closedCaseCount?: number | null,
    completedCaseCount?: number | null,
    legalTeamIDs?: Array< string > | null,
    notes?: string | null,
    petitionerParagraph?: string | null,
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    companyDataId?: string | null,
  } | null,
};

export type OnUpdatePreparedFormSubscriptionVariables = {
  id: string,
};

export type OnUpdatePreparedFormSubscription = {
  onUpdatePreparedForm?:  {
    __typename: "PreparedForm",
    id: string,
    caseID?: string | null,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    companyID?: string | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    relativeAdmins?: Array< string > | null,
    state: PreparedFormState,
    preparerID?: string | null,
    preparer?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    templateID?: string | null,
    template?:  {
      __typename: "PreparedFormTemplate",
      id: string,
      name: string,
      processes?: Array< VisaStatus > | null,
      archived?: boolean | null,
      updatedAt: string,
      requiresAttorneyApproval?: boolean | null,
      requiresSponsorApproval?: boolean | null,
      requiresNationalApproval?: boolean | null,
      employersCanView?: boolean | null,
      nationalsCanView?: boolean | null,
    } | null,
    completedFormID?: string | null,
    completedForm?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    completedFormHistory?:  {
      __typename: "ModelFileDataConnection",
      nextToken?: string | null,
    } | null,
    assignedToID?: string | null,
    assignedToEmployerID?: string | null,
    assignedToNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedDate?: string | null,
    rejectedByID?: string | null,
    rejectedByEmployerID?: string | null,
    rejectedByNationalID?: string | null,
    rejectedByTeamMemberID?: string | null,
    rejectedByEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    rejectedByTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requiresAttorneyApproval?: boolean | null,
    attorneyApproverID?: string | null,
    attorneyApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    attorneyApprovalDate?: string | null,
    requiresSponsorApproval?: boolean | null,
    sponsorApproverID?: string | null,
    sponsorApproverEmployerID?: string | null,
    sponsorApproverNationalID?: string | null,
    sponsorApproverEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApproverNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    sponsorApprovalDate?: string | null,
    requiresNationalApproval?: boolean | null,
    nationalApproverID?: string | null,
    nationalApprover?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    nationalApprovalDate?: string | null,
    finalCaseManagerApproverID?: string | null,
    finalCaseManagerApprover?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    finalCaseManagerApprovalDate?: string | null,
    employersCanView?: boolean | null,
    nationalsCanView?: boolean | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateActivityByIndirectTargetIDSubscriptionVariables = {
  indirectTargetID?: string | null,
};

export type OnCreateActivityByIndirectTargetIDSubscription = {
  onCreateActivityByIndirectTargetID?:  {
    __typename: "Activity",
    id: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    activityType: ActivityType,
    ipAddress?: string | null,
    fieldName?: string | null,
    updatedValue?: string | null,
    actorID: string,
    actorEmployerID?: string | null,
    actorForeignNationalID?: string | null,
    actorTeamMemberID?: string | null,
    actorType?: PersonType | null,
    actorEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    actorTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    directTargetID?: string | null,
    directTargetCaseID?: string | null,
    directTargetCompanyID?: string | null,
    directTargetEmployerID?: string | null,
    directTargetFileDataID?: string | null,
    directTargetForeignNationalID?: string | null,
    directTargetProcessRequestID?: string | null,
    directTargetTaskID?: string | null,
    directTargetTeamMemberID?: string | null,
    directTargetReportID?: string | null,
    targetString?: string | null,
    targetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    targetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetTask?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    targetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    targetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    indirectTargetID?: string | null,
    indirectTargetCaseID?: string | null,
    indirectTargetCompanyID?: string | null,
    indirectTargetEmployerID?: string | null,
    indirectTargetForeignNationalID?: string | null,
    indirectTargetProcessRequestID?: string | null,
    indirectTargetTeamMemberID?: string | null,
    indirectTargetReportID?: string | null,
    indirectTargetString?: string | null,
    indirectTargetCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    indirectTargetEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    indirectTargetReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    ownerID?: string | null,
    ownerCaseID?: string | null,
    ownerCompanyID?: string | null,
    ownerEmployerID?: string | null,
    ownerFileDataID?: string | null,
    ownerForeignNationalID?: string | null,
    ownerProcessRequestID?: string | null,
    ownerTeamMemberID?: string | null,
    ownerReportID?: string | null,
    ownerCase?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerCompany?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    ownerEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerFileData?:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerProcessRequest?:  {
      __typename: "ProcessRequest",
      id: string,
      assignedToID?: string | null,
      assignedToEmployerID?: string | null,
      assignedToTeamMemberID?: string | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      initiatorID?: string | null,
      jobDescriptionID?: string | null,
      requesterID?: string | null,
      requestDate: string,
      approvalDate?: string | null,
      archivedDate?: string | null,
      cancelDate?: string | null,
      foreignNationalID?: string | null,
      needsEmployerRevision?: boolean | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      slug: string,
      state: ProcessRequestState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ownerReport?:  {
      __typename: "Report",
      id: string,
      templateID: string,
      companyIds?: Array< string | null > | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      type?: TemplateType | null,
      name: string,
      status: ReportStatus,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      fromTemplate?: boolean | null,
      totalCountCycle?: number | null,
      completedCountCycle?: number | null,
      isCurrent?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
  } | null,
};

export type OnCreateCaseFileSubscriptionVariables = {
  caseID: string,
};

export type OnCreateCaseFileSubscription = {
  onCreateCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCaseFileSubscriptionVariables = {
  caseID: string,
};

export type OnDeleteCaseFileSubscription = {
  onDeleteCaseFile?:  {
    __typename: "CaseFile",
    id: string,
    fileID: string,
    caseID: string,
    file:  {
      __typename: "FileData",
      id: string,
      expirationDate?: string | null,
      durationOfStatus?: boolean | null,
      fileName: string,
      fileType?: FileType | null,
      fileRequirement?: string | null,
      fileCategory?: string | null,
      contentType?: string | null,
      issueDate?: string | null,
      dueDate?: string | null,
      isFlattened?: boolean | null,
      processRequestID?: string | null,
      companyID?: string | null,
      ownerNationalID?: string | null,
      sourceID?: string | null,
      uploadDate: string,
      uploaderID?: string | null,
      uploaderEmployerID?: string | null,
      uploaderForeignNationalID?: string | null,
      uploaderTeamMemberID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskSubscriptionVariables = {
  id: string,
};

export type OnUpdateTaskSubscription = {
  onUpdateTask?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type OnUpdateTaskByCaseIDSubscriptionVariables = {
  caseID: string,
};

export type OnUpdateTaskByCaseIDSubscription = {
  onUpdateTaskByCaseID?:  {
    __typename: "Task",
    id: string,
    action: string,
    isKeyDate?: boolean | null,
    keyDateAlternateAction?: string | null,
    isPaymentStatus?: boolean | null,
    paymentStatusAlternateAction?: string | null,
    assignedToID?: string | null,
    isAssignedToLegalAssistants?: boolean | null,
    assignedToEmployerID?: string | null,
    assignedToForeignNationalID?: string | null,
    assignedToTeamMemberID?: string | null,
    assignedToEmployer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToForeignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assignedToTeamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    caseID: string,
    case:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    caseState?: CaseState | null,
    category: TaskCategory,
    companyID?: string | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      lowerName?: string | null,
      lowerNameKey: string,
      displayCompanyName?: string | null,
      slug: string,
      type: CompanyType,
      domainWhitelist?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      isPartnerCompany?: boolean | null,
      isParent?: boolean | null,
      parentID?: string | null,
      archived?: ArchivedState | null,
      companyNumber: number,
      nationalCount?: number | null,
      accountManagerID?: string | null,
      openCaseCount?: number | null,
      closedCaseCount?: number | null,
      completedCaseCount?: number | null,
      legalTeamIDs?: Array< string > | null,
      notes?: string | null,
      petitionerParagraph?: string | null,
      createdAt: string,
      updatedAt: string,
      companyDataId?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelCommentConnection",
      nextToken?: string | null,
    } | null,
    completeDate?: string | null,
    deadline: string,
    deadlineIsManuallySet?: boolean | null,
    deleteDate?: string | null,
    deleteReason?: string | null,
    dependencies?:  {
      __typename: "ModelTaskConnection",
      nextToken?: string | null,
    } | null,
    description?: string | null,
    duration?: number | null,
    foreignNationalID: string,
    foreignNational?:  {
      __typename: "ForeignNational",
      type: PersonType,
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      completedOnboardingQuestionsBy?: string | null,
      email?: string | null,
      emailPersonal?: string | null,
      emailWork?: string | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      nickname?: string | null,
      employeeId?: string | null,
      additionalFirstnames?: Array< string > | null,
      additionalMiddlenames?: Array< string > | null,
      additionalLastnames?: Array< string > | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      maritalStatus?: MaritalStatus | null,
      spouse?: boolean | null,
      dependents?: number | null,
      phone?: string | null,
      phoneWork?: string | null,
      companyID?: string | null,
      companyNationalNumber?: number | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      relatives?: Array< string > | null,
      relativeAdmins?: Array< string > | null,
      immigrationVisaStatus?: string | null,
      visaExpiration?: string | null,
      nonImmigrantVisaNumber?: string | null,
      visaIssueDate?: string | null,
      visaConsulate?: string | null,
      immigrantVisaApplicant?: boolean | null,
      immigrantPetitionEverFiled?: boolean | null,
      hasPendingETA9089?: boolean | null,
      aosFilingEligible?: AOSFilingEligibility | null,
      hasValidOrExpiredEAD?: boolean | null,
      hasPendingUSCISApplication?: boolean | null,
      hasHadVisaPetitionRevokedOrDenied?: boolean | null,
      hasBeenArrestedSinceLastUSEntry?: boolean | null,
      hasTransportedWeapons?: boolean | null,
      hasParticipatedInArmedGroup?: boolean | null,
      hasDetailedPerson?: boolean | null,
      hasUsedWeapons?: boolean | null,
      hasWeaponsTraining?: boolean | null,
      hasCriminalOffence?: boolean | null,
      hasViolatedVisaTerms?: boolean | null,
      citizenshipCountry?: Array< CountryCode > | null,
      birthCountry?: CountryCode | null,
      birthState?: string | null,
      birthDate?: string | null,
      birthCity?: string | null,
      jobDescriptionID?: string | null,
      nivMaxout?: string | null,
      isRemote?: boolean | null,
      hasNonUSPassport?: boolean | null,
      passportGender?: PassportGender | null,
      passportIssueDate?: string | null,
      passportExpirationDate?: string | null,
      passportExpirationReminderSentForDate?: string | null,
      passportNumber?: string | null,
      passportCountry?: CountryCode | null,
      usSSN?: string | null,
      hasSSN?: boolean | null,
      aNumber?: string | null,
      lastEntryUS?: string | null,
      i94ArrivalDepartureRecordNumber?: string | null,
      sevisNumber?: string | null,
      eadNumber?: string | null,
      fileRequirementsManipulated?: string | null,
      test?: string | null,
      notes?: string | null,
      companyName?: string | null,
      immigrationCurrentStatus?: string | null,
      immigrationStatusExpiration?: string | null,
      employmentBasedCategory?: string | null,
      priorityDate?: string | null,
      eadExpDate?: string | null,
      I797ExpDate?: string | null,
      visaExpDate?: string | null,
      chargeabilityCountry?: CountryCode | null,
      birthCountryCode?: string | null,
      socCode?: string | null,
      firstEntryUS?: string | null,
      taxTrackingF1J1?: string | null,
      citizenshipEligibilityDate?: string | null,
      startDate?: string | null,
      legalTeamIDs?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    groupsCanRead?: Array< string > | null,
    isCustom?: boolean | null,
    isManuallyUnlocked?: boolean | null,
    prerequisite?:  {
      __typename: "Task",
      id: string,
      action: string,
      isKeyDate?: boolean | null,
      keyDateAlternateAction?: string | null,
      isPaymentStatus?: boolean | null,
      paymentStatusAlternateAction?: string | null,
      assignedToID?: string | null,
      isAssignedToLegalAssistants?: boolean | null,
      assignedToEmployerID?: string | null,
      assignedToForeignNationalID?: string | null,
      assignedToTeamMemberID?: string | null,
      caseID: string,
      caseState?: CaseState | null,
      category: TaskCategory,
      companyID?: string | null,
      completeDate?: string | null,
      deadline: string,
      deadlineIsManuallySet?: boolean | null,
      deleteDate?: string | null,
      deleteReason?: string | null,
      description?: string | null,
      duration?: number | null,
      foreignNationalID: string,
      groupsCanRead?: Array< string > | null,
      isCustom?: boolean | null,
      isManuallyUnlocked?: boolean | null,
      prerequisiteID?: string | null,
      startDate: string,
      state: TaskState,
      templateID?: string | null,
      assigneeLowerName?: string | null,
      attorneyLowerFirstName?: string | null,
      attorneyLowerName?: string | null,
      paralegalLowerName?: string | null,
      paralegalLowerFirstName?: string | null,
      companyLowerName?: string | null,
      nationalLowerName?: string | null,
      orderIndex?: number | null,
      defaultAssignee?: string | null,
      createdAt: string,
      updatedAt: string,
      foreignNationalTasksId?: string | null,
      employerTasksId?: string | null,
    } | null,
    prerequisiteID?: string | null,
    startDate: string,
    state: TaskState,
    templateID?: string | null,
    assigneeLowerName?: string | null,
    attorneyLowerFirstName?: string | null,
    attorneyLowerName?: string | null,
    paralegalLowerName?: string | null,
    paralegalLowerFirstName?: string | null,
    companyLowerName?: string | null,
    nationalLowerName?: string | null,
    orderIndex?: number | null,
    defaultAssignee?: string | null,
    createdAt: string,
    updatedAt: string,
    foreignNationalTasksId?: string | null,
    employerTasksId?: string | null,
  } | null,
};

export type OnDeleteReportSubscriptionVariables = {
  reportID: string,
};

export type OnDeleteReportSubscription = {
  onDeleteReport?:  {
    __typename: "Report",
    id: string,
    templateID: string,
    template?:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null,
    customTemplate:  {
      __typename: "CustomTemplate",
      id: string,
      teamMemberId?: string | null,
      employerID?: string | null,
      accessibleIds?: Array< string | null > | null,
      editableIds?: Array< string | null > | null,
      name: string,
      selectedFields?: string | null,
      includeFN?: boolean | null,
      individualFNCase?: boolean | null,
      includeCases?: boolean | null,
      numberOfFilters?: number | null,
      numberOfColumns?: number | null,
      type?: TemplateType | null,
      category?: TemplateCategory | null,
      isDeleted?: boolean | null,
      viewAccess?: AccessPermission | null,
      editAccess?: EditPermission | null,
      accessibleCompanyIds?: Array< string | null > | null,
      companyIds?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    },
    reportEntries?:  {
      __typename: "ModelReportEntriesConnection",
      nextToken?: string | null,
    } | null,
    companyIds?: Array< string | null > | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    type?: TemplateType | null,
    name: string,
    status: ReportStatus,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    fromTemplate?: boolean | null,
    totalCountCycle?: number | null,
    completedCountCycle?: number | null,
    isCurrent?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteTemplateSubscriptionVariables = {
  templateID: string,
};

export type OnDeleteTemplateSubscription = {
  onDeleteTemplate?:  {
    __typename: "CustomTemplate",
    id: string,
    teamMemberId?: string | null,
    teamMember?:  {
      __typename: "TeamMember",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      username?: string | null,
      firstname: string,
      middlename?: string | null,
      lastname: string,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      phone?: string | null,
      position?: Position | null,
      title?: string | null,
      licensingAuthority?: string | null,
      stateBarNumber?: string | null,
      isAdmin?: boolean | null,
      managerID?: string | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      recentlyViewedCases?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      companiesAssignedTo?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    employerID?: string | null,
    employer?:  {
      __typename: "Employer",
      id: string,
      createdBy?: string | null,
      slug: string,
      userAgreementAcknowledged?: boolean | null,
      userAgreementAcknowledgementDate?: string | null,
      userAgreementAcknowledgementText?: string | null,
      hasLoggedIn?: boolean | null,
      type: PersonType,
      email?: string | null,
      personalEmail?: string | null,
      newsletterModalViewCount?: number | null,
      username?: string | null,
      firstname?: string | null,
      middlename?: string | null,
      lastname?: string | null,
      lowerFirst: string,
      lowerLast: string,
      lowerFull: string,
      address?: string | null,
      phone?: string | null,
      personalPhone?: string | null,
      title?: string | null,
      companyIDs?: Array< string > | null,
      hasCompletedOnboardingQuestions?: boolean | null,
      recentlyViewedCases?: Array< string > | null,
      mostRecentlyInvited?: string | null,
      archived: ArchivedState,
      invoicingContactCompanyIDs?: Array< string > | null,
      isInvoicingContact?: boolean | null,
      primaryContactCompanyIDs?: Array< string > | null,
      isPrimaryContact?: boolean | null,
      seniorContactCompanyIDs?: Array< string > | null,
      isSeniorContact?: boolean | null,
      signatoryContactCompanyIDs?: Array< string > | null,
      isSignatoryContact?: boolean | null,
      assignedCaseIDs?: Array< string > | null,
      nationalsWithOpenCases?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    reports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    templateReports?:  {
      __typename: "ModelReportConnection",
      nextToken?: string | null,
    } | null,
    accessibleIds?: Array< string | null > | null,
    editableIds?: Array< string | null > | null,
    name: string,
    selectedFields?: string | null,
    includeFN?: boolean | null,
    individualFNCase?: boolean | null,
    includeCases?: boolean | null,
    numberOfFilters?: number | null,
    numberOfColumns?: number | null,
    type?: TemplateType | null,
    category?: TemplateCategory | null,
    isDeleted?: boolean | null,
    viewAccess?: AccessPermission | null,
    editAccess?: EditPermission | null,
    accessibleCompanyIds?: Array< string | null > | null,
    companyIds?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateAdditionalFieldsSubscriptionVariables = {
  filter?: ModelSubscriptionAdditionalFieldsFilterInput | null,
};

export type OnCreateAdditionalFieldsSubscription = {
  onCreateAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAdditionalFieldsSubscriptionVariables = {
  filter?: ModelSubscriptionAdditionalFieldsFilterInput | null,
};

export type OnUpdateAdditionalFieldsSubscription = {
  onUpdateAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAdditionalFieldsSubscriptionVariables = {
  filter?: ModelSubscriptionAdditionalFieldsFilterInput | null,
};

export type OnDeleteAdditionalFieldsSubscription = {
  onDeleteAdditionalFields?:  {
    __typename: "AdditionalFields",
    id: string,
    caseID: string,
    case?:  {
      __typename: "Case",
      id: string,
      caseNumber?: string | null,
      slug: string,
      attorneyID?: string | null,
      caseManagerID?: string | null,
      complianceListID?: string | null,
      PERMFilingDataID?: string | null,
      pinnedCaseNoteID?: string | null,
      contributorIds?: Array< string | null > | null,
      sponsoringEmployerID?: string | null,
      sponsoringNationalID?: string | null,
      foreignNationalID: string,
      welcomeLetterAcknowledged?: boolean | null,
      welcomeLetterAcknowledgementDate?: string | null,
      welcomeLetterAcknowledgedBy?: string | null,
      welcomeLetterText?: string | null,
      nationalVisaExpiration?: string | null,
      relativeAdmins?: Array< string > | null,
      startDate: string,
      closeDate?: string | null,
      closeReason?: string | null,
      completeDate?: string | null,
      sourceID: string,
      state: CaseState,
      lowerNationalName?: string | null,
      lowerCompanyName?: string | null,
      lowerProcessType?: string | null,
      currentPhase?: CasePhase | null,
      prevailingWageCaseNumber?: string | null,
      USCISReceiptNumber?: string | null,
      AOSReceiptNotice?: string | null,
      I485JReceiptNotice?: string | null,
      SelectionNoticeNo?: string | null,
      ETACaseNumber?: string | null,
      isShipmentTrackingElectronically?: boolean | null,
      companyID?: string | null,
      individualSponsored?: boolean | null,
      jobDescriptionID?: string | null,
      resumeID?: string | null,
      requestedProcess?: VisaStatus | null,
      requestedProcessSubCategory?: VisaSubCategory | null,
      requestedProcessAdditionalProcessing?: Array< VisaAdditionalProcessing > | null,
      globalRequestedProcessSubCategory?: string | null,
      globalProcessCountryCode?: CountryCode | null,
      globalProcessDuration?: GlobalProcessDuration | null,
      globalVisaType?: GlobalVisaType | null,
      vendorID?: string | null,
      additionalFieldID?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    fields?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSchedulerSubscriptionVariables = {
  filter?: ModelSubscriptionSchedulerFilterInput | null,
};

export type OnCreateSchedulerSubscription = {
  onCreateScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnUpdateSchedulerSubscriptionVariables = {
  filter?: ModelSubscriptionSchedulerFilterInput | null,
};

export type OnUpdateSchedulerSubscription = {
  onUpdateScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnDeleteSchedulerSubscriptionVariables = {
  filter?: ModelSubscriptionSchedulerFilterInput | null,
};

export type OnDeleteSchedulerSubscription = {
  onDeleteScheduler?:  {
    __typename: "Scheduler",
    id: string,
    name: string,
    eventBridgeschedulerName: string,
    eventBridgeSchedulerID: string,
    description?: string | null,
    schedulerExpression: string,
    endDate: string,
    startTime: string,
    frequencyNumber: number,
    frequencyUnit: string,
    startDate: string,
    timeZone: string,
    targetUrl: string,
    entityID: string,
    taskDefinitionID: string,
    taskDefinition?:  {
      __typename: "TaskDefinition",
      id: string,
      taskType: TaskType,
      payload: string,
      recipientIDs?: Array< string > | null,
      companyIndividualIDs?: Array< string | null > | null,
      individualIDs?: Array< string | null > | null,
      companyIDs?: Array< string > | null,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnCreateVendorSubscriptionVariables = {
  filter?: ModelSubscriptionVendorFilterInput | null,
};

export type OnCreateVendorSubscription = {
  onCreateVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnUpdateVendorSubscriptionVariables = {
  filter?: ModelSubscriptionVendorFilterInput | null,
};

export type OnUpdateVendorSubscription = {
  onUpdateVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnDeleteVendorSubscriptionVariables = {
  filter?: ModelSubscriptionVendorFilterInput | null,
};

export type OnDeleteVendorSubscription = {
  onDeleteVendor?:  {
    __typename: "Vendor",
    id: string,
    name: string,
    type: VendorType,
    location?: string | null,
    email?: string | null,
    lowerName?: string | null,
    processRequests?:  {
      __typename: "ModelProcessRequestConnection",
      nextToken?: string | null,
    } | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnCreateTaskDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionTaskDefinitionFilterInput | null,
};

export type OnCreateTaskDefinitionSubscription = {
  onCreateTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnUpdateTaskDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionTaskDefinitionFilterInput | null,
};

export type OnUpdateTaskDefinitionSubscription = {
  onUpdateTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type OnDeleteTaskDefinitionSubscriptionVariables = {
  filter?: ModelSubscriptionTaskDefinitionFilterInput | null,
};

export type OnDeleteTaskDefinitionSubscription = {
  onDeleteTaskDefinition?:  {
    __typename: "TaskDefinition",
    id: string,
    taskType: TaskType,
    scheduler?:  {
      __typename: "Scheduler",
      id: string,
      name: string,
      eventBridgeschedulerName: string,
      eventBridgeSchedulerID: string,
      description?: string | null,
      schedulerExpression: string,
      endDate: string,
      startTime: string,
      frequencyNumber: number,
      frequencyUnit: string,
      startDate: string,
      timeZone: string,
      targetUrl: string,
      entityID: string,
      taskDefinitionID: string,
      updatedAt?: string | null,
      createdAt?: string | null,
    } | null,
    payload: string,
    recipientIDs?: Array< string > | null,
    companyIndividualIDs?: Array< string | null > | null,
    individualIDs?: Array< string | null > | null,
    companyIDs?: Array< string > | null,
    updatedAt?: string | null,
    createdAt?: string | null,
  } | null,
};

export type GetEmployerConnectionsQueryVariables = {
  id?: string | null,
};

export type GetEmployerConnectionsQuery = {
  getEmployer?:  {
    __typename: "Employer",
    companyIDs?: Array< string > | null,
    id: string,
    adminCompanies?:  {
      __typename: "ModelEmployerAdminAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAdminAssignment",
        id: string,
      } | null >,
    } | null,
    companies?:  {
      __typename: "ModelEmployerAssignmentConnection",
      items:  Array< {
        __typename: "EmployerAssignment",
        id: string,
      } | null >,
    } | null,
    invoicingContactCompanies?:  {
      __typename: "ModelInvoicingContactConnection",
      items:  Array< {
        __typename: "InvoicingContact",
        id: string,
      } | null >,
    } | null,
    primaryContactCompanies?:  {
      __typename: "ModelPrimaryContactConnection",
      items:  Array< {
        __typename: "PrimaryContact",
        id: string,
      } | null >,
    } | null,
    seniorContactCompanies?:  {
      __typename: "ModelSeniorContactConnection",
      items:  Array< {
        __typename: "SeniorContact",
        id: string,
      } | null >,
    } | null,
    signatoryContactCompanies?:  {
      __typename: "ModelSignatoryContactConnection",
      items:  Array< {
        __typename: "SignatoryContact",
        id: string,
      } | null >,
    } | null,
  } | null,
};

export type GetTeamMemberConnectionsQueryVariables = {
  id?: string | null,
};

export type GetTeamMemberConnectionsQuery = {
  getTeamMember?:  {
    __typename: "TeamMember",
    attorneyAssignments?:  {
      __typename: "ModelAttorneyAssignmentConnection",
      items:  Array< {
        __typename: "AttorneyAssignment",
        id: string,
      } | null >,
    } | null,
    paralegalAssignments?:  {
      __typename: "ModelParalegalAssignmentConnection",
      items:  Array< {
        __typename: "ParalegalAssignment",
        id: string,
      } | null >,
    } | null,
    id: string,
  } | null,
};
